"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Esdec calculator API
 * Esdec calculator API
 *
 * The version of the OpenAPI document: v1.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoofDTOHighBuildingSafetyFactorOptionEnum = exports.RoofDTOConsequenceClassEnum = exports.RoofDTOHookTypeEnum = exports.RoofDTOHookSizeEnum = exports.RoofDTOMaterialEnum = exports.RoofDTOTerrainCategoryEnum = exports.RoofDTOSnowzoneEnum = exports.RoofDTOWindzoneEnum = exports.RoofDTOClipTypeEnum = exports.RoofDTONumberOfPanelsPerOptimizerEnum = exports.RoofDTOChosenAttachmentTypeEnum = exports.RoofDTOPreferredProductEnum = exports.RoofDTOPreferredProductColorEnum = exports.RoofDTOClampTypeEnum = exports.RoofDTOSideEnum = exports.RoofDTOTypeEnum = exports.RegisterIdentityDTOBusinessUnitsEnum = exports.RegisterIdentityDTOTypeEnum = exports.ProjectDTOStatusEnum = exports.ProductOptionDTOApplicableProductsEnum = exports.ModuleSidePlatePlacementDTOSidePlatePlacementEnum = exports.ModuleDTOTypeEnum = exports.IdentityDTOBusinessUnitsEnum = exports.IdentityDTOTypeEnum = exports.FieldDtoRowConnectorLengthEnum = exports.FieldDtoCableExitGuideChoiceEnum = exports.FieldDtoOrientationEnum = exports.FieldDtoRowDistanceEnum = exports.FieldDtoPanelConfigurationEnum = exports.FieldDtoRailSystemEnum = exports.FieldDTOCableExitGuideChoiceEnum = exports.FieldDTOModuleConfigurationEnum = exports.FieldDTORailSystemEnum = exports.FieldDTOSidePlatesOptionEnum = exports.FieldDTOOrientationEnum = exports.EngineErrorDtoProductEnum = exports.DrawingFieldsShortcutRoofDtoHookTypeEnum = exports.DrawingFieldsShortcutRoofDtoRoofStructureEnum = exports.DrawingFieldsShortcutRoofDtoAttachmentTypeEnum = exports.DrawingFieldsShortcutRoofDtoClampTypeEnum = exports.DrawingFieldsShortcutRoofDtoMaterialEnum = exports.DrawingFieldsShortcutRoofDtoProductEnum = exports.DrawingFieldsShortcutFieldDtoRowConnectorLengthEnum = exports.DrawingFieldsShortcutFieldDtoPanelConfigurationEnum = exports.DrawingFieldsShortcutFieldDtoRailSystemEnum = exports.DrawingFieldsShortcutFieldDtoOrientationEnum = exports.CheckoutResultDtoCheckoutTypeEnum = exports.BatchJobStatusDTOStatusEnum = exports.ArticleSetDetailsDTOArticleTypeEnum = exports.ArticleSetDetailsDTOProductEnum = void 0;
exports.RoofWithArticlesDTOTerrainCategoryEnum = exports.RoofWithArticlesDTOSnowzoneEnum = exports.RoofWithArticlesDTOWindzoneEnum = exports.RoofWithArticlesDTOClipTypeEnum = exports.RoofWithArticlesDTONumberOfPanelsPerOptimizerEnum = exports.RoofWithArticlesDTOChosenAttachmentTypeEnum = exports.RoofWithArticlesDTOPreferredProductEnum = exports.RoofWithArticlesDTOPreferredProductColorEnum = exports.RoofWithArticlesDTOClampTypeEnum = exports.RoofWithArticlesDTOSideEnum = exports.RoofWithArticlesDTOTypeEnum = exports.RoofSummaryDTOProductEnum = exports.RoofSummaryDTOTerrainCategoryEnum = exports.RoofSummaryDTOWindzoneEnum = exports.RoofSummaryDTOStatusEnum = exports.RoofStatusDTOStatusEnum = exports.RoofDtoDualRailUnitChoiceEnum = exports.RoofDtoSteelThicknessEnum = exports.RoofDtoTopographyEnum = exports.RoofDtoBallastElementEnum = exports.RoofDtoPreferredFastenerEnum = exports.RoofDtoRoofStructureEnum = exports.RoofDtoSeamTypeEnum = exports.RoofDtoSteelTypeEnum = exports.RoofDtoSnowzoneEnum = exports.RoofDtoGroundingOptionEnum = exports.RoofDtoConsequenceClassEnum = exports.RoofDtoMlpeClipEnum = exports.RoofDtoNumberOfPanelsPerOptimizerEnum = exports.RoofDtoHookSizeTypeEnum = exports.RoofDtoHookTypeEnum = exports.RoofDtoAttachmentTypeEnum = exports.RoofDtoTerrainCategoryEnum = exports.RoofDtoWindzoneEnum = exports.RoofDtoSideEnum = exports.RoofDtoTypeEnum = exports.RoofDtoMaterialEnum = exports.RoofDtoClampTypeEnum = exports.RoofDtoCountryEnum = exports.RoofDtoProductEnum = exports.RoofDTOStatusEnum = exports.RoofDTOSteelThicknessEnum = exports.RoofDTODualRailUnitChoiceEnum = exports.RoofDTOTopographyEnum = exports.RoofDTOPreferredFastenerEnum = exports.RoofDTOBallastElementEnum = exports.RoofDTORoofStructureEnum = exports.RoofDTOSteelTypeEnum = exports.RoofDTOSeamTypeEnum = exports.RoofDTOGroundingOptionEnum = void 0;
exports.UserPreferenceDTOHookTypeEnum = exports.UserPreferenceDTODefaultGroundingOptionEnum = exports.UserAccountDTOBusinessUnitEnum = exports.UpdateIdentityDTOCountryEnum = exports.SimpleRoofDTOProductEnum = exports.SimpleRoofDTORoofTypeEnum = exports.SimpleRoofDTOStatusEnum = exports.SimpleProjectDTOStatusEnum = exports.SidePlatePlacementFieldDtoSidePlatePlacementEnum = exports.RoofZonesShortcutRoofDtoTypeEnum = exports.RoofWithoutIdDTOSteelThicknessEnum = exports.RoofWithoutIdDTODualRailUnitChoiceEnum = exports.RoofWithoutIdDTOTopographyEnum = exports.RoofWithoutIdDTOPreferredFastenerEnum = exports.RoofWithoutIdDTOBallastElementEnum = exports.RoofWithoutIdDTORoofStructureEnum = exports.RoofWithoutIdDTOSteelTypeEnum = exports.RoofWithoutIdDTOSeamTypeEnum = exports.RoofWithoutIdDTOGroundingOptionEnum = exports.RoofWithoutIdDTOHighBuildingSafetyFactorOptionEnum = exports.RoofWithoutIdDTOConsequenceClassEnum = exports.RoofWithoutIdDTOHookTypeEnum = exports.RoofWithoutIdDTOHookSizeEnum = exports.RoofWithoutIdDTOMaterialEnum = exports.RoofWithoutIdDTOTerrainCategoryEnum = exports.RoofWithoutIdDTOSnowzoneEnum = exports.RoofWithoutIdDTOWindzoneEnum = exports.RoofWithoutIdDTOClipTypeEnum = exports.RoofWithoutIdDTONumberOfPanelsPerOptimizerEnum = exports.RoofWithoutIdDTOChosenAttachmentTypeEnum = exports.RoofWithoutIdDTOPreferredProductEnum = exports.RoofWithoutIdDTOPreferredProductColorEnum = exports.RoofWithoutIdDTOClampTypeEnum = exports.RoofWithoutIdDTOSideEnum = exports.RoofWithoutIdDTOTypeEnum = exports.RoofWithArticlesDTOStatusEnum = exports.RoofWithArticlesDTOSteelThicknessEnum = exports.RoofWithArticlesDTODualRailUnitChoiceEnum = exports.RoofWithArticlesDTOTopographyEnum = exports.RoofWithArticlesDTOPreferredFastenerEnum = exports.RoofWithArticlesDTOBallastElementEnum = exports.RoofWithArticlesDTORoofStructureEnum = exports.RoofWithArticlesDTOSteelTypeEnum = exports.RoofWithArticlesDTOSeamTypeEnum = exports.RoofWithArticlesDTOGroundingOptionEnum = exports.RoofWithArticlesDTOHighBuildingSafetyFactorOptionEnum = exports.RoofWithArticlesDTOConsequenceClassEnum = exports.RoofWithArticlesDTOHookTypeEnum = exports.RoofWithArticlesDTOHookSizeEnum = exports.RoofWithArticlesDTOMaterialEnum = void 0;
exports.ShortcutResourceApiAxiosParamCreator = exports.RoofResourceApi = exports.RoofResourceApiFactory = exports.RoofResourceApiFp = exports.RoofResourceApiAxiosParamCreator = exports.ProjectResourceApi = exports.ProjectResourceApiFactory = exports.ProjectResourceApiFp = exports.ProjectResourceApiAxiosParamCreator = exports.LocationResourceApi = exports.LocationResourceApiFactory = exports.LocationResourceApiFp = exports.LocationResourceApiAxiosParamCreator = exports.JobControllerApi = exports.JobControllerApiFactory = exports.JobControllerApiFp = exports.JobControllerApiAxiosParamCreator = exports.IdentitySupportApi = exports.IdentitySupportApiFactory = exports.IdentitySupportApiFp = exports.IdentitySupportApiAxiosParamCreator = exports.IdentityControllerApi = exports.IdentityControllerApiFactory = exports.IdentityControllerApiFp = exports.IdentityControllerApiAxiosParamCreator = exports.ConfigurationControllerApi = exports.ConfigurationControllerApiFactory = exports.ConfigurationControllerApiFp = exports.ConfigurationControllerApiAxiosParamCreator = exports.CalculationResourceApi = exports.CalculationResourceApiFactory = exports.CalculationResourceApiFp = exports.CalculationResourceApiAxiosParamCreator = exports.ArticleResourceApi = exports.ArticleResourceApiFactory = exports.ArticleResourceApiFp = exports.ArticleResourceApiAxiosParamCreator = exports.ZoneReferenceInfoDTOTerrainCategoryEnum = exports.ZoneReferenceInfoDTOSnowZoneEnum = exports.ZoneReferenceInfoDTOWindZoneEnum = exports.ZoneInformationDTOTerrainCategoryEnum = exports.ZoneInformationDTOSnowZoneEnum = exports.ZoneInformationDTOWindZoneEnum = exports.ZoneDtoTypeEnum = exports.WindDataCombinationDTOCategoryEnum = exports.WindDataCombinationDTOProductEnum = exports.VisualizationResultDTODependenciesEnum = exports.VisualizationResultDTORuleTypeEnum = exports.VisualizationInputDTORuleTypeEnum = exports.VendorDtoCheckoutTypeEnum = void 0;
exports.WindDataResourceApi = exports.WindDataResourceApiFactory = exports.WindDataResourceApiFp = exports.WindDataResourceApiAxiosParamCreator = exports.WebshopResourceApi = exports.WebshopResourceApiFactory = exports.WebshopResourceApiFp = exports.WebshopResourceApiAxiosParamCreator = exports.VisualizationResourceApi = exports.VisualizationResourceApiFactory = exports.VisualizationResourceApiFp = exports.VisualizationResourceApiAxiosParamCreator = exports.VendorResourceApi = exports.VendorResourceApiFactory = exports.VendorResourceApiFp = exports.VendorResourceApiAxiosParamCreator = exports.UserPreferencesControllerApi = exports.UserPreferencesControllerApiFactory = exports.UserPreferencesControllerApiFp = exports.UserPreferencesControllerApiAxiosParamCreator = exports.UserAccountControllerApi = exports.UserAccountControllerApiFactory = exports.UserAccountControllerApiFp = exports.UserAccountControllerApiAxiosParamCreator = exports.SolarPanelResourceApi = exports.SolarPanelResourceApiFactory = exports.SolarPanelResourceApiFp = exports.SolarPanelResourceApiAxiosParamCreator = exports.ShortcutsApi = exports.ShortcutsApiFactory = exports.ShortcutsApiFp = exports.ShortcutsApiAxiosParamCreator = exports.ShortcutResourceApi = exports.ShortcutResourceApiFactory = exports.ShortcutResourceApiFp = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ArticleSetDetailsDTOProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10',
    Connect: 'CONNECT'
};
exports.ArticleSetDetailsDTOArticleTypeEnum = {
    Adapter: 'ADAPTER',
    AuxiliarySet: 'AUXILIARY_SET',
    BallastBracket: 'BALLAST_BRACKET',
    BallastContainerLandscape: 'BALLAST_CONTAINER_LANDSCAPE',
    BallastContainerPortrait: 'BALLAST_CONTAINER_PORTRAIT',
    BallastContainerScrew: 'BALLAST_CONTAINER_SCREW',
    BasePlate: 'BASE_PLATE',
    BasePlateBracket: 'BASE_PLATE_BRACKET',
    BaseProfilePanel: 'BASE_PROFILE_PANEL',
    BaseProfileRow: 'BASE_PROFILE_ROW',
    BlackEndCap: 'BLACK_END_CAP',
    CableBracket: 'CABLE_BRACKET',
    CableClip: 'CABLE_CLIP',
    CableExitGuide: 'CABLE_EXIT_GUIDE',
    ColorCap: 'COLOR_CAP',
    CorrugatedMountingBracket: 'CORRUGATED_MOUNTING_BRACKET',
    CouplerScrew: 'COUPLER_SCREW',
    CouplingStrip: 'COUPLING_STRIP',
    EndCapWithoutClampSupport: 'END_CAP_WITHOUT_CLAMP_SUPPORT',
    EndClamp: 'END_CLAMP',
    EndClampSupports: 'END_CLAMP_SUPPORTS',
    EpdmAdapter: 'EPDM_ADAPTER',
    EpdmKit: 'EPDM_KIT',
    EpdmTape: 'EPDM_TAPE',
    Extender: 'EXTENDER',
    ExtraVerticalRailScrew: 'EXTRA_VERTICAL_RAIL_SCREW',
    GroundingBracket: 'GROUNDING_BRACKET',
    GroundingClip: 'GROUNDING_CLIP',
    GroundingScrewSideDeflector: 'GROUNDING_SCREW_SIDE_DEFLECTOR',
    GroundingSpringForBase: 'GROUNDING_SPRING_FOR_BASE',
    HangerBolt: 'HANGER_BOLT',
    HighBase: 'HIGH_BASE',
    LeftWindDeflectorLandscape: 'LEFT_WIND_DEFLECTOR_LANDSCAPE',
    LeftWindDeflectorPortrait: 'LEFT_WIND_DEFLECTOR_PORTRAIT',
    LockingScrew: 'LOCKING_SCREW',
    LowerClampScrewWithoutExtension: 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION',
    LowerClampScrewWithExtension: 'LOWER_CLAMP_SCREW_WITH_EXTENSION',
    LowerMountingScrewRearWindDeflector: 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    LowBase: 'LOW_BASE',
    LowBaseExtension: 'LOW_BASE_EXTENSION',
    MeasuringBar: 'MEASURING_BAR',
    MidClamp: 'MID_CLAMP',
    ModuleClamp: 'MODULE_CLAMP',
    ModuleSpacer: 'MODULE_SPACER',
    ModuleUnlockTool: 'MODULE_UNLOCK_TOOL',
    MountingProfiles: 'MOUNTING_PROFILES',
    MountingProfileLandscape: 'MOUNTING_PROFILE_LANDSCAPE',
    MountingProfilePortrait: 'MOUNTING_PROFILE_PORTRAIT',
    MountingProfileScrew: 'MOUNTING_PROFILE_SCREW',
    MountingRail: 'MOUNTING_RAIL',
    MountingRailCableClipOptimizer: 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER',
    MountingRailCoupler: 'MOUNTING_RAIL_COUPLER',
    MountingRailEndCap: 'MOUNTING_RAIL_END_CAP',
    MountingScrewLowerClampNoExtension: 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION',
    MountingScrewLowerClampWithExtension: 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION',
    MountingScrewPanel: 'MOUNTING_SCREW_PANEL',
    MountingScrewUpperClamp: 'MOUNTING_SCREW_UPPER_CLAMP',
    OldRailUnit2P: 'OLD_RAIL_UNIT_2P',
    PerimeterBracket: 'PERIMETER_BRACKET',
    PerimeterContainerExtension: 'PERIMETER_CONTAINER_EXTENSION',
    RafterScrew: 'RAFTER_SCREW',
    RailStartUnit4P: 'RAIL_START_UNIT_4P',
    RailUnit1P: 'RAIL_UNIT_1P',
    RailUnit2P: 'RAIL_UNIT_2P',
    RailUnit3P: 'RAIL_UNIT_3P',
    RailUnit4P: 'RAIL_UNIT_4P',
    RearWindDeflectorClip: 'REAR_WIND_DEFLECTOR_CLIP',
    RearWindDeflectorLandscape: 'REAR_WIND_DEFLECTOR_LANDSCAPE',
    RearWindDeflectorPortrait: 'REAR_WIND_DEFLECTOR_PORTRAIT',
    RightWindDeflectorLandscape: 'RIGHT_WIND_DEFLECTOR_LANDSCAPE',
    RightWindDeflectorPortrait: 'RIGHT_WIND_DEFLECTOR_PORTRAIT',
    Rivet: 'RIVET',
    RoofHook: 'ROOF_HOOK',
    RoofHookBolt: 'ROOF_HOOK_BOLT',
    RoofHookNut: 'ROOF_HOOK_NUT',
    RoofHookSpacer: 'ROOF_HOOK_SPACER',
    RoofSupport: 'ROOF_SUPPORT',
    RoofSupportScrew: 'ROOF_SUPPORT_SCREW',
    ScrewCap: 'SCREW_CAP',
    ScrewGroundingBracket: 'SCREW_GROUNDING_BRACKET',
    SeamClamp: 'SEAM_CLAMP',
    SelfDrillingScrew: 'SELF_DRILLING_SCREW',
    SheetScrews: 'SHEET_SCREWS',
    SideWindDeflectorScrew: 'SIDE_WIND_DEFLECTOR_SCREW',
    SlateRoofHook: 'SLATE_ROOF_HOOK',
    Stabilizer: 'STABILIZER',
    StabilizerScrew: 'STABILIZER_SCREW',
    SteelSupportScrew: 'STEEL_SUPPORT_SCREW',
    TixophalteKit: 'TIXOPHALTE_KIT',
    TorxBit: 'TORX_BIT',
    Mat: 'MAT',
    Tray: 'TRAY',
    UpperClampScrew: 'UPPER_CLAMP_SCREW',
    UpperMountingScrewRearWindDeflector: 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    Washers: 'WASHERS',
    WavePlusSideDeflectorClamps: 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS',
    WavePlusSideWindDeflectorSet: 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET',
    Coupler: 'COUPLER'
};
exports.BatchJobStatusDTOStatusEnum = {
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Running: 'RUNNING',
    NotRunBefore: 'NOT_RUN_BEFORE'
};
exports.CheckoutResultDtoCheckoutTypeEnum = {
    Javascript: 'JAVASCRIPT',
    Redirect: 'REDIRECT'
};
exports.DrawingFieldsShortcutFieldDtoOrientationEnum = {
    Portrait: 'PORTRAIT',
    Landscape: 'LANDSCAPE'
};
exports.DrawingFieldsShortcutFieldDtoRailSystemEnum = {
    Horizontal: 'HORIZONTAL',
    Vertical: 'VERTICAL',
    Cross: 'CROSS'
};
exports.DrawingFieldsShortcutFieldDtoPanelConfigurationEnum = {
    Single: 'SINGLE',
    Dual: 'DUAL'
};
exports.DrawingFieldsShortcutFieldDtoRowConnectorLengthEnum = {
    _0: 'ROW_CONNECTOR_LENGTH_0',
    _210: 'ROW_CONNECTOR_LENGTH_210',
    _320: 'ROW_CONNECTOR_LENGTH_320',
    _370: 'ROW_CONNECTOR_LENGTH_370',
    _500: 'ROW_CONNECTOR_LENGTH_500',
    _550: 'ROW_CONNECTOR_LENGTH_550',
    _700: 'ROW_CONNECTOR_LENGTH_700',
    _750: 'ROW_CONNECTOR_LENGTH_750',
    _940: 'ROW_CONNECTOR_LENGTH_940'
};
exports.DrawingFieldsShortcutRoofDtoProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    Connect: 'CONNECT'
};
exports.DrawingFieldsShortcutRoofDtoMaterialEnum = {
    Tiles: 'TILES',
    ArabicTiles: 'ARABIC_TILES',
    Epdm: 'EPDM',
    Slate: 'SLATE',
    Corrugated: 'CORRUGATED',
    CorrugatedSteel: 'CORRUGATED_STEEL',
    BitumenInsulated: 'BITUMEN_INSULATED',
    BitumenUninsulated: 'BITUMEN_UNINSULATED',
    StandingSeam: 'STANDING_SEAM',
    Pvc: 'PVC',
    Tpo: 'TPO',
    Steel: 'STEEL',
    Other: 'OTHER',
    Flange: 'FLANGE',
    Kalzip: 'KALZIP'
};
exports.DrawingFieldsShortcutRoofDtoClampTypeEnum = {
    Universal: 'UNIVERSAL',
    Wide: 'WIDE'
};
exports.DrawingFieldsShortcutRoofDtoAttachmentTypeEnum = {
    Supports: 'SUPPORTS',
    DowelScrews: 'DOWEL_SCREWS',
    SlateHooks: 'SLATE_HOOKS',
    CorrugatedBrackets: 'CORRUGATED_BRACKETS',
    MountingProfiles: 'MOUNTING_PROFILES'
};
exports.DrawingFieldsShortcutRoofDtoRoofStructureEnum = {
    Purlins: 'PURLINS',
    Rafters: 'RAFTERS',
    Solid: 'SOLID'
};
exports.DrawingFieldsShortcutRoofDtoHookTypeEnum = {
    Normal: 'NORMAL',
    Truss: 'TRUSS',
    Pro: 'PRO'
};
exports.EngineErrorDtoProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10'
};
exports.FieldDTOOrientationEnum = {
    Portrait: 'PORTRAIT',
    Landscape: 'LANDSCAPE'
};
exports.FieldDTOSidePlatesOptionEnum = {
    On: 'ON',
    Off: 'OFF',
    Optimized: 'OPTIMIZED'
};
exports.FieldDTORailSystemEnum = {
    Vertical: 'VERTICAL',
    Horizontal: 'HORIZONTAL',
    Cross: 'CROSS'
};
exports.FieldDTOModuleConfigurationEnum = {
    Single: 'SINGLE',
    Dual: 'DUAL'
};
exports.FieldDTOCableExitGuideChoiceEnum = {
    NoCableExitGuides: 'NO_CABLE_EXIT_GUIDES',
    LeftSide: 'LEFT_SIDE',
    RightSide: 'RIGHT_SIDE',
    BothSides: 'BOTH_SIDES'
};
exports.FieldDtoRailSystemEnum = {
    Horizontal: 'HORIZONTAL',
    Vertical: 'VERTICAL',
    Cross: 'CROSS'
};
exports.FieldDtoPanelConfigurationEnum = {
    Single: 'SINGLE',
    Dual: 'DUAL'
};
exports.FieldDtoRowDistanceEnum = {
    _1320: 'ROW_DISTANCE_1320',
    _1500: 'ROW_DISTANCE_1500',
    _1700: 'ROW_DISTANCE_1700',
    _1890: 'ROW_DISTANCE_1890',
    _2100: 'ROW_DISTANCE_2100',
    _2260: 'ROW_DISTANCE_2260',
    _2440: 'ROW_DISTANCE_2440',
    _2640: 'ROW_DISTANCE_2640',
    _2830: 'ROW_DISTANCE_2830'
};
exports.FieldDtoOrientationEnum = {
    Portrait: 'PORTRAIT',
    Landscape: 'LANDSCAPE'
};
exports.FieldDtoCableExitGuideChoiceEnum = {
    NoCableExitGuides: 'NO_CABLE_EXIT_GUIDES',
    LeftSide: 'LEFT_SIDE',
    RightSide: 'RIGHT_SIDE',
    BothSides: 'BOTH_SIDES'
};
exports.FieldDtoRowConnectorLengthEnum = {
    _0: 'ROW_CONNECTOR_LENGTH_0',
    _210: 'ROW_CONNECTOR_LENGTH_210',
    _320: 'ROW_CONNECTOR_LENGTH_320',
    _370: 'ROW_CONNECTOR_LENGTH_370',
    _500: 'ROW_CONNECTOR_LENGTH_500',
    _550: 'ROW_CONNECTOR_LENGTH_550',
    _700: 'ROW_CONNECTOR_LENGTH_700',
    _750: 'ROW_CONNECTOR_LENGTH_750',
    _940: 'ROW_CONNECTOR_LENGTH_940'
};
exports.IdentityDTOTypeEnum = {
    Api: 'API',
    Basic: 'BASIC',
    Enstall: 'ENSTALL',
    Vendor: 'VENDOR'
};
exports.IdentityDTOBusinessUnitsEnum = {
    Esdec: 'ESDEC',
    Cpx: 'CPX',
    Blubase: 'BLUBASE'
};
exports.ModuleDTOTypeEnum = {
    Standard: 'STANDARD',
    Dual: 'DUAL',
    EastHalf: 'EAST_HALF',
    WestHalf: 'WEST_HALF'
};
exports.ModuleSidePlatePlacementDTOSidePlatePlacementEnum = {
    North: 'NORTH',
    South: 'SOUTH',
    Double: 'DOUBLE',
    None: 'NONE'
};
exports.ProductOptionDTOApplicableProductsEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10',
    Connect: 'CONNECT'
};
exports.ProjectDTOStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Finalizing: 'FINALIZING',
    Error: 'ERROR',
    Discontinued: 'DISCONTINUED'
};
exports.RegisterIdentityDTOTypeEnum = {
    Api: 'API',
    Basic: 'BASIC',
    Enstall: 'ENSTALL',
    Vendor: 'VENDOR'
};
exports.RegisterIdentityDTOBusinessUnitsEnum = {
    Esdec: 'ESDEC',
    Cpx: 'CPX',
    Blubase: 'BLUBASE'
};
exports.RoofDTOTypeEnum = {
    Flat: 'FLAT',
    Sloped: 'SLOPED'
};
exports.RoofDTOSideEnum = {
    Windward: 'WINDWARD',
    Leeward: 'LEEWARD'
};
exports.RoofDTOClampTypeEnum = {
    Universal: 'UNIVERSAL',
    Wide: 'WIDE'
};
exports.RoofDTOPreferredProductColorEnum = {
    Grey: 'GREY',
    Black: 'BLACK'
};
exports.RoofDTOPreferredProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10'
};
exports.RoofDTOChosenAttachmentTypeEnum = {
    Supports: 'SUPPORTS',
    HangerBolts: 'HANGER_BOLTS',
    SlateHooks: 'SLATE_HOOKS',
    CorrugatedBrackets: 'CORRUGATED_BRACKETS',
    MountingProfiles: 'MOUNTING_PROFILES'
};
exports.RoofDTONumberOfPanelsPerOptimizerEnum = {
    Zero: 'ZERO',
    One: 'ONE',
    Two: 'TWO',
    Four: 'FOUR'
};
exports.RoofDTOClipTypeEnum = {
    None: 'NONE',
    Light: 'LIGHT',
    Heavy: 'HEAVY'
};
exports.RoofDTOWindzoneEnum = {
    BeZone1: 'BE_ZONE_1',
    BeZone2: 'BE_ZONE_2',
    BeZone3: 'BE_ZONE_3',
    BeZone4: 'BE_ZONE_4',
    DeZone1: 'DE_ZONE_1',
    DeZone2: 'DE_ZONE_2',
    DeZone3: 'DE_ZONE_3',
    DeZone4: 'DE_ZONE_4',
    FrZone1: 'FR_ZONE_1',
    FrZone2: 'FR_ZONE_2',
    FrZone3: 'FR_ZONE_3',
    FrZone4: 'FR_ZONE_4',
    InZone1: 'IN_ZONE_1',
    InZone2: 'IN_ZONE_2',
    InZone3: 'IN_ZONE_3',
    InZone4: 'IN_ZONE_4',
    InZone5: 'IN_ZONE_5',
    InZone6: 'IN_ZONE_6',
    NlZone1: 'NL_ZONE_1',
    NlZone2: 'NL_ZONE_2',
    NlZone3: 'NL_ZONE_3',
    NoneSelected: 'NONE_SELECTED',
    PtZoneA: 'PT_ZONE_A',
    PtZoneB: 'PT_ZONE_B',
    SpZoneA: 'SP_ZONE_A',
    SpZoneB: 'SP_ZONE_B',
    SpZoneC: 'SP_ZONE_C',
    SvZone21: 'SV_ZONE_21',
    SvZone22: 'SV_ZONE_22',
    SvZone23: 'SV_ZONE_23',
    SvZone24: 'SV_ZONE_24',
    SvZone25: 'SV_ZONE_25',
    SvZone26: 'SV_ZONE_26',
    PlZone1: 'PL_ZONE_1',
    PlZone2: 'PL_ZONE_2',
    PlZone3: 'PL_ZONE_3',
    PlBorderZone12: 'PL_BORDER_ZONE_1_2',
    DkZone24: 'DK_ZONE_24',
    DkZone25: 'DK_ZONE_25',
    DkZone26: 'DK_ZONE_26',
    DkZone27: 'DK_ZONE_27'
};
exports.RoofDTOSnowzoneEnum = {
    Germany1: 'GERMANY_1',
    Germany1A: 'GERMANY_1_A',
    Germany2: 'GERMANY_2',
    Germany2A: 'GERMANY_2_A',
    Germany3: 'GERMANY_3',
    Germany3A: 'GERMANY_3_A',
    GermanyGt3A: 'GERMANY_GT_3_A',
    Sweden10: 'SWEDEN_1_0',
    Sweden15: 'SWEDEN_1_5',
    Sweden20: 'SWEDEN_2_0',
    Sweden25: 'SWEDEN_2_5',
    Sweden30: 'SWEDEN_3_0',
    Sweden35: 'SWEDEN_3_5',
    Sweden45: 'SWEDEN_4_5',
    Sweden55: 'SWEDEN_5_5',
    Spain1: 'SPAIN_1',
    Spain2: 'SPAIN_2',
    Spain3: 'SPAIN_3',
    Spain4: 'SPAIN_4',
    Spain5: 'SPAIN_5',
    Spain6: 'SPAIN_6',
    Spain7: 'SPAIN_7',
    PortugalZ1: 'PORTUGAL_Z_1',
    PortugalZ2: 'PORTUGAL_Z_2',
    PortugalZ3: 'PORTUGAL_Z_3',
    FranceA1: 'FRANCE_A1',
    FranceA2: 'FRANCE_A2',
    FranceB1: 'FRANCE_B1',
    FranceB2: 'FRANCE_B2',
    FranceC1: 'FRANCE_C1',
    FranceC2: 'FRANCE_C2',
    FranceD: 'FRANCE_D',
    FranceE: 'FRANCE_E',
    Poland1: 'POLAND_1',
    Poland2: 'POLAND_2',
    Poland3: 'POLAND_3',
    Poland4: 'POLAND_4',
    Poland5: 'POLAND_5',
    Uk1: 'UK_1',
    Uk2: 'UK_2',
    Uk3: 'UK_3',
    Uk4: 'UK_4',
    Uk5: 'UK_5',
    Uk65: 'UK_6_5',
    Ireland04: 'IRELAND_0_4',
    Ireland05: 'IRELAND_0_5',
    Ireland06: 'IRELAND_0_6',
    Ireland07: 'IRELAND_0_7'
};
exports.RoofDTOTerrainCategoryEnum = {
    EuCategory0: 'EU_CATEGORY_0',
    EuCategory1: 'EU_CATEGORY_1',
    EuCategory2: 'EU_CATEGORY_2',
    EuCategory3: 'EU_CATEGORY_3',
    EuCategory4: 'EU_CATEGORY_4',
    EuCategory5: 'EU_CATEGORY_5',
    MixedProfile1: 'MIXED_PROFILE_1',
    MixedProfile2: 'MIXED_PROFILE_2',
    MixedProfile3: 'MIXED_PROFILE_3',
    France0: 'FRANCE_0',
    France2: 'FRANCE_2',
    France3A: 'FRANCE_3_A',
    France3B: 'FRANCE_3_B',
    France4: 'FRANCE_4',
    Portugal1: 'PORTUGAL_1',
    Portugal2: 'PORTUGAL_2',
    Portugal3: 'PORTUGAL_3',
    Portugal4: 'PORTUGAL_4',
    UkSea: 'UK_SEA',
    UkTown: 'UK_TOWN',
    UkCountry: 'UK_COUNTRY',
    IeSea: 'IE_SEA',
    IeTown: 'IE_TOWN',
    IeCountry: 'IE_COUNTRY',
    NoneSelected: 'NONE_SELECTED'
};
exports.RoofDTOMaterialEnum = {
    Tiles: 'TILES',
    ArabicTiles: 'ARABIC_TILES',
    Epdm: 'EPDM',
    Slate: 'SLATE',
    Corrugated: 'CORRUGATED',
    BitumenInsulated: 'BITUMEN_INSULATED',
    BitumenUninsulated: 'BITUMEN_UNINSULATED',
    StandingSeam: 'STANDING_SEAM',
    Pvc: 'PVC',
    Tpo: 'TPO',
    Steel: 'STEEL',
    Other: 'OTHER',
    NoneSelected: 'NONE_SELECTED'
};
exports.RoofDTOHookSizeEnum = {
    Standard: 'STANDARD',
    Multi: 'MULTI',
    Medium: 'MEDIUM',
    Wide: 'WIDE'
};
exports.RoofDTOHookTypeEnum = {
    Normal: 'NORMAL',
    Truss: 'TRUSS',
    Hv: 'HV',
    Hvg: 'HVG',
    Pro: 'PRO'
};
exports.RoofDTOConsequenceClassEnum = {
    Cc1: 'CC1',
    Cc2: 'CC2',
    Cc3: 'CC3'
};
exports.RoofDTOHighBuildingSafetyFactorOptionEnum = {
    Automatic: 'AUTOMATIC',
    Manual: 'MANUAL',
    Off: 'OFF'
};
exports.RoofDTOGroundingOptionEnum = {
    Off: 'OFF',
    ModulesOnly: 'MODULES_ONLY',
    All: 'ALL'
};
exports.RoofDTOSeamTypeEnum = {
    SingleFolded: 'SINGLE_FOLDED',
    DoubleFolded: 'DOUBLE_FOLDED',
    Rounded: 'ROUNDED',
    Snap: 'SNAP'
};
exports.RoofDTOSteelTypeEnum = {
    Trapezoidal: 'TRAPEZOIDAL',
    Corrugated: 'CORRUGATED',
    TiledSheets: 'TILED_SHEETS'
};
exports.RoofDTORoofStructureEnum = {
    Purlins: 'PURLINS',
    Rafters: 'RAFTERS',
    Solid: 'SOLID'
};
exports.RoofDTOBallastElementEnum = {
    ConcreteSlab4Kg: 'CONCRETE_SLAB_4KG',
    ConcreteSlab36Kg: 'CONCRETE_SLAB_3_6KG',
    Custom: 'CUSTOM'
};
exports.RoofDTOPreferredFastenerEnum = {
    ScrewMount: 'SCREW_MOUNT',
    RivetMount: 'RIVET_MOUNT'
};
exports.RoofDTOTopographyEnum = {
    Windswept: 'WINDSWEPT',
    Normal: 'NORMAL',
    Sheltered: 'SHELTERED'
};
exports.RoofDTODualRailUnitChoiceEnum = {
    Mix4P2P: 'MIX_4P_2P',
    Only2P: 'ONLY_2P'
};
exports.RoofDTOSteelThicknessEnum = {
    _05To10: 'THICKNESS_0_5_TO_1_0',
    _11To15: 'THICKNESS_1_1_TO_1_5',
    Gt15: 'THICKNESS_GT_1_5'
};
exports.RoofDTOStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Finalizing: 'FINALIZING',
    Error: 'ERROR',
    Discontinued: 'DISCONTINUED'
};
exports.RoofDtoProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    Connect: 'CONNECT'
};
exports.RoofDtoCountryEnum = {
    Belgium: 'BELGIUM',
    Eurocode: 'EUROCODE',
    Finland: 'FINLAND',
    France: 'FRANCE',
    Germany: 'GERMANY',
    Netherlands: 'NETHERLANDS',
    Norway: 'NORWAY',
    Poland: 'POLAND',
    Portugal: 'PORTUGAL',
    Spain: 'SPAIN',
    Sweden: 'SWEDEN',
    Denmark: 'DENMARK',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND'
};
exports.RoofDtoClampTypeEnum = {
    Universal: 'UNIVERSAL',
    Wide: 'WIDE'
};
exports.RoofDtoMaterialEnum = {
    Tiles: 'TILES',
    ArabicTiles: 'ARABIC_TILES',
    Epdm: 'EPDM',
    Slate: 'SLATE',
    Corrugated: 'CORRUGATED',
    CorrugatedSteel: 'CORRUGATED_STEEL',
    BitumenInsulated: 'BITUMEN_INSULATED',
    BitumenUninsulated: 'BITUMEN_UNINSULATED',
    StandingSeam: 'STANDING_SEAM',
    Pvc: 'PVC',
    Tpo: 'TPO',
    Steel: 'STEEL',
    Other: 'OTHER',
    Flange: 'FLANGE',
    Kalzip: 'KALZIP'
};
exports.RoofDtoTypeEnum = {
    Flat: 'FLAT',
    Sloped: 'SLOPED'
};
exports.RoofDtoSideEnum = {
    Windward: 'WINDWARD',
    Leeward: 'LEEWARD'
};
exports.RoofDtoWindzoneEnum = {
    NlZone1: 'NL_ZONE_1',
    NlZone2: 'NL_ZONE_2',
    NlZone3: 'NL_ZONE_3',
    BeZone1: 'BE_ZONE_1',
    BeZone2: 'BE_ZONE_2',
    BeZone3: 'BE_ZONE_3',
    BeZone4: 'BE_ZONE_4',
    DeZone1: 'DE_ZONE_1',
    DeZone2: 'DE_ZONE_2',
    DeZone3: 'DE_ZONE_3',
    DeZone4: 'DE_ZONE_4',
    FrZone1: 'FR_ZONE_1',
    FrZone2: 'FR_ZONE_2',
    FrZone3: 'FR_ZONE_3',
    FrZone4: 'FR_ZONE_4',
    SpZoneA: 'SP_ZONE_A',
    SpZoneB: 'SP_ZONE_B',
    SpZoneC: 'SP_ZONE_C',
    SvZone21: 'SV_ZONE_21',
    SvZone22: 'SV_ZONE_22',
    SvZone23: 'SV_ZONE_23',
    SvZone24: 'SV_ZONE_24',
    SvZone25: 'SV_ZONE_25',
    SvZone26: 'SV_ZONE_26',
    PlZone1: 'PL_ZONE_1',
    PlZone2: 'PL_ZONE_2',
    PlZone3: 'PL_ZONE_3',
    PlBorderZone12: 'PL_BORDER_ZONE_1_2',
    DkZone24: 'DK_ZONE_24',
    DkZone25: 'DK_ZONE_25',
    DkZone26: 'DK_ZONE_26',
    DkZone27: 'DK_ZONE_27'
};
exports.RoofDtoTerrainCategoryEnum = {
    EuCategory0: 'EU_CATEGORY_0',
    EuCategory1: 'EU_CATEGORY_1',
    EuCategory2: 'EU_CATEGORY_2',
    EuCategory3: 'EU_CATEGORY_3',
    EuCategory4: 'EU_CATEGORY_4',
    EuCategory5: 'EU_CATEGORY_5',
    France0: 'FRANCE_0',
    France2: 'FRANCE_2',
    France3A: 'FRANCE_3_A',
    France3B: 'FRANCE_3_B',
    France4: 'FRANCE_4',
    MixedProfile1: 'MIXED_PROFILE_1',
    MixedProfile2: 'MIXED_PROFILE_2',
    MixedProfile3: 'MIXED_PROFILE_3',
    Portugal1: 'PORTUGAL_1',
    Portugal2: 'PORTUGAL_2',
    Portugal3: 'PORTUGAL_3',
    Portugal4: 'PORTUGAL_4',
    UkSea: 'UK_SEA',
    UkTown: 'UK_TOWN',
    UkCountry: 'UK_COUNTRY',
    IeSea: 'IE_SEA',
    IeTown: 'IE_TOWN',
    IeCountry: 'IE_COUNTRY'
};
exports.RoofDtoAttachmentTypeEnum = {
    Supports: 'SUPPORTS',
    DowelScrews: 'DOWEL_SCREWS',
    SlateHooks: 'SLATE_HOOKS',
    CorrugatedBrackets: 'CORRUGATED_BRACKETS',
    MountingProfiles: 'MOUNTING_PROFILES'
};
exports.RoofDtoHookTypeEnum = {
    Normal: 'NORMAL',
    Truss: 'TRUSS',
    Pro: 'PRO',
    Hv: 'HV',
    Hvg: 'HVG'
};
exports.RoofDtoHookSizeTypeEnum = {
    Standard: 'STANDARD',
    Multi: 'MULTI',
    Medium: 'MEDIUM',
    Wide: 'WIDE'
};
exports.RoofDtoNumberOfPanelsPerOptimizerEnum = {
    Zero: 'ZERO',
    One: 'ONE',
    Two: 'TWO',
    Four: 'FOUR'
};
exports.RoofDtoMlpeClipEnum = {
    None: 'NONE',
    Light: 'LIGHT',
    Heavy: 'HEAVY'
};
exports.RoofDtoConsequenceClassEnum = {
    Cc1: 'CC1',
    Cc2: 'CC2',
    Cc3: 'CC3'
};
exports.RoofDtoGroundingOptionEnum = {
    Off: 'OFF',
    ModulesOnly: 'MODULES_ONLY',
    All: 'ALL'
};
exports.RoofDtoSnowzoneEnum = {
    Germany1: 'GERMANY_1',
    Germany1A: 'GERMANY_1_A',
    Germany2: 'GERMANY_2',
    Germany2A: 'GERMANY_2_A',
    Germany3: 'GERMANY_3',
    Germany3A: 'GERMANY_3_A',
    GermanyGt3A: 'GERMANY_GT_3_A',
    Sweden10: 'SWEDEN_1_0',
    Sweden15: 'SWEDEN_1_5',
    Sweden20: 'SWEDEN_2_0',
    Sweden25: 'SWEDEN_2_5',
    Sweden30: 'SWEDEN_3_0',
    Sweden35: 'SWEDEN_3_5',
    Sweden45: 'SWEDEN_4_5',
    Sweden55: 'SWEDEN_5_5',
    Spain1: 'SPAIN_1',
    Spain2: 'SPAIN_2',
    Spain3: 'SPAIN_3',
    Spain4: 'SPAIN_4',
    Spain5: 'SPAIN_5',
    Spain6: 'SPAIN_6',
    Spain7: 'SPAIN_7',
    PortugalZ1: 'PORTUGAL_Z_1',
    PortugalZ2: 'PORTUGAL_Z_2',
    PortugalZ3: 'PORTUGAL_Z_3',
    FranceA1: 'FRANCE_A1',
    FranceA2: 'FRANCE_A2',
    FranceB1: 'FRANCE_B1',
    FranceB2: 'FRANCE_B2',
    FranceC1: 'FRANCE_C1',
    FranceC2: 'FRANCE_C2',
    FranceD: 'FRANCE_D',
    FranceE: 'FRANCE_E',
    Poland1: 'POLAND_1',
    Poland2: 'POLAND_2',
    Poland3: 'POLAND_3',
    Poland4: 'POLAND_4',
    Poland5: 'POLAND_5',
    Uk1: 'UK_1',
    Uk2: 'UK_2',
    Uk3: 'UK_3',
    Uk4: 'UK_4',
    Uk5: 'UK_5',
    Uk65: 'UK_6_5',
    Ireland04: 'IRELAND_0_4',
    Ireland05: 'IRELAND_0_5',
    Ireland06: 'IRELAND_0_6',
    Ireland07: 'IRELAND_0_7'
};
exports.RoofDtoSteelTypeEnum = {
    Trapezoidal: 'TRAPEZOIDAL',
    Corrugated: 'CORRUGATED',
    TiledSheets: 'TILED_SHEETS'
};
exports.RoofDtoSeamTypeEnum = {
    SingleFolded: 'SINGLE_FOLDED',
    DoubleFolded: 'DOUBLE_FOLDED',
    Rounded: 'ROUNDED',
    Snap: 'SNAP'
};
exports.RoofDtoRoofStructureEnum = {
    Purlins: 'PURLINS',
    Rafters: 'RAFTERS',
    Solid: 'SOLID'
};
exports.RoofDtoPreferredFastenerEnum = {
    ScrewMount: 'SCREW_MOUNT',
    RivetMount: 'RIVET_MOUNT'
};
exports.RoofDtoBallastElementEnum = {
    _4Kg: 'CONCRETE_SLAB_4KG',
    _36Kg: 'CONCRETE_SLAB_3_6KG'
};
exports.RoofDtoTopographyEnum = {
    Windswept: 'WINDSWEPT',
    Normal: 'NORMAL',
    Sheltered: 'SHELTERED'
};
exports.RoofDtoSteelThicknessEnum = {
    _05To10: 'THICKNESS_0_5_TO_1_0',
    _11To15: 'THICKNESS_1_1_TO_1_5',
    Gt15: 'THICKNESS_GT_1_5'
};
exports.RoofDtoDualRailUnitChoiceEnum = {
    _1P: 'ONLY_1P',
    _2P: 'ONLY_2P'
};
exports.RoofStatusDTOStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Finalizing: 'FINALIZING',
    Error: 'ERROR',
    Discontinued: 'DISCONTINUED'
};
exports.RoofSummaryDTOStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Finalizing: 'FINALIZING',
    Error: 'ERROR',
    Discontinued: 'DISCONTINUED'
};
exports.RoofSummaryDTOWindzoneEnum = {
    BeZone1: 'BE_ZONE_1',
    BeZone2: 'BE_ZONE_2',
    BeZone3: 'BE_ZONE_3',
    BeZone4: 'BE_ZONE_4',
    DeZone1: 'DE_ZONE_1',
    DeZone2: 'DE_ZONE_2',
    DeZone3: 'DE_ZONE_3',
    DeZone4: 'DE_ZONE_4',
    FrZone1: 'FR_ZONE_1',
    FrZone2: 'FR_ZONE_2',
    FrZone3: 'FR_ZONE_3',
    FrZone4: 'FR_ZONE_4',
    InZone1: 'IN_ZONE_1',
    InZone2: 'IN_ZONE_2',
    InZone3: 'IN_ZONE_3',
    InZone4: 'IN_ZONE_4',
    InZone5: 'IN_ZONE_5',
    InZone6: 'IN_ZONE_6',
    NlZone1: 'NL_ZONE_1',
    NlZone2: 'NL_ZONE_2',
    NlZone3: 'NL_ZONE_3',
    NoneSelected: 'NONE_SELECTED',
    PtZoneA: 'PT_ZONE_A',
    PtZoneB: 'PT_ZONE_B',
    SpZoneA: 'SP_ZONE_A',
    SpZoneB: 'SP_ZONE_B',
    SpZoneC: 'SP_ZONE_C',
    SvZone21: 'SV_ZONE_21',
    SvZone22: 'SV_ZONE_22',
    SvZone23: 'SV_ZONE_23',
    SvZone24: 'SV_ZONE_24',
    SvZone25: 'SV_ZONE_25',
    SvZone26: 'SV_ZONE_26',
    PlZone1: 'PL_ZONE_1',
    PlZone2: 'PL_ZONE_2',
    PlZone3: 'PL_ZONE_3',
    PlBorderZone12: 'PL_BORDER_ZONE_1_2',
    DkZone24: 'DK_ZONE_24',
    DkZone25: 'DK_ZONE_25',
    DkZone26: 'DK_ZONE_26',
    DkZone27: 'DK_ZONE_27'
};
exports.RoofSummaryDTOTerrainCategoryEnum = {
    EuCategory0: 'EU_CATEGORY_0',
    EuCategory1: 'EU_CATEGORY_1',
    EuCategory2: 'EU_CATEGORY_2',
    EuCategory3: 'EU_CATEGORY_3',
    EuCategory4: 'EU_CATEGORY_4',
    EuCategory5: 'EU_CATEGORY_5',
    MixedProfile1: 'MIXED_PROFILE_1',
    MixedProfile2: 'MIXED_PROFILE_2',
    MixedProfile3: 'MIXED_PROFILE_3',
    France0: 'FRANCE_0',
    France2: 'FRANCE_2',
    France3A: 'FRANCE_3_A',
    France3B: 'FRANCE_3_B',
    France4: 'FRANCE_4',
    Portugal1: 'PORTUGAL_1',
    Portugal2: 'PORTUGAL_2',
    Portugal3: 'PORTUGAL_3',
    Portugal4: 'PORTUGAL_4',
    UkSea: 'UK_SEA',
    UkTown: 'UK_TOWN',
    UkCountry: 'UK_COUNTRY',
    IeSea: 'IE_SEA',
    IeTown: 'IE_TOWN',
    IeCountry: 'IE_COUNTRY',
    NoneSelected: 'NONE_SELECTED'
};
exports.RoofSummaryDTOProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10'
};
exports.RoofWithArticlesDTOTypeEnum = {
    Flat: 'FLAT',
    Sloped: 'SLOPED'
};
exports.RoofWithArticlesDTOSideEnum = {
    Windward: 'WINDWARD',
    Leeward: 'LEEWARD'
};
exports.RoofWithArticlesDTOClampTypeEnum = {
    Universal: 'UNIVERSAL',
    Wide: 'WIDE'
};
exports.RoofWithArticlesDTOPreferredProductColorEnum = {
    Grey: 'GREY',
    Black: 'BLACK'
};
exports.RoofWithArticlesDTOPreferredProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10'
};
exports.RoofWithArticlesDTOChosenAttachmentTypeEnum = {
    Supports: 'SUPPORTS',
    HangerBolts: 'HANGER_BOLTS',
    SlateHooks: 'SLATE_HOOKS',
    CorrugatedBrackets: 'CORRUGATED_BRACKETS',
    MountingProfiles: 'MOUNTING_PROFILES'
};
exports.RoofWithArticlesDTONumberOfPanelsPerOptimizerEnum = {
    Zero: 'ZERO',
    One: 'ONE',
    Two: 'TWO',
    Four: 'FOUR'
};
exports.RoofWithArticlesDTOClipTypeEnum = {
    None: 'NONE',
    Light: 'LIGHT',
    Heavy: 'HEAVY'
};
exports.RoofWithArticlesDTOWindzoneEnum = {
    BeZone1: 'BE_ZONE_1',
    BeZone2: 'BE_ZONE_2',
    BeZone3: 'BE_ZONE_3',
    BeZone4: 'BE_ZONE_4',
    DeZone1: 'DE_ZONE_1',
    DeZone2: 'DE_ZONE_2',
    DeZone3: 'DE_ZONE_3',
    DeZone4: 'DE_ZONE_4',
    FrZone1: 'FR_ZONE_1',
    FrZone2: 'FR_ZONE_2',
    FrZone3: 'FR_ZONE_3',
    FrZone4: 'FR_ZONE_4',
    InZone1: 'IN_ZONE_1',
    InZone2: 'IN_ZONE_2',
    InZone3: 'IN_ZONE_3',
    InZone4: 'IN_ZONE_4',
    InZone5: 'IN_ZONE_5',
    InZone6: 'IN_ZONE_6',
    NlZone1: 'NL_ZONE_1',
    NlZone2: 'NL_ZONE_2',
    NlZone3: 'NL_ZONE_3',
    NoneSelected: 'NONE_SELECTED',
    PtZoneA: 'PT_ZONE_A',
    PtZoneB: 'PT_ZONE_B',
    SpZoneA: 'SP_ZONE_A',
    SpZoneB: 'SP_ZONE_B',
    SpZoneC: 'SP_ZONE_C',
    SvZone21: 'SV_ZONE_21',
    SvZone22: 'SV_ZONE_22',
    SvZone23: 'SV_ZONE_23',
    SvZone24: 'SV_ZONE_24',
    SvZone25: 'SV_ZONE_25',
    SvZone26: 'SV_ZONE_26',
    PlZone1: 'PL_ZONE_1',
    PlZone2: 'PL_ZONE_2',
    PlZone3: 'PL_ZONE_3',
    PlBorderZone12: 'PL_BORDER_ZONE_1_2',
    DkZone24: 'DK_ZONE_24',
    DkZone25: 'DK_ZONE_25',
    DkZone26: 'DK_ZONE_26',
    DkZone27: 'DK_ZONE_27'
};
exports.RoofWithArticlesDTOSnowzoneEnum = {
    Germany1: 'GERMANY_1',
    Germany1A: 'GERMANY_1_A',
    Germany2: 'GERMANY_2',
    Germany2A: 'GERMANY_2_A',
    Germany3: 'GERMANY_3',
    Germany3A: 'GERMANY_3_A',
    GermanyGt3A: 'GERMANY_GT_3_A',
    Sweden10: 'SWEDEN_1_0',
    Sweden15: 'SWEDEN_1_5',
    Sweden20: 'SWEDEN_2_0',
    Sweden25: 'SWEDEN_2_5',
    Sweden30: 'SWEDEN_3_0',
    Sweden35: 'SWEDEN_3_5',
    Sweden45: 'SWEDEN_4_5',
    Sweden55: 'SWEDEN_5_5',
    Spain1: 'SPAIN_1',
    Spain2: 'SPAIN_2',
    Spain3: 'SPAIN_3',
    Spain4: 'SPAIN_4',
    Spain5: 'SPAIN_5',
    Spain6: 'SPAIN_6',
    Spain7: 'SPAIN_7',
    PortugalZ1: 'PORTUGAL_Z_1',
    PortugalZ2: 'PORTUGAL_Z_2',
    PortugalZ3: 'PORTUGAL_Z_3',
    FranceA1: 'FRANCE_A1',
    FranceA2: 'FRANCE_A2',
    FranceB1: 'FRANCE_B1',
    FranceB2: 'FRANCE_B2',
    FranceC1: 'FRANCE_C1',
    FranceC2: 'FRANCE_C2',
    FranceD: 'FRANCE_D',
    FranceE: 'FRANCE_E',
    Poland1: 'POLAND_1',
    Poland2: 'POLAND_2',
    Poland3: 'POLAND_3',
    Poland4: 'POLAND_4',
    Poland5: 'POLAND_5',
    Uk1: 'UK_1',
    Uk2: 'UK_2',
    Uk3: 'UK_3',
    Uk4: 'UK_4',
    Uk5: 'UK_5',
    Uk65: 'UK_6_5',
    Ireland04: 'IRELAND_0_4',
    Ireland05: 'IRELAND_0_5',
    Ireland06: 'IRELAND_0_6',
    Ireland07: 'IRELAND_0_7'
};
exports.RoofWithArticlesDTOTerrainCategoryEnum = {
    EuCategory0: 'EU_CATEGORY_0',
    EuCategory1: 'EU_CATEGORY_1',
    EuCategory2: 'EU_CATEGORY_2',
    EuCategory3: 'EU_CATEGORY_3',
    EuCategory4: 'EU_CATEGORY_4',
    EuCategory5: 'EU_CATEGORY_5',
    MixedProfile1: 'MIXED_PROFILE_1',
    MixedProfile2: 'MIXED_PROFILE_2',
    MixedProfile3: 'MIXED_PROFILE_3',
    France0: 'FRANCE_0',
    France2: 'FRANCE_2',
    France3A: 'FRANCE_3_A',
    France3B: 'FRANCE_3_B',
    France4: 'FRANCE_4',
    Portugal1: 'PORTUGAL_1',
    Portugal2: 'PORTUGAL_2',
    Portugal3: 'PORTUGAL_3',
    Portugal4: 'PORTUGAL_4',
    UkSea: 'UK_SEA',
    UkTown: 'UK_TOWN',
    UkCountry: 'UK_COUNTRY',
    IeSea: 'IE_SEA',
    IeTown: 'IE_TOWN',
    IeCountry: 'IE_COUNTRY',
    NoneSelected: 'NONE_SELECTED'
};
exports.RoofWithArticlesDTOMaterialEnum = {
    Tiles: 'TILES',
    ArabicTiles: 'ARABIC_TILES',
    Epdm: 'EPDM',
    Slate: 'SLATE',
    Corrugated: 'CORRUGATED',
    BitumenInsulated: 'BITUMEN_INSULATED',
    BitumenUninsulated: 'BITUMEN_UNINSULATED',
    StandingSeam: 'STANDING_SEAM',
    Pvc: 'PVC',
    Tpo: 'TPO',
    Steel: 'STEEL',
    Other: 'OTHER',
    NoneSelected: 'NONE_SELECTED'
};
exports.RoofWithArticlesDTOHookSizeEnum = {
    Standard: 'STANDARD',
    Multi: 'MULTI',
    Medium: 'MEDIUM',
    Wide: 'WIDE'
};
exports.RoofWithArticlesDTOHookTypeEnum = {
    Normal: 'NORMAL',
    Truss: 'TRUSS',
    Hv: 'HV',
    Hvg: 'HVG',
    Pro: 'PRO'
};
exports.RoofWithArticlesDTOConsequenceClassEnum = {
    Cc1: 'CC1',
    Cc2: 'CC2',
    Cc3: 'CC3'
};
exports.RoofWithArticlesDTOHighBuildingSafetyFactorOptionEnum = {
    Automatic: 'AUTOMATIC',
    Manual: 'MANUAL',
    Off: 'OFF'
};
exports.RoofWithArticlesDTOGroundingOptionEnum = {
    Off: 'OFF',
    ModulesOnly: 'MODULES_ONLY',
    All: 'ALL'
};
exports.RoofWithArticlesDTOSeamTypeEnum = {
    SingleFolded: 'SINGLE_FOLDED',
    DoubleFolded: 'DOUBLE_FOLDED',
    Rounded: 'ROUNDED',
    Snap: 'SNAP'
};
exports.RoofWithArticlesDTOSteelTypeEnum = {
    Trapezoidal: 'TRAPEZOIDAL',
    Corrugated: 'CORRUGATED',
    TiledSheets: 'TILED_SHEETS'
};
exports.RoofWithArticlesDTORoofStructureEnum = {
    Purlins: 'PURLINS',
    Rafters: 'RAFTERS',
    Solid: 'SOLID'
};
exports.RoofWithArticlesDTOBallastElementEnum = {
    ConcreteSlab4Kg: 'CONCRETE_SLAB_4KG',
    ConcreteSlab36Kg: 'CONCRETE_SLAB_3_6KG',
    Custom: 'CUSTOM'
};
exports.RoofWithArticlesDTOPreferredFastenerEnum = {
    ScrewMount: 'SCREW_MOUNT',
    RivetMount: 'RIVET_MOUNT'
};
exports.RoofWithArticlesDTOTopographyEnum = {
    Windswept: 'WINDSWEPT',
    Normal: 'NORMAL',
    Sheltered: 'SHELTERED'
};
exports.RoofWithArticlesDTODualRailUnitChoiceEnum = {
    Mix4P2P: 'MIX_4P_2P',
    Only2P: 'ONLY_2P'
};
exports.RoofWithArticlesDTOSteelThicknessEnum = {
    _05To10: 'THICKNESS_0_5_TO_1_0',
    _11To15: 'THICKNESS_1_1_TO_1_5',
    Gt15: 'THICKNESS_GT_1_5'
};
exports.RoofWithArticlesDTOStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Finalizing: 'FINALIZING',
    Error: 'ERROR',
    Discontinued: 'DISCONTINUED'
};
exports.RoofWithoutIdDTOTypeEnum = {
    Flat: 'FLAT',
    Sloped: 'SLOPED'
};
exports.RoofWithoutIdDTOSideEnum = {
    Windward: 'WINDWARD',
    Leeward: 'LEEWARD'
};
exports.RoofWithoutIdDTOClampTypeEnum = {
    Universal: 'UNIVERSAL',
    Wide: 'WIDE'
};
exports.RoofWithoutIdDTOPreferredProductColorEnum = {
    Grey: 'GREY',
    Black: 'BLACK'
};
exports.RoofWithoutIdDTOPreferredProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10'
};
exports.RoofWithoutIdDTOChosenAttachmentTypeEnum = {
    Supports: 'SUPPORTS',
    HangerBolts: 'HANGER_BOLTS',
    SlateHooks: 'SLATE_HOOKS',
    CorrugatedBrackets: 'CORRUGATED_BRACKETS',
    MountingProfiles: 'MOUNTING_PROFILES'
};
exports.RoofWithoutIdDTONumberOfPanelsPerOptimizerEnum = {
    Zero: 'ZERO',
    One: 'ONE',
    Two: 'TWO',
    Four: 'FOUR'
};
exports.RoofWithoutIdDTOClipTypeEnum = {
    None: 'NONE',
    Light: 'LIGHT',
    Heavy: 'HEAVY'
};
exports.RoofWithoutIdDTOWindzoneEnum = {
    BeZone1: 'BE_ZONE_1',
    BeZone2: 'BE_ZONE_2',
    BeZone3: 'BE_ZONE_3',
    BeZone4: 'BE_ZONE_4',
    DeZone1: 'DE_ZONE_1',
    DeZone2: 'DE_ZONE_2',
    DeZone3: 'DE_ZONE_3',
    DeZone4: 'DE_ZONE_4',
    FrZone1: 'FR_ZONE_1',
    FrZone2: 'FR_ZONE_2',
    FrZone3: 'FR_ZONE_3',
    FrZone4: 'FR_ZONE_4',
    InZone1: 'IN_ZONE_1',
    InZone2: 'IN_ZONE_2',
    InZone3: 'IN_ZONE_3',
    InZone4: 'IN_ZONE_4',
    InZone5: 'IN_ZONE_5',
    InZone6: 'IN_ZONE_6',
    NlZone1: 'NL_ZONE_1',
    NlZone2: 'NL_ZONE_2',
    NlZone3: 'NL_ZONE_3',
    NoneSelected: 'NONE_SELECTED',
    PtZoneA: 'PT_ZONE_A',
    PtZoneB: 'PT_ZONE_B',
    SpZoneA: 'SP_ZONE_A',
    SpZoneB: 'SP_ZONE_B',
    SpZoneC: 'SP_ZONE_C',
    SvZone21: 'SV_ZONE_21',
    SvZone22: 'SV_ZONE_22',
    SvZone23: 'SV_ZONE_23',
    SvZone24: 'SV_ZONE_24',
    SvZone25: 'SV_ZONE_25',
    SvZone26: 'SV_ZONE_26',
    PlZone1: 'PL_ZONE_1',
    PlZone2: 'PL_ZONE_2',
    PlZone3: 'PL_ZONE_3',
    PlBorderZone12: 'PL_BORDER_ZONE_1_2',
    DkZone24: 'DK_ZONE_24',
    DkZone25: 'DK_ZONE_25',
    DkZone26: 'DK_ZONE_26',
    DkZone27: 'DK_ZONE_27'
};
exports.RoofWithoutIdDTOSnowzoneEnum = {
    Germany1: 'GERMANY_1',
    Germany1A: 'GERMANY_1_A',
    Germany2: 'GERMANY_2',
    Germany2A: 'GERMANY_2_A',
    Germany3: 'GERMANY_3',
    Germany3A: 'GERMANY_3_A',
    GermanyGt3A: 'GERMANY_GT_3_A',
    Sweden10: 'SWEDEN_1_0',
    Sweden15: 'SWEDEN_1_5',
    Sweden20: 'SWEDEN_2_0',
    Sweden25: 'SWEDEN_2_5',
    Sweden30: 'SWEDEN_3_0',
    Sweden35: 'SWEDEN_3_5',
    Sweden45: 'SWEDEN_4_5',
    Sweden55: 'SWEDEN_5_5',
    Spain1: 'SPAIN_1',
    Spain2: 'SPAIN_2',
    Spain3: 'SPAIN_3',
    Spain4: 'SPAIN_4',
    Spain5: 'SPAIN_5',
    Spain6: 'SPAIN_6',
    Spain7: 'SPAIN_7',
    PortugalZ1: 'PORTUGAL_Z_1',
    PortugalZ2: 'PORTUGAL_Z_2',
    PortugalZ3: 'PORTUGAL_Z_3',
    FranceA1: 'FRANCE_A1',
    FranceA2: 'FRANCE_A2',
    FranceB1: 'FRANCE_B1',
    FranceB2: 'FRANCE_B2',
    FranceC1: 'FRANCE_C1',
    FranceC2: 'FRANCE_C2',
    FranceD: 'FRANCE_D',
    FranceE: 'FRANCE_E',
    Poland1: 'POLAND_1',
    Poland2: 'POLAND_2',
    Poland3: 'POLAND_3',
    Poland4: 'POLAND_4',
    Poland5: 'POLAND_5',
    Uk1: 'UK_1',
    Uk2: 'UK_2',
    Uk3: 'UK_3',
    Uk4: 'UK_4',
    Uk5: 'UK_5',
    Uk65: 'UK_6_5',
    Ireland04: 'IRELAND_0_4',
    Ireland05: 'IRELAND_0_5',
    Ireland06: 'IRELAND_0_6',
    Ireland07: 'IRELAND_0_7'
};
exports.RoofWithoutIdDTOTerrainCategoryEnum = {
    EuCategory0: 'EU_CATEGORY_0',
    EuCategory1: 'EU_CATEGORY_1',
    EuCategory2: 'EU_CATEGORY_2',
    EuCategory3: 'EU_CATEGORY_3',
    EuCategory4: 'EU_CATEGORY_4',
    EuCategory5: 'EU_CATEGORY_5',
    MixedProfile1: 'MIXED_PROFILE_1',
    MixedProfile2: 'MIXED_PROFILE_2',
    MixedProfile3: 'MIXED_PROFILE_3',
    France0: 'FRANCE_0',
    France2: 'FRANCE_2',
    France3A: 'FRANCE_3_A',
    France3B: 'FRANCE_3_B',
    France4: 'FRANCE_4',
    Portugal1: 'PORTUGAL_1',
    Portugal2: 'PORTUGAL_2',
    Portugal3: 'PORTUGAL_3',
    Portugal4: 'PORTUGAL_4',
    UkSea: 'UK_SEA',
    UkTown: 'UK_TOWN',
    UkCountry: 'UK_COUNTRY',
    IeSea: 'IE_SEA',
    IeTown: 'IE_TOWN',
    IeCountry: 'IE_COUNTRY',
    NoneSelected: 'NONE_SELECTED'
};
exports.RoofWithoutIdDTOMaterialEnum = {
    Tiles: 'TILES',
    ArabicTiles: 'ARABIC_TILES',
    Epdm: 'EPDM',
    Slate: 'SLATE',
    Corrugated: 'CORRUGATED',
    BitumenInsulated: 'BITUMEN_INSULATED',
    BitumenUninsulated: 'BITUMEN_UNINSULATED',
    StandingSeam: 'STANDING_SEAM',
    Pvc: 'PVC',
    Tpo: 'TPO',
    Steel: 'STEEL',
    Other: 'OTHER',
    NoneSelected: 'NONE_SELECTED'
};
exports.RoofWithoutIdDTOHookSizeEnum = {
    Standard: 'STANDARD',
    Multi: 'MULTI',
    Medium: 'MEDIUM',
    Wide: 'WIDE'
};
exports.RoofWithoutIdDTOHookTypeEnum = {
    Normal: 'NORMAL',
    Truss: 'TRUSS',
    Hv: 'HV',
    Hvg: 'HVG',
    Pro: 'PRO'
};
exports.RoofWithoutIdDTOConsequenceClassEnum = {
    Cc1: 'CC1',
    Cc2: 'CC2',
    Cc3: 'CC3'
};
exports.RoofWithoutIdDTOHighBuildingSafetyFactorOptionEnum = {
    Automatic: 'AUTOMATIC',
    Manual: 'MANUAL',
    Off: 'OFF'
};
exports.RoofWithoutIdDTOGroundingOptionEnum = {
    Off: 'OFF',
    ModulesOnly: 'MODULES_ONLY',
    All: 'ALL'
};
exports.RoofWithoutIdDTOSeamTypeEnum = {
    SingleFolded: 'SINGLE_FOLDED',
    DoubleFolded: 'DOUBLE_FOLDED',
    Rounded: 'ROUNDED',
    Snap: 'SNAP'
};
exports.RoofWithoutIdDTOSteelTypeEnum = {
    Trapezoidal: 'TRAPEZOIDAL',
    Corrugated: 'CORRUGATED',
    TiledSheets: 'TILED_SHEETS'
};
exports.RoofWithoutIdDTORoofStructureEnum = {
    Purlins: 'PURLINS',
    Rafters: 'RAFTERS',
    Solid: 'SOLID'
};
exports.RoofWithoutIdDTOBallastElementEnum = {
    ConcreteSlab4Kg: 'CONCRETE_SLAB_4KG',
    ConcreteSlab36Kg: 'CONCRETE_SLAB_3_6KG',
    Custom: 'CUSTOM'
};
exports.RoofWithoutIdDTOPreferredFastenerEnum = {
    ScrewMount: 'SCREW_MOUNT',
    RivetMount: 'RIVET_MOUNT'
};
exports.RoofWithoutIdDTOTopographyEnum = {
    Windswept: 'WINDSWEPT',
    Normal: 'NORMAL',
    Sheltered: 'SHELTERED'
};
exports.RoofWithoutIdDTODualRailUnitChoiceEnum = {
    Mix4P2P: 'MIX_4P_2P',
    Only2P: 'ONLY_2P'
};
exports.RoofWithoutIdDTOSteelThicknessEnum = {
    _05To10: 'THICKNESS_0_5_TO_1_0',
    _11To15: 'THICKNESS_1_1_TO_1_5',
    Gt15: 'THICKNESS_GT_1_5'
};
exports.RoofZonesShortcutRoofDtoTypeEnum = {
    Flat: 'FLAT',
    Sloped: 'SLOPED'
};
exports.SidePlatePlacementFieldDtoSidePlatePlacementEnum = {
    North: 'NORTH',
    South: 'SOUTH',
    Double: 'DOUBLE'
};
exports.SimpleProjectDTOStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Finalizing: 'FINALIZING',
    Error: 'ERROR',
    Discontinued: 'DISCONTINUED'
};
exports.SimpleRoofDTOStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Finalizing: 'FINALIZING',
    Error: 'ERROR',
    Discontinued: 'DISCONTINUED'
};
exports.SimpleRoofDTORoofTypeEnum = {
    Flat: 'FLAT',
    Sloped: 'SLOPED'
};
exports.SimpleRoofDTOProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10'
};
exports.UpdateIdentityDTOCountryEnum = {
    Ad: 'AD',
    Ae: 'AE',
    Af: 'AF',
    Ag: 'AG',
    Ai: 'AI',
    Al: 'AL',
    Am: 'AM',
    Ao: 'AO',
    Aq: 'AQ',
    Ar: 'AR',
    As: 'AS',
    At: 'AT',
    Au: 'AU',
    Aw: 'AW',
    Ax: 'AX',
    Az: 'AZ',
    Ba: 'BA',
    Bb: 'BB',
    Bd: 'BD',
    Be: 'BE',
    Bf: 'BF',
    Bg: 'BG',
    Bh: 'BH',
    Bi: 'BI',
    Bj: 'BJ',
    Bl: 'BL',
    Bm: 'BM',
    Bn: 'BN',
    Bo: 'BO',
    Bq: 'BQ',
    Br: 'BR',
    Bs: 'BS',
    Bt: 'BT',
    Bv: 'BV',
    Bw: 'BW',
    By: 'BY',
    Bz: 'BZ',
    Ca: 'CA',
    Cc: 'CC',
    Cd: 'CD',
    Cf: 'CF',
    Cg: 'CG',
    Ch: 'CH',
    Ci: 'CI',
    Ck: 'CK',
    Cl: 'CL',
    Cm: 'CM',
    Cn: 'CN',
    Co: 'CO',
    Cr: 'CR',
    Cu: 'CU',
    Cv: 'CV',
    Cw: 'CW',
    Cx: 'CX',
    Cy: 'CY',
    Cz: 'CZ',
    De: 'DE',
    Dj: 'DJ',
    Dk: 'DK',
    Dm: 'DM',
    Do: 'DO',
    Dz: 'DZ',
    Ec: 'EC',
    Ee: 'EE',
    Eg: 'EG',
    Eh: 'EH',
    Er: 'ER',
    Es: 'ES',
    Et: 'ET',
    Fi: 'FI',
    Fj: 'FJ',
    Fk: 'FK',
    Fm: 'FM',
    Fo: 'FO',
    Fr: 'FR',
    Ga: 'GA',
    Gb: 'GB',
    Gd: 'GD',
    Ge: 'GE',
    Gf: 'GF',
    Gg: 'GG',
    Gh: 'GH',
    Gi: 'GI',
    Gl: 'GL',
    Gm: 'GM',
    Gn: 'GN',
    Gp: 'GP',
    Gq: 'GQ',
    Gr: 'GR',
    Gs: 'GS',
    Gt: 'GT',
    Gu: 'GU',
    Gw: 'GW',
    Gy: 'GY',
    Hk: 'HK',
    Hm: 'HM',
    Hn: 'HN',
    Hr: 'HR',
    Ht: 'HT',
    Hu: 'HU',
    Id: 'ID',
    Ie: 'IE',
    Il: 'IL',
    Im: 'IM',
    In: 'IN',
    Io: 'IO',
    Iq: 'IQ',
    Ir: 'IR',
    Is: 'IS',
    It: 'IT',
    Je: 'JE',
    Jm: 'JM',
    Jo: 'JO',
    Jp: 'JP',
    Ke: 'KE',
    Kg: 'KG',
    Kh: 'KH',
    Ki: 'KI',
    Km: 'KM',
    Kn: 'KN',
    Kp: 'KP',
    Kr: 'KR',
    Kw: 'KW',
    Ky: 'KY',
    Kz: 'KZ',
    La: 'LA',
    Lb: 'LB',
    Lc: 'LC',
    Li: 'LI',
    Lk: 'LK',
    Lr: 'LR',
    Ls: 'LS',
    Lt: 'LT',
    Lu: 'LU',
    Lv: 'LV',
    Ly: 'LY',
    Ma: 'MA',
    Mc: 'MC',
    Md: 'MD',
    Me: 'ME',
    Mf: 'MF',
    Mg: 'MG',
    Mh: 'MH',
    Mk: 'MK',
    Ml: 'ML',
    Mm: 'MM',
    Mn: 'MN',
    Mo: 'MO',
    Mp: 'MP',
    Mq: 'MQ',
    Mr: 'MR',
    Ms: 'MS',
    Mt: 'MT',
    Mu: 'MU',
    Mv: 'MV',
    Mw: 'MW',
    Mx: 'MX',
    My: 'MY',
    Mz: 'MZ',
    Na: 'NA',
    Nc: 'NC',
    Ne: 'NE',
    Nf: 'NF',
    Ng: 'NG',
    Ni: 'NI',
    Nl: 'NL',
    No: 'NO',
    Np: 'NP',
    Nr: 'NR',
    Nu: 'NU',
    Nz: 'NZ',
    Om: 'OM',
    Pa: 'PA',
    Pe: 'PE',
    Pf: 'PF',
    Pg: 'PG',
    Ph: 'PH',
    Pk: 'PK',
    Pl: 'PL',
    Pm: 'PM',
    Pn: 'PN',
    Pr: 'PR',
    Ps: 'PS',
    Pt: 'PT',
    Pw: 'PW',
    Py: 'PY',
    Qa: 'QA',
    Re: 'RE',
    Ro: 'RO',
    Rs: 'RS',
    Ru: 'RU',
    Rw: 'RW',
    Sa: 'SA',
    Sb: 'SB',
    Sc: 'SC',
    Sd: 'SD',
    Se: 'SE',
    Sg: 'SG',
    Sh: 'SH',
    Si: 'SI',
    Sj: 'SJ',
    Sk: 'SK',
    Sl: 'SL',
    Sm: 'SM',
    Sn: 'SN',
    So: 'SO',
    Sr: 'SR',
    Ss: 'SS',
    St: 'ST',
    Sv: 'SV',
    Sx: 'SX',
    Sy: 'SY',
    Sz: 'SZ',
    Tc: 'TC',
    Td: 'TD',
    Tf: 'TF',
    Tg: 'TG',
    Th: 'TH',
    Tj: 'TJ',
    Tk: 'TK',
    Tl: 'TL',
    Tm: 'TM',
    Tn: 'TN',
    To: 'TO',
    Tr: 'TR',
    Tt: 'TT',
    Tv: 'TV',
    Tw: 'TW',
    Tz: 'TZ',
    Ua: 'UA',
    Ug: 'UG',
    Um: 'UM',
    Us: 'US',
    Uy: 'UY',
    Uz: 'UZ',
    Va: 'VA',
    Vc: 'VC',
    Ve: 'VE',
    Vg: 'VG',
    Vi: 'VI',
    Vn: 'VN',
    Vu: 'VU',
    Wf: 'WF',
    Ws: 'WS',
    Ye: 'YE',
    Yt: 'YT',
    Za: 'ZA',
    Zm: 'ZM',
    Zw: 'ZW'
};
exports.UserAccountDTOBusinessUnitEnum = {
    Esdec: 'ESDEC',
    Cpx: 'CPX',
    Blubase: 'BLUBASE'
};
exports.UserPreferenceDTODefaultGroundingOptionEnum = {
    Off: 'OFF',
    ModulesOnly: 'MODULES_ONLY',
    All: 'ALL'
};
exports.UserPreferenceDTOHookTypeEnum = {
    Normal: 'NORMAL',
    Truss: 'TRUSS',
    Pro: 'PRO'
};
exports.VendorDtoCheckoutTypeEnum = {
    Javascript: 'JAVASCRIPT',
    Redirect: 'REDIRECT'
};
exports.VisualizationInputDTORuleTypeEnum = {
    ProjectReferencePeriod: 'PROJECT_REFERENCE_PERIOD',
    RoofCountry: 'ROOF_COUNTRY',
    RoofBom: 'ROOF_BOM',
    RoofAppliedProduct: 'ROOF_APPLIED_PRODUCT',
    RoofApplicableProducts: 'ROOF_APPLICABLE_PRODUCTS',
    RoofAvailableProducts: 'ROOF_AVAILABLE_PRODUCTS',
    RoofBusinessUnitProducts: 'ROOF_BUSINESS_UNIT_PRODUCTS',
    RoofPreferredProduct: 'ROOF_PREFERRED_PRODUCT',
    RoofHeight: 'ROOF_HEIGHT',
    RoofAppliedHeight: 'ROOF_APPLIED_HEIGHT',
    RoofTerrainCategory: 'ROOF_TERRAIN_CATEGORY',
    RoofSnowzone: 'ROOF_SNOWZONE',
    RoofMinimumHeight: 'ROOF_MINIMUM_HEIGHT',
    RoofRoughnessLength: 'ROOF_ROUGHNESS_LENGTH',
    RoofRoughnessLengthDependantTerrainFactor: 'ROOF_ROUGHNESS_LENGTH_DEPENDANT_TERRAIN_FACTOR',
    RoofRoughnessFactor: 'ROOF_ROUGHNESS_FACTOR',
    RoofSlope: 'ROOF_SLOPE',
    RoofType: 'ROOF_TYPE',
    RoofSide: 'ROOF_SIDE',
    RoofSlopeForLoadEquations: 'ROOF_SLOPE_FOR_LOAD_EQUATIONS',
    RoofMaterial: 'ROOF_MATERIAL',
    RoofFrictionCoefficient: 'ROOF_FRICTION_COEFFICIENT',
    RoofFlangeDistance: 'ROOF_FLANGE_DISTANCE',
    RoofEdges: 'ROOF_EDGES',
    RoofBoundingBox: 'ROOF_BOUNDING_BOX',
    RoofDistanceBetweenRailsUnderModule: 'ROOF_DISTANCE_BETWEEN_RAILS_UNDER_MODULE',
    RoofDistanceBetweenRailsBetweenModules: 'ROOF_DISTANCE_BETWEEN_RAILS_BETWEEN_MODULES',
    RoofMaximumDistanceBetweenRailsForRearWindDeflector: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_REAR_WIND_DEFLECTOR',
    RoofMinimumDistanceBetweenRailsForPanelLength: 'ROOF_MINIMUM_DISTANCE_BETWEEN_RAILS_FOR_PANEL_LENGTH',
    RoofMaximumDistanceBetweenRailsForPanelLength: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_PANEL_LENGTH',
    RoofMaximumDistanceBetweenRailsUnderModule: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_UNDER_MODULE',
    MaximumDistanceCorrugatedBrackets: 'MAXIMUM_DISTANCE_CORRUGATED_BRACKETS',
    RoofExtraCostPerRail: 'ROOF_EXTRA_COST_PER_RAIL',
    RoofAttachmentType: 'ROOF_ATTACHMENT_TYPE',
    RoofAvailableRails: 'ROOF_AVAILABLE_RAILS',
    RoofHookType: 'ROOF_HOOK_TYPE',
    RoofHookSize: 'ROOF_HOOK_SIZE',
    RoofHookPressureLimit: 'ROOF_HOOK_PRESSURE_LIMIT',
    RoofAllSegments: 'ROOF_ALL_SEGMENTS',
    RoofUniqueSegments: 'ROOF_UNIQUE_SEGMENTS',
    RoofSegmentTypes: 'ROOF_SEGMENT_TYPES',
    RoofSegmentTypeModuleSpaces: 'ROOF_SEGMENT_TYPE_MODULE_SPACES',
    RoofUniqueSegmentsRowDistance: 'ROOF_UNIQUE_SEGMENTS_ROW_DISTANCE',
    RoofColor: 'ROOF_COLOR',
    RoofSkippingApplied: 'ROOF_SKIPPING_APPLIED',
    RoofPerimeterApplied: 'ROOF_PERIMETER_APPLIED',
    RoofLength: 'ROOF_LENGTH',
    RoofWidth: 'ROOF_WIDTH',
    RoofTotalYield: 'ROOF_TOTAL_YIELD',
    RoofArea: 'ROOF_AREA',
    RoofLoadOverArea: 'ROOF_LOAD_OVER_AREA',
    RoofTotalSystemArea: 'ROOF_TOTAL_SYSTEM_AREA',
    RoofTotalBallastWeight: 'ROOF_TOTAL_BALLAST_WEIGHT',
    RoofPurlinDistance: 'ROOF_PURLIN_DISTANCE',
    RoofChosenAttachmentType: 'ROOF_CHOSEN_ATTACHMENT_TYPE',
    RoofChosenHangerBolt: 'ROOF_CHOSEN_HANGER_BOLT',
    RoofDilatationDistance: 'ROOF_DILATATION_DISTANCE',
    RoofNumberOfModulesInRow: 'ROOF_NUMBER_OF_MODULES_IN_ROW',
    RoofTotalWeight: 'ROOF_TOTAL_WEIGHT',
    RoofAirDensity: 'ROOF_AIR_DENSITY',
    RoofAverageRoofLoadOverTotalSystem: 'ROOF_AVERAGE_ROOF_LOAD_OVER_TOTAL_SYSTEM',
    RoofNumberOfBallastElements: 'ROOF_NUMBER_OF_BALLAST_ELEMENTS',
    RoofAltitudeAboveSeaLevel: 'ROOF_ALTITUDE_ABOVE_SEA_LEVEL',
    RoofSectionDistance: 'ROOF_SECTION_DISTANCE',
    RoofGapSpace: 'ROOF_GAP_SPACE',
    RoofTotalBuildingHeight: 'ROOF_TOTAL_BUILDING_HEIGHT',
    RoofParapetHeight: 'ROOF_PARAPET_HEIGHT',
    RoofNumberOfPanels: 'ROOF_NUMBER_OF_PANELS',
    RoofDistanceToCoast: 'ROOF_DISTANCE_TO_COAST',
    RoofDistanceToCityBoundary: 'ROOF_DISTANCE_TO_CITY_BOUNDARY',
    RoofAltitudeOfTheUpwindBase: 'ROOF_ALTITUDE_OF_THE_UPWIND_BASE',
    RoofAppliedDistanceToCityBoundary: 'ROOF_APPLIED_DISTANCE_TO_CITY_BOUNDARY',
    RoofTpoMatsNeeded: 'ROOF_TPO_MATS_NEEDED',
    RoofTotalPrice: 'ROOF_TOTAL_PRICE',
    RoofPricePerPanel: 'ROOF_PRICE_PER_PANEL',
    RoofPricePerWattPeak: 'ROOF_PRICE_PER_WATT_PEAK',
    RoofRotation: 'ROOF_ROTATION',
    RoofSideWindDeflectorWidth: 'ROOF_SIDE_WIND_DEFLECTOR_WIDTH',
    RoofConsequenceClass: 'ROOF_CONSEQUENCE_CLASS',
    RoofGroundingOption: 'ROOF_GROUNDING_OPTION',
    RoofBomAdjustments: 'ROOF_BOM_ADJUSTMENTS',
    RoofPermanentLoadPerModule: 'ROOF_PERMANENT_LOAD_PER_MODULE',
    RoofHasOldOrWetSnow: 'ROOF_HAS_OLD_OR_WET_SNOW',
    RoofRailsRequired: 'ROOF_RAILS_REQUIRED',
    RoofNoGoAreaDepth: 'ROOF_NO_GO_AREA_DEPTH',
    RoofAttachToRoofStructure: 'ROOF_ATTACH_TO_ROOF_STRUCTURE',
    RoofStructure: 'ROOF_STRUCTURE',
    RoofSectioningType: 'ROOF_SECTIONING_TYPE',
    RoofRafterDistance: 'ROOF_RAFTER_DISTANCE',
    RoofCanPerimeterBeDisabled: 'ROOF_CAN_PERIMETER_BE_DISABLED',
    RoofPanelAngle: 'ROOF_PANEL_ANGLE',
    RoofSidePlatePlacement: 'ROOF_SIDE_PLATE_PLACEMENT',
    RoofSeamType: 'ROOF_SEAM_TYPE',
    RoofSteelType: 'ROOF_STEEL_TYPE',
    RoofDisableNoGoArea: 'ROOF_DISABLE_NO_GO_AREA',
    RoofPolygon: 'ROOF_POLYGON',
    RoofFields: 'ROOF_FIELDS',
    RoofMeasurements: 'ROOF_MEASUREMENTS',
    RoofPreferredFastener: 'ROOF_PREFERRED_FASTENER',
    RoofObstacles: 'ROOF_OBSTACLES',
    RoofShape: 'ROOF_SHAPE',
    RoofFreezeThawLikely: 'ROOF_FREEZE_THAW_LIKELY',
    RoofDriftedSnowPossibleOnSide: 'ROOF_DRIFTED_SNOW_POSSIBLE_ON_SIDE',
    RoofWallHeight: 'ROOF_WALL_HEIGHT',
    RoofUseFormCoefficientDueToWind: 'ROOF_USE_FORM_COEFFICIENT_DUE_TO_WIND',
    RoofFormCoefficientDueToWind: 'ROOF_FORM_COEFFICIENT_DUE_TO_WIND',
    RoofTopography: 'ROOF_TOPOGRAPHY',
    RoofSnowFencesPresent: 'ROOF_SNOW_FENCES_PRESENT',
    RoofMapWindSpeed: 'ROOF_MAP_WIND_SPEED',
    RoofIsRoofHookAttachedToStructure: 'ROOF_IS_ROOF_HOOK_ATTACHED_TO_STRUCTURE',
    RoofMatsIncluded: 'ROOF_MATS_INCLUDED',
    RoofSteelThickness: 'ROOF_STEEL_THICKNESS',
    WindDeflectorLandscapeSize: 'WIND_DEFLECTOR_LANDSCAPE_SIZE',
    PressureCoefficientRearWindDeflector: 'PRESSURE_COEFFICIENT_REAR_WIND_DEFLECTOR',
    SurfaceAreaRearWindDeflector: 'SURFACE_AREA_REAR_WIND_DEFLECTOR',
    ForceOnRearWindDeflector: 'FORCE_ON_REAR_WIND_DEFLECTOR',
    WindExposureFactor: 'WIND_EXPOSURE_FACTOR',
    SurfaceAreaSideDeflector: 'SURFACE_AREA_SIDE_DEFLECTOR',
    InwardsPressureCoefficientSideDeflector: 'INWARDS_PRESSURE_COEFFICIENT_SIDE_DEFLECTOR',
    InwardsPressureForceOnSideDeflector: 'INWARDS_PRESSURE_FORCE_ON_SIDE_DEFLECTOR',
    OutwardsSuctionCoefficientSideDeflector: 'OUTWARDS_SUCTION_COEFFICIENT_SIDE_DEFLECTOR',
    OutwardsSuctionForceOnSideDeflector: 'OUTWARDS_SUCTION_FORCE_ON_SIDE_DEFLECTOR',
    InwardsPressureForceLimitForSideDeflector: 'INWARDS_PRESSURE_FORCE_LIMIT_FOR_SIDE_DEFLECTOR',
    OutwardsSuctionForceLimitForSideDeflector: 'OUTWARDS_SUCTION_FORCE_LIMIT_FOR_SIDE_DEFLECTOR',
    EdgeLength: 'EDGE_LENGTH',
    EdgeZoneScalingFactor: 'EDGE_ZONE_SCALING_FACTOR',
    EdgeZoneHorizontalDepth: 'EDGE_ZONE_HORIZONTAL_DEPTH',
    EdgeZoneDepth: 'EDGE_ZONE_DEPTH',
    EdgeZoneVerticalDepth: 'EDGE_ZONE_VERTICAL_DEPTH',
    AllowedCentralRoofZones: 'ALLOWED_CENTRAL_ROOF_ZONES',
    CommercialCentralRoofZones: 'COMMERCIAL_CENTRAL_ROOF_ZONES',
    CommercialEdgeZone: 'COMMERCIAL_EDGE_ZONE',
    EurocodeCentralRoofZones: 'EUROCODE_CENTRAL_ROOF_ZONES',
    EurocodeEdgeZone: 'EUROCODE_EDGE_ZONE',
    EurocodeNorthEdgeZone: 'EUROCODE_NORTH_EDGE_ZONE',
    EurocodeSouthEdgeZone: 'EUROCODE_SOUTH_EDGE_ZONE',
    PeutzCentralRoofZones: 'PEUTZ_CENTRAL_ROOF_ZONES',
    PeutzInnerEdgeZoneHorizontalDepth: 'PEUTZ_INNER_EDGE_ZONE_HORIZONTAL_DEPTH',
    PeutzInnerEdgeZoneVerticalDepth: 'PEUTZ_INNER_EDGE_ZONE_VERTICAL_DEPTH',
    PeutzInnerEdgeZoneDepth: 'PEUTZ_INNER_EDGE_ZONE_DEPTH',
    PeutzInnerEdgeZones: 'PEUTZ_INNER_EDGE_ZONES',
    PeutzNorthInnerEdgeZones: 'PEUTZ_NORTH_INNER_EDGE_ZONES',
    PeutzSouthInnerEdgeZones: 'PEUTZ_SOUTH_INNER_EDGE_ZONES',
    SystemHeight: 'SYSTEM_HEIGHT',
    FieldRoofHorizontalDilatationLength: 'FIELD_ROOF_HORIZONTAL_DILATATION_LENGTH',
    FieldRoofVerticalDilatationLength: 'FIELD_ROOF_VERTICAL_DILATATION_LENGTH',
    FieldRoofEffectiveVerticalDilatation: 'FIELD_ROOF_EFFECTIVE_VERTICAL_DILATATION',
    FieldRoofEffectiveHorizontalDilatation: 'FIELD_ROOF_EFFECTIVE_HORIZONTAL_DILATATION',
    FieldHorizontalDilatationGapSpacing: 'FIELD_HORIZONTAL_DILATATION_GAP_SPACING',
    FieldVerticalDilatationGapSpacing: 'FIELD_VERTICAL_DILATATION_GAP_SPACING',
    FieldCoordinate: 'FIELD_COORDINATE',
    FieldSegments: 'FIELD_SEGMENTS',
    FieldSidePlatesOption: 'FIELD_SIDE_PLATES_OPTION',
    FieldRowDistance: 'FIELD_ROW_DISTANCE',
    FieldReferenceRowDistanceLandscape: 'FIELD_REFERENCE_ROW_DISTANCE_LANDSCAPE',
    FieldModules: 'FIELD_MODULES',
    FieldSetup: 'FIELD_SETUP',
    FieldOrientation: 'FIELD_ORIENTATION',
    FieldRailSystem: 'FIELD_RAIL_SYSTEM',
    SegmentTotalPanelWeight: 'SEGMENT_TOTAL_PANEL_WEIGHT',
    FieldModuleLocationLimits: 'FIELD_MODULE_LOCATION_LIMITS',
    FieldModuleConfiguration: 'FIELD_MODULE_CONFIGURATION',
    FieldRowConnectorLength: 'FIELD_ROW_CONNECTOR_LENGTH',
    FieldHorizontalModuleGapSpacing: 'FIELD_HORIZONTAL_MODULE_GAP_SPACING',
    FieldVerticalModuleGapSpacing: 'FIELD_VERTICAL_MODULE_GAP_SPACING',
    FieldNeedRoofSectionSpanningRails: 'FIELD_NEED_ROOF_SECTION_SPANNING_RAILS',
    SegmentNumberOfPanels: 'SEGMENT_NUMBER_OF_PANELS',
    SegmentBasePlateGroups: 'SEGMENT_BASE_PLATE_GROUPS',
    SegmentNumberOfSingleModules: 'SEGMENT_NUMBER_OF_SINGLE_MODULES',
    SegmentNumberOfSingleModuleSides: 'SEGMENT_NUMBER_OF_SINGLE_MODULE_SIDES',
    SegmentNumberOfLinesOfSideBySideSingleModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_SINGLE_MODULES',
    SegmentNumberOfDualModules: 'SEGMENT_NUMBER_OF_DUAL_MODULES',
    SegmentNumberOfDualModuleSides: 'SEGMENT_NUMBER_OF_DUAL_MODULE_SIDES',
    SegmentNumberOfLinesOfSideBySideDualModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_DUAL_MODULES',
    SegmentLength: 'SEGMENT_LENGTH',
    SegmentLengthWithoutRails: 'SEGMENT_LENGTH_WITHOUT_RAILS',
    SegmentTotalBallastWeight: 'SEGMENT_TOTAL_BALLAST_WEIGHT',
    SegmentTotalYield: 'SEGMENT_TOTAL_YIELD',
    SegmentSystemArea: 'SEGMENT_SYSTEM_AREA',
    SegmentEndSpacing: 'SEGMENT_END_SPACING',
    SegmentNumberOfSides: 'SEGMENT_NUMBER_OF_SIDES',
    SegmentNumberOfHighBallastedSides: 'SEGMENT_NUMBER_OF_HIGH_BALLASTED_SIDES',
    SegmentNumberOfPerimeteredSides: 'SEGMENT_NUMBER_OF_PERIMETERED_SIDES',
    SegmentNumberOfMiddleSides: 'SEGMENT_NUMBER_OF_MIDDLE_SIDES',
    SegmentNumberOfModulesWithContainerNearLowBase: 'SEGMENT_NUMBER_OF_MODULES_WITH_CONTAINER_NEAR_LOW_BASE',
    SegmentNumberOfMiddleModules: 'SEGMENT_NUMBER_OF_MIDDLE_MODULES',
    SegmentNumberOfLinesOfSideBySideModulesWithModulesNearLowBase: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_MODULES_WITH_MODULES_NEAR_LOW_BASE',
    SegmentNumberOfLinesOfSideBySideMiddleModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_MIDDLE_MODULES',
    SegmentNumberOfBallastedModules: 'SEGMENT_NUMBER_OF_BALLASTED_MODULES',
    SegmentNumberOfHighBallastedModules: 'SEGMENT_NUMBER_OF_HIGH_BALLASTED_MODULES',
    SegmentNumberOfLinesOfSideBySideHighBallastedModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_HIGH_BALLASTED_MODULES',
    SegmentNumberOfDoubleBallastedRegularSides: 'SEGMENT_NUMBER_OF_DOUBLE_BALLASTED_REGULAR_SIDES',
    SegmentNumberOfPanelsWithHighBaseAdjacentContainerUnderneath: 'SEGMENT_NUMBER_OF_PANELS_WITH_HIGH_BASE_ADJACENT_CONTAINER_UNDERNEATH',
    SegmentNumberOfLinesOfSideBySidePanelsWithHighBaseAdjacentContainerUnderneath: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_PANELS_WITH_HIGH_BASE_ADJACENT_CONTAINER_UNDERNEATH',
    SegmentNumberOfDoublePerimeteredModules: 'SEGMENT_NUMBER_OF_DOUBLE_PERIMETERED_MODULES',
    SegmentNumberOfLinesOfSideBySideDoublePerimeteredModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_DOUBLE_PERIMETERED_MODULES',
    SegmentNumberOfDoublePerimeteredSides: 'SEGMENT_NUMBER_OF_DOUBLE_PERIMETERED_SIDES',
    SegmentNumberOfBallastElements: 'SEGMENT_NUMBER_OF_BALLAST_ELEMENTS',
    SegmentNumberOfLinesOfSideBySidePanels: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_PANELS',
    SegmentNumberOfRowConnectors: 'SEGMENT_NUMBER_OF_ROW_CONNECTORS',
    SegmentLinesOfSucceedingModules: 'SEGMENT_LINES_OF_SUCCEEDING_MODULES',
    SegmentLinesOfSideBySideModules: 'SEGMENT_LINES_OF_SIDE_BY_SIDE_MODULES',
    SegmentRectangles: 'SEGMENT_RECTANGLES',
    SegmentMountingWeight: 'SEGMENT_MOUNTING_WEIGHT',
    SegmentTotalInstallationWeight: 'SEGMENT_TOTAL_INSTALLATION_WEIGHT',
    SegmentRailsNeedToBeExtended: 'SEGMENT_RAILS_NEED_TO_BE_EXTENDED',
    SegmentDistanceBetweenFirstAndLastAttachment: 'SEGMENT_DISTANCE_BETWEEN_FIRST_AND_LAST_ATTACHMENT',
    SegmentFirstAttachmentPosition: 'SEGMENT_FIRST_ATTACHMENT_POSITION',
    SegmentRequiredRailLength: 'SEGMENT_REQUIRED_RAIL_LENGTH',
    SegmentMaxNumberOfRows: 'SEGMENT_MAX_NUMBER_OF_ROWS',
    SegmentRoofZone: 'SEGMENT_ROOF_ZONE',
    SegmentAverageRoofLoadOverSystemArea: 'SEGMENT_AVERAGE_ROOF_LOAD_OVER_SYSTEM_AREA',
    SegmentAverageLoadPerModule: 'SEGMENT_AVERAGE_LOAD_PER_MODULE',
    SegmentPointLoad: 'SEGMENT_POINT_LOAD',
    SegmentMaximalStaticPointLoad: 'SEGMENT_MAXIMAL_STATIC_POINT_LOAD',
    SegmentAttachmentPositions: 'SEGMENT_ATTACHMENT_POSITIONS',
    SegmentAttachmentInterval: 'SEGMENT_ATTACHMENT_INTERVAL',
    SegmentFirstRailOffset: 'SEGMENT_FIRST_RAIL_OFFSET',
    SegmentRailSpacing: 'SEGMENT_RAIL_SPACING',
    SegmentRailSpacingBasedOnSectionDistance: 'SEGMENT_RAIL_SPACING_BASED_ON_SECTION_DISTANCE',
    SegmentFixationPlan: 'SEGMENT_FIXATION_PLAN',
    SegmentNumberOfPerimeterSidesWithRowConnectors: 'SEGMENT_NUMBER_OF_PERIMETER_SIDES_WITH_ROW_CONNECTORS',
    SegmentNeedRoofSectionSpanningRails: 'SEGMENT_NEED_ROOF_SECTION_SPANNING_RAILS',
    SegmentPolygon: 'SEGMENT_POLYGON',
    SegmentTypeRelativePosition: 'SEGMENT_TYPE_RELATIVE_POSITION',
    SegmentOriginPosition: 'SEGMENT_ORIGIN_POSITION',
    SegmentMaximumStaticWeightPerBasePlate: 'SEGMENT_MAXIMUM_STATIC_WEIGHT_PER_BASE_PLATE',
    SegmentDynamicWeightPerBasePlateInBasePlateGroup: 'SEGMENT_DYNAMIC_WEIGHT_PER_BASE_PLATE_IN_BASE_PLATE_GROUP',
    SegmentMaximumDynamicWeightPerBasePlate: 'SEGMENT_MAXIMUM_DYNAMIC_WEIGHT_PER_BASE_PLATE',
    SegmentStabilizerPosition: 'SEGMENT_STABILIZER_POSITION',
    SegmentsWithPerimeterBallasting: 'SEGMENTS_WITH_PERIMETER_BALLASTING',
    SegmentsWithSkipping: 'SEGMENTS_WITH_SKIPPING',
    SegmentsBallastWeightIncludingBallastArticleWeight: 'SEGMENTS_BALLAST_WEIGHT_INCLUDING_BALLAST_ARTICLE_WEIGHT',
    SegmentsWithMomentComparison: 'SEGMENTS_WITH_MOMENT_COMPARISON',
    SegmentArticles: 'SEGMENT_ARTICLES',
    ArticleWeight: 'ARTICLE_WEIGHT',
    ModuleHorizontalModuleSpace: 'MODULE_HORIZONTAL_MODULE_SPACE',
    ModuleVerticalModuleSpace: 'MODULE_VERTICAL_MODULE_SPACE',
    ModuleBreadth: 'MODULE_BREADTH',
    PanelWidth: 'PANEL_WIDTH',
    PanelLength: 'PANEL_LENGTH',
    PanelWeight: 'PANEL_WEIGHT',
    PanelSurfaceArea: 'PANEL_SURFACE_AREA',
    PanelIsLarge: 'PANEL_IS_LARGE',
    NumberOfRailLines: 'NUMBER_OF_RAIL_LINES',
    PanelThickness: 'PANEL_THICKNESS',
    PanelYield: 'PANEL_YIELD',
    PanelSystemArea: 'PANEL_SYSTEM_AREA',
    ModulesModuleWeight: 'MODULES_MODULE_WEIGHT',
    ModulesRowDistanceHalfModules: 'MODULES_ROW_DISTANCE_HALF_MODULES',
    WindpressureCorrectedPeakVelocityPressureOverReferencePeriod: 'WINDPRESSURE_CORRECTED_PEAK_VELOCITY_PRESSURE_OVER_REFERENCE_PERIOD',
    WindpressureHighBuildingSafetyFactor: 'WINDPRESSURE_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureManualHighBuildingSafetyFactor: 'WINDPRESSURE_MANUAL_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureAutomaticHighBuildingSafetyFactor: 'WINDPRESSURE_AUTOMATIC_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureAutomaticHighBuildingSafetyFactorOption: 'WINDPRESSURE_AUTOMATIC_HIGH_BUILDING_SAFETY_FACTOR_OPTION',
    WindpressureBuildingShapeRatio: 'WINDPRESSURE_BUILDING_SHAPE_RATIO',
    WindpressureWindzone: 'WINDPRESSURE_WINDZONE',
    WindpressureOrographyFactor: 'WINDPRESSURE_OROGRAPHY_FACTOR',
    WindpressureBasicWindVelocity: 'WINDPRESSURE_BASIC_WIND_VELOCITY',
    WindpressureFundamentalValueBasicWindVelocity: 'WINDPRESSURE_FUNDAMENTAL_VALUE_BASIC_WIND_VELOCITY',
    WindpressureNValue: 'WINDPRESSURE_N_VALUE',
    WindpressureKValue: 'WINDPRESSURE_K_VALUE',
    WindpressurePValue: 'WINDPRESSURE_P_VALUE',
    WindpressureProbabilityFactor: 'WINDPRESSURE_PROBABILITY_FACTOR',
    WindpressurePeakVelocityPressure: 'WINDPRESSURE_PEAK_VELOCITY_PRESSURE',
    WindpressurePeakVelocityPressureOverReferencePeriod: 'WINDPRESSURE_PEAK_VELOCITY_PRESSURE_OVER_REFERENCE_PERIOD',
    WindpressureStrongWinds: 'WINDPRESSURE_STRONG_WINDS',
    WindpressureWindloadCategory: 'WINDPRESSURE_WINDLOAD_CATEGORY',
    WindpressureWindloadFavourablePermanentLoad: 'WINDPRESSURE_WINDLOAD_FAVOURABLE_PERMANENT_LOAD',
    WindpressureWindloadUnfavourablePermanentLoad: 'WINDPRESSURE_WINDLOAD_UNFAVOURABLE_PERMANENT_LOAD',
    WindpressureWindloadReductionFactor: 'WINDPRESSURE_WINDLOAD_REDUCTION_FACTOR',
    WindpressureMeanWindVelocity: 'WINDPRESSURE_MEAN_WIND_VELOCITY',
    WindpressureInputBasicVelocityPressure: 'WINDPRESSURE_INPUT_BASIC_VELOCITY_PRESSURE',
    WindpressureBasicWindPressure: 'WINDPRESSURE_BASIC_WIND_PRESSURE',
    WindpressureTurbulenceIntensity: 'WINDPRESSURE_TURBULENCE_INTENSITY',
    WindpressureTurbulenceFactor: 'WINDPRESSURE_TURBULENCE_FACTOR',
    WindpressureMaximumBuildingHeight: 'WINDPRESSURE_MAXIMUM_BUILDING_HEIGHT',
    WindpressureSizeFactorExposureFactor: 'WINDPRESSURE_SIZE_FACTOR_EXPOSURE_FACTOR',
    StandardWindpressurePerModule: 'STANDARD_WINDPRESSURE_PER_MODULE',
    AppliedDistanceToCoast: 'APPLIED_DISTANCE_TO_COAST',
    AppliedSafetyFactorCc1: 'APPLIED_SAFETY_FACTOR_CC1',
    SidePlatesSafetyFactor: 'SIDE_PLATES_SAFETY_FACTOR',
    ReliabilityFactor: 'RELIABILITY_FACTOR',
    ReliabilityFactorPerConsequenceClass: 'RELIABILITY_FACTOR_PER_CONSEQUENCE_CLASS',
    VariableLoadFactor: 'VARIABLE_LOAD_FACTOR',
    VariableLoadFactorPerConsequenceClass: 'VARIABLE_LOAD_FACTOR_PER_CONSEQUENCE_CLASS',
    DisplacementHeight: 'DISPLACEMENT_HEIGHT',
    TownTerrainExposureFactor: 'TOWN_TERRAIN_EXPOSURE_FACTOR',
    AltitudeFactor: 'ALTITUDE_FACTOR',
    BallastArticleWeight: 'BALLAST_ARTICLE_WEIGHT',
    BallastUseBallast: 'BALLAST_USE_BALLAST',
    BallastPlan: 'BALLAST_PLAN',
    BallastPlanSegment: 'BALLAST_PLAN_SEGMENT',
    BallastGroupsForSegment: 'BALLAST_GROUPS_FOR_SEGMENT',
    BallastGroupsForLargestRectangles: 'BALLAST_GROUPS_FOR_LARGEST_RECTANGLES',
    BallastAssignedGroups: 'BALLAST_ASSIGNED_GROUPS',
    BallastCountrySafetyFactor: 'BALLAST_COUNTRY_SAFETY_FACTOR',
    BallastAppliedSafetyFactor: 'BALLAST_APPLIED_SAFETY_FACTOR',
    BallastCThetaSquared: 'BALLAST_C_THETA_SQUARED',
    BallastUseCTheta: 'BALLAST_USE_C_THETA',
    BallastAverageSurfaceArea: 'BALLAST_AVERAGE_SURFACE_AREA',
    BallastPeutzValueForLiftForce: 'BALLAST_PEUTZ_VALUE_FOR_LIFT_FORCE',
    BallastDirectionalFactorForLiftForce: 'BALLAST_DIRECTIONAL_FACTOR_FOR_LIFT_FORCE',
    BallastWindForcePerWindDirectionForLiftForce: 'BALLAST_WIND_FORCE_PER_WIND_DIRECTION_FOR_LIFT_FORCE',
    BallastMaxWindForcePerPeutzGroupForLiftForce: 'BALLAST_MAX_WIND_FORCE_PER_PEUTZ_GROUP_FOR_LIFT_FORCE',
    BallastRequiredGroupsWithPeutzDataForLiftForce: 'BALLAST_REQUIRED_GROUPS_WITH_PEUTZ_DATA_FOR_LIFT_FORCE',
    BallastTotalWindForceForAssignedGroupsForLiftForce: 'BALLAST_TOTAL_WIND_FORCE_FOR_ASSIGNED_GROUPS_FOR_LIFT_FORCE',
    BallastPeutzValueForCombinedForces: 'BALLAST_PEUTZ_VALUE_FOR_COMBINED_FORCES',
    BallastDirectionalFactorForCombinedForces: 'BALLAST_DIRECTIONAL_FACTOR_FOR_COMBINED_FORCES',
    BallastWindForcePerWindDirectionForCombinedForces: 'BALLAST_WIND_FORCE_PER_WIND_DIRECTION_FOR_COMBINED_FORCES',
    BallastMaxWindForcePerPeutzGroupForCombinedForced: 'BALLAST_MAX_WIND_FORCE_PER_PEUTZ_GROUP_FOR_COMBINED_FORCED',
    BallastRequiredGroupsWithPeutzDataForCombinedForces: 'BALLAST_REQUIRED_GROUPS_WITH_PEUTZ_DATA_FOR_COMBINED_FORCES',
    BallastTotalWindForceForAssignedGroupsForCombinedForces: 'BALLAST_TOTAL_WIND_FORCE_FOR_ASSIGNED_GROUPS_FOR_COMBINED_FORCES',
    BallastWindtunnelSafetyFactor: 'BALLAST_WINDTUNNEL_SAFETY_FACTOR',
    BallastNumberOfElementsUnderPanelInCouplerlessRail: 'BALLAST_NUMBER_OF_ELEMENTS_UNDER_PANEL_IN_COUPLERLESS_RAIL',
    BallastNumberOfElementsUnderPanelInRailWithCoupler: 'BALLAST_NUMBER_OF_ELEMENTS_UNDER_PANEL_IN_RAIL_WITH_COUPLER',
    BallastNumberOfRailsPerModule: 'BALLAST_NUMBER_OF_RAILS_PER_MODULE',
    BallastMaximumLiftForceOnPanel: 'BALLAST_MAXIMUM_LIFT_FORCE_ON_PANEL',
    BallastGroupsForLiftForce: 'BALLAST_GROUPS_FOR_LIFT_FORCE',
    BallastUpwardsLiftForceOnPanelPerBallastGroup: 'BALLAST_UPWARDS_LIFT_FORCE_ON_PANEL_PER_BALLAST_GROUP',
    BallastUpwardsLiftForcePerModuleInSingleSegments: 'BALLAST_UPWARDS_LIFT_FORCE_PER_MODULE_IN_SINGLE_SEGMENTS',
    BallastMaximumForcePerpendicularToPanelIn2RailConfiguration: 'BALLAST_MAXIMUM_FORCE_PERPENDICULAR_TO_PANEL_IN_2_RAIL_CONFIGURATION',
    BallastMaximumForcePerpendicularToPanelIn3RailConfiguration: 'BALLAST_MAXIMUM_FORCE_PERPENDICULAR_TO_PANEL_IN_3_RAIL_CONFIGURATION',
    BallastNumberOfBallastContainersInSegment: 'BALLAST_NUMBER_OF_BALLAST_CONTAINERS_IN_SEGMENT',
    BallastAdditionalBallastElementsPerBracket: 'BALLAST_ADDITIONAL_BALLAST_ELEMENTS_PER_BRACKET',
    BallastDetermineMaximumLiftCoefficientHalfPanel: 'BALLAST_DETERMINE_MAXIMUM_LIFT_COEFFICIENT_HALF_PANEL',
    BallastMaximumElementsUnderPanelForCouplerlessRailWithBrackets: 'BALLAST_MAXIMUM_ELEMENTS_UNDER_PANEL_FOR_COUPLERLESS_RAIL_WITH_BRACKETS',
    BallastElementCapacityPerRailUnitPerModule: 'BALLAST_ELEMENT_CAPACITY_PER_RAIL_UNIT_PER_MODULE',
    SegmentLinesOfSucceedingModulesWith3RdRail: 'SEGMENT_LINES_OF_SUCCEEDING_MODULES_WITH_3RD_RAIL',
    BallastTotalWeight: 'BALLAST_TOTAL_WEIGHT',
    TotalWeightLimitPerBallastGroup: 'TOTAL_WEIGHT_LIMIT_PER_BALLAST_GROUP',
    BallastWeightPerModuleInSegment: 'BALLAST_WEIGHT_PER_MODULE_IN_SEGMENT',
    BallastElementsWithoutTiltingMeasures: 'BALLAST_ELEMENTS_WITHOUT_TILTING_MEASURES',
    BallastElementsWithTiltingMeasures: 'BALLAST_ELEMENTS_WITH_TILTING_MEASURES',
    BallastMaxTotalWeightForHalfModules: 'BALLAST_MAX_TOTAL_WEIGHT_FOR_HALF_MODULES',
    BallastTotalWeightPositionsInRectangle: 'BALLAST_TOTAL_WEIGHT_POSITIONS_IN_RECTANGLE',
    BallastTotalWeightPerModuleInSegment: 'BALLAST_TOTAL_WEIGHT_PER_MODULE_IN_SEGMENT',
    BallastWeightAfterPerimeterTweak: 'BALLAST_WEIGHT_AFTER_PERIMETER_TWEAK',
    BallastWeightPerModuleInGrid: 'BALLAST_WEIGHT_PER_MODULE_IN_GRID',
    BallastCornerEdgezoneWidth: 'BALLAST_CORNER_EDGEZONE_WIDTH',
    BallastSubtractMountingSystemWeight: 'BALLAST_SUBTRACT_MOUNTING_SYSTEM_WEIGHT',
    BallastBlockedPerimeterPossible: 'BALLAST_BLOCKED_PERIMETER_POSSIBLE',
    BallastPerimeterTypes: 'BALLAST_PERIMETER_TYPES',
    BallastMaximumNumberOfBallastElementsInBottomLayer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_BOTTOM_LAYER',
    BallastMaximumNumberOfBallastElementsInTopLayer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_TOP_LAYER',
    BallastMaximumNumberOfBallastElementsInPrimaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_PRIMARY_BALLAST_CONTAINER',
    BallastMaximumNumberOfBallastElementsInSecondaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_SECONDARY_BALLAST_CONTAINER',
    BallastMaximumNumberOfBallastElementsInTertiaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_TERTIARY_BALLAST_CONTAINER',
    BallastDistributionPlanSegmentWithoutTiltingMeasures: 'BALLAST_DISTRIBUTION_PLAN_SEGMENT_WITHOUT_TILTING_MEASURES',
    BallastDistributionPlanSegmentWithTiltingMeasures: 'BALLAST_DISTRIBUTION_PLAN_SEGMENT_WITH_TILTING_MEASURES',
    BallastDistributionPlanField: 'BALLAST_DISTRIBUTION_PLAN_FIELD',
    BallastElementDistributionPerModuleWithoutTiltingMeasures: 'BALLAST_ELEMENT_DISTRIBUTION_PER_MODULE_WITHOUT_TILTING_MEASURES',
    BallastMaximumWeightInPrimaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_PRIMARY_BALLAST_CONTAINER',
    BallastMaximumWeightInSecondaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_SECONDARY_BALLAST_CONTAINER',
    BallastMaximumWeightInTertiaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_TERTIARY_BALLAST_CONTAINER',
    BallastContainerWeight: 'BALLAST_CONTAINER_WEIGHT',
    BallastTrayWeight: 'BALLAST_TRAY_WEIGHT',
    BallastExtenderWeight: 'BALLAST_EXTENDER_WEIGHT',
    BallastContainerWeightLimit: 'BALLAST_CONTAINER_WEIGHT_LIMIT',
    BallastRawWeight: 'BALLAST_RAW_WEIGHT',
    BallastSecondContainerPerimeterModuleThreshold: 'BALLAST_SECOND_CONTAINER_PERIMETER_MODULE_THRESHOLD',
    BallastSkippingWeightAfterSkipping: 'BALLAST_SKIPPING_WEIGHT_AFTER_SKIPPING',
    BallastSkippingTotalWeightInSkippingArea: 'BALLAST_SKIPPING_TOTAL_WEIGHT_IN_SKIPPING_AREA',
    BallastSkippingBallastGridWithSkipping: 'BALLAST_SKIPPING_BALLAST_GRID_WITH_SKIPPING',
    BallastSkippingBallastedPositionsInSkippingArea: 'BALLAST_SKIPPING_BALLASTED_POSITIONS_IN_SKIPPING_AREA',
    BallastSkippingBallastedPanelsWithBaseAlgorithmForSkipping: 'BALLAST_SKIPPING_BALLASTED_PANELS_WITH_BASE_ALGORITHM_FOR_SKIPPING',
    BallastSkippingSkippingAreas: 'BALLAST_SKIPPING_SKIPPING_AREAS',
    BallastSkippingSkippingAreaTypes: 'BALLAST_SKIPPING_SKIPPING_AREA_TYPES',
    BallastSkippingBallastMinimumNumberOfBallastedPositions: 'BALLAST_SKIPPING_BALLAST_MINIMUM_NUMBER_OF_BALLASTED_POSITIONS',
    BallastSkippingRequiredBallastedPositions: 'BALLAST_SKIPPING_REQUIRED_BALLASTED_POSITIONS',
    BallastSkippingSkippingFactor: 'BALLAST_SKIPPING_SKIPPING_FACTOR',
    BallastSkippingMaximumSkippingFactor: 'BALLAST_SKIPPING_MAXIMUM_SKIPPING_FACTOR',
    BallastSkippingOptimalSkippingFactor: 'BALLAST_SKIPPING_OPTIMAL_SKIPPING_FACTOR',
    BallastSkippingCanSkip: 'BALLAST_SKIPPING_CAN_SKIP',
    BallastSkippingMaximumBallastPreSkipping: 'BALLAST_SKIPPING_MAXIMUM_BALLAST_PRE_SKIPPING',
    BallastSkippingMaximumWeightPostSkipping: 'BALLAST_SKIPPING_MAXIMUM_WEIGHT_POST_SKIPPING',
    BallastSkippingMinimumBallastWeightPerPosition: 'BALLAST_SKIPPING_MINIMUM_BALLAST_WEIGHT_PER_POSITION',
    BallastSkippingMinimumSkippingFactor: 'BALLAST_SKIPPING_MINIMUM_SKIPPING_FACTOR',
    BallastSkippingMaximumNumberOfBallastedPositions: 'BALLAST_SKIPPING_MAXIMUM_NUMBER_OF_BALLASTED_POSITIONS',
    BallastSkippingSuperskipStage800AndLower: 'BALLAST_SKIPPING_SUPERSKIP_STAGE_800_AND_LOWER',
    BallastSkippingSuperskipStageAbove800: 'BALLAST_SKIPPING_SUPERSKIP_STAGE_ABOVE_800',
    BallastSkippingSuperskipStage: 'BALLAST_SKIPPING_SUPERSKIP_STAGE',
    BallastSkippingShiftCornerAdjacents: 'BALLAST_SKIPPING_SHIFT_CORNER_ADJACENTS',
    BallastSkippingStage2ExtraShiftingPeakVelocityPressureLimit: 'BALLAST_SKIPPING_STAGE_2_EXTRA_SHIFTING_PEAK_VELOCITY_PRESSURE_LIMIT',
    BallastSkippingModulePositionType: 'BALLAST_SKIPPING_MODULE_POSITION_TYPE',
    BallastSkippingShiftedBallastWeights: 'BALLAST_SKIPPING_SHIFTED_BALLAST_WEIGHTS',
    BallastRailWeight: 'BALLAST_RAIL_WEIGHT',
    BallastWeightFffArticleAmount: 'BALLAST_WEIGHT_FFF_ARTICLE_AMOUNT',
    BallastWeightFfWavePlusArticleAmount: 'BALLAST_WEIGHT_FF_WAVE_PLUS_ARTICLE_AMOUNT',
    BallastWeightApproximateWeightOfUnballastedSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfUnballastedSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfUnballastedCenterOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_CENTER_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfUnballastedCenterOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_CENTER_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfExposedRightSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_RIGHT_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfExposedRightSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_RIGHT_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfExposedLeftSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_LEFT_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfExposedLeftSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_LEFT_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfSharedSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_SHARED_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfSharedSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_SHARED_SIDE_OF_SINGLE_MODULE',
    BallastWeightOfRowConnectionCalculationRule: 'BALLAST_WEIGHT_OF_ROW_CONNECTION_CALCULATION_RULE',
    BallastWeightBallastMountingWeightGrid: 'BALLAST_WEIGHT_BALLAST_MOUNTING_WEIGHT_GRID',
    BallastWeightBallastMinimumWeightDoublePerimeterIsolatedUnit: 'BALLAST_WEIGHT_BALLAST_MINIMUM_WEIGHT_DOUBLE_PERIMETER_ISOLATED_UNIT',
    BaseBallastWeightCapacity: 'BASE_BALLAST_WEIGHT_CAPACITY',
    BallastWaveAdditionalRailsRequired: 'BALLAST_WAVE_ADDITIONAL_RAILS_REQUIRED',
    BallastWaveRailArticles: 'BALLAST_WAVE_RAIL_ARTICLES',
    BallastFffContainerArticles: 'BALLAST_FFF_CONTAINER_ARTICLES',
    BallastElementWeight: 'BALLAST_ELEMENT_WEIGHT',
    BallastMaximumWeightUnderPanelForCouplerlessRailWithBracket: 'BALLAST_MAXIMUM_WEIGHT_UNDER_PANEL_FOR_COUPLERLESS_RAIL_WITH_BRACKET',
    BallastFfWavePlusDualAdditionalRailBallastThreshold: 'BALLAST_FF_WAVE_PLUS_DUAL_ADDITIONAL_RAIL_BALLAST_THRESHOLD',
    BallastArticleWeightCapacityPerPosition: 'BALLAST_ARTICLE_WEIGHT_CAPACITY_PER_POSITION',
    BallastStandardGravitationalAcceleration: 'BALLAST_STANDARD_GRAVITATIONAL_ACCELERATION',
    BallastNorthTiltingPoint: 'BALLAST_NORTH_TILTING_POINT',
    BallastResultingMomentLiftForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_LIFT_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentLiftForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_LIFT_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentBaseMountingSystemForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BASE_MOUNTING_SYSTEM_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBaseMountingSystemForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BASE_MOUNTING_SYSTEM_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentPanelForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_PANEL_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentPanelForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_PANEL_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentBallastWithoutTiltingMeasuresForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITHOUT_TILTING_MEASURES_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBallastWithTiltingMeasuresForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITH_TILTING_MEASURES_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBallastWithTiltingMeasuresForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITH_TILTING_MEASURES_FOR_SOUTH_TILTING_POINT',
    BallastDistanceMountingSystemCenterToNorthTiltingPoint: 'BALLAST_DISTANCE_MOUNTING_SYSTEM_CENTER_TO_NORTH_TILTING_POINT',
    BallastDistancePanelCenterToNorthTiltingPoint: 'BALLAST_DISTANCE_PANEL_CENTER_TO_NORTH_TILTING_POINT',
    BallastDistanceWavePlusBallastPositionToNorthTiltingPoint: 'BALLAST_DISTANCE_WAVE_PLUS_BALLAST_POSITION_TO_NORTH_TILTING_POINT',
    BallastDistanceFlatfixFusionBallastArticlePositionToNorthTiltingPoint: 'BALLAST_DISTANCE_FLATFIX_FUSION_BALLAST_ARTICLE_POSITION_TO_NORTH_TILTING_POINT',
    BallastTotalResultingMomentForNorthTiltingPointWithoutTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_WITHOUT_TILTING_MEASURES',
    BallastTotalResultingMomentForNorthTiltingPointWithTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_WITH_TILTING_MEASURES',
    BallastTotalResultingMomentForNorthTiltingPointBeforeBallast: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_BEFORE_BALLAST',
    BallastSouthTiltingPoint: 'BALLAST_SOUTH_TILTING_POINT',
    BallastDistanceMountingSystemCenterToSouthTiltingPoint: 'BALLAST_DISTANCE_MOUNTING_SYSTEM_CENTER_TO_SOUTH_TILTING_POINT',
    BallastDistancePanelCenterToSouthTiltingPoint: 'BALLAST_DISTANCE_PANEL_CENTER_TO_SOUTH_TILTING_POINT',
    BallastDistanceBallastPositionToSouthTiltingPoint: 'BALLAST_DISTANCE_BALLAST_POSITION_TO_SOUTH_TILTING_POINT',
    BallastTotalResultingMomentForSouthTiltingPointWithTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_SOUTH_TILTING_POINT_WITH_TILTING_MEASURES',
    BallastResultingMomentsForRoof: 'BALLAST_RESULTING_MOMENTS_FOR_ROOF',
    BallastResultingMomentAdditionalPerimeterBracketForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_ADDITIONAL_PERIMETER_BRACKET_FOR_NORTH_TILTING_POINT',
    BallastAdditionalBallastDistributionPositionsRequiredAgainstTilting: 'BALLAST_ADDITIONAL_BALLAST_DISTRIBUTION_POSITIONS_REQUIRED_AGAINST_TILTING',
    BallastAdditionalDistanceToTiltingPoint: 'BALLAST_ADDITIONAL_DISTANCE_TO_TILTING_POINT',
    BallastElement: 'BALLAST_ELEMENT',
    BallastCustomBallastElementWeight: 'BALLAST_CUSTOM_BALLAST_ELEMENT_WEIGHT',
    BallastWaveBracketsBallastArticles: 'BALLAST_WAVE_BRACKETS_BALLAST_ARTICLES',
    BallastWaveMiddleBaseBallastArticles: 'BALLAST_WAVE_MIDDLE_BASE_BALLAST_ARTICLES',
    BallastWaveHighBaseBallastArticles: 'BALLAST_WAVE_HIGH_BASE_BALLAST_ARTICLES',
    BallastWaveLowBaseBallastArticles: 'BALLAST_WAVE_LOW_BASE_BALLAST_ARTICLES',
    BallastMinimumBallastWeightToPreventTilting: 'BALLAST_MINIMUM_BALLAST_WEIGHT_TO_PREVENT_TILTING',
    MarginPerBallastElement: 'MARGIN_PER_BALLAST_ELEMENT',
    WidthUprightBallastElement: 'WIDTH_UPRIGHT_BALLAST_ELEMENT',
    WidthBallastElementOnSide: 'WIDTH_BALLAST_ELEMENT_ON_SIDE',
    AdditionalCapacityTrayWithUprightElements: 'ADDITIONAL_CAPACITY_TRAY_WITH_UPRIGHT_ELEMENTS',
    AdditionalCapacityTrayWithElementsOnSide: 'ADDITIONAL_CAPACITY_TRAY_WITH_ELEMENTS_ON_SIDE',
    TrayOverspan: 'TRAY_OVERSPAN',
    CapacityExtenderWithUprightElements: 'CAPACITY_EXTENDER_WITH_UPRIGHT_ELEMENTS',
    CapacityExtenderWithElementsOnSide: 'CAPACITY_EXTENDER_WITH_ELEMENTS_ON_SIDE',
    ElementsInPerimeterBracket: 'ELEMENTS_IN_PERIMETER_BRACKET',
    AvailableBallastDistributionPositionsAndElementCapacity: 'AVAILABLE_BALLAST_DISTRIBUTION_POSITIONS_AND_ELEMENT_CAPACITY',
    LeastCostlyRailCombination: 'LEAST_COSTLY_RAIL_COMBINATION',
    ClickfitNumberOfRails: 'CLICKFIT_NUMBER_OF_RAILS',
    ClickfitModuleSpace: 'CLICKFIT_MODULE_SPACE',
    ClickfitRoofSectionsCovered: 'CLICKFIT_ROOF_SECTIONS_COVERED',
    ClickfitNumberOfAttachmentsPerRailLine: 'CLICKFIT_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    MaxDistanceBetweenAttachments: 'MAX_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitMinNumberOfRoofAttachments: 'CLICKFIT_MIN_NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitNumberOfAuxiliarySets: 'CLICKFIT_NUMBER_OF_AUXILIARY_SETS',
    ClickfitMaximumTilePressure: 'CLICKFIT_MAXIMUM_TILE_PRESSURE',
    ClickfitMinimumDistanceAttachmentToRailEnd: 'CLICKFIT_MINIMUM_DISTANCE_ATTACHMENT_TO_RAIL_END',
    ClickfitMaximumDistanceAttachmentToRailEnd: 'CLICKFIT_MAXIMUM_DISTANCE_ATTACHMENT_TO_RAIL_END',
    ClickfitMinimumRoofSectionsCovered: 'CLICKFIT_MINIMUM_ROOF_SECTIONS_COVERED',
    ClickfitTotalOverspanWithMinimumRoofSectionsCovered: 'CLICKFIT_TOTAL_OVERSPAN_WITH_MINIMUM_ROOF_SECTIONS_COVERED',
    ClickfitCoverAdditionalSection: 'CLICKFIT_COVER_ADDITIONAL_SECTION',
    ClickfitNumberOfSectionsBetweenAttachments: 'CLICKFIT_NUMBER_OF_SECTIONS_BETWEEN_ATTACHMENTS',
    ClickfitRailsInLineWithRoofSection: 'CLICKFIT_RAILS_IN_LINE_WITH_ROOF_SECTION',
    ClickfitRelativePanelSizeBetweenRails: 'CLICKFIT_RELATIVE_PANEL_SIZE_BETWEEN_RAILS',
    ClickfitGridCellSpace: 'CLICKFIT_GRID_CELL_SPACE',
    ClickfitEvoBom: 'CLICKFIT_EVO_BOM',
    ClickfitEvoBomSegment: 'CLICKFIT_EVO_BOM_SEGMENT',
    NumberOfRoofAttachments: 'NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitEvoCableClips: 'CLICKFIT_EVO_CABLE_CLIPS',
    ClickfitEvoMidClamps: 'CLICKFIT_EVO_MID_CLAMPS',
    ClickfitEvoEndClamps: 'CLICKFIT_EVO_END_CLAMPS',
    ClickfitEvoBitTorx: 'CLICKFIT_EVO_BIT_TORX',
    ClickfitEvoNumberOfCableClips: 'CLICKFIT_EVO_NUMBER_OF_CABLE_CLIPS',
    NumberOfProfileFasteners: 'NUMBER_OF_PROFILE_FASTENERS',
    ClickfitEvoExtraVerticalRailScrews: 'CLICKFIT_EVO_EXTRA_VERTICAL_RAIL_SCREWS',
    ClickfitEvoNumberOfPanelsPerOptimizer: 'CLICKFIT_EVO_NUMBER_OF_PANELS_PER_OPTIMIZER',
    ClickfitEvoNumberOfClamps: 'CLICKFIT_EVO_NUMBER_OF_CLAMPS',
    ClickfitEvoNumberOfMidClamps: 'CLICKFIT_EVO_NUMBER_OF_MID_CLAMPS',
    ClickfitEvoNumberOfEndClamps: 'CLICKFIT_EVO_NUMBER_OF_END_CLAMPS',
    ClickfitEvoEndClampSupports: 'CLICKFIT_EVO_END_CLAMP_SUPPORTS',
    ClickfitEvoEndCapWithoutClampSupport: 'CLICKFIT_EVO_END_CAP_WITHOUT_CLAMP_SUPPORT',
    ClickfitEvoAuxiliarySets: 'CLICKFIT_EVO_AUXILIARY_SETS',
    ClickfitEvoCouplers: 'CLICKFIT_EVO_COUPLERS',
    ClickfitEvoRails: 'CLICKFIT_EVO_RAILS',
    ClickfitEvoEndCaps: 'CLICKFIT_EVO_END_CAPS',
    ClickfitEvoPanelAndMountingCombinedWeight: 'CLICKFIT_EVO_PANEL_AND_MOUNTING_COMBINED_WEIGHT',
    ClickfitEvoAverageMountingSystemWeight: 'CLICKFIT_EVO_AVERAGE_MOUNTING_SYSTEM_WEIGHT',
    ClickfitEvoLockingScrews: 'CLICKFIT_EVO_LOCKING_SCREWS',
    ClickfitEvoVerticalLockingScrewsQuantity: 'CLICKFIT_EVO_VERTICAL_LOCKING_SCREWS_QUANTITY',
    ClickfitEvoClipType: 'CLICKFIT_EVO_CLIP_TYPE',
    ClickfitEvoClampType: 'CLICKFIT_EVO_CLAMP_TYPE',
    ClickfitEvoIsClipUsed: 'CLICKFIT_EVO_IS_CLIP_USED',
    ClickfitEvoCorrugatedMountingBrackets: 'CLICKFIT_EVO_CORRUGATED_MOUNTING_BRACKETS',
    ClickfitEvoCorrugatedSteelAdapters: 'CLICKFIT_EVO_CORRUGATED_STEEL_ADAPTERS',
    ClickfitEvoTilesHookSpacers: 'CLICKFIT_EVO_TILES_HOOK_SPACERS',
    ClickfitEvoTilesHooks: 'CLICKFIT_EVO_TILES_HOOKS',
    ClickfitEvoSlateHooks: 'CLICKFIT_EVO_SLATE_HOOKS',
    ClickfitEvoSteelSheetScrews: 'CLICKFIT_EVO_STEEL_SHEET_SCREWS',
    ClickfitEvoMountingProfiles: 'CLICKFIT_EVO_MOUNTING_PROFILES',
    ClickfitEvoSteelAttachmentType: 'CLICKFIT_EVO_STEEL_ATTACHMENT_TYPE',
    RoofAttachmentLiftLimit: 'ROOF_ATTACHMENT_LIFT_LIMIT',
    RoofAttachmentPressureLimit: 'ROOF_ATTACHMENT_PRESSURE_LIMIT',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLineForPressure: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE_FOR_PRESSURE',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLineForLift: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE_FOR_LIFT',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLine: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    ClickfitEvoIdealDistanceBetweenAttachments: 'CLICKFIT_EVO_IDEAL_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitEvoMinimumDistanceBetweenAttachments: 'CLICKFIT_EVO_MINIMUM_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitEvoMaxNumberOfAttachmentsPerRailLine: 'CLICKFIT_EVO_MAX_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    ClickfitEvoLiftForceOnModuleClamp: 'CLICKFIT_EVO_LIFT_FORCE_ON_MODULE_CLAMP',
    ClickfitEvoPressureForceOnModuleClamp: 'CLICKFIT_EVO_PRESSURE_FORCE_ON_MODULE_CLAMP',
    MaximumAllowableBendingMomentForLift: 'MAXIMUM_ALLOWABLE_BENDING_MOMENT_FOR_LIFT',
    MaximumAllowableBendingMomentForPressure: 'MAXIMUM_ALLOWABLE_BENDING_MOMENT_FOR_PRESSURE',
    AllowableForceFractionFastenerForMountingProfile: 'ALLOWABLE_FORCE_FRACTION_FASTENER_FOR_MOUNTING_PROFILE',
    ClickfitEvoMaximumRailSpan: 'CLICKFIT_EVO_MAXIMUM_RAIL_SPAN',
    ClickfitEvoSeamClamps: 'CLICKFIT_EVO_SEAM_CLAMPS',
    UseForcesOnPanelForAttachments: 'USE_FORCES_ON_PANEL_FOR_ATTACHMENTS',
    ClickfitEvoHangerBoltArticle: 'CLICKFIT_EVO_HANGER_BOLT_ARTICLE',
    ClickfitEvoRafterScrewArticleSetArticle: 'CLICKFIT_EVO_RAFTER_SCREW_ARTICLE_SET_ARTICLE',
    ClickfitEvoHangerBolts: 'CLICKFIT_EVO_HANGER_BOLTS',
    ClickfitEvoWashers: 'CLICKFIT_EVO_WASHERS',
    ClickfitEvoTixophalteKits: 'CLICKFIT_EVO_TIXOPHALTE_KITS',
    ClickfitEvoEpdmKits: 'CLICKFIT_EVO_EPDM_KITS',
    ClickfitEvoRivets: 'CLICKFIT_EVO_RIVETS',
    ClickfitEvoProHookRafterScrews: 'CLICKFIT_EVO_PRO_HOOK_RAFTER_SCREWS',
    ClickfitEvoMountingProfilesArticleSetArticle: 'CLICKFIT_EVO_MOUNTING_PROFILES_ARTICLE_SET_ARTICLE',
    IdealNumberOfMountingProfilesPerSideForPressure: 'IDEAL_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE_FOR_PRESSURE',
    MinimumNumberOfMountingProfilesPerSide: 'MINIMUM_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    MaximumNumberOfMountingProfilesPerSide: 'MAXIMUM_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    NumberOfMountingProfilesPerSide: 'NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    ProfileFastenerLiftLimit: 'PROFILE_FASTENER_LIFT_LIMIT',
    WorstForceFractionPerNumberOfFastenersPerProfile: 'WORST_FORCE_FRACTION_PER_NUMBER_OF_FASTENERS_PER_PROFILE',
    IdealNumberOfMountingProfilesPerSideForLift: 'IDEAL_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE_FOR_LIFT',
    MaxDownwardsForceOnMountingProfilePerSegment: 'MAX_DOWNWARDS_FORCE_ON_MOUNTING_PROFILE_PER_SEGMENT',
    MaxUpwardsForceOnMountingProfilePerSegment: 'MAX_UPWARDS_FORCE_ON_MOUNTING_PROFILE_PER_SEGMENT',
    MaxUpwardsForceOnProfileFastenerPerSegment: 'MAX_UPWARDS_FORCE_ON_PROFILE_FASTENER_PER_SEGMENT',
    MaxUpwardsForceOnFastenerForRoof: 'MAX_UPWARDS_FORCE_ON_FASTENER_FOR_ROOF',
    ClickfitBasicBom: 'CLICKFIT_BASIC_BOM',
    ClickfitBasicBomSegment: 'CLICKFIT_BASIC_BOM_SEGMENT',
    ClickfitBasicEndClampsSegment: 'CLICKFIT_BASIC_END_CLAMPS_SEGMENT',
    ClickfitBasicMountingScrewPanelSegment: 'CLICKFIT_BASIC_MOUNTING_SCREW_PANEL_SEGMENT',
    ClickfitBasicModuleClampSegment: 'CLICKFIT_BASIC_MODULE_CLAMP_SEGMENT',
    ClickfitBasicSupportsSegment: 'CLICKFIT_BASIC_SUPPORTS_SEGMENT',
    ClickfitBasicMountingRailSegment: 'CLICKFIT_BASIC_MOUNTING_RAIL_SEGMENT',
    ClickfitBasicCouplingStripSegment: 'CLICKFIT_BASIC_COUPLING_STRIP_SEGMENT',
    ClickfitBasicCouplingScrewSegment: 'CLICKFIT_BASIC_COUPLING_SCREW_SEGMENT',
    ClickfitBasicNumberOfRoofAttachments: 'CLICKFIT_BASIC_NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitBasicAuxiliarySet: 'CLICKFIT_BASIC_AUXILIARY_SET',
    ClickfitBasicSteelSupportScrew: 'CLICKFIT_BASIC_STEEL_SUPPORT_SCREW',
    ClickfitBasicSteelEpdmTapes: 'CLICKFIT_BASIC_STEEL_EPDM_TAPES',
    ClickfitBasicTiledRoofHook: 'CLICKFIT_BASIC_TILED_ROOF_HOOK',
    ClickfitBasicTiledRoofHookNut: 'CLICKFIT_BASIC_TILED_ROOF_HOOK_NUT',
    ClickfitBasicTiledRoofHookBolt: 'CLICKFIT_BASIC_TILED_ROOF_HOOK_BOLT',
    ClickfitBasicBitumenSupportScrew: 'CLICKFIT_BASIC_BITUMEN_SUPPORT_SCREW',
    ClickfitBasicBitumenSupportScrewType: 'CLICKFIT_BASIC_BITUMEN_SUPPORT_SCREW_TYPE',
    ClickfitBasicBitumenTixophalteKits: 'CLICKFIT_BASIC_BITUMEN_TIXOPHALTE_KITS',
    ClickfitBasicBlackEndCap: 'CLICKFIT_BASIC_BLACK_END_CAP',
    ClickfitBasicBlackColorCaps: 'CLICKFIT_BASIC_BLACK_COLOR_CAPS',
    FlatfixEndClamp: 'FLATFIX_END_CLAMP',
    FlatfixBaseProfileRow: 'FLATFIX_BASE_PROFILE_ROW',
    FlatfixSelfTappingScrews: 'FLATFIX_SELF_TAPPING_SCREWS',
    FlatfixLeftWindDeflector: 'FLATFIX_LEFT_WIND_DEFLECTOR',
    FlatfixRightWindDeflector: 'FLATFIX_RIGHT_WIND_DEFLECTOR',
    FlatfixFusionRearWindDeflector: 'FLATFIX_FUSION_REAR_WIND_DEFLECTOR',
    FlatfixRearWindDeflectorOffset: 'FLATFIX_REAR_WIND_DEFLECTOR_OFFSET',
    FlatfixCableClip: 'FLATFIX_CABLE_CLIP',
    FlatfixCableExitGuide: 'FLATFIX_CABLE_EXIT_GUIDE',
    FlatfixCableExitGuideSide: 'FLATFIX_CABLE_EXIT_GUIDE_SIDE',
    FlatfixMidClamp: 'FLATFIX_MID_CLAMP',
    FlatfixBaseProfile: 'FLATFIX_BASE_PROFILE',
    FlatfixBasePlate: 'FLATFIX_BASE_PLATE',
    FlatfixBasePlateBracket: 'FLATFIX_BASE_PLATE_BRACKET',
    FlatfixHighBase: 'FLATFIX_HIGH_BASE',
    FlatfixHighBaseMountingScrews: 'FLATFIX_HIGH_BASE_MOUNTING_SCREWS',
    FlatfixLowBase: 'FLATFIX_LOW_BASE',
    FlatfixLowBaseExtension: 'FLATFIX_LOW_BASE_EXTENSION',
    FlatfixStabilizerScrew: 'FLATFIX_STABILIZER_SCREW',
    FlatfixBallastContainer: 'FLATFIX_BALLAST_CONTAINER',
    FlatfixStabilizer: 'FLATFIX_STABILIZER',
    FlatfixBallastContainerArticle: 'FLATFIX_BALLAST_CONTAINER_ARTICLE',
    FlatfixLandscapeExtensionNeeded: 'FLATFIX_LANDSCAPE_EXTENSION_NEEDED',
    FlatfixBaseplateSurface: 'FLATFIX_BASEPLATE_SURFACE',
    FlatfixNumberOfBasePlates: 'FLATFIX_NUMBER_OF_BASE_PLATES',
    FlatfixTpoMats: 'FLATFIX_TPO_MATS',
    FlatfixGridCellSpace: 'FLATFIX_GRID_CELL_SPACE',
    FlatfixRearWindDeflectorDimension: 'FLATFIX_REAR_WIND_DEFLECTOR_DIMENSION',
    FlatfixHalfModulesOffset: 'FLATFIX_HALF_MODULES_OFFSET',
    FlatfixBlackScrewCaps: 'FLATFIX_BLACK_SCREW_CAPS',
    FlatfixFusionBom: 'FLATFIX_FUSION_BOM',
    FlatfixFusionBomSegment: 'FLATFIX_FUSION_BOM_SEGMENT',
    FlatfixFusionLowerMountingScrewRearWindDeflector: 'FLATFIX_FUSION_LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    FlatfixFusionUpperMountingScrewRearWindDeflector: 'FLATFIX_FUSION_UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    FlatfixFusionGroundingPlan: 'FLATFIX_FUSION_GROUNDING_PLAN',
    FlatfixFusionGroundingClip: 'FLATFIX_FUSION_GROUNDING_CLIP',
    FlatfixFusionGroundingBracket: 'FLATFIX_FUSION_GROUNDING_BRACKET',
    FlatfixFusionScrewGroundingBracket: 'FLATFIX_FUSION_SCREW_GROUNDING_BRACKET',
    FlatfixFusionGroundingScrewSideDeflector: 'FLATFIX_FUSION_GROUNDING_SCREW_SIDE_DEFLECTOR',
    FlatfixFusionGroundingSpring: 'FLATFIX_FUSION_GROUNDING_SPRING',
    FlatfixModuleDepth: 'FLATFIX_MODULE_DEPTH',
    FlatfixModuleSpace: 'FLATFIX_MODULE_SPACE',
    FlatfixFusionReferenceRowConnectorLength: 'FLATFIX_FUSION_REFERENCE_ROW_CONNECTOR_LENGTH',
    FlatfixFusionRowDistanceFactor: 'FLATFIX_FUSION_ROW_DISTANCE_FACTOR',
    FlatfixFusionDownwardForcePerPanelLimit: 'FLATFIX_FUSION_DOWNWARD_FORCE_PER_PANEL_LIMIT',
    FlatfixFusionDownwardForcePerPanelLimitExceeded: 'FLATFIX_FUSION_DOWNWARD_FORCE_PER_PANEL_LIMIT_EXCEEDED',
    FlatfixFusionSideWindDeflectorMountingScrew: 'FLATFIX_FUSION_SIDE_WIND_DEFLECTOR_MOUNTING_SCREW',
    FlatfixFusionMountingScrewLowerClamp: 'FLATFIX_FUSION_MOUNTING_SCREW_LOWER_CLAMP',
    FlatfixFusionSideDeflectors: 'FLATFIX_FUSION_SIDE_DEFLECTORS',
    FlatfixFusionMountingScrewLowerClampArticleSetArticle: 'FLATFIX_FUSION_MOUNTING_SCREW_LOWER_CLAMP_ARTICLE_SET_ARTICLE',
    FlatfixFusionLowBaseArticleSetArticle: 'FLATFIX_FUSION_LOW_BASE_ARTICLE_SET_ARTICLE',
    FlatfixFusionHighBaseArticleSetArticle: 'FLATFIX_FUSION_HIGH_BASE_ARTICLE_SET_ARTICLE',
    FlatfixFusionBaseProfilePanelArticleSetArticle: 'FLATFIX_FUSION_BASE_PROFILE_PANEL_ARTICLE_SET_ARTICLE',
    FlatfixFusionLeftWindDeflectorArticle: 'FLATFIX_FUSION_LEFT_WIND_DEFLECTOR_ARTICLE',
    FlatfixFusionRightWindDeflectorArticle: 'FLATFIX_FUSION_RIGHT_WIND_DEFLECTOR_ARTICLE',
    FlatfixFusionRearWindDeflectorArticle: 'FLATFIX_FUSION_REAR_WIND_DEFLECTOR_ARTICLE',
    FlatfixWaveNumberBallastBrackets: 'FLATFIX_WAVE_NUMBER_BALLAST_BRACKETS',
    FlatfixWeightPerBasePlateGroup: 'FLATFIX_WEIGHT_PER_BASE_PLATE_GROUP',
    FlatfixWaveRowDistance: 'FLATFIX_WAVE_ROW_DISTANCE',
    FlatfixWaveRailUnitProtrusionLength: 'FLATFIX_WAVE_RAIL_UNIT_PROTRUSION_LENGTH',
    FlatfixWavePlusBallastDistributionTypes: 'FLATFIX_WAVE_PLUS_BALLAST_DISTRIBUTION_TYPES',
    FlatfixWavePlusBom: 'FLATFIX_WAVE_PLUS_BOM',
    FlatfixWavePlusBomSegment: 'FLATFIX_WAVE_PLUS_BOM_SEGMENT',
    FlatfixWavePlusSideWindDeflectorNumberOfSets: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_NUMBER_OF_SETS',
    FlatfixWavePlusStabilizerGap: 'FLATFIX_WAVE_PLUS_STABILIZER_GAP',
    FlatfixWavePlusBracketsForStabilizerGap: 'FLATFIX_WAVE_PLUS_BRACKETS_FOR_STABILIZER_GAP',
    FlatfixWavePlusCableBrackets: 'FLATFIX_WAVE_PLUS_CABLE_BRACKETS',
    FlatfixWavePlusBallastBrackets: 'FLATFIX_WAVE_PLUS_BALLAST_BRACKETS',
    FlatfixWavePlusStabilizer: 'FLATFIX_WAVE_PLUS_STABILIZER',
    FlatfixWavePlusStabilizerArticle: 'FLATFIX_WAVE_PLUS_STABILIZER_ARTICLE',
    FlatfixWavePlusStabilizerLength: 'FLATFIX_WAVE_PLUS_STABILIZER_LENGTH',
    FlatfixWavePlusStabilizerOverspan: 'FLATFIX_WAVE_PLUS_STABILIZER_OVERSPAN',
    FlatfixWavePlusMinimumStabilizerOverspan: 'FLATFIX_WAVE_PLUS_MINIMUM_STABILIZER_OVERSPAN',
    FlatfixWavePlusBasePlate: 'FLATFIX_WAVE_PLUS_BASE_PLATE',
    FlatfixWavePlusRailUnit1P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_1P',
    FlatfixWavePlusRailUnit2P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_2P',
    FlatfixWavePlusOldRailUnit2P: 'FLATFIX_WAVE_PLUS_OLD_RAIL_UNIT_2P',
    FlatfixWavePlusRailUnit3P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_3P',
    FlatfixWavePlusRailUnit4P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_4P',
    FlatfixWavePlusDualRailUnitChoice: 'FLATFIX_WAVE_PLUS_DUAL_RAIL_UNIT_CHOICE',
    FlatfixWavePlusRailStartUnit4P: 'FLATFIX_WAVE_PLUS_RAIL_START_UNIT_4P',
    FlatfixWavePlusRailWidth: 'FLATFIX_WAVE_PLUS_RAIL_WIDTH',
    FlatfixWavePlusWidePanelSolutionNeeded: 'FLATFIX_WAVE_PLUS_WIDE_PANEL_SOLUTION_NEEDED',
    FlatfixWavePlusMeasuringBar: 'FLATFIX_WAVE_PLUS_MEASURING_BAR',
    FlatfixWavePlusModuleSpacer: 'FLATFIX_WAVE_PLUS_MODULE_SPACER',
    FlatfixWavePlusModuleUnlockTool: 'FLATFIX_WAVE_PLUS_MODULE_UNLOCK_TOOL',
    FlatfixWavePlusMinimumRailsUnderModule: 'FLATFIX_WAVE_PLUS_MINIMUM_RAILS_UNDER_MODULE',
    FlatfixWavePlusMaxLiftForceOnPanelIn2RailConfig: 'FLATFIX_WAVE_PLUS_MAX_LIFT_FORCE_ON_PANEL_IN_2_RAIL_CONFIG',
    FlatfixWavePlusMaxLiftForceOnPanelIn3RailConfig: 'FLATFIX_WAVE_PLUS_MAX_LIFT_FORCE_ON_PANEL_IN_3_RAIL_CONFIG',
    FlatfixWavePlusSidePlatesPlacement: 'FLATFIX_WAVE_PLUS_SIDE_PLATES_PLACEMENT',
    FlatfixWavePlusRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusOptimalRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_OPTIMAL_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusRearWindDeflectorLength: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_LENGTH',
    FlatfixWavePlusOptimalRearWindDeflectorLength: 'FLATFIX_WAVE_PLUS_OPTIMAL_REAR_WIND_DEFLECTOR_LENGTH',
    FlatfixWavePlusMarginRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_MARGIN_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusRearWindDeflectorArticleSetArticle: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_ARTICLE_SET_ARTICLE',
    FlatfixWavePlusRearWindDeflector: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR',
    FlatfixWavePlusRearWindDeflectorClip: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_CLIP',
    FlatfixWavePlusPerimeterBracket: 'FLATFIX_WAVE_PLUS_PERIMETER_BRACKET',
    FlatfixWavePlusTray: 'FLATFIX_WAVE_PLUS_TRAY',
    FlatfixWavePlusExtender: 'FLATFIX_WAVE_PLUS_EXTENDER',
    FlatfixWavePlusMinOverspanRearWindDeflector: 'FLATFIX_WAVE_PLUS_MIN_OVERSPAN_REAR_WIND_DEFLECTOR',
    FlatfixWavePlusRailUnitPlacementRegularRails: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_PLACEMENT_REGULAR_RAILS',
    FlatfixWavePlusRailUnitPlacement3RdRails: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_PLACEMENT_3RD_RAILS',
    FlatfixPlusWeightCapacityPerBallastArticleTypePosition: 'FLATFIX_PLUS_WEIGHT_CAPACITY_PER_BALLAST_ARTICLE_TYPE_POSITION',
    FlatfixWavePlusMaximumDistanceBetweenRailsForTrays: 'FLATFIX_WAVE_PLUS_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_TRAYS',
    FlatfixWavePlusTraysPossible: 'FLATFIX_WAVE_PLUS_TRAYS_POSSIBLE',
    FlatfixWavePlusAdditionalRailUnitForBallastAllowed: 'FLATFIX_WAVE_PLUS_ADDITIONAL_RAIL_UNIT_FOR_BALLAST_ALLOWED',
    FlatfixWavePlusMinimumDistanceBetweenRailsForExtender: 'FLATFIX_WAVE_PLUS_MINIMUM_DISTANCE_BETWEEN_RAILS_FOR_EXTENDER',
    FlatfixWavePlusMaximumDistanceBetweenRailsForExtender: 'FLATFIX_WAVE_PLUS_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_EXTENDER',
    FlatfixWavePlusExtendersPossible: 'FLATFIX_WAVE_PLUS_EXTENDERS_POSSIBLE',
    FlatfixWavePlusTrayArticle: 'FLATFIX_WAVE_PLUS_TRAY_ARTICLE',
    FlatfixWavePlusExtenderArticle: 'FLATFIX_WAVE_PLUS_EXTENDER_ARTICLE',
    FlatfixWavePlusRegularRailUnitOffset: 'FLATFIX_WAVE_PLUS_REGULAR_RAIL_UNIT_OFFSET',
    FlatfixWavePlusBasePlateOffsets: 'FLATFIX_WAVE_PLUS_BASE_PLATE_OFFSETS',
    FlatfixWavePlusReducedInsideRailCapacityWithTray: 'FLATFIX_WAVE_PLUS_REDUCED_INSIDE_RAIL_CAPACITY_WITH_TRAY',
    FlatfixWavePlusSideWindDeflectorSetArticleSetArticle: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET_ARTICLE_SET_ARTICLE',
    FlatfixWavePlusSideWindDeflectorSet: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET',
    FlatfixWavePlusSideWindDeflectorClamp: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_CLAMP',
    WaveBasePlatesPerRailUnit: 'WAVE_BASE_PLATES_PER_RAIL_UNIT',
    WaveMat: 'WAVE_MAT',
    WaveTotalWeightLimit: 'WAVE_TOTAL_WEIGHT_LIMIT',
    DesignValueExceptionalSnowLoadOnGround: 'DESIGN_VALUE_EXCEPTIONAL_SNOW_LOAD_ON_GROUND',
    ExceptionalSnowLoadCoefficient: 'EXCEPTIONAL_SNOW_LOAD_COEFFICIENT',
    ExceptionalSnowLoadOnRoof: 'EXCEPTIONAL_SNOW_LOAD_ON_ROOF',
    ProductCanBeCalculatedWithSnow: 'PRODUCT_CAN_BE_CALCULATED_WITH_SNOW',
    RegularSnowLoadOnTheRoof: 'REGULAR_SNOW_LOAD_ON_THE_ROOF',
    SnowLoadApplySnowLoad: 'SNOW_LOAD_APPLY_SNOW_LOAD',
    SnowLoadCharacteristicGroundLoad: 'SNOW_LOAD_CHARACTERISTIC_GROUND_LOAD',
    SnowLoadEffectiveFormCoefficient: 'SNOW_LOAD_EFFECTIVE_FORM_COEFFICIENT',
    ExceptionalSnowLoadEffectiveFormCoefficient: 'EXCEPTIONAL_SNOW_LOAD_EFFECTIVE_FORM_COEFFICIENT',
    SnowLoadExposureFactor: 'SNOW_LOAD_EXPOSURE_FACTOR',
    SnowLoadFormCoefficientOne: 'SNOW_LOAD_FORM_COEFFICIENT_ONE',
    SnowLoadFormCoefficientTwo: 'SNOW_LOAD_FORM_COEFFICIENT_TWO',
    SnowLoadFormCoefficientFive: 'SNOW_LOAD_FORM_COEFFICIENT_FIVE',
    ExceptionalSnowLoadFormCoefficientFive: 'EXCEPTIONAL_SNOW_LOAD_FORM_COEFFICIENT_FIVE',
    SnowLoadGroundLoadOverReferencePeriod: 'SNOW_LOAD_GROUND_LOAD_OVER_REFERENCE_PERIOD',
    RegularSnowLoadPerpendicularDownForceOnPanel: 'REGULAR_SNOW_LOAD_PERPENDICULAR_DOWN_FORCE_ON_PANEL',
    SnowLoadProbabilityFactor: 'SNOW_LOAD_PROBABILITY_FACTOR',
    SnowLoadVariationCoefficientAnnualMaximum: 'SNOW_LOAD_VARIATION_COEFFICIENT_ANNUAL_MAXIMUM',
    SnowLoadThermalCoefficient: 'SNOW_LOAD_THERMAL_COEFFICIENT',
    SnowLoadSnowWeightDensity: 'SNOW_LOAD_SNOW_WEIGHT_DENSITY',
    SnowLoadOnGround: 'SNOW_LOAD_ON_GROUND',
    SnowLoadOnGroundLimit: 'SNOW_LOAD_ON_GROUND_LIMIT',
    SnowLoadOnGroundSpain: 'SNOW_LOAD_ON_GROUND_SPAIN',
    SnowLoadFreezeThawFactorSpain: 'SNOW_LOAD_FREEZE_THAW_FACTOR_SPAIN',
    InExceptionalSnowLoadArea: 'IN_EXCEPTIONAL_SNOW_LOAD_AREA',
    CalculateExceptionalSnowLoads: 'CALCULATE_EXCEPTIONAL_SNOW_LOADS',
    ExceptionalSnowLoadOnPanel: 'EXCEPTIONAL_SNOW_LOAD_ON_PANEL',
    FactoredExceptionalSnowPressureOnPanel: 'FACTORED_EXCEPTIONAL_SNOW_PRESSURE_ON_PANEL',
    FactoredExceptionalSnowPressurePerModule: 'FACTORED_EXCEPTIONAL_SNOW_PRESSURE_PER_MODULE',
    CombinationFactorWindInAccidentalDesignSituations: 'COMBINATION_FACTOR_WIND_IN_ACCIDENTAL_DESIGN_SITUATIONS',
    ExceptionalSnowLoadCombination: 'EXCEPTIONAL_SNOW_LOAD_COMBINATION',
    WorstCaseFactoredSnowPressureOnPanel: 'WORST_CASE_FACTORED_SNOW_PRESSURE_ON_PANEL',
    WorstCaseSnowLoadOnGround: 'WORST_CASE_SNOW_LOAD_ON_GROUND',
    AlternativeLoadEquations: 'ALTERNATIVE_LOAD_EQUATIONS',
    AveragePressureOnModule: 'AVERAGE_PRESSURE_ON_MODULE',
    AverageWindloadLift: 'AVERAGE_WINDLOAD_LIFT',
    AveragePressurePerAttachmentForSegment: 'AVERAGE_PRESSURE_PER_ATTACHMENT_FOR_SEGMENT',
    AverageLiftPerAttachmentForSegment: 'AVERAGE_LIFT_PER_ATTACHMENT_FOR_SEGMENT',
    StandardWindloadPressureCoefficientPlus: 'STANDARD_WINDLOAD_PRESSURE_COEFFICIENT_PLUS',
    WindloadPressureCoefficientMinus: 'WINDLOAD_PRESSURE_COEFFICIENT_MINUS',
    StandardWindloadPerpendicularWindDownForceOnPanel: 'STANDARD_WINDLOAD_PERPENDICULAR_WIND_DOWN_FORCE_ON_PANEL',
    WindloadPerpendicularWindLiftForceOnPanel: 'WINDLOAD_PERPENDICULAR_WIND_LIFT_FORCE_ON_PANEL',
    WindloadMaxLoadOnPanel: 'WINDLOAD_MAX_LOAD_ON_PANEL',
    PrimaryWindPressureCombination: 'PRIMARY_WIND_PRESSURE_COMBINATION',
    PrimaryWindLiftCombination: 'PRIMARY_WIND_LIFT_COMBINATION',
    WindtunnelPressureCoefficientPlus: 'WINDTUNNEL_PRESSURE_COEFFICIENT_PLUS',
    WindtunnelPerpendicularWindDownforceOnPanel: 'WINDTUNNEL_PERPENDICULAR_WIND_DOWNFORCE_ON_PANEL',
    WindtunnelFactoredWindPressurePerModule: 'WINDTUNNEL_FACTORED_WIND_PRESSURE_PER_MODULE',
    CombinationFactorWind: 'COMBINATION_FACTOR_WIND',
    CombinationFactorSnow: 'COMBINATION_FACTOR_SNOW',
    FactoredUnfavourablePermanentLoadPerModule: 'FACTORED_UNFAVOURABLE_PERMANENT_LOAD_PER_MODULE',
    StandardFactoredWindPressurePerModule: 'STANDARD_FACTORED_WIND_PRESSURE_PER_MODULE',
    FactoredRegularSnowPressurePerModule: 'FACTORED_REGULAR_SNOW_PRESSURE_PER_MODULE',
    FactoredRegularSnowPressureOnPanel: 'FACTORED_REGULAR_SNOW_PRESSURE_ON_PANEL',
    SnowAndWindCombinedLoadCombination: 'SNOW_AND_WIND_COMBINED_LOAD_COMBINATION',
    PrimaryWindWithSecondarySnowCombinedLoadCombination: 'PRIMARY_WIND_WITH_SECONDARY_SNOW_COMBINED_LOAD_COMBINATION',
    PrimarySnowWithSecondaryWindCombinedLoadCombination: 'PRIMARY_SNOW_WITH_SECONDARY_WIND_COMBINED_LOAD_COMBINATION',
    WorstCaseLoadPerModule: 'WORST_CASE_LOAD_PER_MODULE',
    WorstCaseLoadPerBasePlateGroup: 'WORST_CASE_LOAD_PER_BASE_PLATE_GROUP',
    DynamicPointLoadsPerBasePlateGroup: 'DYNAMIC_POINT_LOADS_PER_BASE_PLATE_GROUP',
    MaxDynamicPointLoadInSegment: 'MAX_DYNAMIC_POINT_LOAD_IN_SEGMENT',
    MaxDynamicPointLoadOnRoof: 'MAX_DYNAMIC_POINT_LOAD_ON_ROOF',
    MaxStaticPointLoadOnRoof: 'MAX_STATIC_POINT_LOAD_ON_ROOF',
    IgnoreVariableLoadsForCombinedLoads: 'IGNORE_VARIABLE_LOADS_FOR_COMBINED_LOADS',
    WindpressureWindloadUnfavourablePermanentLoadFactorCombinedLoads: 'WINDPRESSURE_WINDLOAD_UNFAVOURABLE_PERMANENT_LOAD_FACTOR_COMBINED_LOADS',
    FactoredUnfavourablePermanentLoadPerModuleForCombinedLoads: 'FACTORED_UNFAVOURABLE_PERMANENT_LOAD_PER_MODULE_FOR_COMBINED_LOADS',
    StaticWeightPerBasePlateInBasePlateGroup: 'STATIC_WEIGHT_PER_BASE_PLATE_IN_BASE_PLATE_GROUP',
    MaximumDynamicWeightPerBasePlateOnRoof: 'MAXIMUM_DYNAMIC_WEIGHT_PER_BASE_PLATE_ON_ROOF',
    WindpressureAsCombinedLoadCombination: 'WINDPRESSURE_AS_COMBINED_LOAD_COMBINATION',
    MinumumShapeCoefficientWithSnowFences: 'MINUMUM_SHAPE_COEFFICIENT_WITH_SNOW_FENCES',
    CombinedExceptionalAndRegularSnowLoadOnRoof: 'COMBINED_EXCEPTIONAL_AND_REGULAR_SNOW_LOAD_ON_ROOF',
    TotalPressureForceOnSegment: 'TOTAL_PRESSURE_FORCE_ON_SEGMENT',
    TotalLiftForceOnSegment: 'TOTAL_LIFT_FORCE_ON_SEGMENT',
    MaximumLiftPerAttachmentForRoof: 'MAXIMUM_LIFT_PER_ATTACHMENT_FOR_ROOF',
    MaximumPressurePerAttachmentForRoof: 'MAXIMUM_PRESSURE_PER_ATTACHMENT_FOR_ROOF',
    LengthBaseProfilePanel: 'LENGTH_BASE_PROFILE_PANEL',
    MarginBaseProfilePanel: 'MARGIN_BASE_PROFILE_PANEL',
    MarginBaseProfileRow: 'MARGIN_BASE_PROFILE_ROW',
    InstallationSummary: 'INSTALLATION_SUMMARY',
    InstallationSummaryFrontPage: 'INSTALLATION_SUMMARY_FRONT_PAGE',
    InstallationSummaryHeader: 'INSTALLATION_SUMMARY_HEADER',
    InstallationSummaryOtherDocuments: 'INSTALLATION_SUMMARY_OTHER_DOCUMENTS',
    InstallationSummaryRoofOverview: 'INSTALLATION_SUMMARY_ROOF_OVERVIEW',
    InstallationSummaryCompleteMaterials: 'INSTALLATION_SUMMARY_COMPLETE_MATERIALS',
    InstallationSummaryAssembly: 'INSTALLATION_SUMMARY_ASSEMBLY',
    InstallationSummarySegments: 'INSTALLATION_SUMMARY_SEGMENTS',
    InstallationSummaryCalculations: 'INSTALLATION_SUMMARY_CALCULATIONS',
    InstallationSummaryBackPage: 'INSTALLATION_SUMMARY_BACK_PAGE',
    InstallationSummaryImageAssemblyPlan: 'INSTALLATION_SUMMARY_IMAGE_ASSEMBLY_PLAN',
    InstallationSummaryImageAverageLoads: 'INSTALLATION_SUMMARY_IMAGE_AVERAGE_LOADS',
    InstallationSummaryImageRoofOverview: 'INSTALLATION_SUMMARY_IMAGE_ROOF_OVERVIEW',
    InstallationSummaryImageBallast: 'INSTALLATION_SUMMARY_IMAGE_BALLAST',
    InstallationSummaryImageMiniMap: 'INSTALLATION_SUMMARY_IMAGE_MINI_MAP',
    OrderList: 'ORDER_LIST',
    OrderListSummary: 'ORDER_LIST_SUMMARY',
    OrderListFooter: 'ORDER_LIST_FOOTER'
};
exports.VisualizationResultDTORuleTypeEnum = {
    ProjectReferencePeriod: 'PROJECT_REFERENCE_PERIOD',
    RoofCountry: 'ROOF_COUNTRY',
    RoofBom: 'ROOF_BOM',
    RoofAppliedProduct: 'ROOF_APPLIED_PRODUCT',
    RoofApplicableProducts: 'ROOF_APPLICABLE_PRODUCTS',
    RoofAvailableProducts: 'ROOF_AVAILABLE_PRODUCTS',
    RoofBusinessUnitProducts: 'ROOF_BUSINESS_UNIT_PRODUCTS',
    RoofPreferredProduct: 'ROOF_PREFERRED_PRODUCT',
    RoofHeight: 'ROOF_HEIGHT',
    RoofAppliedHeight: 'ROOF_APPLIED_HEIGHT',
    RoofTerrainCategory: 'ROOF_TERRAIN_CATEGORY',
    RoofSnowzone: 'ROOF_SNOWZONE',
    RoofMinimumHeight: 'ROOF_MINIMUM_HEIGHT',
    RoofRoughnessLength: 'ROOF_ROUGHNESS_LENGTH',
    RoofRoughnessLengthDependantTerrainFactor: 'ROOF_ROUGHNESS_LENGTH_DEPENDANT_TERRAIN_FACTOR',
    RoofRoughnessFactor: 'ROOF_ROUGHNESS_FACTOR',
    RoofSlope: 'ROOF_SLOPE',
    RoofType: 'ROOF_TYPE',
    RoofSide: 'ROOF_SIDE',
    RoofSlopeForLoadEquations: 'ROOF_SLOPE_FOR_LOAD_EQUATIONS',
    RoofMaterial: 'ROOF_MATERIAL',
    RoofFrictionCoefficient: 'ROOF_FRICTION_COEFFICIENT',
    RoofFlangeDistance: 'ROOF_FLANGE_DISTANCE',
    RoofEdges: 'ROOF_EDGES',
    RoofBoundingBox: 'ROOF_BOUNDING_BOX',
    RoofDistanceBetweenRailsUnderModule: 'ROOF_DISTANCE_BETWEEN_RAILS_UNDER_MODULE',
    RoofDistanceBetweenRailsBetweenModules: 'ROOF_DISTANCE_BETWEEN_RAILS_BETWEEN_MODULES',
    RoofMaximumDistanceBetweenRailsForRearWindDeflector: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_REAR_WIND_DEFLECTOR',
    RoofMinimumDistanceBetweenRailsForPanelLength: 'ROOF_MINIMUM_DISTANCE_BETWEEN_RAILS_FOR_PANEL_LENGTH',
    RoofMaximumDistanceBetweenRailsForPanelLength: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_PANEL_LENGTH',
    RoofMaximumDistanceBetweenRailsUnderModule: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_UNDER_MODULE',
    MaximumDistanceCorrugatedBrackets: 'MAXIMUM_DISTANCE_CORRUGATED_BRACKETS',
    RoofExtraCostPerRail: 'ROOF_EXTRA_COST_PER_RAIL',
    RoofAttachmentType: 'ROOF_ATTACHMENT_TYPE',
    RoofAvailableRails: 'ROOF_AVAILABLE_RAILS',
    RoofHookType: 'ROOF_HOOK_TYPE',
    RoofHookSize: 'ROOF_HOOK_SIZE',
    RoofHookPressureLimit: 'ROOF_HOOK_PRESSURE_LIMIT',
    RoofAllSegments: 'ROOF_ALL_SEGMENTS',
    RoofUniqueSegments: 'ROOF_UNIQUE_SEGMENTS',
    RoofSegmentTypes: 'ROOF_SEGMENT_TYPES',
    RoofSegmentTypeModuleSpaces: 'ROOF_SEGMENT_TYPE_MODULE_SPACES',
    RoofUniqueSegmentsRowDistance: 'ROOF_UNIQUE_SEGMENTS_ROW_DISTANCE',
    RoofColor: 'ROOF_COLOR',
    RoofSkippingApplied: 'ROOF_SKIPPING_APPLIED',
    RoofPerimeterApplied: 'ROOF_PERIMETER_APPLIED',
    RoofLength: 'ROOF_LENGTH',
    RoofWidth: 'ROOF_WIDTH',
    RoofTotalYield: 'ROOF_TOTAL_YIELD',
    RoofArea: 'ROOF_AREA',
    RoofLoadOverArea: 'ROOF_LOAD_OVER_AREA',
    RoofTotalSystemArea: 'ROOF_TOTAL_SYSTEM_AREA',
    RoofTotalBallastWeight: 'ROOF_TOTAL_BALLAST_WEIGHT',
    RoofPurlinDistance: 'ROOF_PURLIN_DISTANCE',
    RoofChosenAttachmentType: 'ROOF_CHOSEN_ATTACHMENT_TYPE',
    RoofChosenHangerBolt: 'ROOF_CHOSEN_HANGER_BOLT',
    RoofDilatationDistance: 'ROOF_DILATATION_DISTANCE',
    RoofNumberOfModulesInRow: 'ROOF_NUMBER_OF_MODULES_IN_ROW',
    RoofTotalWeight: 'ROOF_TOTAL_WEIGHT',
    RoofAirDensity: 'ROOF_AIR_DENSITY',
    RoofAverageRoofLoadOverTotalSystem: 'ROOF_AVERAGE_ROOF_LOAD_OVER_TOTAL_SYSTEM',
    RoofNumberOfBallastElements: 'ROOF_NUMBER_OF_BALLAST_ELEMENTS',
    RoofAltitudeAboveSeaLevel: 'ROOF_ALTITUDE_ABOVE_SEA_LEVEL',
    RoofSectionDistance: 'ROOF_SECTION_DISTANCE',
    RoofGapSpace: 'ROOF_GAP_SPACE',
    RoofTotalBuildingHeight: 'ROOF_TOTAL_BUILDING_HEIGHT',
    RoofParapetHeight: 'ROOF_PARAPET_HEIGHT',
    RoofNumberOfPanels: 'ROOF_NUMBER_OF_PANELS',
    RoofDistanceToCoast: 'ROOF_DISTANCE_TO_COAST',
    RoofDistanceToCityBoundary: 'ROOF_DISTANCE_TO_CITY_BOUNDARY',
    RoofAltitudeOfTheUpwindBase: 'ROOF_ALTITUDE_OF_THE_UPWIND_BASE',
    RoofAppliedDistanceToCityBoundary: 'ROOF_APPLIED_DISTANCE_TO_CITY_BOUNDARY',
    RoofTpoMatsNeeded: 'ROOF_TPO_MATS_NEEDED',
    RoofTotalPrice: 'ROOF_TOTAL_PRICE',
    RoofPricePerPanel: 'ROOF_PRICE_PER_PANEL',
    RoofPricePerWattPeak: 'ROOF_PRICE_PER_WATT_PEAK',
    RoofRotation: 'ROOF_ROTATION',
    RoofSideWindDeflectorWidth: 'ROOF_SIDE_WIND_DEFLECTOR_WIDTH',
    RoofConsequenceClass: 'ROOF_CONSEQUENCE_CLASS',
    RoofGroundingOption: 'ROOF_GROUNDING_OPTION',
    RoofBomAdjustments: 'ROOF_BOM_ADJUSTMENTS',
    RoofPermanentLoadPerModule: 'ROOF_PERMANENT_LOAD_PER_MODULE',
    RoofHasOldOrWetSnow: 'ROOF_HAS_OLD_OR_WET_SNOW',
    RoofRailsRequired: 'ROOF_RAILS_REQUIRED',
    RoofNoGoAreaDepth: 'ROOF_NO_GO_AREA_DEPTH',
    RoofAttachToRoofStructure: 'ROOF_ATTACH_TO_ROOF_STRUCTURE',
    RoofStructure: 'ROOF_STRUCTURE',
    RoofSectioningType: 'ROOF_SECTIONING_TYPE',
    RoofRafterDistance: 'ROOF_RAFTER_DISTANCE',
    RoofCanPerimeterBeDisabled: 'ROOF_CAN_PERIMETER_BE_DISABLED',
    RoofPanelAngle: 'ROOF_PANEL_ANGLE',
    RoofSidePlatePlacement: 'ROOF_SIDE_PLATE_PLACEMENT',
    RoofSeamType: 'ROOF_SEAM_TYPE',
    RoofSteelType: 'ROOF_STEEL_TYPE',
    RoofDisableNoGoArea: 'ROOF_DISABLE_NO_GO_AREA',
    RoofPolygon: 'ROOF_POLYGON',
    RoofFields: 'ROOF_FIELDS',
    RoofMeasurements: 'ROOF_MEASUREMENTS',
    RoofPreferredFastener: 'ROOF_PREFERRED_FASTENER',
    RoofObstacles: 'ROOF_OBSTACLES',
    RoofShape: 'ROOF_SHAPE',
    RoofFreezeThawLikely: 'ROOF_FREEZE_THAW_LIKELY',
    RoofDriftedSnowPossibleOnSide: 'ROOF_DRIFTED_SNOW_POSSIBLE_ON_SIDE',
    RoofWallHeight: 'ROOF_WALL_HEIGHT',
    RoofUseFormCoefficientDueToWind: 'ROOF_USE_FORM_COEFFICIENT_DUE_TO_WIND',
    RoofFormCoefficientDueToWind: 'ROOF_FORM_COEFFICIENT_DUE_TO_WIND',
    RoofTopography: 'ROOF_TOPOGRAPHY',
    RoofSnowFencesPresent: 'ROOF_SNOW_FENCES_PRESENT',
    RoofMapWindSpeed: 'ROOF_MAP_WIND_SPEED',
    RoofIsRoofHookAttachedToStructure: 'ROOF_IS_ROOF_HOOK_ATTACHED_TO_STRUCTURE',
    RoofMatsIncluded: 'ROOF_MATS_INCLUDED',
    RoofSteelThickness: 'ROOF_STEEL_THICKNESS',
    WindDeflectorLandscapeSize: 'WIND_DEFLECTOR_LANDSCAPE_SIZE',
    PressureCoefficientRearWindDeflector: 'PRESSURE_COEFFICIENT_REAR_WIND_DEFLECTOR',
    SurfaceAreaRearWindDeflector: 'SURFACE_AREA_REAR_WIND_DEFLECTOR',
    ForceOnRearWindDeflector: 'FORCE_ON_REAR_WIND_DEFLECTOR',
    WindExposureFactor: 'WIND_EXPOSURE_FACTOR',
    SurfaceAreaSideDeflector: 'SURFACE_AREA_SIDE_DEFLECTOR',
    InwardsPressureCoefficientSideDeflector: 'INWARDS_PRESSURE_COEFFICIENT_SIDE_DEFLECTOR',
    InwardsPressureForceOnSideDeflector: 'INWARDS_PRESSURE_FORCE_ON_SIDE_DEFLECTOR',
    OutwardsSuctionCoefficientSideDeflector: 'OUTWARDS_SUCTION_COEFFICIENT_SIDE_DEFLECTOR',
    OutwardsSuctionForceOnSideDeflector: 'OUTWARDS_SUCTION_FORCE_ON_SIDE_DEFLECTOR',
    InwardsPressureForceLimitForSideDeflector: 'INWARDS_PRESSURE_FORCE_LIMIT_FOR_SIDE_DEFLECTOR',
    OutwardsSuctionForceLimitForSideDeflector: 'OUTWARDS_SUCTION_FORCE_LIMIT_FOR_SIDE_DEFLECTOR',
    EdgeLength: 'EDGE_LENGTH',
    EdgeZoneScalingFactor: 'EDGE_ZONE_SCALING_FACTOR',
    EdgeZoneHorizontalDepth: 'EDGE_ZONE_HORIZONTAL_DEPTH',
    EdgeZoneDepth: 'EDGE_ZONE_DEPTH',
    EdgeZoneVerticalDepth: 'EDGE_ZONE_VERTICAL_DEPTH',
    AllowedCentralRoofZones: 'ALLOWED_CENTRAL_ROOF_ZONES',
    CommercialCentralRoofZones: 'COMMERCIAL_CENTRAL_ROOF_ZONES',
    CommercialEdgeZone: 'COMMERCIAL_EDGE_ZONE',
    EurocodeCentralRoofZones: 'EUROCODE_CENTRAL_ROOF_ZONES',
    EurocodeEdgeZone: 'EUROCODE_EDGE_ZONE',
    EurocodeNorthEdgeZone: 'EUROCODE_NORTH_EDGE_ZONE',
    EurocodeSouthEdgeZone: 'EUROCODE_SOUTH_EDGE_ZONE',
    PeutzCentralRoofZones: 'PEUTZ_CENTRAL_ROOF_ZONES',
    PeutzInnerEdgeZoneHorizontalDepth: 'PEUTZ_INNER_EDGE_ZONE_HORIZONTAL_DEPTH',
    PeutzInnerEdgeZoneVerticalDepth: 'PEUTZ_INNER_EDGE_ZONE_VERTICAL_DEPTH',
    PeutzInnerEdgeZoneDepth: 'PEUTZ_INNER_EDGE_ZONE_DEPTH',
    PeutzInnerEdgeZones: 'PEUTZ_INNER_EDGE_ZONES',
    PeutzNorthInnerEdgeZones: 'PEUTZ_NORTH_INNER_EDGE_ZONES',
    PeutzSouthInnerEdgeZones: 'PEUTZ_SOUTH_INNER_EDGE_ZONES',
    SystemHeight: 'SYSTEM_HEIGHT',
    FieldRoofHorizontalDilatationLength: 'FIELD_ROOF_HORIZONTAL_DILATATION_LENGTH',
    FieldRoofVerticalDilatationLength: 'FIELD_ROOF_VERTICAL_DILATATION_LENGTH',
    FieldRoofEffectiveVerticalDilatation: 'FIELD_ROOF_EFFECTIVE_VERTICAL_DILATATION',
    FieldRoofEffectiveHorizontalDilatation: 'FIELD_ROOF_EFFECTIVE_HORIZONTAL_DILATATION',
    FieldHorizontalDilatationGapSpacing: 'FIELD_HORIZONTAL_DILATATION_GAP_SPACING',
    FieldVerticalDilatationGapSpacing: 'FIELD_VERTICAL_DILATATION_GAP_SPACING',
    FieldCoordinate: 'FIELD_COORDINATE',
    FieldSegments: 'FIELD_SEGMENTS',
    FieldSidePlatesOption: 'FIELD_SIDE_PLATES_OPTION',
    FieldRowDistance: 'FIELD_ROW_DISTANCE',
    FieldReferenceRowDistanceLandscape: 'FIELD_REFERENCE_ROW_DISTANCE_LANDSCAPE',
    FieldModules: 'FIELD_MODULES',
    FieldSetup: 'FIELD_SETUP',
    FieldOrientation: 'FIELD_ORIENTATION',
    FieldRailSystem: 'FIELD_RAIL_SYSTEM',
    SegmentTotalPanelWeight: 'SEGMENT_TOTAL_PANEL_WEIGHT',
    FieldModuleLocationLimits: 'FIELD_MODULE_LOCATION_LIMITS',
    FieldModuleConfiguration: 'FIELD_MODULE_CONFIGURATION',
    FieldRowConnectorLength: 'FIELD_ROW_CONNECTOR_LENGTH',
    FieldHorizontalModuleGapSpacing: 'FIELD_HORIZONTAL_MODULE_GAP_SPACING',
    FieldVerticalModuleGapSpacing: 'FIELD_VERTICAL_MODULE_GAP_SPACING',
    FieldNeedRoofSectionSpanningRails: 'FIELD_NEED_ROOF_SECTION_SPANNING_RAILS',
    SegmentNumberOfPanels: 'SEGMENT_NUMBER_OF_PANELS',
    SegmentBasePlateGroups: 'SEGMENT_BASE_PLATE_GROUPS',
    SegmentNumberOfSingleModules: 'SEGMENT_NUMBER_OF_SINGLE_MODULES',
    SegmentNumberOfSingleModuleSides: 'SEGMENT_NUMBER_OF_SINGLE_MODULE_SIDES',
    SegmentNumberOfLinesOfSideBySideSingleModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_SINGLE_MODULES',
    SegmentNumberOfDualModules: 'SEGMENT_NUMBER_OF_DUAL_MODULES',
    SegmentNumberOfDualModuleSides: 'SEGMENT_NUMBER_OF_DUAL_MODULE_SIDES',
    SegmentNumberOfLinesOfSideBySideDualModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_DUAL_MODULES',
    SegmentLength: 'SEGMENT_LENGTH',
    SegmentLengthWithoutRails: 'SEGMENT_LENGTH_WITHOUT_RAILS',
    SegmentTotalBallastWeight: 'SEGMENT_TOTAL_BALLAST_WEIGHT',
    SegmentTotalYield: 'SEGMENT_TOTAL_YIELD',
    SegmentSystemArea: 'SEGMENT_SYSTEM_AREA',
    SegmentEndSpacing: 'SEGMENT_END_SPACING',
    SegmentNumberOfSides: 'SEGMENT_NUMBER_OF_SIDES',
    SegmentNumberOfHighBallastedSides: 'SEGMENT_NUMBER_OF_HIGH_BALLASTED_SIDES',
    SegmentNumberOfPerimeteredSides: 'SEGMENT_NUMBER_OF_PERIMETERED_SIDES',
    SegmentNumberOfMiddleSides: 'SEGMENT_NUMBER_OF_MIDDLE_SIDES',
    SegmentNumberOfModulesWithContainerNearLowBase: 'SEGMENT_NUMBER_OF_MODULES_WITH_CONTAINER_NEAR_LOW_BASE',
    SegmentNumberOfMiddleModules: 'SEGMENT_NUMBER_OF_MIDDLE_MODULES',
    SegmentNumberOfLinesOfSideBySideModulesWithModulesNearLowBase: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_MODULES_WITH_MODULES_NEAR_LOW_BASE',
    SegmentNumberOfLinesOfSideBySideMiddleModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_MIDDLE_MODULES',
    SegmentNumberOfBallastedModules: 'SEGMENT_NUMBER_OF_BALLASTED_MODULES',
    SegmentNumberOfHighBallastedModules: 'SEGMENT_NUMBER_OF_HIGH_BALLASTED_MODULES',
    SegmentNumberOfLinesOfSideBySideHighBallastedModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_HIGH_BALLASTED_MODULES',
    SegmentNumberOfDoubleBallastedRegularSides: 'SEGMENT_NUMBER_OF_DOUBLE_BALLASTED_REGULAR_SIDES',
    SegmentNumberOfPanelsWithHighBaseAdjacentContainerUnderneath: 'SEGMENT_NUMBER_OF_PANELS_WITH_HIGH_BASE_ADJACENT_CONTAINER_UNDERNEATH',
    SegmentNumberOfLinesOfSideBySidePanelsWithHighBaseAdjacentContainerUnderneath: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_PANELS_WITH_HIGH_BASE_ADJACENT_CONTAINER_UNDERNEATH',
    SegmentNumberOfDoublePerimeteredModules: 'SEGMENT_NUMBER_OF_DOUBLE_PERIMETERED_MODULES',
    SegmentNumberOfLinesOfSideBySideDoublePerimeteredModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_DOUBLE_PERIMETERED_MODULES',
    SegmentNumberOfDoublePerimeteredSides: 'SEGMENT_NUMBER_OF_DOUBLE_PERIMETERED_SIDES',
    SegmentNumberOfBallastElements: 'SEGMENT_NUMBER_OF_BALLAST_ELEMENTS',
    SegmentNumberOfLinesOfSideBySidePanels: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_PANELS',
    SegmentNumberOfRowConnectors: 'SEGMENT_NUMBER_OF_ROW_CONNECTORS',
    SegmentLinesOfSucceedingModules: 'SEGMENT_LINES_OF_SUCCEEDING_MODULES',
    SegmentLinesOfSideBySideModules: 'SEGMENT_LINES_OF_SIDE_BY_SIDE_MODULES',
    SegmentRectangles: 'SEGMENT_RECTANGLES',
    SegmentMountingWeight: 'SEGMENT_MOUNTING_WEIGHT',
    SegmentTotalInstallationWeight: 'SEGMENT_TOTAL_INSTALLATION_WEIGHT',
    SegmentRailsNeedToBeExtended: 'SEGMENT_RAILS_NEED_TO_BE_EXTENDED',
    SegmentDistanceBetweenFirstAndLastAttachment: 'SEGMENT_DISTANCE_BETWEEN_FIRST_AND_LAST_ATTACHMENT',
    SegmentFirstAttachmentPosition: 'SEGMENT_FIRST_ATTACHMENT_POSITION',
    SegmentRequiredRailLength: 'SEGMENT_REQUIRED_RAIL_LENGTH',
    SegmentMaxNumberOfRows: 'SEGMENT_MAX_NUMBER_OF_ROWS',
    SegmentRoofZone: 'SEGMENT_ROOF_ZONE',
    SegmentAverageRoofLoadOverSystemArea: 'SEGMENT_AVERAGE_ROOF_LOAD_OVER_SYSTEM_AREA',
    SegmentAverageLoadPerModule: 'SEGMENT_AVERAGE_LOAD_PER_MODULE',
    SegmentPointLoad: 'SEGMENT_POINT_LOAD',
    SegmentMaximalStaticPointLoad: 'SEGMENT_MAXIMAL_STATIC_POINT_LOAD',
    SegmentAttachmentPositions: 'SEGMENT_ATTACHMENT_POSITIONS',
    SegmentAttachmentInterval: 'SEGMENT_ATTACHMENT_INTERVAL',
    SegmentFirstRailOffset: 'SEGMENT_FIRST_RAIL_OFFSET',
    SegmentRailSpacing: 'SEGMENT_RAIL_SPACING',
    SegmentRailSpacingBasedOnSectionDistance: 'SEGMENT_RAIL_SPACING_BASED_ON_SECTION_DISTANCE',
    SegmentFixationPlan: 'SEGMENT_FIXATION_PLAN',
    SegmentNumberOfPerimeterSidesWithRowConnectors: 'SEGMENT_NUMBER_OF_PERIMETER_SIDES_WITH_ROW_CONNECTORS',
    SegmentNeedRoofSectionSpanningRails: 'SEGMENT_NEED_ROOF_SECTION_SPANNING_RAILS',
    SegmentPolygon: 'SEGMENT_POLYGON',
    SegmentTypeRelativePosition: 'SEGMENT_TYPE_RELATIVE_POSITION',
    SegmentOriginPosition: 'SEGMENT_ORIGIN_POSITION',
    SegmentMaximumStaticWeightPerBasePlate: 'SEGMENT_MAXIMUM_STATIC_WEIGHT_PER_BASE_PLATE',
    SegmentDynamicWeightPerBasePlateInBasePlateGroup: 'SEGMENT_DYNAMIC_WEIGHT_PER_BASE_PLATE_IN_BASE_PLATE_GROUP',
    SegmentMaximumDynamicWeightPerBasePlate: 'SEGMENT_MAXIMUM_DYNAMIC_WEIGHT_PER_BASE_PLATE',
    SegmentStabilizerPosition: 'SEGMENT_STABILIZER_POSITION',
    SegmentsWithPerimeterBallasting: 'SEGMENTS_WITH_PERIMETER_BALLASTING',
    SegmentsWithSkipping: 'SEGMENTS_WITH_SKIPPING',
    SegmentsBallastWeightIncludingBallastArticleWeight: 'SEGMENTS_BALLAST_WEIGHT_INCLUDING_BALLAST_ARTICLE_WEIGHT',
    SegmentsWithMomentComparison: 'SEGMENTS_WITH_MOMENT_COMPARISON',
    SegmentArticles: 'SEGMENT_ARTICLES',
    ArticleWeight: 'ARTICLE_WEIGHT',
    ModuleHorizontalModuleSpace: 'MODULE_HORIZONTAL_MODULE_SPACE',
    ModuleVerticalModuleSpace: 'MODULE_VERTICAL_MODULE_SPACE',
    ModuleBreadth: 'MODULE_BREADTH',
    PanelWidth: 'PANEL_WIDTH',
    PanelLength: 'PANEL_LENGTH',
    PanelWeight: 'PANEL_WEIGHT',
    PanelSurfaceArea: 'PANEL_SURFACE_AREA',
    PanelIsLarge: 'PANEL_IS_LARGE',
    NumberOfRailLines: 'NUMBER_OF_RAIL_LINES',
    PanelThickness: 'PANEL_THICKNESS',
    PanelYield: 'PANEL_YIELD',
    PanelSystemArea: 'PANEL_SYSTEM_AREA',
    ModulesModuleWeight: 'MODULES_MODULE_WEIGHT',
    ModulesRowDistanceHalfModules: 'MODULES_ROW_DISTANCE_HALF_MODULES',
    WindpressureCorrectedPeakVelocityPressureOverReferencePeriod: 'WINDPRESSURE_CORRECTED_PEAK_VELOCITY_PRESSURE_OVER_REFERENCE_PERIOD',
    WindpressureHighBuildingSafetyFactor: 'WINDPRESSURE_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureManualHighBuildingSafetyFactor: 'WINDPRESSURE_MANUAL_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureAutomaticHighBuildingSafetyFactor: 'WINDPRESSURE_AUTOMATIC_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureAutomaticHighBuildingSafetyFactorOption: 'WINDPRESSURE_AUTOMATIC_HIGH_BUILDING_SAFETY_FACTOR_OPTION',
    WindpressureBuildingShapeRatio: 'WINDPRESSURE_BUILDING_SHAPE_RATIO',
    WindpressureWindzone: 'WINDPRESSURE_WINDZONE',
    WindpressureOrographyFactor: 'WINDPRESSURE_OROGRAPHY_FACTOR',
    WindpressureBasicWindVelocity: 'WINDPRESSURE_BASIC_WIND_VELOCITY',
    WindpressureFundamentalValueBasicWindVelocity: 'WINDPRESSURE_FUNDAMENTAL_VALUE_BASIC_WIND_VELOCITY',
    WindpressureNValue: 'WINDPRESSURE_N_VALUE',
    WindpressureKValue: 'WINDPRESSURE_K_VALUE',
    WindpressurePValue: 'WINDPRESSURE_P_VALUE',
    WindpressureProbabilityFactor: 'WINDPRESSURE_PROBABILITY_FACTOR',
    WindpressurePeakVelocityPressure: 'WINDPRESSURE_PEAK_VELOCITY_PRESSURE',
    WindpressurePeakVelocityPressureOverReferencePeriod: 'WINDPRESSURE_PEAK_VELOCITY_PRESSURE_OVER_REFERENCE_PERIOD',
    WindpressureStrongWinds: 'WINDPRESSURE_STRONG_WINDS',
    WindpressureWindloadCategory: 'WINDPRESSURE_WINDLOAD_CATEGORY',
    WindpressureWindloadFavourablePermanentLoad: 'WINDPRESSURE_WINDLOAD_FAVOURABLE_PERMANENT_LOAD',
    WindpressureWindloadUnfavourablePermanentLoad: 'WINDPRESSURE_WINDLOAD_UNFAVOURABLE_PERMANENT_LOAD',
    WindpressureWindloadReductionFactor: 'WINDPRESSURE_WINDLOAD_REDUCTION_FACTOR',
    WindpressureMeanWindVelocity: 'WINDPRESSURE_MEAN_WIND_VELOCITY',
    WindpressureInputBasicVelocityPressure: 'WINDPRESSURE_INPUT_BASIC_VELOCITY_PRESSURE',
    WindpressureBasicWindPressure: 'WINDPRESSURE_BASIC_WIND_PRESSURE',
    WindpressureTurbulenceIntensity: 'WINDPRESSURE_TURBULENCE_INTENSITY',
    WindpressureTurbulenceFactor: 'WINDPRESSURE_TURBULENCE_FACTOR',
    WindpressureMaximumBuildingHeight: 'WINDPRESSURE_MAXIMUM_BUILDING_HEIGHT',
    WindpressureSizeFactorExposureFactor: 'WINDPRESSURE_SIZE_FACTOR_EXPOSURE_FACTOR',
    StandardWindpressurePerModule: 'STANDARD_WINDPRESSURE_PER_MODULE',
    AppliedDistanceToCoast: 'APPLIED_DISTANCE_TO_COAST',
    AppliedSafetyFactorCc1: 'APPLIED_SAFETY_FACTOR_CC1',
    SidePlatesSafetyFactor: 'SIDE_PLATES_SAFETY_FACTOR',
    ReliabilityFactor: 'RELIABILITY_FACTOR',
    ReliabilityFactorPerConsequenceClass: 'RELIABILITY_FACTOR_PER_CONSEQUENCE_CLASS',
    VariableLoadFactor: 'VARIABLE_LOAD_FACTOR',
    VariableLoadFactorPerConsequenceClass: 'VARIABLE_LOAD_FACTOR_PER_CONSEQUENCE_CLASS',
    DisplacementHeight: 'DISPLACEMENT_HEIGHT',
    TownTerrainExposureFactor: 'TOWN_TERRAIN_EXPOSURE_FACTOR',
    AltitudeFactor: 'ALTITUDE_FACTOR',
    BallastArticleWeight: 'BALLAST_ARTICLE_WEIGHT',
    BallastUseBallast: 'BALLAST_USE_BALLAST',
    BallastPlan: 'BALLAST_PLAN',
    BallastPlanSegment: 'BALLAST_PLAN_SEGMENT',
    BallastGroupsForSegment: 'BALLAST_GROUPS_FOR_SEGMENT',
    BallastGroupsForLargestRectangles: 'BALLAST_GROUPS_FOR_LARGEST_RECTANGLES',
    BallastAssignedGroups: 'BALLAST_ASSIGNED_GROUPS',
    BallastCountrySafetyFactor: 'BALLAST_COUNTRY_SAFETY_FACTOR',
    BallastAppliedSafetyFactor: 'BALLAST_APPLIED_SAFETY_FACTOR',
    BallastCThetaSquared: 'BALLAST_C_THETA_SQUARED',
    BallastUseCTheta: 'BALLAST_USE_C_THETA',
    BallastAverageSurfaceArea: 'BALLAST_AVERAGE_SURFACE_AREA',
    BallastPeutzValueForLiftForce: 'BALLAST_PEUTZ_VALUE_FOR_LIFT_FORCE',
    BallastDirectionalFactorForLiftForce: 'BALLAST_DIRECTIONAL_FACTOR_FOR_LIFT_FORCE',
    BallastWindForcePerWindDirectionForLiftForce: 'BALLAST_WIND_FORCE_PER_WIND_DIRECTION_FOR_LIFT_FORCE',
    BallastMaxWindForcePerPeutzGroupForLiftForce: 'BALLAST_MAX_WIND_FORCE_PER_PEUTZ_GROUP_FOR_LIFT_FORCE',
    BallastRequiredGroupsWithPeutzDataForLiftForce: 'BALLAST_REQUIRED_GROUPS_WITH_PEUTZ_DATA_FOR_LIFT_FORCE',
    BallastTotalWindForceForAssignedGroupsForLiftForce: 'BALLAST_TOTAL_WIND_FORCE_FOR_ASSIGNED_GROUPS_FOR_LIFT_FORCE',
    BallastPeutzValueForCombinedForces: 'BALLAST_PEUTZ_VALUE_FOR_COMBINED_FORCES',
    BallastDirectionalFactorForCombinedForces: 'BALLAST_DIRECTIONAL_FACTOR_FOR_COMBINED_FORCES',
    BallastWindForcePerWindDirectionForCombinedForces: 'BALLAST_WIND_FORCE_PER_WIND_DIRECTION_FOR_COMBINED_FORCES',
    BallastMaxWindForcePerPeutzGroupForCombinedForced: 'BALLAST_MAX_WIND_FORCE_PER_PEUTZ_GROUP_FOR_COMBINED_FORCED',
    BallastRequiredGroupsWithPeutzDataForCombinedForces: 'BALLAST_REQUIRED_GROUPS_WITH_PEUTZ_DATA_FOR_COMBINED_FORCES',
    BallastTotalWindForceForAssignedGroupsForCombinedForces: 'BALLAST_TOTAL_WIND_FORCE_FOR_ASSIGNED_GROUPS_FOR_COMBINED_FORCES',
    BallastWindtunnelSafetyFactor: 'BALLAST_WINDTUNNEL_SAFETY_FACTOR',
    BallastNumberOfElementsUnderPanelInCouplerlessRail: 'BALLAST_NUMBER_OF_ELEMENTS_UNDER_PANEL_IN_COUPLERLESS_RAIL',
    BallastNumberOfElementsUnderPanelInRailWithCoupler: 'BALLAST_NUMBER_OF_ELEMENTS_UNDER_PANEL_IN_RAIL_WITH_COUPLER',
    BallastNumberOfRailsPerModule: 'BALLAST_NUMBER_OF_RAILS_PER_MODULE',
    BallastMaximumLiftForceOnPanel: 'BALLAST_MAXIMUM_LIFT_FORCE_ON_PANEL',
    BallastGroupsForLiftForce: 'BALLAST_GROUPS_FOR_LIFT_FORCE',
    BallastUpwardsLiftForceOnPanelPerBallastGroup: 'BALLAST_UPWARDS_LIFT_FORCE_ON_PANEL_PER_BALLAST_GROUP',
    BallastUpwardsLiftForcePerModuleInSingleSegments: 'BALLAST_UPWARDS_LIFT_FORCE_PER_MODULE_IN_SINGLE_SEGMENTS',
    BallastMaximumForcePerpendicularToPanelIn2RailConfiguration: 'BALLAST_MAXIMUM_FORCE_PERPENDICULAR_TO_PANEL_IN_2_RAIL_CONFIGURATION',
    BallastMaximumForcePerpendicularToPanelIn3RailConfiguration: 'BALLAST_MAXIMUM_FORCE_PERPENDICULAR_TO_PANEL_IN_3_RAIL_CONFIGURATION',
    BallastNumberOfBallastContainersInSegment: 'BALLAST_NUMBER_OF_BALLAST_CONTAINERS_IN_SEGMENT',
    BallastAdditionalBallastElementsPerBracket: 'BALLAST_ADDITIONAL_BALLAST_ELEMENTS_PER_BRACKET',
    BallastDetermineMaximumLiftCoefficientHalfPanel: 'BALLAST_DETERMINE_MAXIMUM_LIFT_COEFFICIENT_HALF_PANEL',
    BallastMaximumElementsUnderPanelForCouplerlessRailWithBrackets: 'BALLAST_MAXIMUM_ELEMENTS_UNDER_PANEL_FOR_COUPLERLESS_RAIL_WITH_BRACKETS',
    BallastElementCapacityPerRailUnitPerModule: 'BALLAST_ELEMENT_CAPACITY_PER_RAIL_UNIT_PER_MODULE',
    SegmentLinesOfSucceedingModulesWith3RdRail: 'SEGMENT_LINES_OF_SUCCEEDING_MODULES_WITH_3RD_RAIL',
    BallastTotalWeight: 'BALLAST_TOTAL_WEIGHT',
    TotalWeightLimitPerBallastGroup: 'TOTAL_WEIGHT_LIMIT_PER_BALLAST_GROUP',
    BallastWeightPerModuleInSegment: 'BALLAST_WEIGHT_PER_MODULE_IN_SEGMENT',
    BallastElementsWithoutTiltingMeasures: 'BALLAST_ELEMENTS_WITHOUT_TILTING_MEASURES',
    BallastElementsWithTiltingMeasures: 'BALLAST_ELEMENTS_WITH_TILTING_MEASURES',
    BallastMaxTotalWeightForHalfModules: 'BALLAST_MAX_TOTAL_WEIGHT_FOR_HALF_MODULES',
    BallastTotalWeightPositionsInRectangle: 'BALLAST_TOTAL_WEIGHT_POSITIONS_IN_RECTANGLE',
    BallastTotalWeightPerModuleInSegment: 'BALLAST_TOTAL_WEIGHT_PER_MODULE_IN_SEGMENT',
    BallastWeightAfterPerimeterTweak: 'BALLAST_WEIGHT_AFTER_PERIMETER_TWEAK',
    BallastWeightPerModuleInGrid: 'BALLAST_WEIGHT_PER_MODULE_IN_GRID',
    BallastCornerEdgezoneWidth: 'BALLAST_CORNER_EDGEZONE_WIDTH',
    BallastSubtractMountingSystemWeight: 'BALLAST_SUBTRACT_MOUNTING_SYSTEM_WEIGHT',
    BallastBlockedPerimeterPossible: 'BALLAST_BLOCKED_PERIMETER_POSSIBLE',
    BallastPerimeterTypes: 'BALLAST_PERIMETER_TYPES',
    BallastMaximumNumberOfBallastElementsInBottomLayer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_BOTTOM_LAYER',
    BallastMaximumNumberOfBallastElementsInTopLayer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_TOP_LAYER',
    BallastMaximumNumberOfBallastElementsInPrimaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_PRIMARY_BALLAST_CONTAINER',
    BallastMaximumNumberOfBallastElementsInSecondaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_SECONDARY_BALLAST_CONTAINER',
    BallastMaximumNumberOfBallastElementsInTertiaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_TERTIARY_BALLAST_CONTAINER',
    BallastDistributionPlanSegmentWithoutTiltingMeasures: 'BALLAST_DISTRIBUTION_PLAN_SEGMENT_WITHOUT_TILTING_MEASURES',
    BallastDistributionPlanSegmentWithTiltingMeasures: 'BALLAST_DISTRIBUTION_PLAN_SEGMENT_WITH_TILTING_MEASURES',
    BallastDistributionPlanField: 'BALLAST_DISTRIBUTION_PLAN_FIELD',
    BallastElementDistributionPerModuleWithoutTiltingMeasures: 'BALLAST_ELEMENT_DISTRIBUTION_PER_MODULE_WITHOUT_TILTING_MEASURES',
    BallastMaximumWeightInPrimaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_PRIMARY_BALLAST_CONTAINER',
    BallastMaximumWeightInSecondaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_SECONDARY_BALLAST_CONTAINER',
    BallastMaximumWeightInTertiaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_TERTIARY_BALLAST_CONTAINER',
    BallastContainerWeight: 'BALLAST_CONTAINER_WEIGHT',
    BallastTrayWeight: 'BALLAST_TRAY_WEIGHT',
    BallastExtenderWeight: 'BALLAST_EXTENDER_WEIGHT',
    BallastContainerWeightLimit: 'BALLAST_CONTAINER_WEIGHT_LIMIT',
    BallastRawWeight: 'BALLAST_RAW_WEIGHT',
    BallastSecondContainerPerimeterModuleThreshold: 'BALLAST_SECOND_CONTAINER_PERIMETER_MODULE_THRESHOLD',
    BallastSkippingWeightAfterSkipping: 'BALLAST_SKIPPING_WEIGHT_AFTER_SKIPPING',
    BallastSkippingTotalWeightInSkippingArea: 'BALLAST_SKIPPING_TOTAL_WEIGHT_IN_SKIPPING_AREA',
    BallastSkippingBallastGridWithSkipping: 'BALLAST_SKIPPING_BALLAST_GRID_WITH_SKIPPING',
    BallastSkippingBallastedPositionsInSkippingArea: 'BALLAST_SKIPPING_BALLASTED_POSITIONS_IN_SKIPPING_AREA',
    BallastSkippingBallastedPanelsWithBaseAlgorithmForSkipping: 'BALLAST_SKIPPING_BALLASTED_PANELS_WITH_BASE_ALGORITHM_FOR_SKIPPING',
    BallastSkippingSkippingAreas: 'BALLAST_SKIPPING_SKIPPING_AREAS',
    BallastSkippingSkippingAreaTypes: 'BALLAST_SKIPPING_SKIPPING_AREA_TYPES',
    BallastSkippingBallastMinimumNumberOfBallastedPositions: 'BALLAST_SKIPPING_BALLAST_MINIMUM_NUMBER_OF_BALLASTED_POSITIONS',
    BallastSkippingRequiredBallastedPositions: 'BALLAST_SKIPPING_REQUIRED_BALLASTED_POSITIONS',
    BallastSkippingSkippingFactor: 'BALLAST_SKIPPING_SKIPPING_FACTOR',
    BallastSkippingMaximumSkippingFactor: 'BALLAST_SKIPPING_MAXIMUM_SKIPPING_FACTOR',
    BallastSkippingOptimalSkippingFactor: 'BALLAST_SKIPPING_OPTIMAL_SKIPPING_FACTOR',
    BallastSkippingCanSkip: 'BALLAST_SKIPPING_CAN_SKIP',
    BallastSkippingMaximumBallastPreSkipping: 'BALLAST_SKIPPING_MAXIMUM_BALLAST_PRE_SKIPPING',
    BallastSkippingMaximumWeightPostSkipping: 'BALLAST_SKIPPING_MAXIMUM_WEIGHT_POST_SKIPPING',
    BallastSkippingMinimumBallastWeightPerPosition: 'BALLAST_SKIPPING_MINIMUM_BALLAST_WEIGHT_PER_POSITION',
    BallastSkippingMinimumSkippingFactor: 'BALLAST_SKIPPING_MINIMUM_SKIPPING_FACTOR',
    BallastSkippingMaximumNumberOfBallastedPositions: 'BALLAST_SKIPPING_MAXIMUM_NUMBER_OF_BALLASTED_POSITIONS',
    BallastSkippingSuperskipStage800AndLower: 'BALLAST_SKIPPING_SUPERSKIP_STAGE_800_AND_LOWER',
    BallastSkippingSuperskipStageAbove800: 'BALLAST_SKIPPING_SUPERSKIP_STAGE_ABOVE_800',
    BallastSkippingSuperskipStage: 'BALLAST_SKIPPING_SUPERSKIP_STAGE',
    BallastSkippingShiftCornerAdjacents: 'BALLAST_SKIPPING_SHIFT_CORNER_ADJACENTS',
    BallastSkippingStage2ExtraShiftingPeakVelocityPressureLimit: 'BALLAST_SKIPPING_STAGE_2_EXTRA_SHIFTING_PEAK_VELOCITY_PRESSURE_LIMIT',
    BallastSkippingModulePositionType: 'BALLAST_SKIPPING_MODULE_POSITION_TYPE',
    BallastSkippingShiftedBallastWeights: 'BALLAST_SKIPPING_SHIFTED_BALLAST_WEIGHTS',
    BallastRailWeight: 'BALLAST_RAIL_WEIGHT',
    BallastWeightFffArticleAmount: 'BALLAST_WEIGHT_FFF_ARTICLE_AMOUNT',
    BallastWeightFfWavePlusArticleAmount: 'BALLAST_WEIGHT_FF_WAVE_PLUS_ARTICLE_AMOUNT',
    BallastWeightApproximateWeightOfUnballastedSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfUnballastedSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfUnballastedCenterOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_CENTER_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfUnballastedCenterOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_CENTER_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfExposedRightSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_RIGHT_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfExposedRightSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_RIGHT_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfExposedLeftSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_LEFT_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfExposedLeftSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_LEFT_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfSharedSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_SHARED_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfSharedSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_SHARED_SIDE_OF_SINGLE_MODULE',
    BallastWeightOfRowConnectionCalculationRule: 'BALLAST_WEIGHT_OF_ROW_CONNECTION_CALCULATION_RULE',
    BallastWeightBallastMountingWeightGrid: 'BALLAST_WEIGHT_BALLAST_MOUNTING_WEIGHT_GRID',
    BallastWeightBallastMinimumWeightDoublePerimeterIsolatedUnit: 'BALLAST_WEIGHT_BALLAST_MINIMUM_WEIGHT_DOUBLE_PERIMETER_ISOLATED_UNIT',
    BaseBallastWeightCapacity: 'BASE_BALLAST_WEIGHT_CAPACITY',
    BallastWaveAdditionalRailsRequired: 'BALLAST_WAVE_ADDITIONAL_RAILS_REQUIRED',
    BallastWaveRailArticles: 'BALLAST_WAVE_RAIL_ARTICLES',
    BallastFffContainerArticles: 'BALLAST_FFF_CONTAINER_ARTICLES',
    BallastElementWeight: 'BALLAST_ELEMENT_WEIGHT',
    BallastMaximumWeightUnderPanelForCouplerlessRailWithBracket: 'BALLAST_MAXIMUM_WEIGHT_UNDER_PANEL_FOR_COUPLERLESS_RAIL_WITH_BRACKET',
    BallastFfWavePlusDualAdditionalRailBallastThreshold: 'BALLAST_FF_WAVE_PLUS_DUAL_ADDITIONAL_RAIL_BALLAST_THRESHOLD',
    BallastArticleWeightCapacityPerPosition: 'BALLAST_ARTICLE_WEIGHT_CAPACITY_PER_POSITION',
    BallastStandardGravitationalAcceleration: 'BALLAST_STANDARD_GRAVITATIONAL_ACCELERATION',
    BallastNorthTiltingPoint: 'BALLAST_NORTH_TILTING_POINT',
    BallastResultingMomentLiftForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_LIFT_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentLiftForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_LIFT_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentBaseMountingSystemForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BASE_MOUNTING_SYSTEM_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBaseMountingSystemForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BASE_MOUNTING_SYSTEM_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentPanelForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_PANEL_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentPanelForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_PANEL_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentBallastWithoutTiltingMeasuresForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITHOUT_TILTING_MEASURES_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBallastWithTiltingMeasuresForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITH_TILTING_MEASURES_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBallastWithTiltingMeasuresForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITH_TILTING_MEASURES_FOR_SOUTH_TILTING_POINT',
    BallastDistanceMountingSystemCenterToNorthTiltingPoint: 'BALLAST_DISTANCE_MOUNTING_SYSTEM_CENTER_TO_NORTH_TILTING_POINT',
    BallastDistancePanelCenterToNorthTiltingPoint: 'BALLAST_DISTANCE_PANEL_CENTER_TO_NORTH_TILTING_POINT',
    BallastDistanceWavePlusBallastPositionToNorthTiltingPoint: 'BALLAST_DISTANCE_WAVE_PLUS_BALLAST_POSITION_TO_NORTH_TILTING_POINT',
    BallastDistanceFlatfixFusionBallastArticlePositionToNorthTiltingPoint: 'BALLAST_DISTANCE_FLATFIX_FUSION_BALLAST_ARTICLE_POSITION_TO_NORTH_TILTING_POINT',
    BallastTotalResultingMomentForNorthTiltingPointWithoutTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_WITHOUT_TILTING_MEASURES',
    BallastTotalResultingMomentForNorthTiltingPointWithTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_WITH_TILTING_MEASURES',
    BallastTotalResultingMomentForNorthTiltingPointBeforeBallast: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_BEFORE_BALLAST',
    BallastSouthTiltingPoint: 'BALLAST_SOUTH_TILTING_POINT',
    BallastDistanceMountingSystemCenterToSouthTiltingPoint: 'BALLAST_DISTANCE_MOUNTING_SYSTEM_CENTER_TO_SOUTH_TILTING_POINT',
    BallastDistancePanelCenterToSouthTiltingPoint: 'BALLAST_DISTANCE_PANEL_CENTER_TO_SOUTH_TILTING_POINT',
    BallastDistanceBallastPositionToSouthTiltingPoint: 'BALLAST_DISTANCE_BALLAST_POSITION_TO_SOUTH_TILTING_POINT',
    BallastTotalResultingMomentForSouthTiltingPointWithTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_SOUTH_TILTING_POINT_WITH_TILTING_MEASURES',
    BallastResultingMomentsForRoof: 'BALLAST_RESULTING_MOMENTS_FOR_ROOF',
    BallastResultingMomentAdditionalPerimeterBracketForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_ADDITIONAL_PERIMETER_BRACKET_FOR_NORTH_TILTING_POINT',
    BallastAdditionalBallastDistributionPositionsRequiredAgainstTilting: 'BALLAST_ADDITIONAL_BALLAST_DISTRIBUTION_POSITIONS_REQUIRED_AGAINST_TILTING',
    BallastAdditionalDistanceToTiltingPoint: 'BALLAST_ADDITIONAL_DISTANCE_TO_TILTING_POINT',
    BallastElement: 'BALLAST_ELEMENT',
    BallastCustomBallastElementWeight: 'BALLAST_CUSTOM_BALLAST_ELEMENT_WEIGHT',
    BallastWaveBracketsBallastArticles: 'BALLAST_WAVE_BRACKETS_BALLAST_ARTICLES',
    BallastWaveMiddleBaseBallastArticles: 'BALLAST_WAVE_MIDDLE_BASE_BALLAST_ARTICLES',
    BallastWaveHighBaseBallastArticles: 'BALLAST_WAVE_HIGH_BASE_BALLAST_ARTICLES',
    BallastWaveLowBaseBallastArticles: 'BALLAST_WAVE_LOW_BASE_BALLAST_ARTICLES',
    BallastMinimumBallastWeightToPreventTilting: 'BALLAST_MINIMUM_BALLAST_WEIGHT_TO_PREVENT_TILTING',
    MarginPerBallastElement: 'MARGIN_PER_BALLAST_ELEMENT',
    WidthUprightBallastElement: 'WIDTH_UPRIGHT_BALLAST_ELEMENT',
    WidthBallastElementOnSide: 'WIDTH_BALLAST_ELEMENT_ON_SIDE',
    AdditionalCapacityTrayWithUprightElements: 'ADDITIONAL_CAPACITY_TRAY_WITH_UPRIGHT_ELEMENTS',
    AdditionalCapacityTrayWithElementsOnSide: 'ADDITIONAL_CAPACITY_TRAY_WITH_ELEMENTS_ON_SIDE',
    TrayOverspan: 'TRAY_OVERSPAN',
    CapacityExtenderWithUprightElements: 'CAPACITY_EXTENDER_WITH_UPRIGHT_ELEMENTS',
    CapacityExtenderWithElementsOnSide: 'CAPACITY_EXTENDER_WITH_ELEMENTS_ON_SIDE',
    ElementsInPerimeterBracket: 'ELEMENTS_IN_PERIMETER_BRACKET',
    AvailableBallastDistributionPositionsAndElementCapacity: 'AVAILABLE_BALLAST_DISTRIBUTION_POSITIONS_AND_ELEMENT_CAPACITY',
    LeastCostlyRailCombination: 'LEAST_COSTLY_RAIL_COMBINATION',
    ClickfitNumberOfRails: 'CLICKFIT_NUMBER_OF_RAILS',
    ClickfitModuleSpace: 'CLICKFIT_MODULE_SPACE',
    ClickfitRoofSectionsCovered: 'CLICKFIT_ROOF_SECTIONS_COVERED',
    ClickfitNumberOfAttachmentsPerRailLine: 'CLICKFIT_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    MaxDistanceBetweenAttachments: 'MAX_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitMinNumberOfRoofAttachments: 'CLICKFIT_MIN_NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitNumberOfAuxiliarySets: 'CLICKFIT_NUMBER_OF_AUXILIARY_SETS',
    ClickfitMaximumTilePressure: 'CLICKFIT_MAXIMUM_TILE_PRESSURE',
    ClickfitMinimumDistanceAttachmentToRailEnd: 'CLICKFIT_MINIMUM_DISTANCE_ATTACHMENT_TO_RAIL_END',
    ClickfitMaximumDistanceAttachmentToRailEnd: 'CLICKFIT_MAXIMUM_DISTANCE_ATTACHMENT_TO_RAIL_END',
    ClickfitMinimumRoofSectionsCovered: 'CLICKFIT_MINIMUM_ROOF_SECTIONS_COVERED',
    ClickfitTotalOverspanWithMinimumRoofSectionsCovered: 'CLICKFIT_TOTAL_OVERSPAN_WITH_MINIMUM_ROOF_SECTIONS_COVERED',
    ClickfitCoverAdditionalSection: 'CLICKFIT_COVER_ADDITIONAL_SECTION',
    ClickfitNumberOfSectionsBetweenAttachments: 'CLICKFIT_NUMBER_OF_SECTIONS_BETWEEN_ATTACHMENTS',
    ClickfitRailsInLineWithRoofSection: 'CLICKFIT_RAILS_IN_LINE_WITH_ROOF_SECTION',
    ClickfitRelativePanelSizeBetweenRails: 'CLICKFIT_RELATIVE_PANEL_SIZE_BETWEEN_RAILS',
    ClickfitGridCellSpace: 'CLICKFIT_GRID_CELL_SPACE',
    ClickfitEvoBom: 'CLICKFIT_EVO_BOM',
    ClickfitEvoBomSegment: 'CLICKFIT_EVO_BOM_SEGMENT',
    NumberOfRoofAttachments: 'NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitEvoCableClips: 'CLICKFIT_EVO_CABLE_CLIPS',
    ClickfitEvoMidClamps: 'CLICKFIT_EVO_MID_CLAMPS',
    ClickfitEvoEndClamps: 'CLICKFIT_EVO_END_CLAMPS',
    ClickfitEvoBitTorx: 'CLICKFIT_EVO_BIT_TORX',
    ClickfitEvoNumberOfCableClips: 'CLICKFIT_EVO_NUMBER_OF_CABLE_CLIPS',
    NumberOfProfileFasteners: 'NUMBER_OF_PROFILE_FASTENERS',
    ClickfitEvoExtraVerticalRailScrews: 'CLICKFIT_EVO_EXTRA_VERTICAL_RAIL_SCREWS',
    ClickfitEvoNumberOfPanelsPerOptimizer: 'CLICKFIT_EVO_NUMBER_OF_PANELS_PER_OPTIMIZER',
    ClickfitEvoNumberOfClamps: 'CLICKFIT_EVO_NUMBER_OF_CLAMPS',
    ClickfitEvoNumberOfMidClamps: 'CLICKFIT_EVO_NUMBER_OF_MID_CLAMPS',
    ClickfitEvoNumberOfEndClamps: 'CLICKFIT_EVO_NUMBER_OF_END_CLAMPS',
    ClickfitEvoEndClampSupports: 'CLICKFIT_EVO_END_CLAMP_SUPPORTS',
    ClickfitEvoEndCapWithoutClampSupport: 'CLICKFIT_EVO_END_CAP_WITHOUT_CLAMP_SUPPORT',
    ClickfitEvoAuxiliarySets: 'CLICKFIT_EVO_AUXILIARY_SETS',
    ClickfitEvoCouplers: 'CLICKFIT_EVO_COUPLERS',
    ClickfitEvoRails: 'CLICKFIT_EVO_RAILS',
    ClickfitEvoEndCaps: 'CLICKFIT_EVO_END_CAPS',
    ClickfitEvoPanelAndMountingCombinedWeight: 'CLICKFIT_EVO_PANEL_AND_MOUNTING_COMBINED_WEIGHT',
    ClickfitEvoAverageMountingSystemWeight: 'CLICKFIT_EVO_AVERAGE_MOUNTING_SYSTEM_WEIGHT',
    ClickfitEvoLockingScrews: 'CLICKFIT_EVO_LOCKING_SCREWS',
    ClickfitEvoVerticalLockingScrewsQuantity: 'CLICKFIT_EVO_VERTICAL_LOCKING_SCREWS_QUANTITY',
    ClickfitEvoClipType: 'CLICKFIT_EVO_CLIP_TYPE',
    ClickfitEvoClampType: 'CLICKFIT_EVO_CLAMP_TYPE',
    ClickfitEvoIsClipUsed: 'CLICKFIT_EVO_IS_CLIP_USED',
    ClickfitEvoCorrugatedMountingBrackets: 'CLICKFIT_EVO_CORRUGATED_MOUNTING_BRACKETS',
    ClickfitEvoCorrugatedSteelAdapters: 'CLICKFIT_EVO_CORRUGATED_STEEL_ADAPTERS',
    ClickfitEvoTilesHookSpacers: 'CLICKFIT_EVO_TILES_HOOK_SPACERS',
    ClickfitEvoTilesHooks: 'CLICKFIT_EVO_TILES_HOOKS',
    ClickfitEvoSlateHooks: 'CLICKFIT_EVO_SLATE_HOOKS',
    ClickfitEvoSteelSheetScrews: 'CLICKFIT_EVO_STEEL_SHEET_SCREWS',
    ClickfitEvoMountingProfiles: 'CLICKFIT_EVO_MOUNTING_PROFILES',
    ClickfitEvoSteelAttachmentType: 'CLICKFIT_EVO_STEEL_ATTACHMENT_TYPE',
    RoofAttachmentLiftLimit: 'ROOF_ATTACHMENT_LIFT_LIMIT',
    RoofAttachmentPressureLimit: 'ROOF_ATTACHMENT_PRESSURE_LIMIT',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLineForPressure: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE_FOR_PRESSURE',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLineForLift: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE_FOR_LIFT',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLine: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    ClickfitEvoIdealDistanceBetweenAttachments: 'CLICKFIT_EVO_IDEAL_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitEvoMinimumDistanceBetweenAttachments: 'CLICKFIT_EVO_MINIMUM_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitEvoMaxNumberOfAttachmentsPerRailLine: 'CLICKFIT_EVO_MAX_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    ClickfitEvoLiftForceOnModuleClamp: 'CLICKFIT_EVO_LIFT_FORCE_ON_MODULE_CLAMP',
    ClickfitEvoPressureForceOnModuleClamp: 'CLICKFIT_EVO_PRESSURE_FORCE_ON_MODULE_CLAMP',
    MaximumAllowableBendingMomentForLift: 'MAXIMUM_ALLOWABLE_BENDING_MOMENT_FOR_LIFT',
    MaximumAllowableBendingMomentForPressure: 'MAXIMUM_ALLOWABLE_BENDING_MOMENT_FOR_PRESSURE',
    AllowableForceFractionFastenerForMountingProfile: 'ALLOWABLE_FORCE_FRACTION_FASTENER_FOR_MOUNTING_PROFILE',
    ClickfitEvoMaximumRailSpan: 'CLICKFIT_EVO_MAXIMUM_RAIL_SPAN',
    ClickfitEvoSeamClamps: 'CLICKFIT_EVO_SEAM_CLAMPS',
    UseForcesOnPanelForAttachments: 'USE_FORCES_ON_PANEL_FOR_ATTACHMENTS',
    ClickfitEvoHangerBoltArticle: 'CLICKFIT_EVO_HANGER_BOLT_ARTICLE',
    ClickfitEvoRafterScrewArticleSetArticle: 'CLICKFIT_EVO_RAFTER_SCREW_ARTICLE_SET_ARTICLE',
    ClickfitEvoHangerBolts: 'CLICKFIT_EVO_HANGER_BOLTS',
    ClickfitEvoWashers: 'CLICKFIT_EVO_WASHERS',
    ClickfitEvoTixophalteKits: 'CLICKFIT_EVO_TIXOPHALTE_KITS',
    ClickfitEvoEpdmKits: 'CLICKFIT_EVO_EPDM_KITS',
    ClickfitEvoRivets: 'CLICKFIT_EVO_RIVETS',
    ClickfitEvoProHookRafterScrews: 'CLICKFIT_EVO_PRO_HOOK_RAFTER_SCREWS',
    ClickfitEvoMountingProfilesArticleSetArticle: 'CLICKFIT_EVO_MOUNTING_PROFILES_ARTICLE_SET_ARTICLE',
    IdealNumberOfMountingProfilesPerSideForPressure: 'IDEAL_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE_FOR_PRESSURE',
    MinimumNumberOfMountingProfilesPerSide: 'MINIMUM_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    MaximumNumberOfMountingProfilesPerSide: 'MAXIMUM_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    NumberOfMountingProfilesPerSide: 'NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    ProfileFastenerLiftLimit: 'PROFILE_FASTENER_LIFT_LIMIT',
    WorstForceFractionPerNumberOfFastenersPerProfile: 'WORST_FORCE_FRACTION_PER_NUMBER_OF_FASTENERS_PER_PROFILE',
    IdealNumberOfMountingProfilesPerSideForLift: 'IDEAL_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE_FOR_LIFT',
    MaxDownwardsForceOnMountingProfilePerSegment: 'MAX_DOWNWARDS_FORCE_ON_MOUNTING_PROFILE_PER_SEGMENT',
    MaxUpwardsForceOnMountingProfilePerSegment: 'MAX_UPWARDS_FORCE_ON_MOUNTING_PROFILE_PER_SEGMENT',
    MaxUpwardsForceOnProfileFastenerPerSegment: 'MAX_UPWARDS_FORCE_ON_PROFILE_FASTENER_PER_SEGMENT',
    MaxUpwardsForceOnFastenerForRoof: 'MAX_UPWARDS_FORCE_ON_FASTENER_FOR_ROOF',
    ClickfitBasicBom: 'CLICKFIT_BASIC_BOM',
    ClickfitBasicBomSegment: 'CLICKFIT_BASIC_BOM_SEGMENT',
    ClickfitBasicEndClampsSegment: 'CLICKFIT_BASIC_END_CLAMPS_SEGMENT',
    ClickfitBasicMountingScrewPanelSegment: 'CLICKFIT_BASIC_MOUNTING_SCREW_PANEL_SEGMENT',
    ClickfitBasicModuleClampSegment: 'CLICKFIT_BASIC_MODULE_CLAMP_SEGMENT',
    ClickfitBasicSupportsSegment: 'CLICKFIT_BASIC_SUPPORTS_SEGMENT',
    ClickfitBasicMountingRailSegment: 'CLICKFIT_BASIC_MOUNTING_RAIL_SEGMENT',
    ClickfitBasicCouplingStripSegment: 'CLICKFIT_BASIC_COUPLING_STRIP_SEGMENT',
    ClickfitBasicCouplingScrewSegment: 'CLICKFIT_BASIC_COUPLING_SCREW_SEGMENT',
    ClickfitBasicNumberOfRoofAttachments: 'CLICKFIT_BASIC_NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitBasicAuxiliarySet: 'CLICKFIT_BASIC_AUXILIARY_SET',
    ClickfitBasicSteelSupportScrew: 'CLICKFIT_BASIC_STEEL_SUPPORT_SCREW',
    ClickfitBasicSteelEpdmTapes: 'CLICKFIT_BASIC_STEEL_EPDM_TAPES',
    ClickfitBasicTiledRoofHook: 'CLICKFIT_BASIC_TILED_ROOF_HOOK',
    ClickfitBasicTiledRoofHookNut: 'CLICKFIT_BASIC_TILED_ROOF_HOOK_NUT',
    ClickfitBasicTiledRoofHookBolt: 'CLICKFIT_BASIC_TILED_ROOF_HOOK_BOLT',
    ClickfitBasicBitumenSupportScrew: 'CLICKFIT_BASIC_BITUMEN_SUPPORT_SCREW',
    ClickfitBasicBitumenSupportScrewType: 'CLICKFIT_BASIC_BITUMEN_SUPPORT_SCREW_TYPE',
    ClickfitBasicBitumenTixophalteKits: 'CLICKFIT_BASIC_BITUMEN_TIXOPHALTE_KITS',
    ClickfitBasicBlackEndCap: 'CLICKFIT_BASIC_BLACK_END_CAP',
    ClickfitBasicBlackColorCaps: 'CLICKFIT_BASIC_BLACK_COLOR_CAPS',
    FlatfixEndClamp: 'FLATFIX_END_CLAMP',
    FlatfixBaseProfileRow: 'FLATFIX_BASE_PROFILE_ROW',
    FlatfixSelfTappingScrews: 'FLATFIX_SELF_TAPPING_SCREWS',
    FlatfixLeftWindDeflector: 'FLATFIX_LEFT_WIND_DEFLECTOR',
    FlatfixRightWindDeflector: 'FLATFIX_RIGHT_WIND_DEFLECTOR',
    FlatfixFusionRearWindDeflector: 'FLATFIX_FUSION_REAR_WIND_DEFLECTOR',
    FlatfixRearWindDeflectorOffset: 'FLATFIX_REAR_WIND_DEFLECTOR_OFFSET',
    FlatfixCableClip: 'FLATFIX_CABLE_CLIP',
    FlatfixCableExitGuide: 'FLATFIX_CABLE_EXIT_GUIDE',
    FlatfixCableExitGuideSide: 'FLATFIX_CABLE_EXIT_GUIDE_SIDE',
    FlatfixMidClamp: 'FLATFIX_MID_CLAMP',
    FlatfixBaseProfile: 'FLATFIX_BASE_PROFILE',
    FlatfixBasePlate: 'FLATFIX_BASE_PLATE',
    FlatfixBasePlateBracket: 'FLATFIX_BASE_PLATE_BRACKET',
    FlatfixHighBase: 'FLATFIX_HIGH_BASE',
    FlatfixHighBaseMountingScrews: 'FLATFIX_HIGH_BASE_MOUNTING_SCREWS',
    FlatfixLowBase: 'FLATFIX_LOW_BASE',
    FlatfixLowBaseExtension: 'FLATFIX_LOW_BASE_EXTENSION',
    FlatfixStabilizerScrew: 'FLATFIX_STABILIZER_SCREW',
    FlatfixBallastContainer: 'FLATFIX_BALLAST_CONTAINER',
    FlatfixStabilizer: 'FLATFIX_STABILIZER',
    FlatfixBallastContainerArticle: 'FLATFIX_BALLAST_CONTAINER_ARTICLE',
    FlatfixLandscapeExtensionNeeded: 'FLATFIX_LANDSCAPE_EXTENSION_NEEDED',
    FlatfixBaseplateSurface: 'FLATFIX_BASEPLATE_SURFACE',
    FlatfixNumberOfBasePlates: 'FLATFIX_NUMBER_OF_BASE_PLATES',
    FlatfixTpoMats: 'FLATFIX_TPO_MATS',
    FlatfixGridCellSpace: 'FLATFIX_GRID_CELL_SPACE',
    FlatfixRearWindDeflectorDimension: 'FLATFIX_REAR_WIND_DEFLECTOR_DIMENSION',
    FlatfixHalfModulesOffset: 'FLATFIX_HALF_MODULES_OFFSET',
    FlatfixBlackScrewCaps: 'FLATFIX_BLACK_SCREW_CAPS',
    FlatfixFusionBom: 'FLATFIX_FUSION_BOM',
    FlatfixFusionBomSegment: 'FLATFIX_FUSION_BOM_SEGMENT',
    FlatfixFusionLowerMountingScrewRearWindDeflector: 'FLATFIX_FUSION_LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    FlatfixFusionUpperMountingScrewRearWindDeflector: 'FLATFIX_FUSION_UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    FlatfixFusionGroundingPlan: 'FLATFIX_FUSION_GROUNDING_PLAN',
    FlatfixFusionGroundingClip: 'FLATFIX_FUSION_GROUNDING_CLIP',
    FlatfixFusionGroundingBracket: 'FLATFIX_FUSION_GROUNDING_BRACKET',
    FlatfixFusionScrewGroundingBracket: 'FLATFIX_FUSION_SCREW_GROUNDING_BRACKET',
    FlatfixFusionGroundingScrewSideDeflector: 'FLATFIX_FUSION_GROUNDING_SCREW_SIDE_DEFLECTOR',
    FlatfixFusionGroundingSpring: 'FLATFIX_FUSION_GROUNDING_SPRING',
    FlatfixModuleDepth: 'FLATFIX_MODULE_DEPTH',
    FlatfixModuleSpace: 'FLATFIX_MODULE_SPACE',
    FlatfixFusionReferenceRowConnectorLength: 'FLATFIX_FUSION_REFERENCE_ROW_CONNECTOR_LENGTH',
    FlatfixFusionRowDistanceFactor: 'FLATFIX_FUSION_ROW_DISTANCE_FACTOR',
    FlatfixFusionDownwardForcePerPanelLimit: 'FLATFIX_FUSION_DOWNWARD_FORCE_PER_PANEL_LIMIT',
    FlatfixFusionDownwardForcePerPanelLimitExceeded: 'FLATFIX_FUSION_DOWNWARD_FORCE_PER_PANEL_LIMIT_EXCEEDED',
    FlatfixFusionSideWindDeflectorMountingScrew: 'FLATFIX_FUSION_SIDE_WIND_DEFLECTOR_MOUNTING_SCREW',
    FlatfixFusionMountingScrewLowerClamp: 'FLATFIX_FUSION_MOUNTING_SCREW_LOWER_CLAMP',
    FlatfixFusionSideDeflectors: 'FLATFIX_FUSION_SIDE_DEFLECTORS',
    FlatfixFusionMountingScrewLowerClampArticleSetArticle: 'FLATFIX_FUSION_MOUNTING_SCREW_LOWER_CLAMP_ARTICLE_SET_ARTICLE',
    FlatfixFusionLowBaseArticleSetArticle: 'FLATFIX_FUSION_LOW_BASE_ARTICLE_SET_ARTICLE',
    FlatfixFusionHighBaseArticleSetArticle: 'FLATFIX_FUSION_HIGH_BASE_ARTICLE_SET_ARTICLE',
    FlatfixFusionBaseProfilePanelArticleSetArticle: 'FLATFIX_FUSION_BASE_PROFILE_PANEL_ARTICLE_SET_ARTICLE',
    FlatfixFusionLeftWindDeflectorArticle: 'FLATFIX_FUSION_LEFT_WIND_DEFLECTOR_ARTICLE',
    FlatfixFusionRightWindDeflectorArticle: 'FLATFIX_FUSION_RIGHT_WIND_DEFLECTOR_ARTICLE',
    FlatfixFusionRearWindDeflectorArticle: 'FLATFIX_FUSION_REAR_WIND_DEFLECTOR_ARTICLE',
    FlatfixWaveNumberBallastBrackets: 'FLATFIX_WAVE_NUMBER_BALLAST_BRACKETS',
    FlatfixWeightPerBasePlateGroup: 'FLATFIX_WEIGHT_PER_BASE_PLATE_GROUP',
    FlatfixWaveRowDistance: 'FLATFIX_WAVE_ROW_DISTANCE',
    FlatfixWaveRailUnitProtrusionLength: 'FLATFIX_WAVE_RAIL_UNIT_PROTRUSION_LENGTH',
    FlatfixWavePlusBallastDistributionTypes: 'FLATFIX_WAVE_PLUS_BALLAST_DISTRIBUTION_TYPES',
    FlatfixWavePlusBom: 'FLATFIX_WAVE_PLUS_BOM',
    FlatfixWavePlusBomSegment: 'FLATFIX_WAVE_PLUS_BOM_SEGMENT',
    FlatfixWavePlusSideWindDeflectorNumberOfSets: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_NUMBER_OF_SETS',
    FlatfixWavePlusStabilizerGap: 'FLATFIX_WAVE_PLUS_STABILIZER_GAP',
    FlatfixWavePlusBracketsForStabilizerGap: 'FLATFIX_WAVE_PLUS_BRACKETS_FOR_STABILIZER_GAP',
    FlatfixWavePlusCableBrackets: 'FLATFIX_WAVE_PLUS_CABLE_BRACKETS',
    FlatfixWavePlusBallastBrackets: 'FLATFIX_WAVE_PLUS_BALLAST_BRACKETS',
    FlatfixWavePlusStabilizer: 'FLATFIX_WAVE_PLUS_STABILIZER',
    FlatfixWavePlusStabilizerArticle: 'FLATFIX_WAVE_PLUS_STABILIZER_ARTICLE',
    FlatfixWavePlusStabilizerLength: 'FLATFIX_WAVE_PLUS_STABILIZER_LENGTH',
    FlatfixWavePlusStabilizerOverspan: 'FLATFIX_WAVE_PLUS_STABILIZER_OVERSPAN',
    FlatfixWavePlusMinimumStabilizerOverspan: 'FLATFIX_WAVE_PLUS_MINIMUM_STABILIZER_OVERSPAN',
    FlatfixWavePlusBasePlate: 'FLATFIX_WAVE_PLUS_BASE_PLATE',
    FlatfixWavePlusRailUnit1P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_1P',
    FlatfixWavePlusRailUnit2P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_2P',
    FlatfixWavePlusOldRailUnit2P: 'FLATFIX_WAVE_PLUS_OLD_RAIL_UNIT_2P',
    FlatfixWavePlusRailUnit3P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_3P',
    FlatfixWavePlusRailUnit4P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_4P',
    FlatfixWavePlusDualRailUnitChoice: 'FLATFIX_WAVE_PLUS_DUAL_RAIL_UNIT_CHOICE',
    FlatfixWavePlusRailStartUnit4P: 'FLATFIX_WAVE_PLUS_RAIL_START_UNIT_4P',
    FlatfixWavePlusRailWidth: 'FLATFIX_WAVE_PLUS_RAIL_WIDTH',
    FlatfixWavePlusWidePanelSolutionNeeded: 'FLATFIX_WAVE_PLUS_WIDE_PANEL_SOLUTION_NEEDED',
    FlatfixWavePlusMeasuringBar: 'FLATFIX_WAVE_PLUS_MEASURING_BAR',
    FlatfixWavePlusModuleSpacer: 'FLATFIX_WAVE_PLUS_MODULE_SPACER',
    FlatfixWavePlusModuleUnlockTool: 'FLATFIX_WAVE_PLUS_MODULE_UNLOCK_TOOL',
    FlatfixWavePlusMinimumRailsUnderModule: 'FLATFIX_WAVE_PLUS_MINIMUM_RAILS_UNDER_MODULE',
    FlatfixWavePlusMaxLiftForceOnPanelIn2RailConfig: 'FLATFIX_WAVE_PLUS_MAX_LIFT_FORCE_ON_PANEL_IN_2_RAIL_CONFIG',
    FlatfixWavePlusMaxLiftForceOnPanelIn3RailConfig: 'FLATFIX_WAVE_PLUS_MAX_LIFT_FORCE_ON_PANEL_IN_3_RAIL_CONFIG',
    FlatfixWavePlusSidePlatesPlacement: 'FLATFIX_WAVE_PLUS_SIDE_PLATES_PLACEMENT',
    FlatfixWavePlusRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusOptimalRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_OPTIMAL_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusRearWindDeflectorLength: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_LENGTH',
    FlatfixWavePlusOptimalRearWindDeflectorLength: 'FLATFIX_WAVE_PLUS_OPTIMAL_REAR_WIND_DEFLECTOR_LENGTH',
    FlatfixWavePlusMarginRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_MARGIN_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusRearWindDeflectorArticleSetArticle: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_ARTICLE_SET_ARTICLE',
    FlatfixWavePlusRearWindDeflector: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR',
    FlatfixWavePlusRearWindDeflectorClip: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_CLIP',
    FlatfixWavePlusPerimeterBracket: 'FLATFIX_WAVE_PLUS_PERIMETER_BRACKET',
    FlatfixWavePlusTray: 'FLATFIX_WAVE_PLUS_TRAY',
    FlatfixWavePlusExtender: 'FLATFIX_WAVE_PLUS_EXTENDER',
    FlatfixWavePlusMinOverspanRearWindDeflector: 'FLATFIX_WAVE_PLUS_MIN_OVERSPAN_REAR_WIND_DEFLECTOR',
    FlatfixWavePlusRailUnitPlacementRegularRails: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_PLACEMENT_REGULAR_RAILS',
    FlatfixWavePlusRailUnitPlacement3RdRails: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_PLACEMENT_3RD_RAILS',
    FlatfixPlusWeightCapacityPerBallastArticleTypePosition: 'FLATFIX_PLUS_WEIGHT_CAPACITY_PER_BALLAST_ARTICLE_TYPE_POSITION',
    FlatfixWavePlusMaximumDistanceBetweenRailsForTrays: 'FLATFIX_WAVE_PLUS_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_TRAYS',
    FlatfixWavePlusTraysPossible: 'FLATFIX_WAVE_PLUS_TRAYS_POSSIBLE',
    FlatfixWavePlusAdditionalRailUnitForBallastAllowed: 'FLATFIX_WAVE_PLUS_ADDITIONAL_RAIL_UNIT_FOR_BALLAST_ALLOWED',
    FlatfixWavePlusMinimumDistanceBetweenRailsForExtender: 'FLATFIX_WAVE_PLUS_MINIMUM_DISTANCE_BETWEEN_RAILS_FOR_EXTENDER',
    FlatfixWavePlusMaximumDistanceBetweenRailsForExtender: 'FLATFIX_WAVE_PLUS_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_EXTENDER',
    FlatfixWavePlusExtendersPossible: 'FLATFIX_WAVE_PLUS_EXTENDERS_POSSIBLE',
    FlatfixWavePlusTrayArticle: 'FLATFIX_WAVE_PLUS_TRAY_ARTICLE',
    FlatfixWavePlusExtenderArticle: 'FLATFIX_WAVE_PLUS_EXTENDER_ARTICLE',
    FlatfixWavePlusRegularRailUnitOffset: 'FLATFIX_WAVE_PLUS_REGULAR_RAIL_UNIT_OFFSET',
    FlatfixWavePlusBasePlateOffsets: 'FLATFIX_WAVE_PLUS_BASE_PLATE_OFFSETS',
    FlatfixWavePlusReducedInsideRailCapacityWithTray: 'FLATFIX_WAVE_PLUS_REDUCED_INSIDE_RAIL_CAPACITY_WITH_TRAY',
    FlatfixWavePlusSideWindDeflectorSetArticleSetArticle: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET_ARTICLE_SET_ARTICLE',
    FlatfixWavePlusSideWindDeflectorSet: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET',
    FlatfixWavePlusSideWindDeflectorClamp: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_CLAMP',
    WaveBasePlatesPerRailUnit: 'WAVE_BASE_PLATES_PER_RAIL_UNIT',
    WaveMat: 'WAVE_MAT',
    WaveTotalWeightLimit: 'WAVE_TOTAL_WEIGHT_LIMIT',
    DesignValueExceptionalSnowLoadOnGround: 'DESIGN_VALUE_EXCEPTIONAL_SNOW_LOAD_ON_GROUND',
    ExceptionalSnowLoadCoefficient: 'EXCEPTIONAL_SNOW_LOAD_COEFFICIENT',
    ExceptionalSnowLoadOnRoof: 'EXCEPTIONAL_SNOW_LOAD_ON_ROOF',
    ProductCanBeCalculatedWithSnow: 'PRODUCT_CAN_BE_CALCULATED_WITH_SNOW',
    RegularSnowLoadOnTheRoof: 'REGULAR_SNOW_LOAD_ON_THE_ROOF',
    SnowLoadApplySnowLoad: 'SNOW_LOAD_APPLY_SNOW_LOAD',
    SnowLoadCharacteristicGroundLoad: 'SNOW_LOAD_CHARACTERISTIC_GROUND_LOAD',
    SnowLoadEffectiveFormCoefficient: 'SNOW_LOAD_EFFECTIVE_FORM_COEFFICIENT',
    ExceptionalSnowLoadEffectiveFormCoefficient: 'EXCEPTIONAL_SNOW_LOAD_EFFECTIVE_FORM_COEFFICIENT',
    SnowLoadExposureFactor: 'SNOW_LOAD_EXPOSURE_FACTOR',
    SnowLoadFormCoefficientOne: 'SNOW_LOAD_FORM_COEFFICIENT_ONE',
    SnowLoadFormCoefficientTwo: 'SNOW_LOAD_FORM_COEFFICIENT_TWO',
    SnowLoadFormCoefficientFive: 'SNOW_LOAD_FORM_COEFFICIENT_FIVE',
    ExceptionalSnowLoadFormCoefficientFive: 'EXCEPTIONAL_SNOW_LOAD_FORM_COEFFICIENT_FIVE',
    SnowLoadGroundLoadOverReferencePeriod: 'SNOW_LOAD_GROUND_LOAD_OVER_REFERENCE_PERIOD',
    RegularSnowLoadPerpendicularDownForceOnPanel: 'REGULAR_SNOW_LOAD_PERPENDICULAR_DOWN_FORCE_ON_PANEL',
    SnowLoadProbabilityFactor: 'SNOW_LOAD_PROBABILITY_FACTOR',
    SnowLoadVariationCoefficientAnnualMaximum: 'SNOW_LOAD_VARIATION_COEFFICIENT_ANNUAL_MAXIMUM',
    SnowLoadThermalCoefficient: 'SNOW_LOAD_THERMAL_COEFFICIENT',
    SnowLoadSnowWeightDensity: 'SNOW_LOAD_SNOW_WEIGHT_DENSITY',
    SnowLoadOnGround: 'SNOW_LOAD_ON_GROUND',
    SnowLoadOnGroundLimit: 'SNOW_LOAD_ON_GROUND_LIMIT',
    SnowLoadOnGroundSpain: 'SNOW_LOAD_ON_GROUND_SPAIN',
    SnowLoadFreezeThawFactorSpain: 'SNOW_LOAD_FREEZE_THAW_FACTOR_SPAIN',
    InExceptionalSnowLoadArea: 'IN_EXCEPTIONAL_SNOW_LOAD_AREA',
    CalculateExceptionalSnowLoads: 'CALCULATE_EXCEPTIONAL_SNOW_LOADS',
    ExceptionalSnowLoadOnPanel: 'EXCEPTIONAL_SNOW_LOAD_ON_PANEL',
    FactoredExceptionalSnowPressureOnPanel: 'FACTORED_EXCEPTIONAL_SNOW_PRESSURE_ON_PANEL',
    FactoredExceptionalSnowPressurePerModule: 'FACTORED_EXCEPTIONAL_SNOW_PRESSURE_PER_MODULE',
    CombinationFactorWindInAccidentalDesignSituations: 'COMBINATION_FACTOR_WIND_IN_ACCIDENTAL_DESIGN_SITUATIONS',
    ExceptionalSnowLoadCombination: 'EXCEPTIONAL_SNOW_LOAD_COMBINATION',
    WorstCaseFactoredSnowPressureOnPanel: 'WORST_CASE_FACTORED_SNOW_PRESSURE_ON_PANEL',
    WorstCaseSnowLoadOnGround: 'WORST_CASE_SNOW_LOAD_ON_GROUND',
    AlternativeLoadEquations: 'ALTERNATIVE_LOAD_EQUATIONS',
    AveragePressureOnModule: 'AVERAGE_PRESSURE_ON_MODULE',
    AverageWindloadLift: 'AVERAGE_WINDLOAD_LIFT',
    AveragePressurePerAttachmentForSegment: 'AVERAGE_PRESSURE_PER_ATTACHMENT_FOR_SEGMENT',
    AverageLiftPerAttachmentForSegment: 'AVERAGE_LIFT_PER_ATTACHMENT_FOR_SEGMENT',
    StandardWindloadPressureCoefficientPlus: 'STANDARD_WINDLOAD_PRESSURE_COEFFICIENT_PLUS',
    WindloadPressureCoefficientMinus: 'WINDLOAD_PRESSURE_COEFFICIENT_MINUS',
    StandardWindloadPerpendicularWindDownForceOnPanel: 'STANDARD_WINDLOAD_PERPENDICULAR_WIND_DOWN_FORCE_ON_PANEL',
    WindloadPerpendicularWindLiftForceOnPanel: 'WINDLOAD_PERPENDICULAR_WIND_LIFT_FORCE_ON_PANEL',
    WindloadMaxLoadOnPanel: 'WINDLOAD_MAX_LOAD_ON_PANEL',
    PrimaryWindPressureCombination: 'PRIMARY_WIND_PRESSURE_COMBINATION',
    PrimaryWindLiftCombination: 'PRIMARY_WIND_LIFT_COMBINATION',
    WindtunnelPressureCoefficientPlus: 'WINDTUNNEL_PRESSURE_COEFFICIENT_PLUS',
    WindtunnelPerpendicularWindDownforceOnPanel: 'WINDTUNNEL_PERPENDICULAR_WIND_DOWNFORCE_ON_PANEL',
    WindtunnelFactoredWindPressurePerModule: 'WINDTUNNEL_FACTORED_WIND_PRESSURE_PER_MODULE',
    CombinationFactorWind: 'COMBINATION_FACTOR_WIND',
    CombinationFactorSnow: 'COMBINATION_FACTOR_SNOW',
    FactoredUnfavourablePermanentLoadPerModule: 'FACTORED_UNFAVOURABLE_PERMANENT_LOAD_PER_MODULE',
    StandardFactoredWindPressurePerModule: 'STANDARD_FACTORED_WIND_PRESSURE_PER_MODULE',
    FactoredRegularSnowPressurePerModule: 'FACTORED_REGULAR_SNOW_PRESSURE_PER_MODULE',
    FactoredRegularSnowPressureOnPanel: 'FACTORED_REGULAR_SNOW_PRESSURE_ON_PANEL',
    SnowAndWindCombinedLoadCombination: 'SNOW_AND_WIND_COMBINED_LOAD_COMBINATION',
    PrimaryWindWithSecondarySnowCombinedLoadCombination: 'PRIMARY_WIND_WITH_SECONDARY_SNOW_COMBINED_LOAD_COMBINATION',
    PrimarySnowWithSecondaryWindCombinedLoadCombination: 'PRIMARY_SNOW_WITH_SECONDARY_WIND_COMBINED_LOAD_COMBINATION',
    WorstCaseLoadPerModule: 'WORST_CASE_LOAD_PER_MODULE',
    WorstCaseLoadPerBasePlateGroup: 'WORST_CASE_LOAD_PER_BASE_PLATE_GROUP',
    DynamicPointLoadsPerBasePlateGroup: 'DYNAMIC_POINT_LOADS_PER_BASE_PLATE_GROUP',
    MaxDynamicPointLoadInSegment: 'MAX_DYNAMIC_POINT_LOAD_IN_SEGMENT',
    MaxDynamicPointLoadOnRoof: 'MAX_DYNAMIC_POINT_LOAD_ON_ROOF',
    MaxStaticPointLoadOnRoof: 'MAX_STATIC_POINT_LOAD_ON_ROOF',
    IgnoreVariableLoadsForCombinedLoads: 'IGNORE_VARIABLE_LOADS_FOR_COMBINED_LOADS',
    WindpressureWindloadUnfavourablePermanentLoadFactorCombinedLoads: 'WINDPRESSURE_WINDLOAD_UNFAVOURABLE_PERMANENT_LOAD_FACTOR_COMBINED_LOADS',
    FactoredUnfavourablePermanentLoadPerModuleForCombinedLoads: 'FACTORED_UNFAVOURABLE_PERMANENT_LOAD_PER_MODULE_FOR_COMBINED_LOADS',
    StaticWeightPerBasePlateInBasePlateGroup: 'STATIC_WEIGHT_PER_BASE_PLATE_IN_BASE_PLATE_GROUP',
    MaximumDynamicWeightPerBasePlateOnRoof: 'MAXIMUM_DYNAMIC_WEIGHT_PER_BASE_PLATE_ON_ROOF',
    WindpressureAsCombinedLoadCombination: 'WINDPRESSURE_AS_COMBINED_LOAD_COMBINATION',
    MinumumShapeCoefficientWithSnowFences: 'MINUMUM_SHAPE_COEFFICIENT_WITH_SNOW_FENCES',
    CombinedExceptionalAndRegularSnowLoadOnRoof: 'COMBINED_EXCEPTIONAL_AND_REGULAR_SNOW_LOAD_ON_ROOF',
    TotalPressureForceOnSegment: 'TOTAL_PRESSURE_FORCE_ON_SEGMENT',
    TotalLiftForceOnSegment: 'TOTAL_LIFT_FORCE_ON_SEGMENT',
    MaximumLiftPerAttachmentForRoof: 'MAXIMUM_LIFT_PER_ATTACHMENT_FOR_ROOF',
    MaximumPressurePerAttachmentForRoof: 'MAXIMUM_PRESSURE_PER_ATTACHMENT_FOR_ROOF',
    LengthBaseProfilePanel: 'LENGTH_BASE_PROFILE_PANEL',
    MarginBaseProfilePanel: 'MARGIN_BASE_PROFILE_PANEL',
    MarginBaseProfileRow: 'MARGIN_BASE_PROFILE_ROW',
    InstallationSummary: 'INSTALLATION_SUMMARY',
    InstallationSummaryFrontPage: 'INSTALLATION_SUMMARY_FRONT_PAGE',
    InstallationSummaryHeader: 'INSTALLATION_SUMMARY_HEADER',
    InstallationSummaryOtherDocuments: 'INSTALLATION_SUMMARY_OTHER_DOCUMENTS',
    InstallationSummaryRoofOverview: 'INSTALLATION_SUMMARY_ROOF_OVERVIEW',
    InstallationSummaryCompleteMaterials: 'INSTALLATION_SUMMARY_COMPLETE_MATERIALS',
    InstallationSummaryAssembly: 'INSTALLATION_SUMMARY_ASSEMBLY',
    InstallationSummarySegments: 'INSTALLATION_SUMMARY_SEGMENTS',
    InstallationSummaryCalculations: 'INSTALLATION_SUMMARY_CALCULATIONS',
    InstallationSummaryBackPage: 'INSTALLATION_SUMMARY_BACK_PAGE',
    InstallationSummaryImageAssemblyPlan: 'INSTALLATION_SUMMARY_IMAGE_ASSEMBLY_PLAN',
    InstallationSummaryImageAverageLoads: 'INSTALLATION_SUMMARY_IMAGE_AVERAGE_LOADS',
    InstallationSummaryImageRoofOverview: 'INSTALLATION_SUMMARY_IMAGE_ROOF_OVERVIEW',
    InstallationSummaryImageBallast: 'INSTALLATION_SUMMARY_IMAGE_BALLAST',
    InstallationSummaryImageMiniMap: 'INSTALLATION_SUMMARY_IMAGE_MINI_MAP',
    OrderList: 'ORDER_LIST',
    OrderListSummary: 'ORDER_LIST_SUMMARY',
    OrderListFooter: 'ORDER_LIST_FOOTER'
};
exports.VisualizationResultDTODependenciesEnum = {
    ProjectReferencePeriod: 'PROJECT_REFERENCE_PERIOD',
    RoofCountry: 'ROOF_COUNTRY',
    RoofBom: 'ROOF_BOM',
    RoofAppliedProduct: 'ROOF_APPLIED_PRODUCT',
    RoofApplicableProducts: 'ROOF_APPLICABLE_PRODUCTS',
    RoofAvailableProducts: 'ROOF_AVAILABLE_PRODUCTS',
    RoofBusinessUnitProducts: 'ROOF_BUSINESS_UNIT_PRODUCTS',
    RoofPreferredProduct: 'ROOF_PREFERRED_PRODUCT',
    RoofHeight: 'ROOF_HEIGHT',
    RoofAppliedHeight: 'ROOF_APPLIED_HEIGHT',
    RoofTerrainCategory: 'ROOF_TERRAIN_CATEGORY',
    RoofSnowzone: 'ROOF_SNOWZONE',
    RoofMinimumHeight: 'ROOF_MINIMUM_HEIGHT',
    RoofRoughnessLength: 'ROOF_ROUGHNESS_LENGTH',
    RoofRoughnessLengthDependantTerrainFactor: 'ROOF_ROUGHNESS_LENGTH_DEPENDANT_TERRAIN_FACTOR',
    RoofRoughnessFactor: 'ROOF_ROUGHNESS_FACTOR',
    RoofSlope: 'ROOF_SLOPE',
    RoofType: 'ROOF_TYPE',
    RoofSide: 'ROOF_SIDE',
    RoofSlopeForLoadEquations: 'ROOF_SLOPE_FOR_LOAD_EQUATIONS',
    RoofMaterial: 'ROOF_MATERIAL',
    RoofFrictionCoefficient: 'ROOF_FRICTION_COEFFICIENT',
    RoofFlangeDistance: 'ROOF_FLANGE_DISTANCE',
    RoofEdges: 'ROOF_EDGES',
    RoofBoundingBox: 'ROOF_BOUNDING_BOX',
    RoofDistanceBetweenRailsUnderModule: 'ROOF_DISTANCE_BETWEEN_RAILS_UNDER_MODULE',
    RoofDistanceBetweenRailsBetweenModules: 'ROOF_DISTANCE_BETWEEN_RAILS_BETWEEN_MODULES',
    RoofMaximumDistanceBetweenRailsForRearWindDeflector: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_REAR_WIND_DEFLECTOR',
    RoofMinimumDistanceBetweenRailsForPanelLength: 'ROOF_MINIMUM_DISTANCE_BETWEEN_RAILS_FOR_PANEL_LENGTH',
    RoofMaximumDistanceBetweenRailsForPanelLength: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_PANEL_LENGTH',
    RoofMaximumDistanceBetweenRailsUnderModule: 'ROOF_MAXIMUM_DISTANCE_BETWEEN_RAILS_UNDER_MODULE',
    MaximumDistanceCorrugatedBrackets: 'MAXIMUM_DISTANCE_CORRUGATED_BRACKETS',
    RoofExtraCostPerRail: 'ROOF_EXTRA_COST_PER_RAIL',
    RoofAttachmentType: 'ROOF_ATTACHMENT_TYPE',
    RoofAvailableRails: 'ROOF_AVAILABLE_RAILS',
    RoofHookType: 'ROOF_HOOK_TYPE',
    RoofHookSize: 'ROOF_HOOK_SIZE',
    RoofHookPressureLimit: 'ROOF_HOOK_PRESSURE_LIMIT',
    RoofAllSegments: 'ROOF_ALL_SEGMENTS',
    RoofUniqueSegments: 'ROOF_UNIQUE_SEGMENTS',
    RoofSegmentTypes: 'ROOF_SEGMENT_TYPES',
    RoofSegmentTypeModuleSpaces: 'ROOF_SEGMENT_TYPE_MODULE_SPACES',
    RoofUniqueSegmentsRowDistance: 'ROOF_UNIQUE_SEGMENTS_ROW_DISTANCE',
    RoofColor: 'ROOF_COLOR',
    RoofSkippingApplied: 'ROOF_SKIPPING_APPLIED',
    RoofPerimeterApplied: 'ROOF_PERIMETER_APPLIED',
    RoofLength: 'ROOF_LENGTH',
    RoofWidth: 'ROOF_WIDTH',
    RoofTotalYield: 'ROOF_TOTAL_YIELD',
    RoofArea: 'ROOF_AREA',
    RoofLoadOverArea: 'ROOF_LOAD_OVER_AREA',
    RoofTotalSystemArea: 'ROOF_TOTAL_SYSTEM_AREA',
    RoofTotalBallastWeight: 'ROOF_TOTAL_BALLAST_WEIGHT',
    RoofPurlinDistance: 'ROOF_PURLIN_DISTANCE',
    RoofChosenAttachmentType: 'ROOF_CHOSEN_ATTACHMENT_TYPE',
    RoofChosenHangerBolt: 'ROOF_CHOSEN_HANGER_BOLT',
    RoofDilatationDistance: 'ROOF_DILATATION_DISTANCE',
    RoofNumberOfModulesInRow: 'ROOF_NUMBER_OF_MODULES_IN_ROW',
    RoofTotalWeight: 'ROOF_TOTAL_WEIGHT',
    RoofAirDensity: 'ROOF_AIR_DENSITY',
    RoofAverageRoofLoadOverTotalSystem: 'ROOF_AVERAGE_ROOF_LOAD_OVER_TOTAL_SYSTEM',
    RoofNumberOfBallastElements: 'ROOF_NUMBER_OF_BALLAST_ELEMENTS',
    RoofAltitudeAboveSeaLevel: 'ROOF_ALTITUDE_ABOVE_SEA_LEVEL',
    RoofSectionDistance: 'ROOF_SECTION_DISTANCE',
    RoofGapSpace: 'ROOF_GAP_SPACE',
    RoofTotalBuildingHeight: 'ROOF_TOTAL_BUILDING_HEIGHT',
    RoofParapetHeight: 'ROOF_PARAPET_HEIGHT',
    RoofNumberOfPanels: 'ROOF_NUMBER_OF_PANELS',
    RoofDistanceToCoast: 'ROOF_DISTANCE_TO_COAST',
    RoofDistanceToCityBoundary: 'ROOF_DISTANCE_TO_CITY_BOUNDARY',
    RoofAltitudeOfTheUpwindBase: 'ROOF_ALTITUDE_OF_THE_UPWIND_BASE',
    RoofAppliedDistanceToCityBoundary: 'ROOF_APPLIED_DISTANCE_TO_CITY_BOUNDARY',
    RoofTpoMatsNeeded: 'ROOF_TPO_MATS_NEEDED',
    RoofTotalPrice: 'ROOF_TOTAL_PRICE',
    RoofPricePerPanel: 'ROOF_PRICE_PER_PANEL',
    RoofPricePerWattPeak: 'ROOF_PRICE_PER_WATT_PEAK',
    RoofRotation: 'ROOF_ROTATION',
    RoofSideWindDeflectorWidth: 'ROOF_SIDE_WIND_DEFLECTOR_WIDTH',
    RoofConsequenceClass: 'ROOF_CONSEQUENCE_CLASS',
    RoofGroundingOption: 'ROOF_GROUNDING_OPTION',
    RoofBomAdjustments: 'ROOF_BOM_ADJUSTMENTS',
    RoofPermanentLoadPerModule: 'ROOF_PERMANENT_LOAD_PER_MODULE',
    RoofHasOldOrWetSnow: 'ROOF_HAS_OLD_OR_WET_SNOW',
    RoofRailsRequired: 'ROOF_RAILS_REQUIRED',
    RoofNoGoAreaDepth: 'ROOF_NO_GO_AREA_DEPTH',
    RoofAttachToRoofStructure: 'ROOF_ATTACH_TO_ROOF_STRUCTURE',
    RoofStructure: 'ROOF_STRUCTURE',
    RoofSectioningType: 'ROOF_SECTIONING_TYPE',
    RoofRafterDistance: 'ROOF_RAFTER_DISTANCE',
    RoofCanPerimeterBeDisabled: 'ROOF_CAN_PERIMETER_BE_DISABLED',
    RoofPanelAngle: 'ROOF_PANEL_ANGLE',
    RoofSidePlatePlacement: 'ROOF_SIDE_PLATE_PLACEMENT',
    RoofSeamType: 'ROOF_SEAM_TYPE',
    RoofSteelType: 'ROOF_STEEL_TYPE',
    RoofDisableNoGoArea: 'ROOF_DISABLE_NO_GO_AREA',
    RoofPolygon: 'ROOF_POLYGON',
    RoofFields: 'ROOF_FIELDS',
    RoofMeasurements: 'ROOF_MEASUREMENTS',
    RoofPreferredFastener: 'ROOF_PREFERRED_FASTENER',
    RoofObstacles: 'ROOF_OBSTACLES',
    RoofShape: 'ROOF_SHAPE',
    RoofFreezeThawLikely: 'ROOF_FREEZE_THAW_LIKELY',
    RoofDriftedSnowPossibleOnSide: 'ROOF_DRIFTED_SNOW_POSSIBLE_ON_SIDE',
    RoofWallHeight: 'ROOF_WALL_HEIGHT',
    RoofUseFormCoefficientDueToWind: 'ROOF_USE_FORM_COEFFICIENT_DUE_TO_WIND',
    RoofFormCoefficientDueToWind: 'ROOF_FORM_COEFFICIENT_DUE_TO_WIND',
    RoofTopography: 'ROOF_TOPOGRAPHY',
    RoofSnowFencesPresent: 'ROOF_SNOW_FENCES_PRESENT',
    RoofMapWindSpeed: 'ROOF_MAP_WIND_SPEED',
    RoofIsRoofHookAttachedToStructure: 'ROOF_IS_ROOF_HOOK_ATTACHED_TO_STRUCTURE',
    RoofMatsIncluded: 'ROOF_MATS_INCLUDED',
    RoofSteelThickness: 'ROOF_STEEL_THICKNESS',
    WindDeflectorLandscapeSize: 'WIND_DEFLECTOR_LANDSCAPE_SIZE',
    PressureCoefficientRearWindDeflector: 'PRESSURE_COEFFICIENT_REAR_WIND_DEFLECTOR',
    SurfaceAreaRearWindDeflector: 'SURFACE_AREA_REAR_WIND_DEFLECTOR',
    ForceOnRearWindDeflector: 'FORCE_ON_REAR_WIND_DEFLECTOR',
    WindExposureFactor: 'WIND_EXPOSURE_FACTOR',
    SurfaceAreaSideDeflector: 'SURFACE_AREA_SIDE_DEFLECTOR',
    InwardsPressureCoefficientSideDeflector: 'INWARDS_PRESSURE_COEFFICIENT_SIDE_DEFLECTOR',
    InwardsPressureForceOnSideDeflector: 'INWARDS_PRESSURE_FORCE_ON_SIDE_DEFLECTOR',
    OutwardsSuctionCoefficientSideDeflector: 'OUTWARDS_SUCTION_COEFFICIENT_SIDE_DEFLECTOR',
    OutwardsSuctionForceOnSideDeflector: 'OUTWARDS_SUCTION_FORCE_ON_SIDE_DEFLECTOR',
    InwardsPressureForceLimitForSideDeflector: 'INWARDS_PRESSURE_FORCE_LIMIT_FOR_SIDE_DEFLECTOR',
    OutwardsSuctionForceLimitForSideDeflector: 'OUTWARDS_SUCTION_FORCE_LIMIT_FOR_SIDE_DEFLECTOR',
    EdgeLength: 'EDGE_LENGTH',
    EdgeZoneScalingFactor: 'EDGE_ZONE_SCALING_FACTOR',
    EdgeZoneHorizontalDepth: 'EDGE_ZONE_HORIZONTAL_DEPTH',
    EdgeZoneDepth: 'EDGE_ZONE_DEPTH',
    EdgeZoneVerticalDepth: 'EDGE_ZONE_VERTICAL_DEPTH',
    AllowedCentralRoofZones: 'ALLOWED_CENTRAL_ROOF_ZONES',
    CommercialCentralRoofZones: 'COMMERCIAL_CENTRAL_ROOF_ZONES',
    CommercialEdgeZone: 'COMMERCIAL_EDGE_ZONE',
    EurocodeCentralRoofZones: 'EUROCODE_CENTRAL_ROOF_ZONES',
    EurocodeEdgeZone: 'EUROCODE_EDGE_ZONE',
    EurocodeNorthEdgeZone: 'EUROCODE_NORTH_EDGE_ZONE',
    EurocodeSouthEdgeZone: 'EUROCODE_SOUTH_EDGE_ZONE',
    PeutzCentralRoofZones: 'PEUTZ_CENTRAL_ROOF_ZONES',
    PeutzInnerEdgeZoneHorizontalDepth: 'PEUTZ_INNER_EDGE_ZONE_HORIZONTAL_DEPTH',
    PeutzInnerEdgeZoneVerticalDepth: 'PEUTZ_INNER_EDGE_ZONE_VERTICAL_DEPTH',
    PeutzInnerEdgeZoneDepth: 'PEUTZ_INNER_EDGE_ZONE_DEPTH',
    PeutzInnerEdgeZones: 'PEUTZ_INNER_EDGE_ZONES',
    PeutzNorthInnerEdgeZones: 'PEUTZ_NORTH_INNER_EDGE_ZONES',
    PeutzSouthInnerEdgeZones: 'PEUTZ_SOUTH_INNER_EDGE_ZONES',
    SystemHeight: 'SYSTEM_HEIGHT',
    FieldRoofHorizontalDilatationLength: 'FIELD_ROOF_HORIZONTAL_DILATATION_LENGTH',
    FieldRoofVerticalDilatationLength: 'FIELD_ROOF_VERTICAL_DILATATION_LENGTH',
    FieldRoofEffectiveVerticalDilatation: 'FIELD_ROOF_EFFECTIVE_VERTICAL_DILATATION',
    FieldRoofEffectiveHorizontalDilatation: 'FIELD_ROOF_EFFECTIVE_HORIZONTAL_DILATATION',
    FieldHorizontalDilatationGapSpacing: 'FIELD_HORIZONTAL_DILATATION_GAP_SPACING',
    FieldVerticalDilatationGapSpacing: 'FIELD_VERTICAL_DILATATION_GAP_SPACING',
    FieldCoordinate: 'FIELD_COORDINATE',
    FieldSegments: 'FIELD_SEGMENTS',
    FieldSidePlatesOption: 'FIELD_SIDE_PLATES_OPTION',
    FieldRowDistance: 'FIELD_ROW_DISTANCE',
    FieldReferenceRowDistanceLandscape: 'FIELD_REFERENCE_ROW_DISTANCE_LANDSCAPE',
    FieldModules: 'FIELD_MODULES',
    FieldSetup: 'FIELD_SETUP',
    FieldOrientation: 'FIELD_ORIENTATION',
    FieldRailSystem: 'FIELD_RAIL_SYSTEM',
    SegmentTotalPanelWeight: 'SEGMENT_TOTAL_PANEL_WEIGHT',
    FieldModuleLocationLimits: 'FIELD_MODULE_LOCATION_LIMITS',
    FieldModuleConfiguration: 'FIELD_MODULE_CONFIGURATION',
    FieldRowConnectorLength: 'FIELD_ROW_CONNECTOR_LENGTH',
    FieldHorizontalModuleGapSpacing: 'FIELD_HORIZONTAL_MODULE_GAP_SPACING',
    FieldVerticalModuleGapSpacing: 'FIELD_VERTICAL_MODULE_GAP_SPACING',
    FieldNeedRoofSectionSpanningRails: 'FIELD_NEED_ROOF_SECTION_SPANNING_RAILS',
    SegmentNumberOfPanels: 'SEGMENT_NUMBER_OF_PANELS',
    SegmentBasePlateGroups: 'SEGMENT_BASE_PLATE_GROUPS',
    SegmentNumberOfSingleModules: 'SEGMENT_NUMBER_OF_SINGLE_MODULES',
    SegmentNumberOfSingleModuleSides: 'SEGMENT_NUMBER_OF_SINGLE_MODULE_SIDES',
    SegmentNumberOfLinesOfSideBySideSingleModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_SINGLE_MODULES',
    SegmentNumberOfDualModules: 'SEGMENT_NUMBER_OF_DUAL_MODULES',
    SegmentNumberOfDualModuleSides: 'SEGMENT_NUMBER_OF_DUAL_MODULE_SIDES',
    SegmentNumberOfLinesOfSideBySideDualModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_DUAL_MODULES',
    SegmentLength: 'SEGMENT_LENGTH',
    SegmentLengthWithoutRails: 'SEGMENT_LENGTH_WITHOUT_RAILS',
    SegmentTotalBallastWeight: 'SEGMENT_TOTAL_BALLAST_WEIGHT',
    SegmentTotalYield: 'SEGMENT_TOTAL_YIELD',
    SegmentSystemArea: 'SEGMENT_SYSTEM_AREA',
    SegmentEndSpacing: 'SEGMENT_END_SPACING',
    SegmentNumberOfSides: 'SEGMENT_NUMBER_OF_SIDES',
    SegmentNumberOfHighBallastedSides: 'SEGMENT_NUMBER_OF_HIGH_BALLASTED_SIDES',
    SegmentNumberOfPerimeteredSides: 'SEGMENT_NUMBER_OF_PERIMETERED_SIDES',
    SegmentNumberOfMiddleSides: 'SEGMENT_NUMBER_OF_MIDDLE_SIDES',
    SegmentNumberOfModulesWithContainerNearLowBase: 'SEGMENT_NUMBER_OF_MODULES_WITH_CONTAINER_NEAR_LOW_BASE',
    SegmentNumberOfMiddleModules: 'SEGMENT_NUMBER_OF_MIDDLE_MODULES',
    SegmentNumberOfLinesOfSideBySideModulesWithModulesNearLowBase: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_MODULES_WITH_MODULES_NEAR_LOW_BASE',
    SegmentNumberOfLinesOfSideBySideMiddleModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_MIDDLE_MODULES',
    SegmentNumberOfBallastedModules: 'SEGMENT_NUMBER_OF_BALLASTED_MODULES',
    SegmentNumberOfHighBallastedModules: 'SEGMENT_NUMBER_OF_HIGH_BALLASTED_MODULES',
    SegmentNumberOfLinesOfSideBySideHighBallastedModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_HIGH_BALLASTED_MODULES',
    SegmentNumberOfDoubleBallastedRegularSides: 'SEGMENT_NUMBER_OF_DOUBLE_BALLASTED_REGULAR_SIDES',
    SegmentNumberOfPanelsWithHighBaseAdjacentContainerUnderneath: 'SEGMENT_NUMBER_OF_PANELS_WITH_HIGH_BASE_ADJACENT_CONTAINER_UNDERNEATH',
    SegmentNumberOfLinesOfSideBySidePanelsWithHighBaseAdjacentContainerUnderneath: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_PANELS_WITH_HIGH_BASE_ADJACENT_CONTAINER_UNDERNEATH',
    SegmentNumberOfDoublePerimeteredModules: 'SEGMENT_NUMBER_OF_DOUBLE_PERIMETERED_MODULES',
    SegmentNumberOfLinesOfSideBySideDoublePerimeteredModules: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_DOUBLE_PERIMETERED_MODULES',
    SegmentNumberOfDoublePerimeteredSides: 'SEGMENT_NUMBER_OF_DOUBLE_PERIMETERED_SIDES',
    SegmentNumberOfBallastElements: 'SEGMENT_NUMBER_OF_BALLAST_ELEMENTS',
    SegmentNumberOfLinesOfSideBySidePanels: 'SEGMENT_NUMBER_OF_LINES_OF_SIDE_BY_SIDE_PANELS',
    SegmentNumberOfRowConnectors: 'SEGMENT_NUMBER_OF_ROW_CONNECTORS',
    SegmentLinesOfSucceedingModules: 'SEGMENT_LINES_OF_SUCCEEDING_MODULES',
    SegmentLinesOfSideBySideModules: 'SEGMENT_LINES_OF_SIDE_BY_SIDE_MODULES',
    SegmentRectangles: 'SEGMENT_RECTANGLES',
    SegmentMountingWeight: 'SEGMENT_MOUNTING_WEIGHT',
    SegmentTotalInstallationWeight: 'SEGMENT_TOTAL_INSTALLATION_WEIGHT',
    SegmentRailsNeedToBeExtended: 'SEGMENT_RAILS_NEED_TO_BE_EXTENDED',
    SegmentDistanceBetweenFirstAndLastAttachment: 'SEGMENT_DISTANCE_BETWEEN_FIRST_AND_LAST_ATTACHMENT',
    SegmentFirstAttachmentPosition: 'SEGMENT_FIRST_ATTACHMENT_POSITION',
    SegmentRequiredRailLength: 'SEGMENT_REQUIRED_RAIL_LENGTH',
    SegmentMaxNumberOfRows: 'SEGMENT_MAX_NUMBER_OF_ROWS',
    SegmentRoofZone: 'SEGMENT_ROOF_ZONE',
    SegmentAverageRoofLoadOverSystemArea: 'SEGMENT_AVERAGE_ROOF_LOAD_OVER_SYSTEM_AREA',
    SegmentAverageLoadPerModule: 'SEGMENT_AVERAGE_LOAD_PER_MODULE',
    SegmentPointLoad: 'SEGMENT_POINT_LOAD',
    SegmentMaximalStaticPointLoad: 'SEGMENT_MAXIMAL_STATIC_POINT_LOAD',
    SegmentAttachmentPositions: 'SEGMENT_ATTACHMENT_POSITIONS',
    SegmentAttachmentInterval: 'SEGMENT_ATTACHMENT_INTERVAL',
    SegmentFirstRailOffset: 'SEGMENT_FIRST_RAIL_OFFSET',
    SegmentRailSpacing: 'SEGMENT_RAIL_SPACING',
    SegmentRailSpacingBasedOnSectionDistance: 'SEGMENT_RAIL_SPACING_BASED_ON_SECTION_DISTANCE',
    SegmentFixationPlan: 'SEGMENT_FIXATION_PLAN',
    SegmentNumberOfPerimeterSidesWithRowConnectors: 'SEGMENT_NUMBER_OF_PERIMETER_SIDES_WITH_ROW_CONNECTORS',
    SegmentNeedRoofSectionSpanningRails: 'SEGMENT_NEED_ROOF_SECTION_SPANNING_RAILS',
    SegmentPolygon: 'SEGMENT_POLYGON',
    SegmentTypeRelativePosition: 'SEGMENT_TYPE_RELATIVE_POSITION',
    SegmentOriginPosition: 'SEGMENT_ORIGIN_POSITION',
    SegmentMaximumStaticWeightPerBasePlate: 'SEGMENT_MAXIMUM_STATIC_WEIGHT_PER_BASE_PLATE',
    SegmentDynamicWeightPerBasePlateInBasePlateGroup: 'SEGMENT_DYNAMIC_WEIGHT_PER_BASE_PLATE_IN_BASE_PLATE_GROUP',
    SegmentMaximumDynamicWeightPerBasePlate: 'SEGMENT_MAXIMUM_DYNAMIC_WEIGHT_PER_BASE_PLATE',
    SegmentStabilizerPosition: 'SEGMENT_STABILIZER_POSITION',
    SegmentsWithPerimeterBallasting: 'SEGMENTS_WITH_PERIMETER_BALLASTING',
    SegmentsWithSkipping: 'SEGMENTS_WITH_SKIPPING',
    SegmentsBallastWeightIncludingBallastArticleWeight: 'SEGMENTS_BALLAST_WEIGHT_INCLUDING_BALLAST_ARTICLE_WEIGHT',
    SegmentsWithMomentComparison: 'SEGMENTS_WITH_MOMENT_COMPARISON',
    SegmentArticles: 'SEGMENT_ARTICLES',
    ArticleWeight: 'ARTICLE_WEIGHT',
    ModuleHorizontalModuleSpace: 'MODULE_HORIZONTAL_MODULE_SPACE',
    ModuleVerticalModuleSpace: 'MODULE_VERTICAL_MODULE_SPACE',
    ModuleBreadth: 'MODULE_BREADTH',
    PanelWidth: 'PANEL_WIDTH',
    PanelLength: 'PANEL_LENGTH',
    PanelWeight: 'PANEL_WEIGHT',
    PanelSurfaceArea: 'PANEL_SURFACE_AREA',
    PanelIsLarge: 'PANEL_IS_LARGE',
    NumberOfRailLines: 'NUMBER_OF_RAIL_LINES',
    PanelThickness: 'PANEL_THICKNESS',
    PanelYield: 'PANEL_YIELD',
    PanelSystemArea: 'PANEL_SYSTEM_AREA',
    ModulesModuleWeight: 'MODULES_MODULE_WEIGHT',
    ModulesRowDistanceHalfModules: 'MODULES_ROW_DISTANCE_HALF_MODULES',
    WindpressureCorrectedPeakVelocityPressureOverReferencePeriod: 'WINDPRESSURE_CORRECTED_PEAK_VELOCITY_PRESSURE_OVER_REFERENCE_PERIOD',
    WindpressureHighBuildingSafetyFactor: 'WINDPRESSURE_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureManualHighBuildingSafetyFactor: 'WINDPRESSURE_MANUAL_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureAutomaticHighBuildingSafetyFactor: 'WINDPRESSURE_AUTOMATIC_HIGH_BUILDING_SAFETY_FACTOR',
    WindpressureAutomaticHighBuildingSafetyFactorOption: 'WINDPRESSURE_AUTOMATIC_HIGH_BUILDING_SAFETY_FACTOR_OPTION',
    WindpressureBuildingShapeRatio: 'WINDPRESSURE_BUILDING_SHAPE_RATIO',
    WindpressureWindzone: 'WINDPRESSURE_WINDZONE',
    WindpressureOrographyFactor: 'WINDPRESSURE_OROGRAPHY_FACTOR',
    WindpressureBasicWindVelocity: 'WINDPRESSURE_BASIC_WIND_VELOCITY',
    WindpressureFundamentalValueBasicWindVelocity: 'WINDPRESSURE_FUNDAMENTAL_VALUE_BASIC_WIND_VELOCITY',
    WindpressureNValue: 'WINDPRESSURE_N_VALUE',
    WindpressureKValue: 'WINDPRESSURE_K_VALUE',
    WindpressurePValue: 'WINDPRESSURE_P_VALUE',
    WindpressureProbabilityFactor: 'WINDPRESSURE_PROBABILITY_FACTOR',
    WindpressurePeakVelocityPressure: 'WINDPRESSURE_PEAK_VELOCITY_PRESSURE',
    WindpressurePeakVelocityPressureOverReferencePeriod: 'WINDPRESSURE_PEAK_VELOCITY_PRESSURE_OVER_REFERENCE_PERIOD',
    WindpressureStrongWinds: 'WINDPRESSURE_STRONG_WINDS',
    WindpressureWindloadCategory: 'WINDPRESSURE_WINDLOAD_CATEGORY',
    WindpressureWindloadFavourablePermanentLoad: 'WINDPRESSURE_WINDLOAD_FAVOURABLE_PERMANENT_LOAD',
    WindpressureWindloadUnfavourablePermanentLoad: 'WINDPRESSURE_WINDLOAD_UNFAVOURABLE_PERMANENT_LOAD',
    WindpressureWindloadReductionFactor: 'WINDPRESSURE_WINDLOAD_REDUCTION_FACTOR',
    WindpressureMeanWindVelocity: 'WINDPRESSURE_MEAN_WIND_VELOCITY',
    WindpressureInputBasicVelocityPressure: 'WINDPRESSURE_INPUT_BASIC_VELOCITY_PRESSURE',
    WindpressureBasicWindPressure: 'WINDPRESSURE_BASIC_WIND_PRESSURE',
    WindpressureTurbulenceIntensity: 'WINDPRESSURE_TURBULENCE_INTENSITY',
    WindpressureTurbulenceFactor: 'WINDPRESSURE_TURBULENCE_FACTOR',
    WindpressureMaximumBuildingHeight: 'WINDPRESSURE_MAXIMUM_BUILDING_HEIGHT',
    WindpressureSizeFactorExposureFactor: 'WINDPRESSURE_SIZE_FACTOR_EXPOSURE_FACTOR',
    StandardWindpressurePerModule: 'STANDARD_WINDPRESSURE_PER_MODULE',
    AppliedDistanceToCoast: 'APPLIED_DISTANCE_TO_COAST',
    AppliedSafetyFactorCc1: 'APPLIED_SAFETY_FACTOR_CC1',
    SidePlatesSafetyFactor: 'SIDE_PLATES_SAFETY_FACTOR',
    ReliabilityFactor: 'RELIABILITY_FACTOR',
    ReliabilityFactorPerConsequenceClass: 'RELIABILITY_FACTOR_PER_CONSEQUENCE_CLASS',
    VariableLoadFactor: 'VARIABLE_LOAD_FACTOR',
    VariableLoadFactorPerConsequenceClass: 'VARIABLE_LOAD_FACTOR_PER_CONSEQUENCE_CLASS',
    DisplacementHeight: 'DISPLACEMENT_HEIGHT',
    TownTerrainExposureFactor: 'TOWN_TERRAIN_EXPOSURE_FACTOR',
    AltitudeFactor: 'ALTITUDE_FACTOR',
    BallastArticleWeight: 'BALLAST_ARTICLE_WEIGHT',
    BallastUseBallast: 'BALLAST_USE_BALLAST',
    BallastPlan: 'BALLAST_PLAN',
    BallastPlanSegment: 'BALLAST_PLAN_SEGMENT',
    BallastGroupsForSegment: 'BALLAST_GROUPS_FOR_SEGMENT',
    BallastGroupsForLargestRectangles: 'BALLAST_GROUPS_FOR_LARGEST_RECTANGLES',
    BallastAssignedGroups: 'BALLAST_ASSIGNED_GROUPS',
    BallastCountrySafetyFactor: 'BALLAST_COUNTRY_SAFETY_FACTOR',
    BallastAppliedSafetyFactor: 'BALLAST_APPLIED_SAFETY_FACTOR',
    BallastCThetaSquared: 'BALLAST_C_THETA_SQUARED',
    BallastUseCTheta: 'BALLAST_USE_C_THETA',
    BallastAverageSurfaceArea: 'BALLAST_AVERAGE_SURFACE_AREA',
    BallastPeutzValueForLiftForce: 'BALLAST_PEUTZ_VALUE_FOR_LIFT_FORCE',
    BallastDirectionalFactorForLiftForce: 'BALLAST_DIRECTIONAL_FACTOR_FOR_LIFT_FORCE',
    BallastWindForcePerWindDirectionForLiftForce: 'BALLAST_WIND_FORCE_PER_WIND_DIRECTION_FOR_LIFT_FORCE',
    BallastMaxWindForcePerPeutzGroupForLiftForce: 'BALLAST_MAX_WIND_FORCE_PER_PEUTZ_GROUP_FOR_LIFT_FORCE',
    BallastRequiredGroupsWithPeutzDataForLiftForce: 'BALLAST_REQUIRED_GROUPS_WITH_PEUTZ_DATA_FOR_LIFT_FORCE',
    BallastTotalWindForceForAssignedGroupsForLiftForce: 'BALLAST_TOTAL_WIND_FORCE_FOR_ASSIGNED_GROUPS_FOR_LIFT_FORCE',
    BallastPeutzValueForCombinedForces: 'BALLAST_PEUTZ_VALUE_FOR_COMBINED_FORCES',
    BallastDirectionalFactorForCombinedForces: 'BALLAST_DIRECTIONAL_FACTOR_FOR_COMBINED_FORCES',
    BallastWindForcePerWindDirectionForCombinedForces: 'BALLAST_WIND_FORCE_PER_WIND_DIRECTION_FOR_COMBINED_FORCES',
    BallastMaxWindForcePerPeutzGroupForCombinedForced: 'BALLAST_MAX_WIND_FORCE_PER_PEUTZ_GROUP_FOR_COMBINED_FORCED',
    BallastRequiredGroupsWithPeutzDataForCombinedForces: 'BALLAST_REQUIRED_GROUPS_WITH_PEUTZ_DATA_FOR_COMBINED_FORCES',
    BallastTotalWindForceForAssignedGroupsForCombinedForces: 'BALLAST_TOTAL_WIND_FORCE_FOR_ASSIGNED_GROUPS_FOR_COMBINED_FORCES',
    BallastWindtunnelSafetyFactor: 'BALLAST_WINDTUNNEL_SAFETY_FACTOR',
    BallastNumberOfElementsUnderPanelInCouplerlessRail: 'BALLAST_NUMBER_OF_ELEMENTS_UNDER_PANEL_IN_COUPLERLESS_RAIL',
    BallastNumberOfElementsUnderPanelInRailWithCoupler: 'BALLAST_NUMBER_OF_ELEMENTS_UNDER_PANEL_IN_RAIL_WITH_COUPLER',
    BallastNumberOfRailsPerModule: 'BALLAST_NUMBER_OF_RAILS_PER_MODULE',
    BallastMaximumLiftForceOnPanel: 'BALLAST_MAXIMUM_LIFT_FORCE_ON_PANEL',
    BallastGroupsForLiftForce: 'BALLAST_GROUPS_FOR_LIFT_FORCE',
    BallastUpwardsLiftForceOnPanelPerBallastGroup: 'BALLAST_UPWARDS_LIFT_FORCE_ON_PANEL_PER_BALLAST_GROUP',
    BallastUpwardsLiftForcePerModuleInSingleSegments: 'BALLAST_UPWARDS_LIFT_FORCE_PER_MODULE_IN_SINGLE_SEGMENTS',
    BallastMaximumForcePerpendicularToPanelIn2RailConfiguration: 'BALLAST_MAXIMUM_FORCE_PERPENDICULAR_TO_PANEL_IN_2_RAIL_CONFIGURATION',
    BallastMaximumForcePerpendicularToPanelIn3RailConfiguration: 'BALLAST_MAXIMUM_FORCE_PERPENDICULAR_TO_PANEL_IN_3_RAIL_CONFIGURATION',
    BallastNumberOfBallastContainersInSegment: 'BALLAST_NUMBER_OF_BALLAST_CONTAINERS_IN_SEGMENT',
    BallastAdditionalBallastElementsPerBracket: 'BALLAST_ADDITIONAL_BALLAST_ELEMENTS_PER_BRACKET',
    BallastDetermineMaximumLiftCoefficientHalfPanel: 'BALLAST_DETERMINE_MAXIMUM_LIFT_COEFFICIENT_HALF_PANEL',
    BallastMaximumElementsUnderPanelForCouplerlessRailWithBrackets: 'BALLAST_MAXIMUM_ELEMENTS_UNDER_PANEL_FOR_COUPLERLESS_RAIL_WITH_BRACKETS',
    BallastElementCapacityPerRailUnitPerModule: 'BALLAST_ELEMENT_CAPACITY_PER_RAIL_UNIT_PER_MODULE',
    SegmentLinesOfSucceedingModulesWith3RdRail: 'SEGMENT_LINES_OF_SUCCEEDING_MODULES_WITH_3RD_RAIL',
    BallastTotalWeight: 'BALLAST_TOTAL_WEIGHT',
    TotalWeightLimitPerBallastGroup: 'TOTAL_WEIGHT_LIMIT_PER_BALLAST_GROUP',
    BallastWeightPerModuleInSegment: 'BALLAST_WEIGHT_PER_MODULE_IN_SEGMENT',
    BallastElementsWithoutTiltingMeasures: 'BALLAST_ELEMENTS_WITHOUT_TILTING_MEASURES',
    BallastElementsWithTiltingMeasures: 'BALLAST_ELEMENTS_WITH_TILTING_MEASURES',
    BallastMaxTotalWeightForHalfModules: 'BALLAST_MAX_TOTAL_WEIGHT_FOR_HALF_MODULES',
    BallastTotalWeightPositionsInRectangle: 'BALLAST_TOTAL_WEIGHT_POSITIONS_IN_RECTANGLE',
    BallastTotalWeightPerModuleInSegment: 'BALLAST_TOTAL_WEIGHT_PER_MODULE_IN_SEGMENT',
    BallastWeightAfterPerimeterTweak: 'BALLAST_WEIGHT_AFTER_PERIMETER_TWEAK',
    BallastWeightPerModuleInGrid: 'BALLAST_WEIGHT_PER_MODULE_IN_GRID',
    BallastCornerEdgezoneWidth: 'BALLAST_CORNER_EDGEZONE_WIDTH',
    BallastSubtractMountingSystemWeight: 'BALLAST_SUBTRACT_MOUNTING_SYSTEM_WEIGHT',
    BallastBlockedPerimeterPossible: 'BALLAST_BLOCKED_PERIMETER_POSSIBLE',
    BallastPerimeterTypes: 'BALLAST_PERIMETER_TYPES',
    BallastMaximumNumberOfBallastElementsInBottomLayer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_BOTTOM_LAYER',
    BallastMaximumNumberOfBallastElementsInTopLayer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_TOP_LAYER',
    BallastMaximumNumberOfBallastElementsInPrimaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_PRIMARY_BALLAST_CONTAINER',
    BallastMaximumNumberOfBallastElementsInSecondaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_SECONDARY_BALLAST_CONTAINER',
    BallastMaximumNumberOfBallastElementsInTertiaryBallastContainer: 'BALLAST_MAXIMUM_NUMBER_OF_BALLAST_ELEMENTS_IN_TERTIARY_BALLAST_CONTAINER',
    BallastDistributionPlanSegmentWithoutTiltingMeasures: 'BALLAST_DISTRIBUTION_PLAN_SEGMENT_WITHOUT_TILTING_MEASURES',
    BallastDistributionPlanSegmentWithTiltingMeasures: 'BALLAST_DISTRIBUTION_PLAN_SEGMENT_WITH_TILTING_MEASURES',
    BallastDistributionPlanField: 'BALLAST_DISTRIBUTION_PLAN_FIELD',
    BallastElementDistributionPerModuleWithoutTiltingMeasures: 'BALLAST_ELEMENT_DISTRIBUTION_PER_MODULE_WITHOUT_TILTING_MEASURES',
    BallastMaximumWeightInPrimaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_PRIMARY_BALLAST_CONTAINER',
    BallastMaximumWeightInSecondaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_SECONDARY_BALLAST_CONTAINER',
    BallastMaximumWeightInTertiaryBallastContainer: 'BALLAST_MAXIMUM_WEIGHT_IN_TERTIARY_BALLAST_CONTAINER',
    BallastContainerWeight: 'BALLAST_CONTAINER_WEIGHT',
    BallastTrayWeight: 'BALLAST_TRAY_WEIGHT',
    BallastExtenderWeight: 'BALLAST_EXTENDER_WEIGHT',
    BallastContainerWeightLimit: 'BALLAST_CONTAINER_WEIGHT_LIMIT',
    BallastRawWeight: 'BALLAST_RAW_WEIGHT',
    BallastSecondContainerPerimeterModuleThreshold: 'BALLAST_SECOND_CONTAINER_PERIMETER_MODULE_THRESHOLD',
    BallastSkippingWeightAfterSkipping: 'BALLAST_SKIPPING_WEIGHT_AFTER_SKIPPING',
    BallastSkippingTotalWeightInSkippingArea: 'BALLAST_SKIPPING_TOTAL_WEIGHT_IN_SKIPPING_AREA',
    BallastSkippingBallastGridWithSkipping: 'BALLAST_SKIPPING_BALLAST_GRID_WITH_SKIPPING',
    BallastSkippingBallastedPositionsInSkippingArea: 'BALLAST_SKIPPING_BALLASTED_POSITIONS_IN_SKIPPING_AREA',
    BallastSkippingBallastedPanelsWithBaseAlgorithmForSkipping: 'BALLAST_SKIPPING_BALLASTED_PANELS_WITH_BASE_ALGORITHM_FOR_SKIPPING',
    BallastSkippingSkippingAreas: 'BALLAST_SKIPPING_SKIPPING_AREAS',
    BallastSkippingSkippingAreaTypes: 'BALLAST_SKIPPING_SKIPPING_AREA_TYPES',
    BallastSkippingBallastMinimumNumberOfBallastedPositions: 'BALLAST_SKIPPING_BALLAST_MINIMUM_NUMBER_OF_BALLASTED_POSITIONS',
    BallastSkippingRequiredBallastedPositions: 'BALLAST_SKIPPING_REQUIRED_BALLASTED_POSITIONS',
    BallastSkippingSkippingFactor: 'BALLAST_SKIPPING_SKIPPING_FACTOR',
    BallastSkippingMaximumSkippingFactor: 'BALLAST_SKIPPING_MAXIMUM_SKIPPING_FACTOR',
    BallastSkippingOptimalSkippingFactor: 'BALLAST_SKIPPING_OPTIMAL_SKIPPING_FACTOR',
    BallastSkippingCanSkip: 'BALLAST_SKIPPING_CAN_SKIP',
    BallastSkippingMaximumBallastPreSkipping: 'BALLAST_SKIPPING_MAXIMUM_BALLAST_PRE_SKIPPING',
    BallastSkippingMaximumWeightPostSkipping: 'BALLAST_SKIPPING_MAXIMUM_WEIGHT_POST_SKIPPING',
    BallastSkippingMinimumBallastWeightPerPosition: 'BALLAST_SKIPPING_MINIMUM_BALLAST_WEIGHT_PER_POSITION',
    BallastSkippingMinimumSkippingFactor: 'BALLAST_SKIPPING_MINIMUM_SKIPPING_FACTOR',
    BallastSkippingMaximumNumberOfBallastedPositions: 'BALLAST_SKIPPING_MAXIMUM_NUMBER_OF_BALLASTED_POSITIONS',
    BallastSkippingSuperskipStage800AndLower: 'BALLAST_SKIPPING_SUPERSKIP_STAGE_800_AND_LOWER',
    BallastSkippingSuperskipStageAbove800: 'BALLAST_SKIPPING_SUPERSKIP_STAGE_ABOVE_800',
    BallastSkippingSuperskipStage: 'BALLAST_SKIPPING_SUPERSKIP_STAGE',
    BallastSkippingShiftCornerAdjacents: 'BALLAST_SKIPPING_SHIFT_CORNER_ADJACENTS',
    BallastSkippingStage2ExtraShiftingPeakVelocityPressureLimit: 'BALLAST_SKIPPING_STAGE_2_EXTRA_SHIFTING_PEAK_VELOCITY_PRESSURE_LIMIT',
    BallastSkippingModulePositionType: 'BALLAST_SKIPPING_MODULE_POSITION_TYPE',
    BallastSkippingShiftedBallastWeights: 'BALLAST_SKIPPING_SHIFTED_BALLAST_WEIGHTS',
    BallastRailWeight: 'BALLAST_RAIL_WEIGHT',
    BallastWeightFffArticleAmount: 'BALLAST_WEIGHT_FFF_ARTICLE_AMOUNT',
    BallastWeightFfWavePlusArticleAmount: 'BALLAST_WEIGHT_FF_WAVE_PLUS_ARTICLE_AMOUNT',
    BallastWeightApproximateWeightOfUnballastedSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfUnballastedSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfUnballastedCenterOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_CENTER_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfUnballastedCenterOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_UNBALLASTED_CENTER_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfExposedRightSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_RIGHT_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfExposedRightSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_RIGHT_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfExposedLeftSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_LEFT_SIDE_OF_SINGLE_MODULE',
    BallastWeightApproximateWeightOfExposedLeftSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_EXPOSED_LEFT_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfSharedSideOfDualModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_SHARED_SIDE_OF_DUAL_MODULE',
    BallastWeightApproximateWeightOfSharedSideOfSingleModule: 'BALLAST_WEIGHT_APPROXIMATE_WEIGHT_OF_SHARED_SIDE_OF_SINGLE_MODULE',
    BallastWeightOfRowConnectionCalculationRule: 'BALLAST_WEIGHT_OF_ROW_CONNECTION_CALCULATION_RULE',
    BallastWeightBallastMountingWeightGrid: 'BALLAST_WEIGHT_BALLAST_MOUNTING_WEIGHT_GRID',
    BallastWeightBallastMinimumWeightDoublePerimeterIsolatedUnit: 'BALLAST_WEIGHT_BALLAST_MINIMUM_WEIGHT_DOUBLE_PERIMETER_ISOLATED_UNIT',
    BaseBallastWeightCapacity: 'BASE_BALLAST_WEIGHT_CAPACITY',
    BallastWaveAdditionalRailsRequired: 'BALLAST_WAVE_ADDITIONAL_RAILS_REQUIRED',
    BallastWaveRailArticles: 'BALLAST_WAVE_RAIL_ARTICLES',
    BallastFffContainerArticles: 'BALLAST_FFF_CONTAINER_ARTICLES',
    BallastElementWeight: 'BALLAST_ELEMENT_WEIGHT',
    BallastMaximumWeightUnderPanelForCouplerlessRailWithBracket: 'BALLAST_MAXIMUM_WEIGHT_UNDER_PANEL_FOR_COUPLERLESS_RAIL_WITH_BRACKET',
    BallastFfWavePlusDualAdditionalRailBallastThreshold: 'BALLAST_FF_WAVE_PLUS_DUAL_ADDITIONAL_RAIL_BALLAST_THRESHOLD',
    BallastArticleWeightCapacityPerPosition: 'BALLAST_ARTICLE_WEIGHT_CAPACITY_PER_POSITION',
    BallastStandardGravitationalAcceleration: 'BALLAST_STANDARD_GRAVITATIONAL_ACCELERATION',
    BallastNorthTiltingPoint: 'BALLAST_NORTH_TILTING_POINT',
    BallastResultingMomentLiftForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_LIFT_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentLiftForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_LIFT_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentBaseMountingSystemForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BASE_MOUNTING_SYSTEM_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBaseMountingSystemForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BASE_MOUNTING_SYSTEM_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentPanelForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_PANEL_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentPanelForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_PANEL_FOR_SOUTH_TILTING_POINT',
    BallastResultingMomentBallastWithoutTiltingMeasuresForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITHOUT_TILTING_MEASURES_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBallastWithTiltingMeasuresForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITH_TILTING_MEASURES_FOR_NORTH_TILTING_POINT',
    BallastResultingMomentBallastWithTiltingMeasuresForSouthTiltingPoint: 'BALLAST_RESULTING_MOMENT_BALLAST_WITH_TILTING_MEASURES_FOR_SOUTH_TILTING_POINT',
    BallastDistanceMountingSystemCenterToNorthTiltingPoint: 'BALLAST_DISTANCE_MOUNTING_SYSTEM_CENTER_TO_NORTH_TILTING_POINT',
    BallastDistancePanelCenterToNorthTiltingPoint: 'BALLAST_DISTANCE_PANEL_CENTER_TO_NORTH_TILTING_POINT',
    BallastDistanceWavePlusBallastPositionToNorthTiltingPoint: 'BALLAST_DISTANCE_WAVE_PLUS_BALLAST_POSITION_TO_NORTH_TILTING_POINT',
    BallastDistanceFlatfixFusionBallastArticlePositionToNorthTiltingPoint: 'BALLAST_DISTANCE_FLATFIX_FUSION_BALLAST_ARTICLE_POSITION_TO_NORTH_TILTING_POINT',
    BallastTotalResultingMomentForNorthTiltingPointWithoutTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_WITHOUT_TILTING_MEASURES',
    BallastTotalResultingMomentForNorthTiltingPointWithTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_WITH_TILTING_MEASURES',
    BallastTotalResultingMomentForNorthTiltingPointBeforeBallast: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_NORTH_TILTING_POINT_BEFORE_BALLAST',
    BallastSouthTiltingPoint: 'BALLAST_SOUTH_TILTING_POINT',
    BallastDistanceMountingSystemCenterToSouthTiltingPoint: 'BALLAST_DISTANCE_MOUNTING_SYSTEM_CENTER_TO_SOUTH_TILTING_POINT',
    BallastDistancePanelCenterToSouthTiltingPoint: 'BALLAST_DISTANCE_PANEL_CENTER_TO_SOUTH_TILTING_POINT',
    BallastDistanceBallastPositionToSouthTiltingPoint: 'BALLAST_DISTANCE_BALLAST_POSITION_TO_SOUTH_TILTING_POINT',
    BallastTotalResultingMomentForSouthTiltingPointWithTiltingMeasures: 'BALLAST_TOTAL_RESULTING_MOMENT_FOR_SOUTH_TILTING_POINT_WITH_TILTING_MEASURES',
    BallastResultingMomentsForRoof: 'BALLAST_RESULTING_MOMENTS_FOR_ROOF',
    BallastResultingMomentAdditionalPerimeterBracketForNorthTiltingPoint: 'BALLAST_RESULTING_MOMENT_ADDITIONAL_PERIMETER_BRACKET_FOR_NORTH_TILTING_POINT',
    BallastAdditionalBallastDistributionPositionsRequiredAgainstTilting: 'BALLAST_ADDITIONAL_BALLAST_DISTRIBUTION_POSITIONS_REQUIRED_AGAINST_TILTING',
    BallastAdditionalDistanceToTiltingPoint: 'BALLAST_ADDITIONAL_DISTANCE_TO_TILTING_POINT',
    BallastElement: 'BALLAST_ELEMENT',
    BallastCustomBallastElementWeight: 'BALLAST_CUSTOM_BALLAST_ELEMENT_WEIGHT',
    BallastWaveBracketsBallastArticles: 'BALLAST_WAVE_BRACKETS_BALLAST_ARTICLES',
    BallastWaveMiddleBaseBallastArticles: 'BALLAST_WAVE_MIDDLE_BASE_BALLAST_ARTICLES',
    BallastWaveHighBaseBallastArticles: 'BALLAST_WAVE_HIGH_BASE_BALLAST_ARTICLES',
    BallastWaveLowBaseBallastArticles: 'BALLAST_WAVE_LOW_BASE_BALLAST_ARTICLES',
    BallastMinimumBallastWeightToPreventTilting: 'BALLAST_MINIMUM_BALLAST_WEIGHT_TO_PREVENT_TILTING',
    MarginPerBallastElement: 'MARGIN_PER_BALLAST_ELEMENT',
    WidthUprightBallastElement: 'WIDTH_UPRIGHT_BALLAST_ELEMENT',
    WidthBallastElementOnSide: 'WIDTH_BALLAST_ELEMENT_ON_SIDE',
    AdditionalCapacityTrayWithUprightElements: 'ADDITIONAL_CAPACITY_TRAY_WITH_UPRIGHT_ELEMENTS',
    AdditionalCapacityTrayWithElementsOnSide: 'ADDITIONAL_CAPACITY_TRAY_WITH_ELEMENTS_ON_SIDE',
    TrayOverspan: 'TRAY_OVERSPAN',
    CapacityExtenderWithUprightElements: 'CAPACITY_EXTENDER_WITH_UPRIGHT_ELEMENTS',
    CapacityExtenderWithElementsOnSide: 'CAPACITY_EXTENDER_WITH_ELEMENTS_ON_SIDE',
    ElementsInPerimeterBracket: 'ELEMENTS_IN_PERIMETER_BRACKET',
    AvailableBallastDistributionPositionsAndElementCapacity: 'AVAILABLE_BALLAST_DISTRIBUTION_POSITIONS_AND_ELEMENT_CAPACITY',
    LeastCostlyRailCombination: 'LEAST_COSTLY_RAIL_COMBINATION',
    ClickfitNumberOfRails: 'CLICKFIT_NUMBER_OF_RAILS',
    ClickfitModuleSpace: 'CLICKFIT_MODULE_SPACE',
    ClickfitRoofSectionsCovered: 'CLICKFIT_ROOF_SECTIONS_COVERED',
    ClickfitNumberOfAttachmentsPerRailLine: 'CLICKFIT_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    MaxDistanceBetweenAttachments: 'MAX_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitMinNumberOfRoofAttachments: 'CLICKFIT_MIN_NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitNumberOfAuxiliarySets: 'CLICKFIT_NUMBER_OF_AUXILIARY_SETS',
    ClickfitMaximumTilePressure: 'CLICKFIT_MAXIMUM_TILE_PRESSURE',
    ClickfitMinimumDistanceAttachmentToRailEnd: 'CLICKFIT_MINIMUM_DISTANCE_ATTACHMENT_TO_RAIL_END',
    ClickfitMaximumDistanceAttachmentToRailEnd: 'CLICKFIT_MAXIMUM_DISTANCE_ATTACHMENT_TO_RAIL_END',
    ClickfitMinimumRoofSectionsCovered: 'CLICKFIT_MINIMUM_ROOF_SECTIONS_COVERED',
    ClickfitTotalOverspanWithMinimumRoofSectionsCovered: 'CLICKFIT_TOTAL_OVERSPAN_WITH_MINIMUM_ROOF_SECTIONS_COVERED',
    ClickfitCoverAdditionalSection: 'CLICKFIT_COVER_ADDITIONAL_SECTION',
    ClickfitNumberOfSectionsBetweenAttachments: 'CLICKFIT_NUMBER_OF_SECTIONS_BETWEEN_ATTACHMENTS',
    ClickfitRailsInLineWithRoofSection: 'CLICKFIT_RAILS_IN_LINE_WITH_ROOF_SECTION',
    ClickfitRelativePanelSizeBetweenRails: 'CLICKFIT_RELATIVE_PANEL_SIZE_BETWEEN_RAILS',
    ClickfitGridCellSpace: 'CLICKFIT_GRID_CELL_SPACE',
    ClickfitEvoBom: 'CLICKFIT_EVO_BOM',
    ClickfitEvoBomSegment: 'CLICKFIT_EVO_BOM_SEGMENT',
    NumberOfRoofAttachments: 'NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitEvoCableClips: 'CLICKFIT_EVO_CABLE_CLIPS',
    ClickfitEvoMidClamps: 'CLICKFIT_EVO_MID_CLAMPS',
    ClickfitEvoEndClamps: 'CLICKFIT_EVO_END_CLAMPS',
    ClickfitEvoBitTorx: 'CLICKFIT_EVO_BIT_TORX',
    ClickfitEvoNumberOfCableClips: 'CLICKFIT_EVO_NUMBER_OF_CABLE_CLIPS',
    NumberOfProfileFasteners: 'NUMBER_OF_PROFILE_FASTENERS',
    ClickfitEvoExtraVerticalRailScrews: 'CLICKFIT_EVO_EXTRA_VERTICAL_RAIL_SCREWS',
    ClickfitEvoNumberOfPanelsPerOptimizer: 'CLICKFIT_EVO_NUMBER_OF_PANELS_PER_OPTIMIZER',
    ClickfitEvoNumberOfClamps: 'CLICKFIT_EVO_NUMBER_OF_CLAMPS',
    ClickfitEvoNumberOfMidClamps: 'CLICKFIT_EVO_NUMBER_OF_MID_CLAMPS',
    ClickfitEvoNumberOfEndClamps: 'CLICKFIT_EVO_NUMBER_OF_END_CLAMPS',
    ClickfitEvoEndClampSupports: 'CLICKFIT_EVO_END_CLAMP_SUPPORTS',
    ClickfitEvoEndCapWithoutClampSupport: 'CLICKFIT_EVO_END_CAP_WITHOUT_CLAMP_SUPPORT',
    ClickfitEvoAuxiliarySets: 'CLICKFIT_EVO_AUXILIARY_SETS',
    ClickfitEvoCouplers: 'CLICKFIT_EVO_COUPLERS',
    ClickfitEvoRails: 'CLICKFIT_EVO_RAILS',
    ClickfitEvoEndCaps: 'CLICKFIT_EVO_END_CAPS',
    ClickfitEvoPanelAndMountingCombinedWeight: 'CLICKFIT_EVO_PANEL_AND_MOUNTING_COMBINED_WEIGHT',
    ClickfitEvoAverageMountingSystemWeight: 'CLICKFIT_EVO_AVERAGE_MOUNTING_SYSTEM_WEIGHT',
    ClickfitEvoLockingScrews: 'CLICKFIT_EVO_LOCKING_SCREWS',
    ClickfitEvoVerticalLockingScrewsQuantity: 'CLICKFIT_EVO_VERTICAL_LOCKING_SCREWS_QUANTITY',
    ClickfitEvoClipType: 'CLICKFIT_EVO_CLIP_TYPE',
    ClickfitEvoClampType: 'CLICKFIT_EVO_CLAMP_TYPE',
    ClickfitEvoIsClipUsed: 'CLICKFIT_EVO_IS_CLIP_USED',
    ClickfitEvoCorrugatedMountingBrackets: 'CLICKFIT_EVO_CORRUGATED_MOUNTING_BRACKETS',
    ClickfitEvoCorrugatedSteelAdapters: 'CLICKFIT_EVO_CORRUGATED_STEEL_ADAPTERS',
    ClickfitEvoTilesHookSpacers: 'CLICKFIT_EVO_TILES_HOOK_SPACERS',
    ClickfitEvoTilesHooks: 'CLICKFIT_EVO_TILES_HOOKS',
    ClickfitEvoSlateHooks: 'CLICKFIT_EVO_SLATE_HOOKS',
    ClickfitEvoSteelSheetScrews: 'CLICKFIT_EVO_STEEL_SHEET_SCREWS',
    ClickfitEvoMountingProfiles: 'CLICKFIT_EVO_MOUNTING_PROFILES',
    ClickfitEvoSteelAttachmentType: 'CLICKFIT_EVO_STEEL_ATTACHMENT_TYPE',
    RoofAttachmentLiftLimit: 'ROOF_ATTACHMENT_LIFT_LIMIT',
    RoofAttachmentPressureLimit: 'ROOF_ATTACHMENT_PRESSURE_LIMIT',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLineForPressure: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE_FOR_PRESSURE',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLineForLift: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE_FOR_LIFT',
    ClickfitEvoIdealNumberOfAttachmentsPerRailLine: 'CLICKFIT_EVO_IDEAL_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    ClickfitEvoIdealDistanceBetweenAttachments: 'CLICKFIT_EVO_IDEAL_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitEvoMinimumDistanceBetweenAttachments: 'CLICKFIT_EVO_MINIMUM_DISTANCE_BETWEEN_ATTACHMENTS',
    ClickfitEvoMaxNumberOfAttachmentsPerRailLine: 'CLICKFIT_EVO_MAX_NUMBER_OF_ATTACHMENTS_PER_RAIL_LINE',
    ClickfitEvoLiftForceOnModuleClamp: 'CLICKFIT_EVO_LIFT_FORCE_ON_MODULE_CLAMP',
    ClickfitEvoPressureForceOnModuleClamp: 'CLICKFIT_EVO_PRESSURE_FORCE_ON_MODULE_CLAMP',
    MaximumAllowableBendingMomentForLift: 'MAXIMUM_ALLOWABLE_BENDING_MOMENT_FOR_LIFT',
    MaximumAllowableBendingMomentForPressure: 'MAXIMUM_ALLOWABLE_BENDING_MOMENT_FOR_PRESSURE',
    AllowableForceFractionFastenerForMountingProfile: 'ALLOWABLE_FORCE_FRACTION_FASTENER_FOR_MOUNTING_PROFILE',
    ClickfitEvoMaximumRailSpan: 'CLICKFIT_EVO_MAXIMUM_RAIL_SPAN',
    ClickfitEvoSeamClamps: 'CLICKFIT_EVO_SEAM_CLAMPS',
    UseForcesOnPanelForAttachments: 'USE_FORCES_ON_PANEL_FOR_ATTACHMENTS',
    ClickfitEvoHangerBoltArticle: 'CLICKFIT_EVO_HANGER_BOLT_ARTICLE',
    ClickfitEvoRafterScrewArticleSetArticle: 'CLICKFIT_EVO_RAFTER_SCREW_ARTICLE_SET_ARTICLE',
    ClickfitEvoHangerBolts: 'CLICKFIT_EVO_HANGER_BOLTS',
    ClickfitEvoWashers: 'CLICKFIT_EVO_WASHERS',
    ClickfitEvoTixophalteKits: 'CLICKFIT_EVO_TIXOPHALTE_KITS',
    ClickfitEvoEpdmKits: 'CLICKFIT_EVO_EPDM_KITS',
    ClickfitEvoRivets: 'CLICKFIT_EVO_RIVETS',
    ClickfitEvoProHookRafterScrews: 'CLICKFIT_EVO_PRO_HOOK_RAFTER_SCREWS',
    ClickfitEvoMountingProfilesArticleSetArticle: 'CLICKFIT_EVO_MOUNTING_PROFILES_ARTICLE_SET_ARTICLE',
    IdealNumberOfMountingProfilesPerSideForPressure: 'IDEAL_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE_FOR_PRESSURE',
    MinimumNumberOfMountingProfilesPerSide: 'MINIMUM_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    MaximumNumberOfMountingProfilesPerSide: 'MAXIMUM_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    NumberOfMountingProfilesPerSide: 'NUMBER_OF_MOUNTING_PROFILES_PER_SIDE',
    ProfileFastenerLiftLimit: 'PROFILE_FASTENER_LIFT_LIMIT',
    WorstForceFractionPerNumberOfFastenersPerProfile: 'WORST_FORCE_FRACTION_PER_NUMBER_OF_FASTENERS_PER_PROFILE',
    IdealNumberOfMountingProfilesPerSideForLift: 'IDEAL_NUMBER_OF_MOUNTING_PROFILES_PER_SIDE_FOR_LIFT',
    MaxDownwardsForceOnMountingProfilePerSegment: 'MAX_DOWNWARDS_FORCE_ON_MOUNTING_PROFILE_PER_SEGMENT',
    MaxUpwardsForceOnMountingProfilePerSegment: 'MAX_UPWARDS_FORCE_ON_MOUNTING_PROFILE_PER_SEGMENT',
    MaxUpwardsForceOnProfileFastenerPerSegment: 'MAX_UPWARDS_FORCE_ON_PROFILE_FASTENER_PER_SEGMENT',
    MaxUpwardsForceOnFastenerForRoof: 'MAX_UPWARDS_FORCE_ON_FASTENER_FOR_ROOF',
    ClickfitBasicBom: 'CLICKFIT_BASIC_BOM',
    ClickfitBasicBomSegment: 'CLICKFIT_BASIC_BOM_SEGMENT',
    ClickfitBasicEndClampsSegment: 'CLICKFIT_BASIC_END_CLAMPS_SEGMENT',
    ClickfitBasicMountingScrewPanelSegment: 'CLICKFIT_BASIC_MOUNTING_SCREW_PANEL_SEGMENT',
    ClickfitBasicModuleClampSegment: 'CLICKFIT_BASIC_MODULE_CLAMP_SEGMENT',
    ClickfitBasicSupportsSegment: 'CLICKFIT_BASIC_SUPPORTS_SEGMENT',
    ClickfitBasicMountingRailSegment: 'CLICKFIT_BASIC_MOUNTING_RAIL_SEGMENT',
    ClickfitBasicCouplingStripSegment: 'CLICKFIT_BASIC_COUPLING_STRIP_SEGMENT',
    ClickfitBasicCouplingScrewSegment: 'CLICKFIT_BASIC_COUPLING_SCREW_SEGMENT',
    ClickfitBasicNumberOfRoofAttachments: 'CLICKFIT_BASIC_NUMBER_OF_ROOF_ATTACHMENTS',
    ClickfitBasicAuxiliarySet: 'CLICKFIT_BASIC_AUXILIARY_SET',
    ClickfitBasicSteelSupportScrew: 'CLICKFIT_BASIC_STEEL_SUPPORT_SCREW',
    ClickfitBasicSteelEpdmTapes: 'CLICKFIT_BASIC_STEEL_EPDM_TAPES',
    ClickfitBasicTiledRoofHook: 'CLICKFIT_BASIC_TILED_ROOF_HOOK',
    ClickfitBasicTiledRoofHookNut: 'CLICKFIT_BASIC_TILED_ROOF_HOOK_NUT',
    ClickfitBasicTiledRoofHookBolt: 'CLICKFIT_BASIC_TILED_ROOF_HOOK_BOLT',
    ClickfitBasicBitumenSupportScrew: 'CLICKFIT_BASIC_BITUMEN_SUPPORT_SCREW',
    ClickfitBasicBitumenSupportScrewType: 'CLICKFIT_BASIC_BITUMEN_SUPPORT_SCREW_TYPE',
    ClickfitBasicBitumenTixophalteKits: 'CLICKFIT_BASIC_BITUMEN_TIXOPHALTE_KITS',
    ClickfitBasicBlackEndCap: 'CLICKFIT_BASIC_BLACK_END_CAP',
    ClickfitBasicBlackColorCaps: 'CLICKFIT_BASIC_BLACK_COLOR_CAPS',
    FlatfixEndClamp: 'FLATFIX_END_CLAMP',
    FlatfixBaseProfileRow: 'FLATFIX_BASE_PROFILE_ROW',
    FlatfixSelfTappingScrews: 'FLATFIX_SELF_TAPPING_SCREWS',
    FlatfixLeftWindDeflector: 'FLATFIX_LEFT_WIND_DEFLECTOR',
    FlatfixRightWindDeflector: 'FLATFIX_RIGHT_WIND_DEFLECTOR',
    FlatfixFusionRearWindDeflector: 'FLATFIX_FUSION_REAR_WIND_DEFLECTOR',
    FlatfixRearWindDeflectorOffset: 'FLATFIX_REAR_WIND_DEFLECTOR_OFFSET',
    FlatfixCableClip: 'FLATFIX_CABLE_CLIP',
    FlatfixCableExitGuide: 'FLATFIX_CABLE_EXIT_GUIDE',
    FlatfixCableExitGuideSide: 'FLATFIX_CABLE_EXIT_GUIDE_SIDE',
    FlatfixMidClamp: 'FLATFIX_MID_CLAMP',
    FlatfixBaseProfile: 'FLATFIX_BASE_PROFILE',
    FlatfixBasePlate: 'FLATFIX_BASE_PLATE',
    FlatfixBasePlateBracket: 'FLATFIX_BASE_PLATE_BRACKET',
    FlatfixHighBase: 'FLATFIX_HIGH_BASE',
    FlatfixHighBaseMountingScrews: 'FLATFIX_HIGH_BASE_MOUNTING_SCREWS',
    FlatfixLowBase: 'FLATFIX_LOW_BASE',
    FlatfixLowBaseExtension: 'FLATFIX_LOW_BASE_EXTENSION',
    FlatfixStabilizerScrew: 'FLATFIX_STABILIZER_SCREW',
    FlatfixBallastContainer: 'FLATFIX_BALLAST_CONTAINER',
    FlatfixStabilizer: 'FLATFIX_STABILIZER',
    FlatfixBallastContainerArticle: 'FLATFIX_BALLAST_CONTAINER_ARTICLE',
    FlatfixLandscapeExtensionNeeded: 'FLATFIX_LANDSCAPE_EXTENSION_NEEDED',
    FlatfixBaseplateSurface: 'FLATFIX_BASEPLATE_SURFACE',
    FlatfixNumberOfBasePlates: 'FLATFIX_NUMBER_OF_BASE_PLATES',
    FlatfixTpoMats: 'FLATFIX_TPO_MATS',
    FlatfixGridCellSpace: 'FLATFIX_GRID_CELL_SPACE',
    FlatfixRearWindDeflectorDimension: 'FLATFIX_REAR_WIND_DEFLECTOR_DIMENSION',
    FlatfixHalfModulesOffset: 'FLATFIX_HALF_MODULES_OFFSET',
    FlatfixBlackScrewCaps: 'FLATFIX_BLACK_SCREW_CAPS',
    FlatfixFusionBom: 'FLATFIX_FUSION_BOM',
    FlatfixFusionBomSegment: 'FLATFIX_FUSION_BOM_SEGMENT',
    FlatfixFusionLowerMountingScrewRearWindDeflector: 'FLATFIX_FUSION_LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    FlatfixFusionUpperMountingScrewRearWindDeflector: 'FLATFIX_FUSION_UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR',
    FlatfixFusionGroundingPlan: 'FLATFIX_FUSION_GROUNDING_PLAN',
    FlatfixFusionGroundingClip: 'FLATFIX_FUSION_GROUNDING_CLIP',
    FlatfixFusionGroundingBracket: 'FLATFIX_FUSION_GROUNDING_BRACKET',
    FlatfixFusionScrewGroundingBracket: 'FLATFIX_FUSION_SCREW_GROUNDING_BRACKET',
    FlatfixFusionGroundingScrewSideDeflector: 'FLATFIX_FUSION_GROUNDING_SCREW_SIDE_DEFLECTOR',
    FlatfixFusionGroundingSpring: 'FLATFIX_FUSION_GROUNDING_SPRING',
    FlatfixModuleDepth: 'FLATFIX_MODULE_DEPTH',
    FlatfixModuleSpace: 'FLATFIX_MODULE_SPACE',
    FlatfixFusionReferenceRowConnectorLength: 'FLATFIX_FUSION_REFERENCE_ROW_CONNECTOR_LENGTH',
    FlatfixFusionRowDistanceFactor: 'FLATFIX_FUSION_ROW_DISTANCE_FACTOR',
    FlatfixFusionDownwardForcePerPanelLimit: 'FLATFIX_FUSION_DOWNWARD_FORCE_PER_PANEL_LIMIT',
    FlatfixFusionDownwardForcePerPanelLimitExceeded: 'FLATFIX_FUSION_DOWNWARD_FORCE_PER_PANEL_LIMIT_EXCEEDED',
    FlatfixFusionSideWindDeflectorMountingScrew: 'FLATFIX_FUSION_SIDE_WIND_DEFLECTOR_MOUNTING_SCREW',
    FlatfixFusionMountingScrewLowerClamp: 'FLATFIX_FUSION_MOUNTING_SCREW_LOWER_CLAMP',
    FlatfixFusionSideDeflectors: 'FLATFIX_FUSION_SIDE_DEFLECTORS',
    FlatfixFusionMountingScrewLowerClampArticleSetArticle: 'FLATFIX_FUSION_MOUNTING_SCREW_LOWER_CLAMP_ARTICLE_SET_ARTICLE',
    FlatfixFusionLowBaseArticleSetArticle: 'FLATFIX_FUSION_LOW_BASE_ARTICLE_SET_ARTICLE',
    FlatfixFusionHighBaseArticleSetArticle: 'FLATFIX_FUSION_HIGH_BASE_ARTICLE_SET_ARTICLE',
    FlatfixFusionBaseProfilePanelArticleSetArticle: 'FLATFIX_FUSION_BASE_PROFILE_PANEL_ARTICLE_SET_ARTICLE',
    FlatfixFusionLeftWindDeflectorArticle: 'FLATFIX_FUSION_LEFT_WIND_DEFLECTOR_ARTICLE',
    FlatfixFusionRightWindDeflectorArticle: 'FLATFIX_FUSION_RIGHT_WIND_DEFLECTOR_ARTICLE',
    FlatfixFusionRearWindDeflectorArticle: 'FLATFIX_FUSION_REAR_WIND_DEFLECTOR_ARTICLE',
    FlatfixWaveNumberBallastBrackets: 'FLATFIX_WAVE_NUMBER_BALLAST_BRACKETS',
    FlatfixWeightPerBasePlateGroup: 'FLATFIX_WEIGHT_PER_BASE_PLATE_GROUP',
    FlatfixWaveRowDistance: 'FLATFIX_WAVE_ROW_DISTANCE',
    FlatfixWaveRailUnitProtrusionLength: 'FLATFIX_WAVE_RAIL_UNIT_PROTRUSION_LENGTH',
    FlatfixWavePlusBallastDistributionTypes: 'FLATFIX_WAVE_PLUS_BALLAST_DISTRIBUTION_TYPES',
    FlatfixWavePlusBom: 'FLATFIX_WAVE_PLUS_BOM',
    FlatfixWavePlusBomSegment: 'FLATFIX_WAVE_PLUS_BOM_SEGMENT',
    FlatfixWavePlusSideWindDeflectorNumberOfSets: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_NUMBER_OF_SETS',
    FlatfixWavePlusStabilizerGap: 'FLATFIX_WAVE_PLUS_STABILIZER_GAP',
    FlatfixWavePlusBracketsForStabilizerGap: 'FLATFIX_WAVE_PLUS_BRACKETS_FOR_STABILIZER_GAP',
    FlatfixWavePlusCableBrackets: 'FLATFIX_WAVE_PLUS_CABLE_BRACKETS',
    FlatfixWavePlusBallastBrackets: 'FLATFIX_WAVE_PLUS_BALLAST_BRACKETS',
    FlatfixWavePlusStabilizer: 'FLATFIX_WAVE_PLUS_STABILIZER',
    FlatfixWavePlusStabilizerArticle: 'FLATFIX_WAVE_PLUS_STABILIZER_ARTICLE',
    FlatfixWavePlusStabilizerLength: 'FLATFIX_WAVE_PLUS_STABILIZER_LENGTH',
    FlatfixWavePlusStabilizerOverspan: 'FLATFIX_WAVE_PLUS_STABILIZER_OVERSPAN',
    FlatfixWavePlusMinimumStabilizerOverspan: 'FLATFIX_WAVE_PLUS_MINIMUM_STABILIZER_OVERSPAN',
    FlatfixWavePlusBasePlate: 'FLATFIX_WAVE_PLUS_BASE_PLATE',
    FlatfixWavePlusRailUnit1P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_1P',
    FlatfixWavePlusRailUnit2P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_2P',
    FlatfixWavePlusOldRailUnit2P: 'FLATFIX_WAVE_PLUS_OLD_RAIL_UNIT_2P',
    FlatfixWavePlusRailUnit3P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_3P',
    FlatfixWavePlusRailUnit4P: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_4P',
    FlatfixWavePlusDualRailUnitChoice: 'FLATFIX_WAVE_PLUS_DUAL_RAIL_UNIT_CHOICE',
    FlatfixWavePlusRailStartUnit4P: 'FLATFIX_WAVE_PLUS_RAIL_START_UNIT_4P',
    FlatfixWavePlusRailWidth: 'FLATFIX_WAVE_PLUS_RAIL_WIDTH',
    FlatfixWavePlusWidePanelSolutionNeeded: 'FLATFIX_WAVE_PLUS_WIDE_PANEL_SOLUTION_NEEDED',
    FlatfixWavePlusMeasuringBar: 'FLATFIX_WAVE_PLUS_MEASURING_BAR',
    FlatfixWavePlusModuleSpacer: 'FLATFIX_WAVE_PLUS_MODULE_SPACER',
    FlatfixWavePlusModuleUnlockTool: 'FLATFIX_WAVE_PLUS_MODULE_UNLOCK_TOOL',
    FlatfixWavePlusMinimumRailsUnderModule: 'FLATFIX_WAVE_PLUS_MINIMUM_RAILS_UNDER_MODULE',
    FlatfixWavePlusMaxLiftForceOnPanelIn2RailConfig: 'FLATFIX_WAVE_PLUS_MAX_LIFT_FORCE_ON_PANEL_IN_2_RAIL_CONFIG',
    FlatfixWavePlusMaxLiftForceOnPanelIn3RailConfig: 'FLATFIX_WAVE_PLUS_MAX_LIFT_FORCE_ON_PANEL_IN_3_RAIL_CONFIG',
    FlatfixWavePlusSidePlatesPlacement: 'FLATFIX_WAVE_PLUS_SIDE_PLATES_PLACEMENT',
    FlatfixWavePlusRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusOptimalRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_OPTIMAL_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusRearWindDeflectorLength: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_LENGTH',
    FlatfixWavePlusOptimalRearWindDeflectorLength: 'FLATFIX_WAVE_PLUS_OPTIMAL_REAR_WIND_DEFLECTOR_LENGTH',
    FlatfixWavePlusMarginRearWindDeflectorGap: 'FLATFIX_WAVE_PLUS_MARGIN_REAR_WIND_DEFLECTOR_GAP',
    FlatfixWavePlusRearWindDeflectorArticleSetArticle: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_ARTICLE_SET_ARTICLE',
    FlatfixWavePlusRearWindDeflector: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR',
    FlatfixWavePlusRearWindDeflectorClip: 'FLATFIX_WAVE_PLUS_REAR_WIND_DEFLECTOR_CLIP',
    FlatfixWavePlusPerimeterBracket: 'FLATFIX_WAVE_PLUS_PERIMETER_BRACKET',
    FlatfixWavePlusTray: 'FLATFIX_WAVE_PLUS_TRAY',
    FlatfixWavePlusExtender: 'FLATFIX_WAVE_PLUS_EXTENDER',
    FlatfixWavePlusMinOverspanRearWindDeflector: 'FLATFIX_WAVE_PLUS_MIN_OVERSPAN_REAR_WIND_DEFLECTOR',
    FlatfixWavePlusRailUnitPlacementRegularRails: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_PLACEMENT_REGULAR_RAILS',
    FlatfixWavePlusRailUnitPlacement3RdRails: 'FLATFIX_WAVE_PLUS_RAIL_UNIT_PLACEMENT_3RD_RAILS',
    FlatfixPlusWeightCapacityPerBallastArticleTypePosition: 'FLATFIX_PLUS_WEIGHT_CAPACITY_PER_BALLAST_ARTICLE_TYPE_POSITION',
    FlatfixWavePlusMaximumDistanceBetweenRailsForTrays: 'FLATFIX_WAVE_PLUS_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_TRAYS',
    FlatfixWavePlusTraysPossible: 'FLATFIX_WAVE_PLUS_TRAYS_POSSIBLE',
    FlatfixWavePlusAdditionalRailUnitForBallastAllowed: 'FLATFIX_WAVE_PLUS_ADDITIONAL_RAIL_UNIT_FOR_BALLAST_ALLOWED',
    FlatfixWavePlusMinimumDistanceBetweenRailsForExtender: 'FLATFIX_WAVE_PLUS_MINIMUM_DISTANCE_BETWEEN_RAILS_FOR_EXTENDER',
    FlatfixWavePlusMaximumDistanceBetweenRailsForExtender: 'FLATFIX_WAVE_PLUS_MAXIMUM_DISTANCE_BETWEEN_RAILS_FOR_EXTENDER',
    FlatfixWavePlusExtendersPossible: 'FLATFIX_WAVE_PLUS_EXTENDERS_POSSIBLE',
    FlatfixWavePlusTrayArticle: 'FLATFIX_WAVE_PLUS_TRAY_ARTICLE',
    FlatfixWavePlusExtenderArticle: 'FLATFIX_WAVE_PLUS_EXTENDER_ARTICLE',
    FlatfixWavePlusRegularRailUnitOffset: 'FLATFIX_WAVE_PLUS_REGULAR_RAIL_UNIT_OFFSET',
    FlatfixWavePlusBasePlateOffsets: 'FLATFIX_WAVE_PLUS_BASE_PLATE_OFFSETS',
    FlatfixWavePlusReducedInsideRailCapacityWithTray: 'FLATFIX_WAVE_PLUS_REDUCED_INSIDE_RAIL_CAPACITY_WITH_TRAY',
    FlatfixWavePlusSideWindDeflectorSetArticleSetArticle: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET_ARTICLE_SET_ARTICLE',
    FlatfixWavePlusSideWindDeflectorSet: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET',
    FlatfixWavePlusSideWindDeflectorClamp: 'FLATFIX_WAVE_PLUS_SIDE_WIND_DEFLECTOR_CLAMP',
    WaveBasePlatesPerRailUnit: 'WAVE_BASE_PLATES_PER_RAIL_UNIT',
    WaveMat: 'WAVE_MAT',
    WaveTotalWeightLimit: 'WAVE_TOTAL_WEIGHT_LIMIT',
    DesignValueExceptionalSnowLoadOnGround: 'DESIGN_VALUE_EXCEPTIONAL_SNOW_LOAD_ON_GROUND',
    ExceptionalSnowLoadCoefficient: 'EXCEPTIONAL_SNOW_LOAD_COEFFICIENT',
    ExceptionalSnowLoadOnRoof: 'EXCEPTIONAL_SNOW_LOAD_ON_ROOF',
    ProductCanBeCalculatedWithSnow: 'PRODUCT_CAN_BE_CALCULATED_WITH_SNOW',
    RegularSnowLoadOnTheRoof: 'REGULAR_SNOW_LOAD_ON_THE_ROOF',
    SnowLoadApplySnowLoad: 'SNOW_LOAD_APPLY_SNOW_LOAD',
    SnowLoadCharacteristicGroundLoad: 'SNOW_LOAD_CHARACTERISTIC_GROUND_LOAD',
    SnowLoadEffectiveFormCoefficient: 'SNOW_LOAD_EFFECTIVE_FORM_COEFFICIENT',
    ExceptionalSnowLoadEffectiveFormCoefficient: 'EXCEPTIONAL_SNOW_LOAD_EFFECTIVE_FORM_COEFFICIENT',
    SnowLoadExposureFactor: 'SNOW_LOAD_EXPOSURE_FACTOR',
    SnowLoadFormCoefficientOne: 'SNOW_LOAD_FORM_COEFFICIENT_ONE',
    SnowLoadFormCoefficientTwo: 'SNOW_LOAD_FORM_COEFFICIENT_TWO',
    SnowLoadFormCoefficientFive: 'SNOW_LOAD_FORM_COEFFICIENT_FIVE',
    ExceptionalSnowLoadFormCoefficientFive: 'EXCEPTIONAL_SNOW_LOAD_FORM_COEFFICIENT_FIVE',
    SnowLoadGroundLoadOverReferencePeriod: 'SNOW_LOAD_GROUND_LOAD_OVER_REFERENCE_PERIOD',
    RegularSnowLoadPerpendicularDownForceOnPanel: 'REGULAR_SNOW_LOAD_PERPENDICULAR_DOWN_FORCE_ON_PANEL',
    SnowLoadProbabilityFactor: 'SNOW_LOAD_PROBABILITY_FACTOR',
    SnowLoadVariationCoefficientAnnualMaximum: 'SNOW_LOAD_VARIATION_COEFFICIENT_ANNUAL_MAXIMUM',
    SnowLoadThermalCoefficient: 'SNOW_LOAD_THERMAL_COEFFICIENT',
    SnowLoadSnowWeightDensity: 'SNOW_LOAD_SNOW_WEIGHT_DENSITY',
    SnowLoadOnGround: 'SNOW_LOAD_ON_GROUND',
    SnowLoadOnGroundLimit: 'SNOW_LOAD_ON_GROUND_LIMIT',
    SnowLoadOnGroundSpain: 'SNOW_LOAD_ON_GROUND_SPAIN',
    SnowLoadFreezeThawFactorSpain: 'SNOW_LOAD_FREEZE_THAW_FACTOR_SPAIN',
    InExceptionalSnowLoadArea: 'IN_EXCEPTIONAL_SNOW_LOAD_AREA',
    CalculateExceptionalSnowLoads: 'CALCULATE_EXCEPTIONAL_SNOW_LOADS',
    ExceptionalSnowLoadOnPanel: 'EXCEPTIONAL_SNOW_LOAD_ON_PANEL',
    FactoredExceptionalSnowPressureOnPanel: 'FACTORED_EXCEPTIONAL_SNOW_PRESSURE_ON_PANEL',
    FactoredExceptionalSnowPressurePerModule: 'FACTORED_EXCEPTIONAL_SNOW_PRESSURE_PER_MODULE',
    CombinationFactorWindInAccidentalDesignSituations: 'COMBINATION_FACTOR_WIND_IN_ACCIDENTAL_DESIGN_SITUATIONS',
    ExceptionalSnowLoadCombination: 'EXCEPTIONAL_SNOW_LOAD_COMBINATION',
    WorstCaseFactoredSnowPressureOnPanel: 'WORST_CASE_FACTORED_SNOW_PRESSURE_ON_PANEL',
    WorstCaseSnowLoadOnGround: 'WORST_CASE_SNOW_LOAD_ON_GROUND',
    AlternativeLoadEquations: 'ALTERNATIVE_LOAD_EQUATIONS',
    AveragePressureOnModule: 'AVERAGE_PRESSURE_ON_MODULE',
    AverageWindloadLift: 'AVERAGE_WINDLOAD_LIFT',
    AveragePressurePerAttachmentForSegment: 'AVERAGE_PRESSURE_PER_ATTACHMENT_FOR_SEGMENT',
    AverageLiftPerAttachmentForSegment: 'AVERAGE_LIFT_PER_ATTACHMENT_FOR_SEGMENT',
    StandardWindloadPressureCoefficientPlus: 'STANDARD_WINDLOAD_PRESSURE_COEFFICIENT_PLUS',
    WindloadPressureCoefficientMinus: 'WINDLOAD_PRESSURE_COEFFICIENT_MINUS',
    StandardWindloadPerpendicularWindDownForceOnPanel: 'STANDARD_WINDLOAD_PERPENDICULAR_WIND_DOWN_FORCE_ON_PANEL',
    WindloadPerpendicularWindLiftForceOnPanel: 'WINDLOAD_PERPENDICULAR_WIND_LIFT_FORCE_ON_PANEL',
    WindloadMaxLoadOnPanel: 'WINDLOAD_MAX_LOAD_ON_PANEL',
    PrimaryWindPressureCombination: 'PRIMARY_WIND_PRESSURE_COMBINATION',
    PrimaryWindLiftCombination: 'PRIMARY_WIND_LIFT_COMBINATION',
    WindtunnelPressureCoefficientPlus: 'WINDTUNNEL_PRESSURE_COEFFICIENT_PLUS',
    WindtunnelPerpendicularWindDownforceOnPanel: 'WINDTUNNEL_PERPENDICULAR_WIND_DOWNFORCE_ON_PANEL',
    WindtunnelFactoredWindPressurePerModule: 'WINDTUNNEL_FACTORED_WIND_PRESSURE_PER_MODULE',
    CombinationFactorWind: 'COMBINATION_FACTOR_WIND',
    CombinationFactorSnow: 'COMBINATION_FACTOR_SNOW',
    FactoredUnfavourablePermanentLoadPerModule: 'FACTORED_UNFAVOURABLE_PERMANENT_LOAD_PER_MODULE',
    StandardFactoredWindPressurePerModule: 'STANDARD_FACTORED_WIND_PRESSURE_PER_MODULE',
    FactoredRegularSnowPressurePerModule: 'FACTORED_REGULAR_SNOW_PRESSURE_PER_MODULE',
    FactoredRegularSnowPressureOnPanel: 'FACTORED_REGULAR_SNOW_PRESSURE_ON_PANEL',
    SnowAndWindCombinedLoadCombination: 'SNOW_AND_WIND_COMBINED_LOAD_COMBINATION',
    PrimaryWindWithSecondarySnowCombinedLoadCombination: 'PRIMARY_WIND_WITH_SECONDARY_SNOW_COMBINED_LOAD_COMBINATION',
    PrimarySnowWithSecondaryWindCombinedLoadCombination: 'PRIMARY_SNOW_WITH_SECONDARY_WIND_COMBINED_LOAD_COMBINATION',
    WorstCaseLoadPerModule: 'WORST_CASE_LOAD_PER_MODULE',
    WorstCaseLoadPerBasePlateGroup: 'WORST_CASE_LOAD_PER_BASE_PLATE_GROUP',
    DynamicPointLoadsPerBasePlateGroup: 'DYNAMIC_POINT_LOADS_PER_BASE_PLATE_GROUP',
    MaxDynamicPointLoadInSegment: 'MAX_DYNAMIC_POINT_LOAD_IN_SEGMENT',
    MaxDynamicPointLoadOnRoof: 'MAX_DYNAMIC_POINT_LOAD_ON_ROOF',
    MaxStaticPointLoadOnRoof: 'MAX_STATIC_POINT_LOAD_ON_ROOF',
    IgnoreVariableLoadsForCombinedLoads: 'IGNORE_VARIABLE_LOADS_FOR_COMBINED_LOADS',
    WindpressureWindloadUnfavourablePermanentLoadFactorCombinedLoads: 'WINDPRESSURE_WINDLOAD_UNFAVOURABLE_PERMANENT_LOAD_FACTOR_COMBINED_LOADS',
    FactoredUnfavourablePermanentLoadPerModuleForCombinedLoads: 'FACTORED_UNFAVOURABLE_PERMANENT_LOAD_PER_MODULE_FOR_COMBINED_LOADS',
    StaticWeightPerBasePlateInBasePlateGroup: 'STATIC_WEIGHT_PER_BASE_PLATE_IN_BASE_PLATE_GROUP',
    MaximumDynamicWeightPerBasePlateOnRoof: 'MAXIMUM_DYNAMIC_WEIGHT_PER_BASE_PLATE_ON_ROOF',
    WindpressureAsCombinedLoadCombination: 'WINDPRESSURE_AS_COMBINED_LOAD_COMBINATION',
    MinumumShapeCoefficientWithSnowFences: 'MINUMUM_SHAPE_COEFFICIENT_WITH_SNOW_FENCES',
    CombinedExceptionalAndRegularSnowLoadOnRoof: 'COMBINED_EXCEPTIONAL_AND_REGULAR_SNOW_LOAD_ON_ROOF',
    TotalPressureForceOnSegment: 'TOTAL_PRESSURE_FORCE_ON_SEGMENT',
    TotalLiftForceOnSegment: 'TOTAL_LIFT_FORCE_ON_SEGMENT',
    MaximumLiftPerAttachmentForRoof: 'MAXIMUM_LIFT_PER_ATTACHMENT_FOR_ROOF',
    MaximumPressurePerAttachmentForRoof: 'MAXIMUM_PRESSURE_PER_ATTACHMENT_FOR_ROOF',
    LengthBaseProfilePanel: 'LENGTH_BASE_PROFILE_PANEL',
    MarginBaseProfilePanel: 'MARGIN_BASE_PROFILE_PANEL',
    MarginBaseProfileRow: 'MARGIN_BASE_PROFILE_ROW',
    InstallationSummary: 'INSTALLATION_SUMMARY',
    InstallationSummaryFrontPage: 'INSTALLATION_SUMMARY_FRONT_PAGE',
    InstallationSummaryHeader: 'INSTALLATION_SUMMARY_HEADER',
    InstallationSummaryOtherDocuments: 'INSTALLATION_SUMMARY_OTHER_DOCUMENTS',
    InstallationSummaryRoofOverview: 'INSTALLATION_SUMMARY_ROOF_OVERVIEW',
    InstallationSummaryCompleteMaterials: 'INSTALLATION_SUMMARY_COMPLETE_MATERIALS',
    InstallationSummaryAssembly: 'INSTALLATION_SUMMARY_ASSEMBLY',
    InstallationSummarySegments: 'INSTALLATION_SUMMARY_SEGMENTS',
    InstallationSummaryCalculations: 'INSTALLATION_SUMMARY_CALCULATIONS',
    InstallationSummaryBackPage: 'INSTALLATION_SUMMARY_BACK_PAGE',
    InstallationSummaryImageAssemblyPlan: 'INSTALLATION_SUMMARY_IMAGE_ASSEMBLY_PLAN',
    InstallationSummaryImageAverageLoads: 'INSTALLATION_SUMMARY_IMAGE_AVERAGE_LOADS',
    InstallationSummaryImageRoofOverview: 'INSTALLATION_SUMMARY_IMAGE_ROOF_OVERVIEW',
    InstallationSummaryImageBallast: 'INSTALLATION_SUMMARY_IMAGE_BALLAST',
    InstallationSummaryImageMiniMap: 'INSTALLATION_SUMMARY_IMAGE_MINI_MAP',
    OrderList: 'ORDER_LIST',
    OrderListSummary: 'ORDER_LIST_SUMMARY',
    OrderListFooter: 'ORDER_LIST_FOOTER'
};
exports.WindDataCombinationDTOProductEnum = {
    ClickfitBasic: 'CLICKFIT_BASIC',
    ClickfitEvo: 'CLICKFIT_EVO',
    ClickfitEvoIn: 'CLICKFIT_EVO_IN',
    FlatfixFusion: 'FLATFIX_FUSION',
    FlatfixWaveEntry: 'FLATFIX_WAVE_ENTRY',
    FlatfixWavePlus: 'FLATFIX_WAVE_PLUS',
    FlatfixFusion10: 'FLATFIX_FUSION_10'
};
exports.WindDataCombinationDTOCategoryEnum = {
    FusionLandscape: 'FUSION_LANDSCAPE',
    FusionPortrait: 'FUSION_PORTRAIT',
    WaveEntryStandard: 'WAVE_ENTRY_STANDARD',
    WavePlusDual: 'WAVE_PLUS_DUAL',
    WavePlusSingle1P: 'WAVE_PLUS_SINGLE_1P',
    WavePlusSingle3P: 'WAVE_PLUS_SINGLE_3P'
};
exports.ZoneDtoTypeEnum = {
    EdgeZone: 'EDGE_ZONE',
    NoGoArea: 'NO_GO_AREA',
    InnerEdgeZone: 'INNER_EDGE_ZONE'
};
exports.ZoneInformationDTOWindZoneEnum = {
    BeZone1: 'BE_ZONE_1',
    BeZone2: 'BE_ZONE_2',
    BeZone3: 'BE_ZONE_3',
    BeZone4: 'BE_ZONE_4',
    DeZone1: 'DE_ZONE_1',
    DeZone2: 'DE_ZONE_2',
    DeZone3: 'DE_ZONE_3',
    DeZone4: 'DE_ZONE_4',
    FrZone1: 'FR_ZONE_1',
    FrZone2: 'FR_ZONE_2',
    FrZone3: 'FR_ZONE_3',
    FrZone4: 'FR_ZONE_4',
    InZone1: 'IN_ZONE_1',
    InZone2: 'IN_ZONE_2',
    InZone3: 'IN_ZONE_3',
    InZone4: 'IN_ZONE_4',
    InZone5: 'IN_ZONE_5',
    InZone6: 'IN_ZONE_6',
    NlZone1: 'NL_ZONE_1',
    NlZone2: 'NL_ZONE_2',
    NlZone3: 'NL_ZONE_3',
    NoneSelected: 'NONE_SELECTED',
    PtZoneA: 'PT_ZONE_A',
    PtZoneB: 'PT_ZONE_B',
    SpZoneA: 'SP_ZONE_A',
    SpZoneB: 'SP_ZONE_B',
    SpZoneC: 'SP_ZONE_C',
    SvZone21: 'SV_ZONE_21',
    SvZone22: 'SV_ZONE_22',
    SvZone23: 'SV_ZONE_23',
    SvZone24: 'SV_ZONE_24',
    SvZone25: 'SV_ZONE_25',
    SvZone26: 'SV_ZONE_26',
    PlZone1: 'PL_ZONE_1',
    PlZone2: 'PL_ZONE_2',
    PlZone3: 'PL_ZONE_3',
    PlBorderZone12: 'PL_BORDER_ZONE_1_2',
    DkZone24: 'DK_ZONE_24',
    DkZone25: 'DK_ZONE_25',
    DkZone26: 'DK_ZONE_26',
    DkZone27: 'DK_ZONE_27'
};
exports.ZoneInformationDTOSnowZoneEnum = {
    Germany1: 'GERMANY_1',
    Germany1A: 'GERMANY_1_A',
    Germany2: 'GERMANY_2',
    Germany2A: 'GERMANY_2_A',
    Germany3: 'GERMANY_3',
    Germany3A: 'GERMANY_3_A',
    GermanyGt3A: 'GERMANY_GT_3_A',
    Sweden10: 'SWEDEN_1_0',
    Sweden15: 'SWEDEN_1_5',
    Sweden20: 'SWEDEN_2_0',
    Sweden25: 'SWEDEN_2_5',
    Sweden30: 'SWEDEN_3_0',
    Sweden35: 'SWEDEN_3_5',
    Sweden45: 'SWEDEN_4_5',
    Sweden55: 'SWEDEN_5_5',
    Spain1: 'SPAIN_1',
    Spain2: 'SPAIN_2',
    Spain3: 'SPAIN_3',
    Spain4: 'SPAIN_4',
    Spain5: 'SPAIN_5',
    Spain6: 'SPAIN_6',
    Spain7: 'SPAIN_7',
    PortugalZ1: 'PORTUGAL_Z_1',
    PortugalZ2: 'PORTUGAL_Z_2',
    PortugalZ3: 'PORTUGAL_Z_3',
    FranceA1: 'FRANCE_A1',
    FranceA2: 'FRANCE_A2',
    FranceB1: 'FRANCE_B1',
    FranceB2: 'FRANCE_B2',
    FranceC1: 'FRANCE_C1',
    FranceC2: 'FRANCE_C2',
    FranceD: 'FRANCE_D',
    FranceE: 'FRANCE_E',
    Poland1: 'POLAND_1',
    Poland2: 'POLAND_2',
    Poland3: 'POLAND_3',
    Poland4: 'POLAND_4',
    Poland5: 'POLAND_5',
    Uk1: 'UK_1',
    Uk2: 'UK_2',
    Uk3: 'UK_3',
    Uk4: 'UK_4',
    Uk5: 'UK_5',
    Uk65: 'UK_6_5',
    Ireland04: 'IRELAND_0_4',
    Ireland05: 'IRELAND_0_5',
    Ireland06: 'IRELAND_0_6',
    Ireland07: 'IRELAND_0_7'
};
exports.ZoneInformationDTOTerrainCategoryEnum = {
    EuCategory0: 'EU_CATEGORY_0',
    EuCategory1: 'EU_CATEGORY_1',
    EuCategory2: 'EU_CATEGORY_2',
    EuCategory3: 'EU_CATEGORY_3',
    EuCategory4: 'EU_CATEGORY_4',
    EuCategory5: 'EU_CATEGORY_5',
    MixedProfile1: 'MIXED_PROFILE_1',
    MixedProfile2: 'MIXED_PROFILE_2',
    MixedProfile3: 'MIXED_PROFILE_3',
    France0: 'FRANCE_0',
    France2: 'FRANCE_2',
    France3A: 'FRANCE_3_A',
    France3B: 'FRANCE_3_B',
    France4: 'FRANCE_4',
    Portugal1: 'PORTUGAL_1',
    Portugal2: 'PORTUGAL_2',
    Portugal3: 'PORTUGAL_3',
    Portugal4: 'PORTUGAL_4',
    UkSea: 'UK_SEA',
    UkTown: 'UK_TOWN',
    UkCountry: 'UK_COUNTRY',
    IeSea: 'IE_SEA',
    IeTown: 'IE_TOWN',
    IeCountry: 'IE_COUNTRY',
    NoneSelected: 'NONE_SELECTED'
};
exports.ZoneReferenceInfoDTOWindZoneEnum = {
    BeZone1: 'BE_ZONE_1',
    BeZone2: 'BE_ZONE_2',
    BeZone3: 'BE_ZONE_3',
    BeZone4: 'BE_ZONE_4',
    DeZone1: 'DE_ZONE_1',
    DeZone2: 'DE_ZONE_2',
    DeZone3: 'DE_ZONE_3',
    DeZone4: 'DE_ZONE_4',
    FrZone1: 'FR_ZONE_1',
    FrZone2: 'FR_ZONE_2',
    FrZone3: 'FR_ZONE_3',
    FrZone4: 'FR_ZONE_4',
    InZone1: 'IN_ZONE_1',
    InZone2: 'IN_ZONE_2',
    InZone3: 'IN_ZONE_3',
    InZone4: 'IN_ZONE_4',
    InZone5: 'IN_ZONE_5',
    InZone6: 'IN_ZONE_6',
    NlZone1: 'NL_ZONE_1',
    NlZone2: 'NL_ZONE_2',
    NlZone3: 'NL_ZONE_3',
    NoneSelected: 'NONE_SELECTED',
    PtZoneA: 'PT_ZONE_A',
    PtZoneB: 'PT_ZONE_B',
    SpZoneA: 'SP_ZONE_A',
    SpZoneB: 'SP_ZONE_B',
    SpZoneC: 'SP_ZONE_C',
    SvZone21: 'SV_ZONE_21',
    SvZone22: 'SV_ZONE_22',
    SvZone23: 'SV_ZONE_23',
    SvZone24: 'SV_ZONE_24',
    SvZone25: 'SV_ZONE_25',
    SvZone26: 'SV_ZONE_26',
    PlZone1: 'PL_ZONE_1',
    PlZone2: 'PL_ZONE_2',
    PlZone3: 'PL_ZONE_3',
    PlBorderZone12: 'PL_BORDER_ZONE_1_2',
    DkZone24: 'DK_ZONE_24',
    DkZone25: 'DK_ZONE_25',
    DkZone26: 'DK_ZONE_26',
    DkZone27: 'DK_ZONE_27'
};
exports.ZoneReferenceInfoDTOSnowZoneEnum = {
    Germany1: 'GERMANY_1',
    Germany1A: 'GERMANY_1_A',
    Germany2: 'GERMANY_2',
    Germany2A: 'GERMANY_2_A',
    Germany3: 'GERMANY_3',
    Germany3A: 'GERMANY_3_A',
    GermanyGt3A: 'GERMANY_GT_3_A',
    Sweden10: 'SWEDEN_1_0',
    Sweden15: 'SWEDEN_1_5',
    Sweden20: 'SWEDEN_2_0',
    Sweden25: 'SWEDEN_2_5',
    Sweden30: 'SWEDEN_3_0',
    Sweden35: 'SWEDEN_3_5',
    Sweden45: 'SWEDEN_4_5',
    Sweden55: 'SWEDEN_5_5',
    Spain1: 'SPAIN_1',
    Spain2: 'SPAIN_2',
    Spain3: 'SPAIN_3',
    Spain4: 'SPAIN_4',
    Spain5: 'SPAIN_5',
    Spain6: 'SPAIN_6',
    Spain7: 'SPAIN_7',
    PortugalZ1: 'PORTUGAL_Z_1',
    PortugalZ2: 'PORTUGAL_Z_2',
    PortugalZ3: 'PORTUGAL_Z_3',
    FranceA1: 'FRANCE_A1',
    FranceA2: 'FRANCE_A2',
    FranceB1: 'FRANCE_B1',
    FranceB2: 'FRANCE_B2',
    FranceC1: 'FRANCE_C1',
    FranceC2: 'FRANCE_C2',
    FranceD: 'FRANCE_D',
    FranceE: 'FRANCE_E',
    Poland1: 'POLAND_1',
    Poland2: 'POLAND_2',
    Poland3: 'POLAND_3',
    Poland4: 'POLAND_4',
    Poland5: 'POLAND_5',
    Uk1: 'UK_1',
    Uk2: 'UK_2',
    Uk3: 'UK_3',
    Uk4: 'UK_4',
    Uk5: 'UK_5',
    Uk65: 'UK_6_5',
    Ireland04: 'IRELAND_0_4',
    Ireland05: 'IRELAND_0_5',
    Ireland06: 'IRELAND_0_6',
    Ireland07: 'IRELAND_0_7'
};
exports.ZoneReferenceInfoDTOTerrainCategoryEnum = {
    EuCategory0: 'EU_CATEGORY_0',
    EuCategory1: 'EU_CATEGORY_1',
    EuCategory2: 'EU_CATEGORY_2',
    EuCategory3: 'EU_CATEGORY_3',
    EuCategory4: 'EU_CATEGORY_4',
    EuCategory5: 'EU_CATEGORY_5',
    MixedProfile1: 'MIXED_PROFILE_1',
    MixedProfile2: 'MIXED_PROFILE_2',
    MixedProfile3: 'MIXED_PROFILE_3',
    France0: 'FRANCE_0',
    France2: 'FRANCE_2',
    France3A: 'FRANCE_3_A',
    France3B: 'FRANCE_3_B',
    France4: 'FRANCE_4',
    Portugal1: 'PORTUGAL_1',
    Portugal2: 'PORTUGAL_2',
    Portugal3: 'PORTUGAL_3',
    Portugal4: 'PORTUGAL_4',
    UkSea: 'UK_SEA',
    UkTown: 'UK_TOWN',
    UkCountry: 'UK_COUNTRY',
    IeSea: 'IE_SEA',
    IeTown: 'IE_TOWN',
    IeCountry: 'IE_COUNTRY',
    NoneSelected: 'NONE_SELECTED'
};
/**
 * ArticleResourceApi - axios parameter creator
 * @export
 */
const ArticleResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticleCategoryDetails: (product, articleType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'product' is not null or undefined
            (0, common_1.assertParamExists)('deleteArticleCategoryDetails', 'product', product);
            // verify required parameter 'articleType' is not null or undefined
            (0, common_1.assertParamExists)('deleteArticleCategoryDetails', 'articleType', articleType);
            const localVarPath = `/api/article/categories/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }
            if (articleType !== undefined) {
                localVarQueryParameter['articleType'] = articleType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActiveArticles: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/article/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Pageable} pageable
         * @param {boolean} [active]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllArticleDetails: (pageable, active, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pageable' is not null or undefined
            (0, common_1.assertParamExists)('getAllArticleDetails', 'pageable', pageable);
            const localVarPath = `/api/article/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleCategories: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/article/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleCategoryDetails: (product, articleType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'product' is not null or undefined
            (0, common_1.assertParamExists)('getArticleCategoryDetails', 'product', product);
            // verify required parameter 'articleType' is not null or undefined
            (0, common_1.assertParamExists)('getArticleCategoryDetails', 'articleType', articleType);
            const localVarPath = `/api/article/categories/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }
            if (articleType !== undefined) {
                localVarQueryParameter['articleType'] = articleType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getArticleDetails', 'id', id);
            const localVarPath = `/api/article/details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {boolean} [sorted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticlesByCategory: (product, articleType, sorted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'product' is not null or undefined
            (0, common_1.assertParamExists)('getArticlesByCategory', 'product', product);
            // verify required parameter 'articleType' is not null or undefined
            (0, common_1.assertParamExists)('getArticlesByCategory', 'articleType', articleType);
            const localVarPath = `/api/article`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }
            if (articleType !== undefined) {
                localVarQueryParameter['articleType'] = articleType;
            }
            if (sorted !== undefined) {
                localVarQueryParameter['sorted'] = sorted;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of dowel screw articles in the current set with the provided product. Product options are: * CLICKFIT_EVO
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} [product]
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDowelScrewsArticles: (product, lang, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/vendors/dowel-screws`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of mounting rail articles in the current set with the provided product. Product options are: * CLICKFIT_BASIC * CLICKFIT_EVO
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} product
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMountingRailArticles: (product, lang, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'product' is not null or undefined
            (0, common_1.assertParamExists)('getMountingRailArticles', 'product', product);
            const localVarPath = `/api/vendors/mounting-rails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of rafter screw articles in the current set for the product CLICKFIT_EVO.
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRafterScrewsArticles: (lang, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/vendors/rafter-screws`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of support screw articles in the current set for the product CLICKFIT_BASIC.
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportScrewsArticles: (lang, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/vendors/support-screws`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {ArticleSetDTO} articleSetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticleCategoryDetails: (product, articleType, articleSetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'product' is not null or undefined
            (0, common_1.assertParamExists)('updateArticleCategoryDetails', 'product', product);
            // verify required parameter 'articleType' is not null or undefined
            (0, common_1.assertParamExists)('updateArticleCategoryDetails', 'articleType', articleType);
            // verify required parameter 'articleSetDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateArticleCategoryDetails', 'articleSetDTO', articleSetDTO);
            const localVarPath = `/api/article/categories/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }
            if (articleType !== undefined) {
                localVarQueryParameter['articleType'] = articleType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(articleSetDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ArticleResourceApiAxiosParamCreator = ArticleResourceApiAxiosParamCreator;
/**
 * ArticleResourceApi - functional programming interface
 * @export
 */
const ArticleResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ArticleResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticleCategoryDetails(product, articleType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteArticleCategoryDetails(product, articleType, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActiveArticles(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllActiveArticles(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {boolean} [active]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllArticleDetails(pageable, active, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllArticleDetails(pageable, active, search, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleCategories(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getArticleCategories(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleCategoryDetails(product, articleType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getArticleCategoryDetails(product, articleType, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetails(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getArticleDetails(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {boolean} [sorted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticlesByCategory(product, articleType, sorted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getArticlesByCategory(product, articleType, sorted, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of dowel screw articles in the current set with the provided product. Product options are: * CLICKFIT_EVO
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} [product]
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDowelScrewsArticles(product, lang, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDowelScrewsArticles(product, lang, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of mounting rail articles in the current set with the provided product. Product options are: * CLICKFIT_BASIC * CLICKFIT_EVO
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} product
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMountingRailArticles(product, lang, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMountingRailArticles(product, lang, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of rafter screw articles in the current set for the product CLICKFIT_EVO.
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRafterScrewsArticles(lang, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRafterScrewsArticles(lang, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of support screw articles in the current set for the product CLICKFIT_BASIC.
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportScrewsArticles(lang, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupportScrewsArticles(lang, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {ArticleSetDTO} articleSetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticleCategoryDetails(product, articleType, articleSetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateArticleCategoryDetails(product, articleType, articleSetDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ArticleResourceApiFp = ArticleResourceApiFp;
/**
 * ArticleResourceApi - factory interface
 * @export
 */
const ArticleResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ArticleResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticleCategoryDetails(product, articleType, options) {
            return localVarFp.deleteArticleCategoryDetails(product, articleType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActiveArticles(options) {
            return localVarFp.getAllActiveArticles(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {boolean} [active]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllArticleDetails(pageable, active, search, options) {
            return localVarFp.getAllArticleDetails(pageable, active, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleCategories(options) {
            return localVarFp.getArticleCategories(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleCategoryDetails(product, articleType, options) {
            return localVarFp.getArticleCategoryDetails(product, articleType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetails(id, options) {
            return localVarFp.getArticleDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {boolean} [sorted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticlesByCategory(product, articleType, sorted, options) {
            return localVarFp.getArticlesByCategory(product, articleType, sorted, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of dowel screw articles in the current set with the provided product. Product options are: * CLICKFIT_EVO
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} [product]
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDowelScrewsArticles(product, lang, options) {
            return localVarFp.getDowelScrewsArticles(product, lang, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of mounting rail articles in the current set with the provided product. Product options are: * CLICKFIT_BASIC * CLICKFIT_EVO
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} product
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMountingRailArticles(product, lang, options) {
            return localVarFp.getMountingRailArticles(product, lang, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of rafter screw articles in the current set for the product CLICKFIT_EVO.
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRafterScrewsArticles(lang, options) {
            return localVarFp.getRafterScrewsArticles(lang, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of support screw articles in the current set for the product CLICKFIT_BASIC.
         * @param {string} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportScrewsArticles(lang, options) {
            return localVarFp.getSupportScrewsArticles(lang, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
         * @param {ArticleSetDTO} articleSetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticleCategoryDetails(product, articleType, articleSetDTO, options) {
            return localVarFp.updateArticleCategoryDetails(product, articleType, articleSetDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ArticleResourceApiFactory = ArticleResourceApiFactory;
/**
 * ArticleResourceApi - object-oriented interface
 * @export
 * @class ArticleResourceApi
 * @extends {BaseAPI}
 */
class ArticleResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
     * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    deleteArticleCategoryDetails(product, articleType, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).deleteArticleCategoryDetails(product, articleType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getAllActiveArticles(options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getAllActiveArticles(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Pageable} pageable
     * @param {boolean} [active]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getAllArticleDetails(pageable, active, search, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getAllArticleDetails(pageable, active, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getArticleCategories(options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getArticleCategories(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
     * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getArticleCategoryDetails(product, articleType, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getArticleCategoryDetails(product, articleType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getArticleDetails(id, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getArticleDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
     * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
     * @param {boolean} [sorted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getArticlesByCategory(product, articleType, sorted, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getArticlesByCategory(product, articleType, sorted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of dowel screw articles in the current set with the provided product. Product options are: * CLICKFIT_EVO
     * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} [product]
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getDowelScrewsArticles(product, lang, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getDowelScrewsArticles(product, lang, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of mounting rail articles in the current set with the provided product. Product options are: * CLICKFIT_BASIC * CLICKFIT_EVO
     * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_PLUS' | 'CONNECT'} product
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getMountingRailArticles(product, lang, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getMountingRailArticles(product, lang, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of rafter screw articles in the current set for the product CLICKFIT_EVO.
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getRafterScrewsArticles(lang, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getRafterScrewsArticles(lang, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of support screw articles in the current set for the product CLICKFIT_BASIC.
     * @param {string} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    getSupportScrewsArticles(lang, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).getSupportScrewsArticles(lang, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
     * @param {'ADAPTER' | 'AUXILIARY_SET' | 'BALLAST_BRACKET' | 'BALLAST_CONTAINER_LANDSCAPE' | 'BALLAST_CONTAINER_PORTRAIT' | 'BALLAST_CONTAINER_SCREW' | 'BASE_PLATE' | 'BASE_PLATE_BRACKET' | 'BASE_PROFILE_PANEL' | 'BASE_PROFILE_ROW' | 'BLACK_END_CAP' | 'CABLE_BRACKET' | 'CABLE_CLIP' | 'CABLE_EXIT_GUIDE' | 'COLOR_CAP' | 'CORRUGATED_MOUNTING_BRACKET' | 'COUPLER_SCREW' | 'COUPLING_STRIP' | 'END_CAP_WITHOUT_CLAMP_SUPPORT' | 'END_CLAMP' | 'END_CLAMP_SUPPORTS' | 'EPDM_ADAPTER' | 'EPDM_KIT' | 'EPDM_TAPE' | 'EXTENDER' | 'EXTRA_VERTICAL_RAIL_SCREW' | 'GROUNDING_BRACKET' | 'GROUNDING_CLIP' | 'GROUNDING_SCREW_SIDE_DEFLECTOR' | 'GROUNDING_SPRING_FOR_BASE' | 'HANGER_BOLT' | 'HIGH_BASE' | 'LEFT_WIND_DEFLECTOR_LANDSCAPE' | 'LEFT_WIND_DEFLECTOR_PORTRAIT' | 'LOCKING_SCREW' | 'LOWER_CLAMP_SCREW_WITHOUT_EXTENSION' | 'LOWER_CLAMP_SCREW_WITH_EXTENSION' | 'LOWER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'LOW_BASE' | 'LOW_BASE_EXTENSION' | 'MEASURING_BAR' | 'MID_CLAMP' | 'MODULE_CLAMP' | 'MODULE_SPACER' | 'MODULE_UNLOCK_TOOL' | 'MOUNTING_PROFILES' | 'MOUNTING_PROFILE_LANDSCAPE' | 'MOUNTING_PROFILE_PORTRAIT' | 'MOUNTING_PROFILE_SCREW' | 'MOUNTING_RAIL' | 'MOUNTING_RAIL_CABLE_CLIP_OPTIMIZER' | 'MOUNTING_RAIL_COUPLER' | 'MOUNTING_RAIL_END_CAP' | 'MOUNTING_SCREW_LOWER_CLAMP_NO_EXTENSION' | 'MOUNTING_SCREW_LOWER_CLAMP_WITH_EXTENSION' | 'MOUNTING_SCREW_PANEL' | 'MOUNTING_SCREW_UPPER_CLAMP' | 'OLD_RAIL_UNIT_2P' | 'PERIMETER_BRACKET' | 'PERIMETER_CONTAINER_EXTENSION' | 'RAFTER_SCREW' | 'RAIL_START_UNIT_4P' | 'RAIL_UNIT_1P' | 'RAIL_UNIT_2P' | 'RAIL_UNIT_3P' | 'RAIL_UNIT_4P' | 'REAR_WIND_DEFLECTOR_CLIP' | 'REAR_WIND_DEFLECTOR_LANDSCAPE' | 'REAR_WIND_DEFLECTOR_PORTRAIT' | 'RIGHT_WIND_DEFLECTOR_LANDSCAPE' | 'RIGHT_WIND_DEFLECTOR_PORTRAIT' | 'RIVET' | 'ROOF_HOOK' | 'ROOF_HOOK_BOLT' | 'ROOF_HOOK_NUT' | 'ROOF_HOOK_SPACER' | 'ROOF_SUPPORT' | 'ROOF_SUPPORT_SCREW' | 'SCREW_CAP' | 'SCREW_GROUNDING_BRACKET' | 'SEAM_CLAMP' | 'SELF_DRILLING_SCREW' | 'SHEET_SCREWS' | 'SIDE_WIND_DEFLECTOR_SCREW' | 'SLATE_ROOF_HOOK' | 'STABILIZER' | 'STABILIZER_SCREW' | 'STEEL_SUPPORT_SCREW' | 'TIXOPHALTE_KIT' | 'TORX_BIT' | 'MAT' | 'TRAY' | 'UPPER_CLAMP_SCREW' | 'UPPER_MOUNTING_SCREW_REAR_WIND_DEFLECTOR' | 'WASHERS' | 'WAVE_PLUS_SIDE_DEFLECTOR_CLAMPS' | 'WAVE_PLUS_SIDE_WIND_DEFLECTOR_SET' | 'COUPLER'} articleType
     * @param {ArticleSetDTO} articleSetDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleResourceApi
     */
    updateArticleCategoryDetails(product, articleType, articleSetDTO, options) {
        return (0, exports.ArticleResourceApiFp)(this.configuration).updateArticleCategoryDetails(product, articleType, articleSetDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ArticleResourceApi = ArticleResourceApi;
/**
 * CalculationResourceApi - axios parameter creator
 * @export
 */
const CalculationResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Validate and optionally store a project and perform a calculation
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {boolean} [persist]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateNewProject: (calculationRequestDto, persist, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'calculationRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('calculateNewProject', 'calculationRequestDto', calculationRequestDto);
            const localVarPath = `/api/vendors/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (persist !== undefined) {
                localVarQueryParameter['persist'] = persist;
            }
            localVarHeaderParameter['Content-Type'] = 'application/vnd.esdec.v1+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(calculationRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Download an installation summary for a persisted and already calculated roof
         * @param {number} projectId
         * @param {number} roofId
         * @param {boolean} [generateNew]
         * @param {string} [lang]
         * @param {boolean} [optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields]
         * @param {number} [maximumRailLength]
         * @param {Set<string>} [excludedRails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInstallationSummary: (projectId, roofId, generateNew, lang, optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields, maximumRailLength, excludedRails, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'projectId' is not null or undefined
            (0, common_1.assertParamExists)('downloadInstallationSummary', 'projectId', projectId);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('downloadInstallationSummary', 'roofId', roofId);
            const localVarPath = `/api/vendors/projects/{projectId}/roofs/{roofId}/reports/installation-summary`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (generateNew !== undefined) {
                localVarQueryParameter['generateNew'] = generateNew;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields !== undefined) {
                localVarQueryParameter['Option to show the inner edge zone in the installation summary. Only applicable for Flatfix Wave Plus with single fields'] = optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields;
            }
            if (maximumRailLength !== undefined) {
                localVarQueryParameter['maximumRailLength'] = maximumRailLength;
            }
            if (excludedRails) {
                localVarQueryParameter['excludedRails'] = Array.from(excludedRails);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary DEPRECATED: Use ShortcutAPI \"/api/v2/shortcuts/roof-zones\" instead: Compute central zones for a set of roofs
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentralRoofZones: (calculationRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'calculationRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('getCentralRoofZones', 'calculationRequestDto', calculationRequestDto);
            const localVarPath = `/api/vendors/projects/actions/centralzones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.esdec.v1+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(calculationRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Compute side plate placements for a set of roofs. Only applicable for FlatFix Wave
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSidePlatePlacements: (calculationRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'calculationRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('getSidePlatePlacements', 'calculationRequestDto', calculationRequestDto);
            const localVarPath = `/api/vendors/projects/actions/sideplates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.esdec.v1+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(calculationRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing project and perform a calculation
         * @param {number} projectId
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingProject: (projectId, calculationRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'projectId' is not null or undefined
            (0, common_1.assertParamExists)('updateExistingProject', 'projectId', projectId);
            // verify required parameter 'calculationRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('updateExistingProject', 'calculationRequestDto', calculationRequestDto);
            const localVarPath = `/api/vendors/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.esdec.v1+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(calculationRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Validate a project. Returns 200 if the request was valid. Otherwise, a list of errors is returned. This feature is deprecated
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCalculationRequest: (calculationRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'calculationRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('validateCalculationRequest', 'calculationRequestDto', calculationRequestDto);
            const localVarPath = `/api/vendors/projects/actions/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.esdec.v1+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(calculationRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CalculationResourceApiAxiosParamCreator = CalculationResourceApiAxiosParamCreator;
/**
 * CalculationResourceApi - functional programming interface
 * @export
 */
const CalculationResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CalculationResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Validate and optionally store a project and perform a calculation
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {boolean} [persist]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateNewProject(calculationRequestDto, persist, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.calculateNewProject(calculationRequestDto, persist, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Download an installation summary for a persisted and already calculated roof
         * @param {number} projectId
         * @param {number} roofId
         * @param {boolean} [generateNew]
         * @param {string} [lang]
         * @param {boolean} [optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields]
         * @param {number} [maximumRailLength]
         * @param {Set<string>} [excludedRails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInstallationSummary(projectId, roofId, generateNew, lang, optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields, maximumRailLength, excludedRails, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadInstallationSummary(projectId, roofId, generateNew, lang, optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields, maximumRailLength, excludedRails, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary DEPRECATED: Use ShortcutAPI \"/api/v2/shortcuts/roof-zones\" instead: Compute central zones for a set of roofs
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentralRoofZones(calculationRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCentralRoofZones(calculationRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Compute side plate placements for a set of roofs. Only applicable for FlatFix Wave
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSidePlatePlacements(calculationRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSidePlatePlacements(calculationRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing project and perform a calculation
         * @param {number} projectId
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingProject(projectId, calculationRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateExistingProject(projectId, calculationRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Validate a project. Returns 200 if the request was valid. Otherwise, a list of errors is returned. This feature is deprecated
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCalculationRequest(calculationRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateCalculationRequest(calculationRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.CalculationResourceApiFp = CalculationResourceApiFp;
/**
 * CalculationResourceApi - factory interface
 * @export
 */
const CalculationResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CalculationResourceApiFp)(configuration);
    return {
        /**
         *
         * @summary Validate and optionally store a project and perform a calculation
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {boolean} [persist]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateNewProject(calculationRequestDto, persist, options) {
            return localVarFp.calculateNewProject(calculationRequestDto, persist, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Download an installation summary for a persisted and already calculated roof
         * @param {number} projectId
         * @param {number} roofId
         * @param {boolean} [generateNew]
         * @param {string} [lang]
         * @param {boolean} [optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields]
         * @param {number} [maximumRailLength]
         * @param {Set<string>} [excludedRails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInstallationSummary(projectId, roofId, generateNew, lang, optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields, maximumRailLength, excludedRails, options) {
            return localVarFp.downloadInstallationSummary(projectId, roofId, generateNew, lang, optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields, maximumRailLength, excludedRails, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary DEPRECATED: Use ShortcutAPI \"/api/v2/shortcuts/roof-zones\" instead: Compute central zones for a set of roofs
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentralRoofZones(calculationRequestDto, options) {
            return localVarFp.getCentralRoofZones(calculationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Compute side plate placements for a set of roofs. Only applicable for FlatFix Wave
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSidePlatePlacements(calculationRequestDto, options) {
            return localVarFp.getSidePlatePlacements(calculationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing project and perform a calculation
         * @param {number} projectId
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExistingProject(projectId, calculationRequestDto, options) {
            return localVarFp.updateExistingProject(projectId, calculationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validate a project. Returns 200 if the request was valid. Otherwise, a list of errors is returned. This feature is deprecated
         * @param {CalculationRequestDto} calculationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCalculationRequest(calculationRequestDto, options) {
            return localVarFp.validateCalculationRequest(calculationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CalculationResourceApiFactory = CalculationResourceApiFactory;
/**
 * CalculationResourceApi - object-oriented interface
 * @export
 * @class CalculationResourceApi
 * @extends {BaseAPI}
 */
class CalculationResourceApi extends base_1.BaseAPI {
    /**
     *
     * @summary Validate and optionally store a project and perform a calculation
     * @param {CalculationRequestDto} calculationRequestDto
     * @param {boolean} [persist]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationResourceApi
     */
    calculateNewProject(calculationRequestDto, persist, options) {
        return (0, exports.CalculationResourceApiFp)(this.configuration).calculateNewProject(calculationRequestDto, persist, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Download an installation summary for a persisted and already calculated roof
     * @param {number} projectId
     * @param {number} roofId
     * @param {boolean} [generateNew]
     * @param {string} [lang]
     * @param {boolean} [optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields]
     * @param {number} [maximumRailLength]
     * @param {Set<string>} [excludedRails]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationResourceApi
     */
    downloadInstallationSummary(projectId, roofId, generateNew, lang, optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields, maximumRailLength, excludedRails, options) {
        return (0, exports.CalculationResourceApiFp)(this.configuration).downloadInstallationSummary(projectId, roofId, generateNew, lang, optionToShowTheInnerEdgeZoneInTheInstallationSummaryOnlyApplicableForFlatfixWavePlusWithSingleFields, maximumRailLength, excludedRails, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary DEPRECATED: Use ShortcutAPI \"/api/v2/shortcuts/roof-zones\" instead: Compute central zones for a set of roofs
     * @param {CalculationRequestDto} calculationRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationResourceApi
     */
    getCentralRoofZones(calculationRequestDto, options) {
        return (0, exports.CalculationResourceApiFp)(this.configuration).getCentralRoofZones(calculationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Compute side plate placements for a set of roofs. Only applicable for FlatFix Wave
     * @param {CalculationRequestDto} calculationRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationResourceApi
     */
    getSidePlatePlacements(calculationRequestDto, options) {
        return (0, exports.CalculationResourceApiFp)(this.configuration).getSidePlatePlacements(calculationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing project and perform a calculation
     * @param {number} projectId
     * @param {CalculationRequestDto} calculationRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationResourceApi
     */
    updateExistingProject(projectId, calculationRequestDto, options) {
        return (0, exports.CalculationResourceApiFp)(this.configuration).updateExistingProject(projectId, calculationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Validate a project. Returns 200 if the request was valid. Otherwise, a list of errors is returned. This feature is deprecated
     * @param {CalculationRequestDto} calculationRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationResourceApi
     */
    validateCalculationRequest(calculationRequestDto, options) {
        return (0, exports.CalculationResourceApiFp)(this.configuration).validateCalculationRequest(calculationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CalculationResourceApi = CalculationResourceApi;
/**
 * ConfigurationControllerApi - axios parameter creator
 * @export
 */
const ConfigurationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration: (name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'name' is not null or undefined
            (0, common_1.assertParamExists)('getConfiguration', 'name', name);
            const localVarPath = `/api/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/configuration/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureToggles: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/configuration/feature-toggles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ConfigurationDTO} configurationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration: (configurationDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateConfiguration', 'configurationDTO', configurationDTO);
            const localVarPath = `/api/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(configurationDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {FeatureToggleDTO} featureToggleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureToggle: (featureToggleDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'featureToggleDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateFeatureToggle', 'featureToggleDTO', featureToggleDTO);
            const localVarPath = `/api/configuration/feature-toggles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(featureToggleDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ConfigurationControllerApiAxiosParamCreator = ConfigurationControllerApiAxiosParamCreator;
/**
 * ConfigurationControllerApi - functional programming interface
 * @export
 */
const ConfigurationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ConfigurationControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConfiguration(name, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConfigurations(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureToggles(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFeatureToggles(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ConfigurationDTO} configurationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(configurationDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateConfiguration(configurationDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {FeatureToggleDTO} featureToggleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureToggle(featureToggleDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateFeatureToggle(featureToggleDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ConfigurationControllerApiFp = ConfigurationControllerApiFp;
/**
 * ConfigurationControllerApi - factory interface
 * @export
 */
const ConfigurationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ConfigurationControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(name, options) {
            return localVarFp.getConfiguration(name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options) {
            return localVarFp.getConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureToggles(options) {
            return localVarFp.getFeatureToggles(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ConfigurationDTO} configurationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(configurationDTO, options) {
            return localVarFp.updateConfiguration(configurationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FeatureToggleDTO} featureToggleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatureToggle(featureToggleDTO, options) {
            return localVarFp.updateFeatureToggle(featureToggleDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ConfigurationControllerApiFactory = ConfigurationControllerApiFactory;
/**
 * ConfigurationControllerApi - object-oriented interface
 * @export
 * @class ConfigurationControllerApi
 * @extends {BaseAPI}
 */
class ConfigurationControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationControllerApi
     */
    getConfiguration(name, options) {
        return (0, exports.ConfigurationControllerApiFp)(this.configuration).getConfiguration(name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationControllerApi
     */
    getConfigurations(options) {
        return (0, exports.ConfigurationControllerApiFp)(this.configuration).getConfigurations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationControllerApi
     */
    getFeatureToggles(options) {
        return (0, exports.ConfigurationControllerApiFp)(this.configuration).getFeatureToggles(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ConfigurationDTO} configurationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationControllerApi
     */
    updateConfiguration(configurationDTO, options) {
        return (0, exports.ConfigurationControllerApiFp)(this.configuration).updateConfiguration(configurationDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FeatureToggleDTO} featureToggleDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationControllerApi
     */
    updateFeatureToggle(featureToggleDTO, options) {
        return (0, exports.ConfigurationControllerApiFp)(this.configuration).updateFeatureToggle(featureToggleDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConfigurationControllerApi = ConfigurationControllerApi;
/**
 * IdentityControllerApi - axios parameter creator
 * @export
 */
const IdentityControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateIdentity: (key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            (0, common_1.assertParamExists)('activateIdentity', 'key', key);
            const localVarPath = `/api/identities/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PasswordChangeDTO} passwordChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: (passwordChangeDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'passwordChangeDTO' is not null or undefined
            (0, common_1.assertParamExists)('changePassword', 'passwordChangeDTO', passwordChangeDTO);
            const localVarPath = `/api/identities/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(passwordChangeDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {IdentityDTO} identityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIdentity: (identityDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'identityDTO' is not null or undefined
            (0, common_1.assertParamExists)('createIdentity', 'identityDTO', identityDTO);
            const localVarPath = `/api/identities/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(identityDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'ESDEC' | 'CPX' | 'BLUBASE'} businessUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshToken: (businessUnit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'businessUnit' is not null or undefined
            (0, common_1.assertParamExists)('createRefreshToken', 'businessUnit', businessUnit);
            const localVarPath = `/api/identities/{businessUnit}/refresh-token`
                .replace(`{${"businessUnit"}}`, encodeURIComponent(String(businessUnit)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {KeyAndPassword} keyAndPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishPasswordReset: (keyAndPassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'keyAndPassword' is not null or undefined
            (0, common_1.assertParamExists)('finishPasswordReset', 'keyAndPassword', keyAndPassword);
            const localVarPath = `/api/identities/reset-password/finish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(keyAndPassword, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIdentity: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/identities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentity: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getIdentity', 'id', id);
            const localVarPath = `/api/identities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPasswordReset: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('initPasswordReset', 'body', body);
            const localVarPath = `/api/identities/reset-password/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RegisterIdentityDTO} registerIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerApiIdentity: (registerIdentityDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerIdentityDTO' is not null or undefined
            (0, common_1.assertParamExists)('registerApiIdentity', 'registerIdentityDTO', registerIdentityDTO);
            const localVarPath = `/api/identities/register/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerIdentityDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RegisterIdentityDTO} registerIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBasicIdentity: (registerIdentityDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerIdentityDTO' is not null or undefined
            (0, common_1.assertParamExists)('registerBasicIdentity', 'registerIdentityDTO', registerIdentityDTO);
            const localVarPath = `/api/identities/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerIdentityDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateIdentityDTO} updateIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity: (id, updateIdentityDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updateIdentity', 'id', id);
            // verify required parameter 'updateIdentityDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateIdentity', 'updateIdentityDTO', updateIdentityDTO);
            const localVarPath = `/api/identities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateIdentityDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateIdentityDTO} updateIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity2: (updateIdentityDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateIdentityDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateIdentity2', 'updateIdentityDTO', updateIdentityDTO);
            const localVarPath = `/api/identities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateIdentityDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.IdentityControllerApiAxiosParamCreator = IdentityControllerApiAxiosParamCreator;
/**
 * IdentityControllerApi - functional programming interface
 * @export
 */
const IdentityControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.IdentityControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateIdentity(key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activateIdentity(key, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {PasswordChangeDTO} passwordChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(passwordChangeDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changePassword(passwordChangeDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {IdentityDTO} identityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIdentity(identityDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createIdentity(identityDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'ESDEC' | 'CPX' | 'BLUBASE'} businessUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshToken(businessUnit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createRefreshToken(businessUnit, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {KeyAndPassword} keyAndPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishPasswordReset(keyAndPassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finishPasswordReset(keyAndPassword, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIdentity(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentIdentity(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentity(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIdentity(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPasswordReset(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initPasswordReset(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RegisterIdentityDTO} registerIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerApiIdentity(registerIdentityDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerApiIdentity(registerIdentityDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RegisterIdentityDTO} registerIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBasicIdentity(registerIdentityDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerBasicIdentity(registerIdentityDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateIdentityDTO} updateIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity(id, updateIdentityDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateIdentity(id, updateIdentityDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UpdateIdentityDTO} updateIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity2(updateIdentityDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateIdentity2(updateIdentityDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.IdentityControllerApiFp = IdentityControllerApiFp;
/**
 * IdentityControllerApi - factory interface
 * @export
 */
const IdentityControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.IdentityControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateIdentity(key, options) {
            return localVarFp.activateIdentity(key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PasswordChangeDTO} passwordChangeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(passwordChangeDTO, options) {
            return localVarFp.changePassword(passwordChangeDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {IdentityDTO} identityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIdentity(identityDTO, options) {
            return localVarFp.createIdentity(identityDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'ESDEC' | 'CPX' | 'BLUBASE'} businessUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefreshToken(businessUnit, options) {
            return localVarFp.createRefreshToken(businessUnit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {KeyAndPassword} keyAndPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishPasswordReset(keyAndPassword, options) {
            return localVarFp.finishPasswordReset(keyAndPassword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIdentity(options) {
            return localVarFp.getCurrentIdentity(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentity(id, options) {
            return localVarFp.getIdentity(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPasswordReset(body, options) {
            return localVarFp.initPasswordReset(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RegisterIdentityDTO} registerIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerApiIdentity(registerIdentityDTO, options) {
            return localVarFp.registerApiIdentity(registerIdentityDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RegisterIdentityDTO} registerIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBasicIdentity(registerIdentityDTO, options) {
            return localVarFp.registerBasicIdentity(registerIdentityDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UpdateIdentityDTO} updateIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity(id, updateIdentityDTO, options) {
            return localVarFp.updateIdentity(id, updateIdentityDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateIdentityDTO} updateIdentityDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity2(updateIdentityDTO, options) {
            return localVarFp.updateIdentity2(updateIdentityDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.IdentityControllerApiFactory = IdentityControllerApiFactory;
/**
 * IdentityControllerApi - object-oriented interface
 * @export
 * @class IdentityControllerApi
 * @extends {BaseAPI}
 */
class IdentityControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    activateIdentity(key, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).activateIdentity(key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PasswordChangeDTO} passwordChangeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    changePassword(passwordChangeDTO, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).changePassword(passwordChangeDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {IdentityDTO} identityDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    createIdentity(identityDTO, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).createIdentity(identityDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {'ESDEC' | 'CPX' | 'BLUBASE'} businessUnit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    createRefreshToken(businessUnit, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).createRefreshToken(businessUnit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {KeyAndPassword} keyAndPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    finishPasswordReset(keyAndPassword, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).finishPasswordReset(keyAndPassword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    getCurrentIdentity(options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).getCurrentIdentity(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    getIdentity(id, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).getIdentity(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    initPasswordReset(body, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).initPasswordReset(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RegisterIdentityDTO} registerIdentityDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    registerApiIdentity(registerIdentityDTO, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).registerApiIdentity(registerIdentityDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RegisterIdentityDTO} registerIdentityDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    registerBasicIdentity(registerIdentityDTO, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).registerBasicIdentity(registerIdentityDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UpdateIdentityDTO} updateIdentityDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    updateIdentity(id, updateIdentityDTO, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).updateIdentity(id, updateIdentityDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UpdateIdentityDTO} updateIdentityDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    updateIdentity2(updateIdentityDTO, options) {
        return (0, exports.IdentityControllerApiFp)(this.configuration).updateIdentity2(updateIdentityDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.IdentityControllerApi = IdentityControllerApi;
/**
 * IdentitySupportApi - axios parameter creator
 * @export
 */
const IdentitySupportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Update an identity with new information
         * @param {string} enstallId The unique identifier of the user in the GIP
         * @param {UpdateIdentityRequest} [updateIdentityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity1: (enstallId, updateIdentityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'enstallId' is not null or undefined
            (0, common_1.assertParamExists)('updateIdentity1', 'enstallId', enstallId);
            const localVarPath = `/api/v2/identities/ENSTALL/{enstallId}`
                .replace(`{${"enstallId"}}`, encodeURIComponent(String(enstallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateIdentityRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Perform a test authentication to see if credentials are correct. The test is done for a specific identity type and will exclude others.
         * @param {EnstallUserValidationRequest} [enstallUserValidationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIdentityAuthentication: (enstallUserValidationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/identities/BASIC/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(enstallUserValidationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.IdentitySupportApiAxiosParamCreator = IdentitySupportApiAxiosParamCreator;
/**
 * IdentitySupportApi - functional programming interface
 * @export
 */
const IdentitySupportApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.IdentitySupportApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Update an identity with new information
         * @param {string} enstallId The unique identifier of the user in the GIP
         * @param {UpdateIdentityRequest} [updateIdentityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity1(enstallId, updateIdentityRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateIdentity1(enstallId, updateIdentityRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Perform a test authentication to see if credentials are correct. The test is done for a specific identity type and will exclude others.
         * @param {EnstallUserValidationRequest} [enstallUserValidationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIdentityAuthentication(enstallUserValidationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateIdentityAuthentication(enstallUserValidationRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.IdentitySupportApiFp = IdentitySupportApiFp;
/**
 * IdentitySupportApi - factory interface
 * @export
 */
const IdentitySupportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.IdentitySupportApiFp)(configuration);
    return {
        /**
         *
         * @summary Update an identity with new information
         * @param {string} enstallId The unique identifier of the user in the GIP
         * @param {UpdateIdentityRequest} [updateIdentityRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIdentity1(enstallId, updateIdentityRequest, options) {
            return localVarFp.updateIdentity1(enstallId, updateIdentityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Perform a test authentication to see if credentials are correct. The test is done for a specific identity type and will exclude others.
         * @param {EnstallUserValidationRequest} [enstallUserValidationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateIdentityAuthentication(enstallUserValidationRequest, options) {
            return localVarFp.validateIdentityAuthentication(enstallUserValidationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.IdentitySupportApiFactory = IdentitySupportApiFactory;
/**
 * IdentitySupportApi - object-oriented interface
 * @export
 * @class IdentitySupportApi
 * @extends {BaseAPI}
 */
class IdentitySupportApi extends base_1.BaseAPI {
    /**
     *
     * @summary Update an identity with new information
     * @param {string} enstallId The unique identifier of the user in the GIP
     * @param {UpdateIdentityRequest} [updateIdentityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentitySupportApi
     */
    updateIdentity1(enstallId, updateIdentityRequest, options) {
        return (0, exports.IdentitySupportApiFp)(this.configuration).updateIdentity1(enstallId, updateIdentityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Perform a test authentication to see if credentials are correct. The test is done for a specific identity type and will exclude others.
     * @param {EnstallUserValidationRequest} [enstallUserValidationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentitySupportApi
     */
    validateIdentityAuthentication(enstallUserValidationRequest, options) {
        return (0, exports.IdentitySupportApiFp)(this.configuration).validateIdentityAuthentication(enstallUserValidationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.IdentitySupportApi = IdentitySupportApi;
/**
 * JobControllerApi - axios parameter creator
 * @export
 */
const JobControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleUpdateStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/jobs/article-update/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} feature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureToggleMigrationStatus: (feature, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'feature' is not null or undefined
            (0, common_1.assertParamExists)('getFeatureToggleMigrationStatus', 'feature', feature);
            const localVarPath = `/api/jobs/feature-toggle-migration/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (feature !== undefined) {
                localVarQueryParameter['feature'] = feature;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticles: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/jobs/article-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.JobControllerApiAxiosParamCreator = JobControllerApiAxiosParamCreator;
/**
 * JobControllerApi - functional programming interface
 * @export
 */
const JobControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.JobControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleUpdateStatus(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getArticleUpdateStatus(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} feature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureToggleMigrationStatus(feature, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFeatureToggleMigrationStatus(feature, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticles(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateArticles(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.JobControllerApiFp = JobControllerApiFp;
/**
 * JobControllerApi - factory interface
 * @export
 */
const JobControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.JobControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleUpdateStatus(options) {
            return localVarFp.getArticleUpdateStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} feature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureToggleMigrationStatus(feature, options) {
            return localVarFp.getFeatureToggleMigrationStatus(feature, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticles(options) {
            return localVarFp.updateArticles(options).then((request) => request(axios, basePath));
        },
    };
};
exports.JobControllerApiFactory = JobControllerApiFactory;
/**
 * JobControllerApi - object-oriented interface
 * @export
 * @class JobControllerApi
 * @extends {BaseAPI}
 */
class JobControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobControllerApi
     */
    getArticleUpdateStatus(options) {
        return (0, exports.JobControllerApiFp)(this.configuration).getArticleUpdateStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} feature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobControllerApi
     */
    getFeatureToggleMigrationStatus(feature, options) {
        return (0, exports.JobControllerApiFp)(this.configuration).getFeatureToggleMigrationStatus(feature, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobControllerApi
     */
    updateArticles(options) {
        return (0, exports.JobControllerApiFp)(this.configuration).updateArticles(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JobControllerApi = JobControllerApi;
/**
 * LocationResourceApi - axios parameter creator
 * @export
 */
const LocationResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} country
         * @param {number} latitude
         * @param {number} longitude
         * @param {string} [administrativeAreaLevel1]
         * @param {string} [administrativeAreaLevel2]
         * @param {string} [locality]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        determineZoneInformation: (country, latitude, longitude, administrativeAreaLevel1, administrativeAreaLevel2, locality, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'country' is not null or undefined
            (0, common_1.assertParamExists)('determineZoneInformation', 'country', country);
            // verify required parameter 'latitude' is not null or undefined
            (0, common_1.assertParamExists)('determineZoneInformation', 'latitude', latitude);
            // verify required parameter 'longitude' is not null or undefined
            (0, common_1.assertParamExists)('determineZoneInformation', 'longitude', longitude);
            const localVarPath = `/api/location/zone-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }
            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }
            if (administrativeAreaLevel1 !== undefined) {
                localVarQueryParameter['administrative_area_level_1'] = administrativeAreaLevel1;
            }
            if (administrativeAreaLevel2 !== undefined) {
                localVarQueryParameter['administrative_area_level_2'] = administrativeAreaLevel2;
            }
            if (locality !== undefined) {
                localVarQueryParameter['locality'] = locality;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.LocationResourceApiAxiosParamCreator = LocationResourceApiAxiosParamCreator;
/**
 * LocationResourceApi - functional programming interface
 * @export
 */
const LocationResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.LocationResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} country
         * @param {number} latitude
         * @param {number} longitude
         * @param {string} [administrativeAreaLevel1]
         * @param {string} [administrativeAreaLevel2]
         * @param {string} [locality]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        determineZoneInformation(country, latitude, longitude, administrativeAreaLevel1, administrativeAreaLevel2, locality, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.determineZoneInformation(country, latitude, longitude, administrativeAreaLevel1, administrativeAreaLevel2, locality, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.LocationResourceApiFp = LocationResourceApiFp;
/**
 * LocationResourceApi - factory interface
 * @export
 */
const LocationResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.LocationResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {string} country
         * @param {number} latitude
         * @param {number} longitude
         * @param {string} [administrativeAreaLevel1]
         * @param {string} [administrativeAreaLevel2]
         * @param {string} [locality]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        determineZoneInformation(country, latitude, longitude, administrativeAreaLevel1, administrativeAreaLevel2, locality, options) {
            return localVarFp.determineZoneInformation(country, latitude, longitude, administrativeAreaLevel1, administrativeAreaLevel2, locality, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LocationResourceApiFactory = LocationResourceApiFactory;
/**
 * LocationResourceApi - object-oriented interface
 * @export
 * @class LocationResourceApi
 * @extends {BaseAPI}
 */
class LocationResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} country
     * @param {number} latitude
     * @param {number} longitude
     * @param {string} [administrativeAreaLevel1]
     * @param {string} [administrativeAreaLevel2]
     * @param {string} [locality]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    determineZoneInformation(country, latitude, longitude, administrativeAreaLevel1, administrativeAreaLevel2, locality, options) {
        return (0, exports.LocationResourceApiFp)(this.configuration).determineZoneInformation(country, latitude, longitude, administrativeAreaLevel1, administrativeAreaLevel2, locality, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LocationResourceApi = LocationResourceApi;
/**
 * ProjectResourceApi - axios parameter creator
 * @export
 */
const ProjectResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneProject: (id, baseProjectDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('cloneProject', 'id', id);
            // verify required parameter 'baseProjectDTO' is not null or undefined
            (0, common_1.assertParamExists)('cloneProject', 'baseProjectDTO', baseProjectDTO);
            const localVarPath = `/api/projects/{id}/clone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(baseProjectDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} shareId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneSharedProject: (shareId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'shareId' is not null or undefined
            (0, common_1.assertParamExists)('cloneSharedProject', 'shareId', shareId);
            const localVarPath = `/api/projects/clone-shared/{shareId}`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: (baseProjectDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'baseProjectDTO' is not null or undefined
            (0, common_1.assertParamExists)('createProject', 'baseProjectDTO', baseProjectDTO);
            const localVarPath = `/api/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(baseProjectDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteProject', 'id', id);
            const localVarPath = `/api/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhenEmpty: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteWhenEmpty', 'id', id);
            const localVarPath = `/api/projects/{id}/empty`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Pageable} pageable
         * @param {string} [search]
         * @param {'IN_PROGRESS' | 'COMPLETED' | 'FINALIZING' | 'ERROR' | 'DISCONTINUED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsForUser: (pageable, search, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pageable' is not null or undefined
            (0, common_1.assertParamExists)('getAllProjectsForUser', 'pageable', pageable);
            const localVarPath = `/api/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Pageable} pageable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplatesForUser: (pageable, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pageable' is not null or undefined
            (0, common_1.assertParamExists)('getAllTemplatesForUser', 'pageable', pageable);
            const localVarPath = `/api/projects/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {string} [accept]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterials: (id, roofs, accept, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBillOfMaterials', 'id', id);
            const localVarPath = `/api/projects/{id}/reports/bill-of-materials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (roofs) {
                localVarQueryParameter['roofs'] = roofs;
            }
            if (accept != null) {
                localVarHeaderParameter['Accept'] = String(accept);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationSummary: (id, roofs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getInstallationSummary', 'id', id);
            const localVarPath = `/api/projects/{id}/reports/installation-summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (roofs) {
                localVarQueryParameter['roofs'] = roofs;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectForUser: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getProjectForUser', 'id', id);
            const localVarPath = `/api/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofsSummary: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRoofsSummary', 'id', id);
            const localVarPath = `/api/projects/{id}/roof-summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateProject: (id, roofs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('migrateProject', 'id', id);
            const localVarPath = `/api/projects/{id}/migrate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (roofs) {
                localVarQueryParameter['roofs'] = roofs;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareProject: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('shareProject', 'id', id);
            const localVarPath = `/api/projects/{id}/share`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: (id, baseProjectDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updateProject', 'id', id);
            // verify required parameter 'baseProjectDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateProject', 'baseProjectDTO', baseProjectDTO);
            const localVarPath = `/api/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(baseProjectDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ProjectResourceApiAxiosParamCreator = ProjectResourceApiAxiosParamCreator;
/**
 * ProjectResourceApi - functional programming interface
 * @export
 */
const ProjectResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ProjectResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneProject(id, baseProjectDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneProject(id, baseProjectDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} shareId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneSharedProject(shareId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneSharedProject(shareId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(baseProjectDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProject(baseProjectDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProject(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhenEmpty(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteWhenEmpty(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {string} [search]
         * @param {'IN_PROGRESS' | 'COMPLETED' | 'FINALIZING' | 'ERROR' | 'DISCONTINUED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsForUser(pageable, search, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllProjectsForUser(pageable, search, status, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplatesForUser(pageable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllTemplatesForUser(pageable, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {string} [accept]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterials(id, roofs, accept, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillOfMaterials(id, roofs, accept, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationSummary(id, roofs, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInstallationSummary(id, roofs, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectForUser(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProjectForUser(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofsSummary(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoofsSummary(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateProject(id, roofs, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrateProject(id, roofs, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareProject(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.shareProject(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(id, baseProjectDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateProject(id, baseProjectDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ProjectResourceApiFp = ProjectResourceApiFp;
/**
 * ProjectResourceApi - factory interface
 * @export
 */
const ProjectResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ProjectResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneProject(id, baseProjectDTO, options) {
            return localVarFp.cloneProject(id, baseProjectDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} shareId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneSharedProject(shareId, options) {
            return localVarFp.cloneSharedProject(shareId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(baseProjectDTO, options) {
            return localVarFp.createProject(baseProjectDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(id, options) {
            return localVarFp.deleteProject(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhenEmpty(id, options) {
            return localVarFp.deleteWhenEmpty(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {string} [search]
         * @param {'IN_PROGRESS' | 'COMPLETED' | 'FINALIZING' | 'ERROR' | 'DISCONTINUED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsForUser(pageable, search, status, options) {
            return localVarFp.getAllProjectsForUser(pageable, search, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplatesForUser(pageable, options) {
            return localVarFp.getAllTemplatesForUser(pageable, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {string} [accept]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterials(id, roofs, accept, options) {
            return localVarFp.getBillOfMaterials(id, roofs, accept, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationSummary(id, roofs, options) {
            return localVarFp.getInstallationSummary(id, roofs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectForUser(id, options) {
            return localVarFp.getProjectForUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofsSummary(id, options) {
            return localVarFp.getRoofsSummary(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Array<number>} [roofs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateProject(id, roofs, options) {
            return localVarFp.migrateProject(id, roofs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareProject(id, options) {
            return localVarFp.shareProject(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {BaseProjectDTO} baseProjectDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(id, baseProjectDTO, options) {
            return localVarFp.updateProject(id, baseProjectDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ProjectResourceApiFactory = ProjectResourceApiFactory;
/**
 * ProjectResourceApi - object-oriented interface
 * @export
 * @class ProjectResourceApi
 * @extends {BaseAPI}
 */
class ProjectResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} id
     * @param {BaseProjectDTO} baseProjectDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    cloneProject(id, baseProjectDTO, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).cloneProject(id, baseProjectDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} shareId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    cloneSharedProject(shareId, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).cloneSharedProject(shareId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BaseProjectDTO} baseProjectDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    createProject(baseProjectDTO, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).createProject(baseProjectDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    deleteProject(id, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).deleteProject(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    deleteWhenEmpty(id, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).deleteWhenEmpty(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Pageable} pageable
     * @param {string} [search]
     * @param {'IN_PROGRESS' | 'COMPLETED' | 'FINALIZING' | 'ERROR' | 'DISCONTINUED'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    getAllProjectsForUser(pageable, search, status, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).getAllProjectsForUser(pageable, search, status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Pageable} pageable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    getAllTemplatesForUser(pageable, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).getAllTemplatesForUser(pageable, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Array<number>} [roofs]
     * @param {string} [accept]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    getBillOfMaterials(id, roofs, accept, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).getBillOfMaterials(id, roofs, accept, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Array<number>} [roofs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    getInstallationSummary(id, roofs, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).getInstallationSummary(id, roofs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    getProjectForUser(id, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).getProjectForUser(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    getRoofsSummary(id, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).getRoofsSummary(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Array<number>} [roofs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    migrateProject(id, roofs, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).migrateProject(id, roofs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    shareProject(id, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).shareProject(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {BaseProjectDTO} baseProjectDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceApi
     */
    updateProject(id, baseProjectDTO, options) {
        return (0, exports.ProjectResourceApiFp)(this.configuration).updateProject(id, baseProjectDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ProjectResourceApi = ProjectResourceApi;
/**
 * RoofResourceApi - axios parameter creator
 * @export
 */
const RoofResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneRoof: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('cloneRoof', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('cloneRoof', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/clone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoof: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('createRoof', 'id', id);
            const localVarPath = `/api/projects/{id}/roofs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoof: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteRoof', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('deleteRoof', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {boolean} [showInnerEdgeZone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeRoof: (id, roofId, showInnerEdgeZone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('finalizeRoof', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('finalizeRoof', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/finalize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (showInnerEdgeZone !== undefined) {
                localVarQueryParameter['showInnerEdgeZone'] = showInnerEdgeZone;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBallastPlan: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBallastPlan', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getBallastPlan', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/reports/ballast-plan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterialsCSV1: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBillOfMaterialsCSV1', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getBillOfMaterialsCSV1', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/reports/bill-of-materials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterialsJSON: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getBillOfMaterialsJSON', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getBillOfMaterialsJSON', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/bill-of-materials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentralRoofZones1: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getCentralRoofZones1', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getCentralRoofZones1', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/central-roof-zones`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationSummaryPDF: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getInstallationSummaryPDF', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getInstallationSummaryPDF', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/reports/installation-summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoof: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRoof', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getRoof', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofCalculations: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRoofCalculations', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getRoofCalculations', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/reports/calculation-results`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofStatus: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getRoofStatus', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getRoofStatus', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZip: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getZip', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('getZip', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/reports`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openRoof: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('openRoof', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('openRoof', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/open`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {RoofWithoutIdDTO} roofWithoutIdDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateRoof: (id, roofId, roofWithoutIdDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('partialUpdateRoof', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('partialUpdateRoof', 'roofId', roofId);
            // verify required parameter 'roofWithoutIdDTO' is not null or undefined
            (0, common_1.assertParamExists)('partialUpdateRoof', 'roofWithoutIdDTO', roofWithoutIdDTO);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roofWithoutIdDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {OptionalArticleDTO} optionalArticleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleOptionalArticle: (id, roofId, optionalArticleDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('toggleOptionalArticle', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('toggleOptionalArticle', 'roofId', roofId);
            // verify required parameter 'optionalArticleDTO' is not null or undefined
            (0, common_1.assertParamExists)('toggleOptionalArticle', 'optionalArticleDTO', optionalArticleDTO);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/optional_articles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(optionalArticleDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {Set<BOMAdjustmentDTO>} bOMAdjustmentDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBOMAdjustments: (id, roofId, bOMAdjustmentDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updateBOMAdjustments', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('updateBOMAdjustments', 'roofId', roofId);
            // verify required parameter 'bOMAdjustmentDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateBOMAdjustments', 'bOMAdjustmentDTO', bOMAdjustmentDTO);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/bom-adjustments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bOMAdjustmentDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {EditorStateDTO} editorStateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEditorState: (id, roofId, editorStateDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updateEditorState', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('updateEditorState', 'roofId', roofId);
            // verify required parameter 'editorStateDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateEditorState', 'editorStateDTO', editorStateDTO);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/editor-state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(editorStateDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductsForRoof: (id, roofId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('validateProductsForRoof', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('validateProductsForRoof', 'roofId', roofId);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/validate-products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RoofResourceApiAxiosParamCreator = RoofResourceApiAxiosParamCreator;
/**
 * RoofResourceApi - functional programming interface
 * @export
 */
const RoofResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RoofResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneRoof(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneRoof(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoof(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createRoof(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoof(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteRoof(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {boolean} [showInnerEdgeZone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeRoof(id, roofId, showInnerEdgeZone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finalizeRoof(id, roofId, showInnerEdgeZone, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBallastPlan(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBallastPlan(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterialsCSV1(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillOfMaterialsCSV1(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterialsJSON(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBillOfMaterialsJSON(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentralRoofZones1(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCentralRoofZones1(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationSummaryPDF(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInstallationSummaryPDF(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoof(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoof(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofCalculations(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoofCalculations(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofStatus(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoofStatus(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZip(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getZip(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openRoof(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.openRoof(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {RoofWithoutIdDTO} roofWithoutIdDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateRoof(id, roofId, roofWithoutIdDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.partialUpdateRoof(id, roofId, roofWithoutIdDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {OptionalArticleDTO} optionalArticleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleOptionalArticle(id, roofId, optionalArticleDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.toggleOptionalArticle(id, roofId, optionalArticleDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {Set<BOMAdjustmentDTO>} bOMAdjustmentDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBOMAdjustments(id, roofId, bOMAdjustmentDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateBOMAdjustments(id, roofId, bOMAdjustmentDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {EditorStateDTO} editorStateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEditorState(id, roofId, editorStateDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEditorState(id, roofId, editorStateDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductsForRoof(id, roofId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateProductsForRoof(id, roofId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.RoofResourceApiFp = RoofResourceApiFp;
/**
 * RoofResourceApi - factory interface
 * @export
 */
const RoofResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RoofResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneRoof(id, roofId, options) {
            return localVarFp.cloneRoof(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoof(id, options) {
            return localVarFp.createRoof(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoof(id, roofId, options) {
            return localVarFp.deleteRoof(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {boolean} [showInnerEdgeZone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeRoof(id, roofId, showInnerEdgeZone, options) {
            return localVarFp.finalizeRoof(id, roofId, showInnerEdgeZone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBallastPlan(id, roofId, options) {
            return localVarFp.getBallastPlan(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterialsCSV1(id, roofId, options) {
            return localVarFp.getBillOfMaterialsCSV1(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillOfMaterialsJSON(id, roofId, options) {
            return localVarFp.getBillOfMaterialsJSON(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCentralRoofZones1(id, roofId, options) {
            return localVarFp.getCentralRoofZones1(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationSummaryPDF(id, roofId, options) {
            return localVarFp.getInstallationSummaryPDF(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoof(id, roofId, options) {
            return localVarFp.getRoof(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofCalculations(id, roofId, options) {
            return localVarFp.getRoofCalculations(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoofStatus(id, roofId, options) {
            return localVarFp.getRoofStatus(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZip(id, roofId, options) {
            return localVarFp.getZip(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openRoof(id, roofId, options) {
            return localVarFp.openRoof(id, roofId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {RoofWithoutIdDTO} roofWithoutIdDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateRoof(id, roofId, roofWithoutIdDTO, options) {
            return localVarFp.partialUpdateRoof(id, roofId, roofWithoutIdDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {OptionalArticleDTO} optionalArticleDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleOptionalArticle(id, roofId, optionalArticleDTO, options) {
            return localVarFp.toggleOptionalArticle(id, roofId, optionalArticleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {Set<BOMAdjustmentDTO>} bOMAdjustmentDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBOMAdjustments(id, roofId, bOMAdjustmentDTO, options) {
            return localVarFp.updateBOMAdjustments(id, roofId, bOMAdjustmentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {EditorStateDTO} editorStateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEditorState(id, roofId, editorStateDTO, options) {
            return localVarFp.updateEditorState(id, roofId, editorStateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProductsForRoof(id, roofId, options) {
            return localVarFp.validateProductsForRoof(id, roofId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RoofResourceApiFactory = RoofResourceApiFactory;
/**
 * RoofResourceApi - object-oriented interface
 * @export
 * @class RoofResourceApi
 * @extends {BaseAPI}
 */
class RoofResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    cloneRoof(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).cloneRoof(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    createRoof(id, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).createRoof(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    deleteRoof(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).deleteRoof(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {boolean} [showInnerEdgeZone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    finalizeRoof(id, roofId, showInnerEdgeZone, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).finalizeRoof(id, roofId, showInnerEdgeZone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getBallastPlan(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getBallastPlan(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getBillOfMaterialsCSV1(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getBillOfMaterialsCSV1(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getBillOfMaterialsJSON(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getBillOfMaterialsJSON(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getCentralRoofZones1(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getCentralRoofZones1(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getInstallationSummaryPDF(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getInstallationSummaryPDF(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getRoof(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getRoof(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getRoofCalculations(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getRoofCalculations(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getRoofStatus(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getRoofStatus(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    getZip(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).getZip(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    openRoof(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).openRoof(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {RoofWithoutIdDTO} roofWithoutIdDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    partialUpdateRoof(id, roofId, roofWithoutIdDTO, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).partialUpdateRoof(id, roofId, roofWithoutIdDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {OptionalArticleDTO} optionalArticleDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    toggleOptionalArticle(id, roofId, optionalArticleDTO, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).toggleOptionalArticle(id, roofId, optionalArticleDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {Set<BOMAdjustmentDTO>} bOMAdjustmentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    updateBOMAdjustments(id, roofId, bOMAdjustmentDTO, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).updateBOMAdjustments(id, roofId, bOMAdjustmentDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {EditorStateDTO} editorStateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    updateEditorState(id, roofId, editorStateDTO, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).updateEditorState(id, roofId, editorStateDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoofResourceApi
     */
    validateProductsForRoof(id, roofId, options) {
        return (0, exports.RoofResourceApiFp)(this.configuration).validateProductsForRoof(id, roofId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RoofResourceApi = RoofResourceApi;
/**
 * ShortcutResourceApi - axios parameter creator
 * @export
 */
const ShortcutResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Calculate information required for drawing fields
         * @param {DrawingFieldsShortcutDto} drawingFieldsShortcutDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeDrawingFieldsShortcut: (drawingFieldsShortcutDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'drawingFieldsShortcutDto' is not null or undefined
            (0, common_1.assertParamExists)('executeDrawingFieldsShortcut', 'drawingFieldsShortcutDto', drawingFieldsShortcutDto);
            const localVarPath = `/api/vendors/shortcuts/drawing-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.esdec.v1+json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(drawingFieldsShortcutDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ShortcutResourceApiAxiosParamCreator = ShortcutResourceApiAxiosParamCreator;
/**
 * ShortcutResourceApi - functional programming interface
 * @export
 */
const ShortcutResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ShortcutResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Calculate information required for drawing fields
         * @param {DrawingFieldsShortcutDto} drawingFieldsShortcutDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeDrawingFieldsShortcut(drawingFieldsShortcutDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.executeDrawingFieldsShortcut(drawingFieldsShortcutDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ShortcutResourceApiFp = ShortcutResourceApiFp;
/**
 * ShortcutResourceApi - factory interface
 * @export
 */
const ShortcutResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ShortcutResourceApiFp)(configuration);
    return {
        /**
         *
         * @summary Calculate information required for drawing fields
         * @param {DrawingFieldsShortcutDto} drawingFieldsShortcutDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeDrawingFieldsShortcut(drawingFieldsShortcutDto, options) {
            return localVarFp.executeDrawingFieldsShortcut(drawingFieldsShortcutDto, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ShortcutResourceApiFactory = ShortcutResourceApiFactory;
/**
 * ShortcutResourceApi - object-oriented interface
 * @export
 * @class ShortcutResourceApi
 * @extends {BaseAPI}
 */
class ShortcutResourceApi extends base_1.BaseAPI {
    /**
     *
     * @summary Calculate information required for drawing fields
     * @param {DrawingFieldsShortcutDto} drawingFieldsShortcutDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortcutResourceApi
     */
    executeDrawingFieldsShortcut(drawingFieldsShortcutDto, options) {
        return (0, exports.ShortcutResourceApiFp)(this.configuration).executeDrawingFieldsShortcut(drawingFieldsShortcutDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ShortcutResourceApi = ShortcutResourceApi;
/**
 * ShortcutsApi - axios parameter creator
 * @export
 */
const ShortcutsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Calculate roof zones for each roof in the project.
         * @param {RoofZonesShortcutRequest} [roofZonesShortcutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeRoofZonesShortcut: (roofZonesShortcutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/shortcuts/roof-zones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roofZonesShortcutRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ShortcutsApiAxiosParamCreator = ShortcutsApiAxiosParamCreator;
/**
 * ShortcutsApi - functional programming interface
 * @export
 */
const ShortcutsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ShortcutsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Calculate roof zones for each roof in the project.
         * @param {RoofZonesShortcutRequest} [roofZonesShortcutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeRoofZonesShortcut(roofZonesShortcutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.executeRoofZonesShortcut(roofZonesShortcutRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ShortcutsApiFp = ShortcutsApiFp;
/**
 * ShortcutsApi - factory interface
 * @export
 */
const ShortcutsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ShortcutsApiFp)(configuration);
    return {
        /**
         *
         * @summary Calculate roof zones for each roof in the project.
         * @param {RoofZonesShortcutRequest} [roofZonesShortcutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeRoofZonesShortcut(roofZonesShortcutRequest, options) {
            return localVarFp.executeRoofZonesShortcut(roofZonesShortcutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ShortcutsApiFactory = ShortcutsApiFactory;
/**
 * ShortcutsApi - object-oriented interface
 * @export
 * @class ShortcutsApi
 * @extends {BaseAPI}
 */
class ShortcutsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Calculate roof zones for each roof in the project.
     * @param {RoofZonesShortcutRequest} [roofZonesShortcutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShortcutsApi
     */
    executeRoofZonesShortcut(roofZonesShortcutRequest, options) {
        return (0, exports.ShortcutsApiFp)(this.configuration).executeRoofZonesShortcut(roofZonesShortcutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ShortcutsApi = ShortcutsApi;
/**
 * SolarPanelResourceApi - axios parameter creator
 * @export
 */
const SolarPanelResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomSolarPanel: (solarpanelDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'solarpanelDTO' is not null or undefined
            (0, common_1.assertParamExists)('createCustomSolarPanel', 'solarpanelDTO', solarpanelDTO);
            const localVarPath = `/api/solarpanels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(solarpanelDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSolarPanel: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteSolarPanel', 'id', id);
            const localVarPath = `/api/solarpanels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolarPanels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/solarpanels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomSolarPanel: (id, solarpanelDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updateCustomSolarPanel', 'id', id);
            // verify required parameter 'solarpanelDTO' is not null or undefined
            (0, common_1.assertParamExists)('updateCustomSolarPanel', 'solarpanelDTO', solarpanelDTO);
            const localVarPath = `/api/solarpanels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(solarpanelDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SolarPanelResourceApiAxiosParamCreator = SolarPanelResourceApiAxiosParamCreator;
/**
 * SolarPanelResourceApi - functional programming interface
 * @export
 */
const SolarPanelResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SolarPanelResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomSolarPanel(solarpanelDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCustomSolarPanel(solarpanelDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSolarPanel(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSolarPanel(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolarPanels(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllSolarPanels(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomSolarPanel(id, solarpanelDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCustomSolarPanel(id, solarpanelDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SolarPanelResourceApiFp = SolarPanelResourceApiFp;
/**
 * SolarPanelResourceApi - factory interface
 * @export
 */
const SolarPanelResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SolarPanelResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomSolarPanel(solarpanelDTO, options) {
            return localVarFp.createCustomSolarPanel(solarpanelDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSolarPanel(id, options) {
            return localVarFp.deleteSolarPanel(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolarPanels(options) {
            return localVarFp.getAllSolarPanels(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomSolarPanel(id, solarpanelDTO, options) {
            return localVarFp.updateCustomSolarPanel(id, solarpanelDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SolarPanelResourceApiFactory = SolarPanelResourceApiFactory;
/**
 * SolarPanelResourceApi - object-oriented interface
 * @export
 * @class SolarPanelResourceApi
 * @extends {BaseAPI}
 */
class SolarPanelResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {SolarpanelDTO} solarpanelDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolarPanelResourceApi
     */
    createCustomSolarPanel(solarpanelDTO, options) {
        return (0, exports.SolarPanelResourceApiFp)(this.configuration).createCustomSolarPanel(solarpanelDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolarPanelResourceApi
     */
    deleteSolarPanel(id, options) {
        return (0, exports.SolarPanelResourceApiFp)(this.configuration).deleteSolarPanel(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolarPanelResourceApi
     */
    getAllSolarPanels(options) {
        return (0, exports.SolarPanelResourceApiFp)(this.configuration).getAllSolarPanels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {SolarpanelDTO} solarpanelDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolarPanelResourceApi
     */
    updateCustomSolarPanel(id, solarpanelDTO, options) {
        return (0, exports.SolarPanelResourceApiFp)(this.configuration).updateCustomSolarPanel(id, solarpanelDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SolarPanelResourceApi = SolarPanelResourceApi;
/**
 * UserAccountControllerApi - axios parameter creator
 * @export
 */
const UserAccountControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/user-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccount1: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('retrieveUserAccount1', 'id', id);
            const localVarPath = `/api/user-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Pageable} pageable
         * @param {string} [role]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccounts: (pageable, role, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pageable' is not null or undefined
            (0, common_1.assertParamExists)('retrieveUserAccounts', 'pageable', pageable);
            const localVarPath = `/api/user-accounts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthorities: (id, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updateAuthorities', 'id', id);
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('updateAuthorities', 'requestBody', requestBody);
            const localVarPath = `/api/user-accounts/{id}/authorities`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserAccountControllerApiAxiosParamCreator = UserAccountControllerApiAxiosParamCreator;
/**
 * UserAccountControllerApi - functional programming interface
 * @export
 */
const UserAccountControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserAccountControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccount(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveUserAccount(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccount1(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveUserAccount1(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {string} [role]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccounts(pageable, role, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveUserAccounts(pageable, role, search, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthorities(id, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAuthorities(id, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UserAccountControllerApiFp = UserAccountControllerApiFp;
/**
 * UserAccountControllerApi - factory interface
 * @export
 */
const UserAccountControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserAccountControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccount(options) {
            return localVarFp.retrieveUserAccount(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccount1(id, options) {
            return localVarFp.retrieveUserAccount1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Pageable} pageable
         * @param {string} [role]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserAccounts(pageable, role, search, options) {
            return localVarFp.retrieveUserAccounts(pageable, role, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthorities(id, requestBody, options) {
            return localVarFp.updateAuthorities(id, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserAccountControllerApiFactory = UserAccountControllerApiFactory;
/**
 * UserAccountControllerApi - object-oriented interface
 * @export
 * @class UserAccountControllerApi
 * @extends {BaseAPI}
 */
class UserAccountControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountControllerApi
     */
    retrieveUserAccount(options) {
        return (0, exports.UserAccountControllerApiFp)(this.configuration).retrieveUserAccount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountControllerApi
     */
    retrieveUserAccount1(id, options) {
        return (0, exports.UserAccountControllerApiFp)(this.configuration).retrieveUserAccount1(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Pageable} pageable
     * @param {string} [role]
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountControllerApi
     */
    retrieveUserAccounts(pageable, role, search, options) {
        return (0, exports.UserAccountControllerApiFp)(this.configuration).retrieveUserAccounts(pageable, role, search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAccountControllerApi
     */
    updateAuthorities(id, requestBody, options) {
        return (0, exports.UserAccountControllerApiFp)(this.configuration).updateAuthorities(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserAccountControllerApi = UserAccountControllerApi;
/**
 * UserPreferencesControllerApi - axios parameter creator
 * @export
 */
const UserPreferencesControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/user-accounts/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UserPreferenceDTO} userPreferenceDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences: (userPreferenceDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userPreferenceDTO' is not null or undefined
            (0, common_1.assertParamExists)('updatePreferences', 'userPreferenceDTO', userPreferenceDTO);
            const localVarPath = `/api/user-accounts/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userPreferenceDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserPreferencesControllerApiAxiosParamCreator = UserPreferencesControllerApiAxiosParamCreator;
/**
 * UserPreferencesControllerApi - functional programming interface
 * @export
 */
const UserPreferencesControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserPreferencesControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPreferences(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UserPreferenceDTO} userPreferenceDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences(userPreferenceDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePreferences(userPreferenceDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UserPreferencesControllerApiFp = UserPreferencesControllerApiFp;
/**
 * UserPreferencesControllerApi - factory interface
 * @export
 */
const UserPreferencesControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserPreferencesControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferences(options) {
            return localVarFp.getPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserPreferenceDTO} userPreferenceDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences(userPreferenceDTO, options) {
            return localVarFp.updatePreferences(userPreferenceDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserPreferencesControllerApiFactory = UserPreferencesControllerApiFactory;
/**
 * UserPreferencesControllerApi - object-oriented interface
 * @export
 * @class UserPreferencesControllerApi
 * @extends {BaseAPI}
 */
class UserPreferencesControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferencesControllerApi
     */
    getPreferences(options) {
        return (0, exports.UserPreferencesControllerApiFp)(this.configuration).getPreferences(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserPreferenceDTO} userPreferenceDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferencesControllerApi
     */
    updatePreferences(userPreferenceDTO, options) {
        return (0, exports.UserPreferencesControllerApiFp)(this.configuration).updatePreferences(userPreferenceDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserPreferencesControllerApi = UserPreferencesControllerApi;
/**
 * VendorResourceApi - axios parameter creator
 * @export
 */
const VendorResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {CheckoutRequestDto} checkoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout: (id, roofId, checkoutRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('checkout', 'id', id);
            // verify required parameter 'roofId' is not null or undefined
            (0, common_1.assertParamExists)('checkout', 'roofId', roofId);
            // verify required parameter 'checkoutRequestDto' is not null or undefined
            (0, common_1.assertParamExists)('checkout', 'checkoutRequestDto', checkoutRequestDto);
            const localVarPath = `/api/projects/{id}/roofs/{roofId}/checkout`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"roofId"}}`, encodeURIComponent(String(roofId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(checkoutRequestDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolarPanelForWebshop: (solarpanelDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'solarpanelDTO' is not null or undefined
            (0, common_1.assertParamExists)('createSolarPanelForWebshop', 'solarpanelDTO', solarpanelDTO);
            const localVarPath = `/vendor/solar-panel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(solarpanelDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSolarPanels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/vendor/solar-panel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markWebshopSolarPanelAsDeleted: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('markWebshopSolarPanelAsDeleted', 'id', id);
            const localVarPath = `/vendor/solar-panel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Redirect webshop authorization endpoint
         * @param {string} vendorUuid
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToVendor: (vendorUuid, state, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vendorUuid' is not null or undefined
            (0, common_1.assertParamExists)('redirectToVendor', 'vendorUuid', vendorUuid);
            const localVarPath = `/vendor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (vendorUuid !== undefined) {
                localVarQueryParameter['vendor-uuid'] = vendorUuid;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.VendorResourceApiAxiosParamCreator = VendorResourceApiAxiosParamCreator;
/**
 * VendorResourceApi - functional programming interface
 * @export
 */
const VendorResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.VendorResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {CheckoutRequestDto} checkoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout(id, roofId, checkoutRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkout(id, roofId, checkoutRequestDto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolarPanelForWebshop(solarpanelDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSolarPanelForWebshop(solarpanelDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSolarPanels(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveSolarPanels(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markWebshopSolarPanelAsDeleted(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markWebshopSolarPanelAsDeleted(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Redirect webshop authorization endpoint
         * @param {string} vendorUuid
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToVendor(vendorUuid, state, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redirectToVendor(vendorUuid, state, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.VendorResourceApiFp = VendorResourceApiFp;
/**
 * VendorResourceApi - factory interface
 * @export
 */
const VendorResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.VendorResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} roofId
         * @param {CheckoutRequestDto} checkoutRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout(id, roofId, checkoutRequestDto, options) {
            return localVarFp.checkout(id, roofId, checkoutRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SolarpanelDTO} solarpanelDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolarPanelForWebshop(solarpanelDTO, options) {
            return localVarFp.createSolarPanelForWebshop(solarpanelDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSolarPanels(options) {
            return localVarFp.getActiveSolarPanels(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markWebshopSolarPanelAsDeleted(id, options) {
            return localVarFp.markWebshopSolarPanelAsDeleted(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Redirect webshop authorization endpoint
         * @param {string} vendorUuid
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToVendor(vendorUuid, state, options) {
            return localVarFp.redirectToVendor(vendorUuid, state, options).then((request) => request(axios, basePath));
        },
    };
};
exports.VendorResourceApiFactory = VendorResourceApiFactory;
/**
 * VendorResourceApi - object-oriented interface
 * @export
 * @class VendorResourceApi
 * @extends {BaseAPI}
 */
class VendorResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} id
     * @param {number} roofId
     * @param {CheckoutRequestDto} checkoutRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorResourceApi
     */
    checkout(id, roofId, checkoutRequestDto, options) {
        return (0, exports.VendorResourceApiFp)(this.configuration).checkout(id, roofId, checkoutRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SolarpanelDTO} solarpanelDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorResourceApi
     */
    createSolarPanelForWebshop(solarpanelDTO, options) {
        return (0, exports.VendorResourceApiFp)(this.configuration).createSolarPanelForWebshop(solarpanelDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorResourceApi
     */
    getActiveSolarPanels(options) {
        return (0, exports.VendorResourceApiFp)(this.configuration).getActiveSolarPanels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorResourceApi
     */
    markWebshopSolarPanelAsDeleted(id, options) {
        return (0, exports.VendorResourceApiFp)(this.configuration).markWebshopSolarPanelAsDeleted(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Redirect webshop authorization endpoint
     * @param {string} vendorUuid
     * @param {string} [state]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorResourceApi
     */
    redirectToVendor(vendorUuid, state, options) {
        return (0, exports.VendorResourceApiFp)(this.configuration).redirectToVendor(vendorUuid, state, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VendorResourceApi = VendorResourceApi;
/**
 * VisualizationResourceApi - axios parameter creator
 * @export
 */
const VisualizationResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {VisualizationInputDTO} visualizationInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationVisualization: (visualizationInputDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'visualizationInputDTO' is not null or undefined
            (0, common_1.assertParamExists)('getCalculationVisualization', 'visualizationInputDTO', visualizationInputDTO);
            const localVarPath = `/api/visualization/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(visualizationInputDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleTypes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/visualization/rule-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.VisualizationResourceApiAxiosParamCreator = VisualizationResourceApiAxiosParamCreator;
/**
 * VisualizationResourceApi - functional programming interface
 * @export
 */
const VisualizationResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.VisualizationResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {VisualizationInputDTO} visualizationInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationVisualization(visualizationInputDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCalculationVisualization(visualizationInputDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRuleTypes(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.VisualizationResourceApiFp = VisualizationResourceApiFp;
/**
 * VisualizationResourceApi - factory interface
 * @export
 */
const VisualizationResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.VisualizationResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {VisualizationInputDTO} visualizationInputDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationVisualization(visualizationInputDTO, options) {
            return localVarFp.getCalculationVisualization(visualizationInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleTypes(options) {
            return localVarFp.getRuleTypes(options).then((request) => request(axios, basePath));
        },
    };
};
exports.VisualizationResourceApiFactory = VisualizationResourceApiFactory;
/**
 * VisualizationResourceApi - object-oriented interface
 * @export
 * @class VisualizationResourceApi
 * @extends {BaseAPI}
 */
class VisualizationResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {VisualizationInputDTO} visualizationInputDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationResourceApi
     */
    getCalculationVisualization(visualizationInputDTO, options) {
        return (0, exports.VisualizationResourceApiFp)(this.configuration).getCalculationVisualization(visualizationInputDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualizationResourceApi
     */
    getRuleTypes(options) {
        return (0, exports.VisualizationResourceApiFp)(this.configuration).getRuleTypes(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VisualizationResourceApi = VisualizationResourceApi;
/**
 * WebshopResourceApi - axios parameter creator
 * @export
 */
const WebshopResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWebshops: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/webshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WebshopResourceApiAxiosParamCreator = WebshopResourceApiAxiosParamCreator;
/**
 * WebshopResourceApi - functional programming interface
 * @export
 */
const WebshopResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WebshopResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWebshops(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllWebshops(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.WebshopResourceApiFp = WebshopResourceApiFp;
/**
 * WebshopResourceApi - factory interface
 * @export
 */
const WebshopResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WebshopResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWebshops(options) {
            return localVarFp.getAllWebshops(options).then((request) => request(axios, basePath));
        },
    };
};
exports.WebshopResourceApiFactory = WebshopResourceApiFactory;
/**
 * WebshopResourceApi - object-oriented interface
 * @export
 * @class WebshopResourceApi
 * @extends {BaseAPI}
 */
class WebshopResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebshopResourceApi
     */
    getAllWebshops(options) {
        return (0, exports.WebshopResourceApiFp)(this.configuration).getAllWebshops(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WebshopResourceApi = WebshopResourceApi;
/**
 * WindDataResourceApi - axios parameter creator
 * @export
 */
const WindDataResourceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWindDataCombinations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/winddata/combinations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'FUSION_LANDSCAPE' | 'FUSION_PORTRAIT' | 'WAVE_PLUS_DUAL' | 'WAVE_PLUS_SINGLE_1P' | 'WAVE_PLUS_SINGLE_3P'} category
         * @param {ImportWindDataRequest} [importWindDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWindData: (product, category, importWindDataRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'product' is not null or undefined
            (0, common_1.assertParamExists)('importWindData', 'product', product);
            // verify required parameter 'category' is not null or undefined
            (0, common_1.assertParamExists)('importWindData', 'category', category);
            const localVarPath = `/api/winddata/{product}/{category}`
                .replace(`{${"product"}}`, encodeURIComponent(String(product)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication basicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(importWindDataRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WindDataResourceApiAxiosParamCreator = WindDataResourceApiAxiosParamCreator;
/**
 * WindDataResourceApi - functional programming interface
 * @export
 */
const WindDataResourceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WindDataResourceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWindDataCombinations(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllWindDataCombinations(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'FUSION_LANDSCAPE' | 'FUSION_PORTRAIT' | 'WAVE_PLUS_DUAL' | 'WAVE_PLUS_SINGLE_1P' | 'WAVE_PLUS_SINGLE_3P'} category
         * @param {ImportWindDataRequest} [importWindDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWindData(product, category, importWindDataRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importWindData(product, category, importWindDataRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.WindDataResourceApiFp = WindDataResourceApiFp;
/**
 * WindDataResourceApi - factory interface
 * @export
 */
const WindDataResourceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WindDataResourceApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWindDataCombinations(options) {
            return localVarFp.getAllWindDataCombinations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
         * @param {'FUSION_LANDSCAPE' | 'FUSION_PORTRAIT' | 'WAVE_PLUS_DUAL' | 'WAVE_PLUS_SINGLE_1P' | 'WAVE_PLUS_SINGLE_3P'} category
         * @param {ImportWindDataRequest} [importWindDataRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWindData(product, category, importWindDataRequest, options) {
            return localVarFp.importWindData(product, category, importWindDataRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.WindDataResourceApiFactory = WindDataResourceApiFactory;
/**
 * WindDataResourceApi - object-oriented interface
 * @export
 * @class WindDataResourceApi
 * @extends {BaseAPI}
 */
class WindDataResourceApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WindDataResourceApi
     */
    getAllWindDataCombinations(options) {
        return (0, exports.WindDataResourceApiFp)(this.configuration).getAllWindDataCombinations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {'CLICKFIT_BASIC' | 'CLICKFIT_EVO' | 'CLICKFIT_EVO_IN' | 'FLATFIX_FUSION' | 'FLATFIX_WAVE_ENTRY' | 'FLATFIX_WAVE_PLUS' | 'FLATFIX_FUSION_10' | 'CONNECT'} product
     * @param {'FUSION_LANDSCAPE' | 'FUSION_PORTRAIT' | 'WAVE_PLUS_DUAL' | 'WAVE_PLUS_SINGLE_1P' | 'WAVE_PLUS_SINGLE_3P'} category
     * @param {ImportWindDataRequest} [importWindDataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WindDataResourceApi
     */
    importWindData(product, category, importWindDataRequest, options) {
        return (0, exports.WindDataResourceApiFp)(this.configuration).importWindData(product, category, importWindDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WindDataResourceApi = WindDataResourceApi;
